import { defineComponent, computed, watch, h, Fragment, getCurrentInstance, effectScope, inject, onMounted, onUnmounted, ref, isRef, createVNode, Text, openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot, createCommentVNode, resolveComponent, createBlock, withCtx, toDisplayString as toDisplayString$1, withDirectives, vModelText, normalizeStyle, renderList, createTextVNode, mergeProps, vModelSelect, resolveDynamicComponent, normalizeProps, Transition, TransitionGroup, useCssVars, pushScopeId, popScopeId, vShow, resolveDirective, withKeys, vModelDynamic, withModifiers } from 'vue';

function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) {
      _defineProperty$8(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _typeof$5(obj) {
  "@babel/helpers - typeof";

  return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$5(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$4(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty$8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray$3(arr, i) {
  return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$9(arr, i) || _nonIterableRest$3();
}

function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$9(arr) || _nonIterableSpread$2();
}

function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$9(arr);
}

function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray$2(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit$3(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$9(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$9(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen);
}

function _arrayLikeToArray$9(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$9(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) {
      _defineProperty$7(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof$4(obj) {
  "@babel/helpers - typeof";

  return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$4(obj);
}

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$3(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty$7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$8(arr, i) || _nonIterableRest$2();
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$8(arr) || _nonIterableSpread$1();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$8(arr);
}

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit$2(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$8(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$8(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen);
}

function _arrayLikeToArray$8(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
!!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var MUTATION_APPROACH_ASYNC = 'async';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION$1 = function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
}();
var PREFIX_TO_STYLE = {
  'fas': 'solid',
  'fa-solid': 'solid',
  'far': 'regular',
  'fa-regular': 'regular',
  'fal': 'light',
  'fa-light': 'light',
  'fat': 'thin',
  'fa-thin': 'thin',
  'fad': 'duotone',
  'fa-duotone': 'duotone',
  'fab': 'brands',
  'fa-brands': 'brands',
  'fak': 'kit',
  'fa-kit': 'kit',
  'fa': 'solid'
};
var STYLE_TO_PREFIX = {
  'solid': 'fas',
  'regular': 'far',
  'light': 'fal',
  'thin': 'fat',
  'duotone': 'fad',
  'brands': 'fab',
  'kit': 'fak'
};
var PREFIX_TO_LONG_STYLE = {
  'fab': 'fa-brands',
  'fad': 'fa-duotone',
  'fak': 'fa-kit',
  'fal': 'fa-light',
  'far': 'fa-regular',
  'fas': 'fa-solid',
  'fat': 'fa-thin'
};
var LONG_STYLE_TO_PREFIX = {
  'fa-brands': 'fab',
  'fa-duotone': 'fad',
  'fa-kit': 'fak',
  'fa-light': 'fal',
  'fa-regular': 'far',
  'fa-solid': 'fas',
  'fa-thin': 'fat'
};
var ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk\-\ ]/; // eslint-disable-line no-useless-escape

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?

var FONT_WEIGHT_TO_PREFIX = {
  '900': 'fas',
  '400': 'far',
  'normal': 'far',
  '300': 'fal',
  '100': 'fat'
};
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
var DUOTONE_CLASSES = {
  GROUP: 'duotone-group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var RESERVED_CLASSES = [].concat(_toConsumableArray$1(Object.keys(STYLE_TO_PREFIX)), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
  return "".concat(n, "x");
})).concat(oneToTwenty.map(function (n) {
  return "w-".concat(n);
}));

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray$2(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  styleDefault: 'solid',
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread2$1(_objectSpread2$1({}, _default), initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_config).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;

      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);

  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = '';

  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }

  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";

function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var _cssInserted = false;

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css: css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = string.charCodeAt(counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      var extra = string.charCodeAt(counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }

  return output;
}

function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  var size = string.length;
  var first = string.charCodeAt(index);
  var second;

  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);

    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }

  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});
}

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2$1(_objectSpread2$1({}, namespace.styles[prefix] || {}), normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var styles = namespace.styles,
    shims = namespace.shims;
var LONG_STYLE = Object.values(PREFIX_TO_LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = Object.keys(PREFIX_TO_STYLE);

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function getIconName(familyPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'number';
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    acc[iconName] = iconName;

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'string';
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }

    return acc;
  });
  _byAlias = lookup(function (acc, icon, iconName) {
    var aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  }); // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.

  var hasRegular = 'far' in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault);
};
onChange(function (c) {
  _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault);
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var style = PREFIX_TO_STYLE[styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[styleOrPrefix] || STYLE_TO_PREFIX[style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
function getCanonicalIcon(values) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
      skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var givenPrefix = null;
  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.familyPrefix, cls);

    if (styles[cls]) {
      cls = LONG_STYLE.includes(cls) ? LONG_STYLE_TO_PREFIX[cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES.indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls);
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass) {
      acc.rest.push(cls);
    }

    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);

      if (shim.prefix) {
        givenPrefix = null;
      }

      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;

      if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
        // Allow a fallback from the regular style to solid if regular is not available
        // but only if we aren't auto-fetching SVGs
        acc.prefix = 'fas';
      }
    }

    return acc;
  }, emptyCanonicalIcon());

  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }

  return canonical;
}

var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck$3(this, Library);

    this.definitions = {};
  }

  _createClass$3(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2$1(_objectSpread2$1({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]);
        var longPrefix = PREFIX_TO_LONG_STYLE[key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        var aliases = icon[2];
        if (!additions[prefix]) additions[prefix] = {};

        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === 'string') {
              additions[prefix][alias] = icon;
            }
          });
        }

        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  var obj = _ref.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k) {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });

  _plugins.forEach(function (plugin) {
    var mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(function (tk) {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }

      if (_typeof$4(mixout[tk]) === 'object') {
        Object.keys(mixout[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }

          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });

    if (plugin.hooks) {
      var hooks = plugin.hooks();
      Object.keys(hooks).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }

        _hooks[hook].push(hooks[hook]);
      });
    }

    if (plugin.provides) {
      plugin.provides(providers);
    }
  });

  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args)); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }

  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject('Operation requires a DOM of some kind.');
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;

    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
var parse$2 = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }

    if (_typeof$4(_icon) === 'object' && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }

    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix: prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }

    if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.familyPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }

    if (typeof _icon === 'string') {
      var _prefix = getDefaultUsablePrefix();

      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  parse: parse$2,
  library: library,
  findIconDefinition: findIconDefinition,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2$1(_objectSpread2$1({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2$1(_objectSpread2$1({}, attributes), {}, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : ''].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread2$1(_objectSpread2$1({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }

  var args = _objectSpread2$1(_objectSpread2$1({}, content), {}, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread2$1(_objectSpread2$1({}, uploadedIconWidthStyle), extra.styles)
  });

  var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  },
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

  var attributes = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _objectSpread2$1({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform: transform,
      startCentered: true,
      width: width,
      height: height
    });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;

  var attributes = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}

var styles$1 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray$2(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};

function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION$1 && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}

function findIcon(iconName, prefix) {
  var givenPrefix = prefix;

  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }

  return new Promise(function (resolve, reject) {
    ({
      found: false,
      width: 512,
      height: 512,
      icon: callProvided('missingIconAbstract') || {}
    });

    if (givenPrefix === 'fa') {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }

    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }

    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2$1(_objectSpread2$1({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = "FA \"6.1.1\"";

var begin = function begin(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};

var perf = {
  begin: begin,
  end: end
};

var noop$2 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}

function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}

function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}

function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}

function createElement(tag) {
  return DOCUMENT.createElement(tag);
}

function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
      ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;

  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }

  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn: ceFn
    }));
  });
  return tag;
}

function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */

  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */

  return comment;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];

    if (node.parentNode) {
      mutation[1].forEach(function (abstract) {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });

      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement

    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
    delete abstract[0].attributes.id;

    if (abstract[0].attributes.class) {
      var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }

        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(' ');

      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }

    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function performOperationSync(op) {
  op();
}

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$2;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;

    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var _options$treeCallback = options.treeCallback,
      treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
      _options$nodeCallback = options.nodeCallback,
      nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
      _options$pseudoElemen = options.pseudoElementsCallback,
      pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  var style = node.getAttribute('style');
  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
}

function classParser (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  var val = getCanonicalIcon(classArray(node));

  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.iconName && val.prefix) {
    return val;
  }

  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }

  return val;
}

function attributesParser (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }

    return acc;
  }, {});
  var title = node.getAttribute('title');
  var titleId = node.getAttribute('data-fa-title-id');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }

  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };

  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2$1({
    iconName: iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix: prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

var styles$2 = namespace.styles;

function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;

  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$2);
  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
    return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }

  var candidates = [];

  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e) {// noop
  }

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }

  var mark = perf.begin('onTree');
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION$1) {
        if (e.name === 'MissingIcon') {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);
  return new Promise(function (resolve, reject) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(function (e) {
      mark();
      reject(e);
    });
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread2$1(_objectSpread2$1({}, params), {}, {
      mask: mask
    }));
  };
}

var render$v = function render(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return domVariants(_objectSpread2$1({
    type: 'icon'
  }, iconDefinition), function () {
    callHooks('beforeDOMElementCreation', {
      iconDefinition: iconDefinition,
      params: params
    });

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout() {
    return {
      icon: resolveIcons(render$v)
    };
  },
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node, callback);
    };

    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      var iconName = nodeMeta.iconName,
          title = nodeMeta.title,
          titleId = nodeMeta.titleId,
          prefix = nodeMeta.prefix,
          transform = nodeMeta.transform,
          symbol = nodeMeta.symbol,
          mask = nodeMeta.mask,
          maskId = nodeMeta.maskId,
          extra = nodeMeta.extra;
      return new Promise(function (resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref) {
          var _ref2 = _slicedToArray$2(_ref, 2),
              main = _ref2[0],
              mask = _ref2[1];

          resolve([node, makeInlineSvgAbstract({
            icons: {
              main: main,
              mask: mask
            },
            prefix: prefix,
            iconName: iconName,
            transform: transform,
            symbol: symbol,
            maskId: maskId,
            title: title,
            titleId: titleId,
            extra: extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };

    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
          attributes = _ref3.attributes,
          main = _ref3.main,
          transform = _ref3.transform,
          styles = _ref3.styles;
      var styleString = joinStyles(styles);

      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }

      var nextChild;

      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main: main,
          transform: transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }

      children.push(nextChild || main.icon);
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var Layers = {
  mixout: function mixout() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: 'layer'
        }, function () {
          callHooks('beforeDOMElementCreation', {
            assembler: assembler,
            params: params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a) {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.familyPrefix, "-layers")].concat(_toConsumableArray$1(classes)).join(' ')
            },
            children: children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout: function mixout() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'counter',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray$1(classes))
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout: function mixout() {
    return {
      text: function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform,
            transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
            _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'text',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersTextAbstract({
            content: content,
            transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), transform),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray$1(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      var title = nodeMeta.title,
          transform = nodeMeta.transform,
          extra = nodeMeta.extra;
      var width = null;
      var height = null;

      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }

      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }

      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width: width,
        height: height,
        transform: transform,
        title: title,
        extra: extra,
        watchable: true
      })]);
    };
  }
};

var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}

function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise(function (resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }

    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
    var fontWeight = styles.getPropertyValue('font-weight');
    var content = styles.getPropertyValue('content');

    if (alreadyProcessedPseudoElement && !fontFamily) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== 'none' && content !== '') {
      var _content = styles.getPropertyValue('content');

      var prefix = ~['Solid', 'Regular', 'Light', 'Thin', 'Duotone', 'Brands', 'Kit'].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];

      var _hexValueFromContent = hexValueFromContent(_content),
          hexValue = _hexValueFromContent.value,
          isSecondary = _hexValueFromContent.isSecondary;

      var isV4 = fontFamily[0].startsWith('FontAwesome');
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;

      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);

        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName


      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);

        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }

        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var abstract = makeInlineSvgAbstract(_objectSpread2$1(_objectSpread2$1({}, meta), {}, {
            icons: {
              main: main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix,
            iconName: iconIdentifier,
            extra: extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement('svg');

          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }

          element.outerHTML = abstract.map(function (a) {
            return toHtml(a);
          }).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

function replace(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}

function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject) {
    var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    var end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(function () {
      end();
      enableObservation();
      resolve();
    }).catch(function () {
      end();
      enableObservation();
      reject();
    });
  });
}

var PseudoElements = {
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node;

      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto: function noAuto() {
        disconnect();
      },
      watch: function watch(params) {
        var observeMutationsRoot = params.observeMutationsRoot;

        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot: observeMutationsRoot
          }));
        }
      }
    };
  }
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
    var parts = n.toLowerCase().split('-');
    var first = parts[0];
    var rest = parts.slice(1).join('-');

    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }

    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }

    rest = parseFloat(rest);

    if (isNaN(rest)) {
      return acc;
    }

    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;

      case 'shrink':
        acc.size = acc.size - rest;
        break;

      case 'left':
        acc.x = acc.x - rest;
        break;

      case 'right':
        acc.x = acc.x + rest;
        break;

      case 'up':
        acc.y = acc.y - rest;
        break;

      case 'down':
        acc.y = acc.y + rest;
        break;

      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }

    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute('data-fa-transform');

        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }

        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      var main = _ref.main,
          transform = _ref.transform,
          containerWidth = _ref.containerWidth,
          iconWidth = _ref.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer: outer,
        inner: inner,
        path: path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2$1({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2$1({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2$1(_objectSpread2$1({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

var Masks = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute('data-fa-mask');
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function (i) {
          return i.trim();
        }));

        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }

        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      var children = _ref.children,
          attributes = _ref.attributes,
          main = _ref.main,
          mask = _ref.mask,
          explicitMaskId = _ref.maskId,
          transform = _ref.transform;
      var mainWidth = main.width,
          mainPath = main.icon;
      var maskWidth = mask.width,
          maskPath = mask.icon;
      var trans = transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: 'rect',
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2$1({}, trans.inner),
        children: [fillBlack(_objectSpread2$1({
          tag: mainPath.tag,
          attributes: _objectSpread2$1(_objectSpread2$1({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2$1({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: 'mask',
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2$1({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides: function provides(providers) {
    var reduceMotion = false;

    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    providers.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: 'currentColor'
      };
      var ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      }; // Ring

      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });

      var OPACITY_ANIMATE = _objectSpread2$1(_objectSpread2$1({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });

      var dot = {
        tag: 'circle',
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };

      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2$1(_objectSpread2$1({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }

      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });

      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }

      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute('data-fa-symbol');
        var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
api.dom;
var parse$1$1 = api.parse;
api.findIconDefinition;
api.toHtml;
var icon = api.icon;
api.layer;
var text = api.text;
api.counter;

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) {
      _defineProperty$6(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof$3(obj) {
  "@babel/helpers - typeof";

  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$3(obj);
}

function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$7(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$7(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray$7(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$7(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen);
}

function _arrayLikeToArray$7(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var humps$1 = {exports: {}};

(function (module) {
(function(global) {

	  var _processKeys = function(convert, obj, options) {
	    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
	      return obj;
	    }

	    var output,
	        i = 0,
	        l = 0;

	    if(_isArray(obj)) {
	      output = [];
	      for(l=obj.length; i<l; i++) {
	        output.push(_processKeys(convert, obj[i], options));
	      }
	    }
	    else {
	      output = {};
	      for(var key in obj) {
	        if(Object.prototype.hasOwnProperty.call(obj, key)) {
	          output[convert(key, options)] = _processKeys(convert, obj[key], options);
	        }
	      }
	    }
	    return output;
	  };

	  // String conversion methods

	  var separateWords = function(string, options) {
	    options = options || {};
	    var separator = options.separator || '_';
	    var split = options.split || /(?=[A-Z])/;

	    return string.split(split).join(separator);
	  };

	  var camelize = function(string) {
	    if (_isNumerical(string)) {
	      return string;
	    }
	    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
	      return chr ? chr.toUpperCase() : '';
	    });
	    // Ensure 1st char is always lowercase
	    return string.substr(0, 1).toLowerCase() + string.substr(1);
	  };

	  var pascalize = function(string) {
	    var camelized = camelize(string);
	    // Ensure 1st char is always uppercase
	    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
	  };

	  var decamelize = function(string, options) {
	    return separateWords(string, options).toLowerCase();
	  };

	  // Utilities
	  // Taken from Underscore.js

	  var toString = Object.prototype.toString;

	  var _isFunction = function(obj) {
	    return typeof(obj) === 'function';
	  };
	  var _isObject = function(obj) {
	    return obj === Object(obj);
	  };
	  var _isArray = function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	  var _isDate = function(obj) {
	    return toString.call(obj) == '[object Date]';
	  };
	  var _isRegExp = function(obj) {
	    return toString.call(obj) == '[object RegExp]';
	  };
	  var _isBoolean = function(obj) {
	    return toString.call(obj) == '[object Boolean]';
	  };

	  // Performant way to determine if obj coerces to a number
	  var _isNumerical = function(obj) {
	    obj = obj - 0;
	    return obj === obj;
	  };

	  // Sets up function which handles processing keys
	  // allowing the convert function to be modified by a callback
	  var _processor = function(convert, options) {
	    var callback = options && 'process' in options ? options.process : options;

	    if(typeof(callback) !== 'function') {
	      return convert;
	    }

	    return function(string, options) {
	      return callback(string, convert, options);
	    }
	  };

	  var humps = {
	    camelize: camelize,
	    decamelize: decamelize,
	    pascalize: pascalize,
	    depascalize: decamelize,
	    camelizeKeys: function(object, options) {
	      return _processKeys(_processor(camelize, options), object);
	    },
	    decamelizeKeys: function(object, options) {
	      return _processKeys(_processor(decamelize, options), object, options);
	    },
	    pascalizeKeys: function(object, options) {
	      return _processKeys(_processor(pascalize, options), object);
	    },
	    depascalizeKeys: function () {
	      return this.decamelizeKeys.apply(this, arguments);
	    }
	  };

	  if (module.exports) {
	    module.exports = humps;
	  } else {
	    global.humps = humps;
	  }

	})(commonjsGlobal$1);
} (humps$1));

var humps = humps$1.exports;

var _excluded = ["class", "style"];
/**
 * Converts a CSS style into a plain Javascript object.
 * @param {String} style The style to converts into a plain Javascript object.
 * @returns {Object}
 */

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (output, pair) {
    var idx = pair.indexOf(':');
    var prop = humps.camelize(pair.slice(0, idx));
    var value = pair.slice(idx + 1).trim();
    output[prop] = value;
    return output;
  }, {});
}
/**
 * Converts a CSS class list into a plain Javascript object.
 * @param {Array<String>} classes The class list to convert.
 * @returns {Object}
 */


function classToObject(classes) {
  return classes.split(/\s+/).reduce(function (output, className) {
    output[className] = true;
    return output;
  }, {});
}
/**
 * Converts a FontAwesome abstract element of an icon into a Vue VNode.
 * @param {AbstractElement | String} abstractElement The element to convert.
 * @param {Object} props The user-defined props.
 * @param {Object} attrs The user-defined native HTML attributes.
 * @returns {VNode}
 */


function convert(abstractElement) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // If the abstract element is a string, we'll just return a string render function
  if (typeof abstractElement === 'string') {
    return abstractElement;
  } // Converting abstract element children into Vue VNodes


  var children = (abstractElement.children || []).map(function (child) {
    return convert(child);
  }); // Converting abstract element attributes into valid Vue format

  var mixins = Object.keys(abstractElement.attributes || {}).reduce(function (mixins, key) {
    var value = abstractElement.attributes[key];

    switch (key) {
      case 'class':
        mixins.class = classToObject(value);
        break;

      case 'style':
        mixins.style = styleToObject(value);
        break;

      default:
        mixins.attrs[key] = value;
    }

    return mixins;
  }, {
    attrs: {},
    class: {},
    style: {}
  }); // Now, we'll return the VNode

  attrs.class;
      var _attrs$style = attrs.style,
      aStyle = _attrs$style === void 0 ? {} : _attrs$style,
      otherAttrs = _objectWithoutProperties(attrs, _excluded);

  return h(abstractElement.tag, _objectSpread2(_objectSpread2(_objectSpread2({}, props), {}, {
    class: mixins.class,
    style: _objectSpread2(_objectSpread2({}, mixins.style), aStyle)
  }, mixins.attrs), otherAttrs), children);
}

var PRODUCTION = false;

try {
  PRODUCTION = "production" === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty$6({}, key, value) : {};
}
function classList(props) {
  var _classes;

  var classes = (_classes = {
    'fa-spin': props.spin,
    'fa-pulse': props.pulse,
    'fa-fw': props.fixedWidth,
    'fa-border': props.border,
    'fa-li': props.listItem,
    'fa-inverse': props.inverse,
    'fa-flip': props.flip === true,
    'fa-flip-horizontal': props.flip === 'horizontal' || props.flip === 'both',
    'fa-flip-vertical': props.flip === 'vertical' || props.flip === 'both'
  }, _defineProperty$6(_classes, "fa-".concat(props.size), props.size !== null), _defineProperty$6(_classes, "fa-rotate-".concat(props.rotation), props.rotation !== null), _defineProperty$6(_classes, "fa-pull-".concat(props.pull), props.pull !== null), _defineProperty$6(_classes, 'fa-swap-opacity', props.swapOpacity), _defineProperty$6(_classes, 'fa-bounce', props.bounce), _defineProperty$6(_classes, 'fa-shake', props.shake), _defineProperty$6(_classes, 'fa-beat', props.beat), _defineProperty$6(_classes, 'fa-fade', props.fade), _defineProperty$6(_classes, 'fa-beat-fade', props.beatFade), _defineProperty$6(_classes, 'fa-flash', props.flash), _defineProperty$6(_classes, 'fa-spin-pulse', props.spinPulse), _defineProperty$6(_classes, 'fa-spin-reverse', props.spinReverse), _classes);
  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

function normalizeIconArgs(icon) {
  if (icon && _typeof$3(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (parse$1$1.icon) {
    return parse$1$1.icon(icon);
  }

  if (icon === null) {
    return null;
  }

  if (_typeof$3(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  }

  if (Array.isArray(icon) && icon.length === 2) {
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  }

  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

var FontAwesomeIcon = defineComponent({
  name: 'FontAwesomeIcon',
  props: {
    border: {
      type: Boolean,
      default: false
    },
    fixedWidth: {
      type: Boolean,
      default: false
    },
    flip: {
      type: [Boolean, String],
      default: false,
      validator: function validator(value) {
        return [true, false, 'horizontal', 'vertical', 'both'].indexOf(value) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: true
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    listItem: {
      type: Boolean,
      default: false
    },
    pull: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['right', 'left'].indexOf(value) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: false
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function validator(value) {
        return [90, 180, 270].indexOf(Number.parseInt(value, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x'].indexOf(value) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: false
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: false
    },
    title: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: false
    },
    bounce: {
      type: Boolean,
      default: false
    },
    shake: {
      type: Boolean,
      default: false
    },
    beat: {
      type: Boolean,
      default: false
    },
    fade: {
      type: Boolean,
      default: false
    },
    beatFade: {
      type: Boolean,
      default: false
    },
    flash: {
      type: Boolean,
      default: false
    },
    spinPulse: {
      type: Boolean,
      default: false
    },
    spinReverse: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, _ref) {
    var attrs = _ref.attrs;
    var icon$1 = computed(function () {
      return normalizeIconArgs(props.icon);
    });
    var classes = computed(function () {
      return objectWithKey('classes', classList(props));
    });
    var transform = computed(function () {
      return objectWithKey('transform', typeof props.transform === 'string' ? parse$1$1.transform(props.transform) : props.transform);
    });
    var mask = computed(function () {
      return objectWithKey('mask', normalizeIconArgs(props.mask));
    });
    var renderedIcon = computed(function () {
      return icon(icon$1.value, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes.value), transform.value), mask.value), {}, {
        symbol: props.symbol,
        title: props.title
      }));
    });
    watch(renderedIcon, function (value) {
      if (!value) {
        return log('Could not find one or more icon(s)', icon$1.value, mask.value);
      }
    }, {
      immediate: true
    });
    var vnode = computed(function () {
      return renderedIcon.value ? convert(renderedIcon.value.abstract[0], {}, attrs) : null;
    });
    return function () {
      return vnode.value;
    };
  }
});

defineComponent({
  name: 'FontAwesomeLayers',
  props: {
    fixedWidth: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, _ref) {
    var slots = _ref.slots;
    var familyPrefix = config$1.familyPrefix;
    var className = computed(function () {
      return ["".concat(familyPrefix, "-layers")].concat(_toConsumableArray(props.fixedWidth ? ["".concat(familyPrefix, "-fw")] : []));
    });
    return function () {
      return h('div', {
        class: className.value
      }, slots.default ? slots.default() : []);
    };
  }
});

defineComponent({
  name: 'FontAwesomeLayersText',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['bottom-left', 'bottom-right', 'top-left', 'top-right'].indexOf(value) > -1;
      }
    }
  },
  setup: function setup(props, _ref) {
    var attrs = _ref.attrs;
    var familyPrefix = config$1.familyPrefix;
    var classes = computed(function () {
      return objectWithKey('classes', [].concat(_toConsumableArray(props.counter ? ["".concat(familyPrefix, "-layers-counter")] : []), _toConsumableArray(props.position ? ["".concat(familyPrefix, "-layers-").concat(props.position)] : [])));
    });
    var transform = computed(function () {
      return objectWithKey('transform', typeof props.transform === 'string' ? parse$1$1.transform(props.transform) : props.transform);
    });
    var abstractElement = computed(function () {
      var _text = text(props.value.toString(), _objectSpread2(_objectSpread2({}, transform.value), classes.value)),
          abstract = _text.abstract;

      if (props.counter) {
        abstract[0].attributes.class = abstract[0].attributes.class.replace('fa-layers-text', '');
      }

      return abstract[0];
    });
    var vnode = computed(function () {
      return convert(abstractElement.value, {}, attrs);
    });
    return function () {
      return vnode.value;
    };
  }
});

/*!
  * shared v9.2.0
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */
/**
 * Original Utilities
 * written by kazuya kawaguchi
 */
const inBrowser = typeof window !== 'undefined';
const hasSymbol = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
const makeSymbol = (name) => hasSymbol ? Symbol(name) : name;
const generateFormatCacheKey = (locale, key, source) => friendlyJSONstringify({ l: locale, k: key, s: source });
const friendlyJSONstringify = (json) => JSON.stringify(json)
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
    .replace(/\u0027/g, '\\u0027');
const isNumber$1 = (val) => typeof val === 'number' && isFinite(val);
const isDate = (val) => toTypeString(val) === '[object Date]';
const isRegExp = (val) => toTypeString(val) === '[object RegExp]';
const isEmptyObject = (val) => isPlainObject$1(val) && Object.keys(val).length === 0;
function warn(msg, err) {
    if (typeof console !== 'undefined') {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */
        if (err) {
            console.warn(err.stack);
        }
    }
}
const assign = Object.assign;
let _globalThis;
const getGlobalThis = () => {
    // prettier-ignore
    return (_globalThis ||
        (_globalThis =
            typeof globalThis !== 'undefined'
                ? globalThis
                : typeof self !== 'undefined'
                    ? self
                    : typeof window !== 'undefined'
                        ? window
                        : typeof global !== 'undefined'
                            ? global
                            : {}));
};
function escapeHtml(rawText) {
    return rawText
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
}
const hasOwnProperty$b = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return hasOwnProperty$b.call(obj, key);
}
/* eslint-enable */
/**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */
const isArray$1 = Array.isArray;
const isFunction$1 = (val) => typeof val === 'function';
const isString = (val) => typeof val === 'string';
const isBoolean = (val) => typeof val === 'boolean';
const isObject$2 = (val) => // eslint-disable-line
 val !== null && typeof val === 'object';
const objectToString$1 = Object.prototype.toString;
const toTypeString = (value) => objectToString$1.call(value);
const isPlainObject$1 = (val) => toTypeString(val) === '[object Object]';
// for converting list and named values to displayed strings.
const toDisplayString = (val) => {
    return val == null
        ? ''
        : isArray$1(val) || (isPlainObject$1(val) && val.toString === objectToString$1)
            ? JSON.stringify(val, null, 2)
            : String(val);
};

/*!
  * message-compiler v9.2.0
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */

const CompileErrorCodes = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // Special value for higher-order compilers to pick up the last code
    // to avoid collision of error codes. This should always be kept as the last
    // item.
    __EXTEND_POINT__: 15
};
function createCompileError(code, loc, options = {}) {
    const { domain, messages, args } = options;
    const msg = code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) {
        error.location = loc;
    }
    error.domain = domain;
    return error;
}
/** @internal */
function defaultOnError(error) {
    throw error;
}
function createPosition(line, column, offset) {
    return { line, column, offset };
}
function createLocation(start, end, source) {
    const loc = { start, end };
    if (source != null) {
        loc.source = source;
    }
    return loc;
}

const CHAR_SP = ' ';
const CHAR_CR = '\r';
const CHAR_LF = '\n';
const CHAR_LS = String.fromCharCode(0x2028);
const CHAR_PS = String.fromCharCode(0x2029);
function createScanner(str) {
    const _buf = str;
    let _index = 0;
    let _line = 1;
    let _column = 1;
    let _peekOffset = 0;
    const isCRLF = (index) => _buf[index] === CHAR_CR && _buf[index + 1] === CHAR_LF;
    const isLF = (index) => _buf[index] === CHAR_LF;
    const isPS = (index) => _buf[index] === CHAR_PS;
    const isLS = (index) => _buf[index] === CHAR_LS;
    const isLineEnd = (index) => isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    const index = () => _index;
    const line = () => _line;
    const column = () => _column;
    const peekOffset = () => _peekOffset;
    const charAt = (offset) => isCRLF(offset) || isPS(offset) || isLS(offset) ? CHAR_LF : _buf[offset];
    const currentChar = () => charAt(_index);
    const currentPeek = () => charAt(_index + _peekOffset);
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) {
            _index++;
        }
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) {
            _peekOffset++;
        }
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek(offset = 0) {
        _peekOffset = offset;
    }
    function skipToPeek() {
        const target = _index + _peekOffset;
        // eslint-disable-next-line no-unmodified-loop-condition
        while (target !== _index) {
            next();
        }
        _peekOffset = 0;
    }
    return {
        index,
        line,
        column,
        peekOffset,
        charAt,
        currentChar,
        currentPeek,
        next,
        peek,
        reset,
        resetPeek,
        skipToPeek
    };
}

const EOF = undefined;
const LITERAL_DELIMITER = "'";
const ERROR_DOMAIN$1 = 'tokenizer';
function createTokenizer(source, options = {}) {
    const location = options.location !== false;
    const _scnr = createScanner(source);
    const currentOffset = () => _scnr.index();
    const currentPosition = () => createPosition(_scnr.line(), _scnr.column(), _scnr.index());
    const _initLoc = currentPosition();
    const _initOffset = currentOffset();
    const _context = {
        currentType: 14 /* EOF */,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 14 /* EOF */,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ''
    };
    const context = () => _context;
    const { onError } = options;
    function emitError(code, pos, offset, ...args) {
        const ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            const loc = createLocation(ctx.startLoc, pos);
            const err = createCompileError(code, loc, {
                domain: ERROR_DOMAIN$1,
                args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        const token = { type };
        if (location) {
            token.loc = createLocation(context.startLoc, context.endLoc);
        }
        if (value != null) {
            token.value = value;
        }
        return token;
    }
    const getEndToken = (context) => getToken(context, 14 /* EOF */);
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        }
        else {
            emitError(CompileErrorCodes.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return '';
        }
    }
    function peekSpaces(scnr) {
        let buf = '';
        while (scnr.currentPeek() === CHAR_SP || scnr.currentPeek() === CHAR_LF) {
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        const buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === EOF) {
            return false;
        }
        const cc = ch.charCodeAt(0);
        return ((cc >= 97 && cc <= 122) || // a-z
            (cc >= 65 && cc <= 90) || // A-Z
            cc === 95 // _
        );
    }
    function isNumberStart(ch) {
        if (ch === EOF) {
            return false;
        }
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ch = scnr.currentPeek() === '-' ? scnr.peek() : scnr.currentPeek();
        const ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 8 /* LinkedAlias */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "." /* LinkedDot */;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 9 /* LinkedDot */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        const { currentType } = context;
        if (!(currentType === 8 /* LinkedAlias */ ||
            currentType === 12 /* LinkedModifier */)) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === ":" /* LinkedDelimiter */;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 10 /* LinkedDelimiter */) {
            return false;
        }
        const fn = () => {
            const ch = scnr.currentPeek();
            if (ch === "{" /* BraceLeft */) {
                return isIdentifierStart(scnr.peek());
            }
            else if (ch === "@" /* LinkedAlias */ ||
                ch === "%" /* Modulo */ ||
                ch === "|" /* Pipe */ ||
                ch === ":" /* LinkedDelimiter */ ||
                ch === "." /* LinkedDot */ ||
                ch === CHAR_SP ||
                !ch) {
                return false;
            }
            else if (ch === CHAR_LF) {
                scnr.peek();
                return fn();
            }
            else {
                // other characters
                return isIdentifierStart(ch);
            }
        };
        const ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "|" /* Pipe */;
        scnr.resetPeek();
        return ret;
    }
    function detectModuloStart(scnr) {
        const spaces = peekSpaces(scnr);
        const ret = scnr.currentPeek() === "%" /* Modulo */ &&
            scnr.peek() === "{" /* BraceLeft */;
        scnr.resetPeek();
        return {
            isModulo: ret,
            hasSpace: spaces.length > 0
        };
    }
    function isTextStart(scnr, reset = true) {
        const fn = (hasSpace = false, prev = '', detectModulo = false) => {
            const ch = scnr.currentPeek();
            if (ch === "{" /* BraceLeft */) {
                return prev === "%" /* Modulo */ ? false : hasSpace;
            }
            else if (ch === "@" /* LinkedAlias */ || !ch) {
                return prev === "%" /* Modulo */ ? true : hasSpace;
            }
            else if (ch === "%" /* Modulo */) {
                scnr.peek();
                return fn(hasSpace, "%" /* Modulo */, true);
            }
            else if (ch === "|" /* Pipe */) {
                return prev === "%" /* Modulo */ || detectModulo
                    ? true
                    : !(prev === CHAR_SP || prev === CHAR_LF);
            }
            else if (ch === CHAR_SP) {
                scnr.peek();
                return fn(true, CHAR_SP, detectModulo);
            }
            else if (ch === CHAR_LF) {
                scnr.peek();
                return fn(true, CHAR_LF, detectModulo);
            }
            else {
                return true;
            }
        };
        const ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        const ch = scnr.currentChar();
        if (ch === EOF) {
            return EOF;
        }
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function takeIdentifierChar(scnr) {
        const closure = (ch) => {
            const cc = ch.charCodeAt(0);
            return ((cc >= 97 && cc <= 122) || // a-z
                (cc >= 65 && cc <= 90) || // A-Z
                (cc >= 48 && cc <= 57) || // 0-9
                cc === 95 || // _
                cc === 36 // $
            );
        };
        return takeChar(scnr, closure);
    }
    function takeDigit(scnr) {
        const closure = (ch) => {
            const cc = ch.charCodeAt(0);
            return cc >= 48 && cc <= 57; // 0-9
        };
        return takeChar(scnr, closure);
    }
    function takeHexDigit(scnr) {
        const closure = (ch) => {
            const cc = ch.charCodeAt(0);
            return ((cc >= 48 && cc <= 57) || // 0-9
                (cc >= 65 && cc <= 70) || // A-F
                (cc >= 97 && cc <= 102)); // a-f
        };
        return takeChar(scnr, closure);
    }
    function getDigits(scnr) {
        let ch = '';
        let num = '';
        while ((ch = takeDigit(scnr))) {
            num += ch;
        }
        return num;
    }
    function readModulo(scnr) {
        skipSpaces(scnr);
        const ch = scnr.currentChar();
        if (ch !== "%" /* Modulo */) {
            emitError(CompileErrorCodes.EXPECTED_TOKEN, currentPosition(), 0, ch);
        }
        scnr.next();
        return "%" /* Modulo */;
    }
    function readText(scnr) {
        let buf = '';
        while (true) {
            const ch = scnr.currentChar();
            if (ch === "{" /* BraceLeft */ ||
                ch === "}" /* BraceRight */ ||
                ch === "@" /* LinkedAlias */ ||
                ch === "|" /* Pipe */ ||
                !ch) {
                break;
            }
            else if (ch === "%" /* Modulo */) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                }
                else {
                    break;
                }
            }
            else if (ch === CHAR_SP || ch === CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                }
                else if (isPluralStart(scnr)) {
                    break;
                }
                else {
                    buf += ch;
                    scnr.next();
                }
            }
            else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let name = '';
        while ((ch = takeIdentifierChar(scnr))) {
            name += ch;
        }
        if (scnr.currentChar() === EOF) {
            emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        }
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        let value = '';
        if (scnr.currentChar() === '-') {
            scnr.next();
            value += `-${getDigits(scnr)}`;
        }
        else {
            value += getDigits(scnr);
        }
        if (scnr.currentChar() === EOF) {
            emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        }
        return value;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        eat(scnr, `\'`);
        let ch = '';
        let literal = '';
        const fn = (x) => x !== LITERAL_DELIMITER && x !== CHAR_LF;
        while ((ch = takeChar(scnr, fn))) {
            if (ch === '\\') {
                literal += readEscapeSequence(scnr);
            }
            else {
                literal += ch;
            }
        }
        const current = scnr.currentChar();
        if (current === CHAR_LF || current === EOF) {
            emitError(CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === CHAR_LF) {
                scnr.next();
                eat(scnr, `\'`);
            }
            return literal;
        }
        eat(scnr, `\'`);
        return literal;
    }
    function readEscapeSequence(scnr) {
        const ch = scnr.currentChar();
        switch (ch) {
            case '\\':
            case `\'`:
                scnr.next();
                return `\\${ch}`;
            case 'u':
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case 'U':
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError(CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return '';
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        let sequence = '';
        for (let i = 0; i < digits; i++) {
            const ch = takeHexDigit(scnr);
            if (!ch) {
                emitError(CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
                break;
            }
            sequence += ch;
        }
        return `\\${unicode}${sequence}`;
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let identifiers = '';
        const closure = (ch) => ch !== "{" /* BraceLeft */ &&
            ch !== "}" /* BraceRight */ &&
            ch !== CHAR_SP &&
            ch !== CHAR_LF;
        while ((ch = takeChar(scnr, closure))) {
            identifiers += ch;
        }
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        let ch = '';
        let name = '';
        while ((ch = takeIdentifierChar(scnr))) {
            name += ch;
        }
        return name;
    }
    function readLinkedRefer(scnr) {
        const fn = (detect = false, buf) => {
            const ch = scnr.currentChar();
            if (ch === "{" /* BraceLeft */ ||
                ch === "%" /* Modulo */ ||
                ch === "@" /* LinkedAlias */ ||
                ch === "|" /* Pipe */ ||
                !ch) {
                return buf;
            }
            else if (ch === CHAR_SP) {
                return buf;
            }
            else if (ch === CHAR_LF) {
                buf += ch;
                scnr.next();
                return fn(detect, buf);
            }
            else {
                buf += ch;
                scnr.next();
                return fn(true, buf);
            }
        };
        return fn(false, '');
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        const plural = eat(scnr, "|" /* Pipe */);
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        let token = null;
        const ch = scnr.currentChar();
        switch (ch) {
            case "{" /* BraceLeft */:
                if (context.braceNest >= 1) {
                    emitError(CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                }
                scnr.next();
                token = getToken(context, 2 /* BraceLeft */, "{" /* BraceLeft */);
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* BraceRight */:
                if (context.braceNest > 0 &&
                    context.currentType === 2 /* BraceLeft */) {
                    emitError(CompileErrorCodes.EMPTY_PLACEHOLDER, currentPosition(), 0);
                }
                scnr.next();
                token = getToken(context, 3 /* BraceRight */, "}" /* BraceRight */);
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) {
                    context.inLinked = false;
                }
                return token;
            case "@" /* LinkedAlias */:
                if (context.braceNest > 0) {
                    emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                }
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default:
                let validNamedIdentifier = true;
                let validListIdentifier = true;
                let validLiteral = true;
                if (isPluralStart(scnr)) {
                    if (context.braceNest > 0) {
                        emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    }
                    token = getToken(context, 1 /* Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (context.braceNest > 0 &&
                    (context.currentType === 5 /* Named */ ||
                        context.currentType === 6 /* List */ ||
                        context.currentType === 7 /* Literal */)) {
                    emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    context.braceNest = 0;
                    return readToken(scnr, context);
                }
                if ((validNamedIdentifier = isNamedIdentifierStart(scnr, context))) {
                    token = getToken(context, 5 /* Named */, readNamedIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if ((validListIdentifier = isListIdentifierStart(scnr, context))) {
                    token = getToken(context, 6 /* List */, readListIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if ((validLiteral = isLiteralStart(scnr, context))) {
                    token = getToken(context, 7 /* Literal */, readLiteral(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                    // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                    token = getToken(context, 13 /* InvalidPlace */, readInvalidIdentifier(scnr));
                    emitError(CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                    skipSpaces(scnr);
                    return token;
                }
                break;
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        const { currentType } = context;
        let token = null;
        const ch = scnr.currentChar();
        if ((currentType === 8 /* LinkedAlias */ ||
            currentType === 9 /* LinkedDot */ ||
            currentType === 12 /* LinkedModifier */ ||
            currentType === 10 /* LinkedDelimiter */) &&
            (ch === CHAR_LF || ch === CHAR_SP)) {
            emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
        }
        switch (ch) {
            case "@" /* LinkedAlias */:
                scnr.next();
                token = getToken(context, 8 /* LinkedAlias */, "@" /* LinkedAlias */);
                context.inLinked = true;
                return token;
            case "." /* LinkedDot */:
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* LinkedDot */, "." /* LinkedDot */);
            case ":" /* LinkedDelimiter */:
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 10 /* LinkedDelimiter */, ":" /* LinkedDelimiter */);
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) ||
                    isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 12 /* LinkedModifier */, readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* BraceLeft */) {
                        // scan the placeholder
                        return readTokenInPlaceholder(scnr, context) || token;
                    }
                    else {
                        return getToken(context, 11 /* LinkedKey */, readLinkedRefer(scnr));
                    }
                }
                if (currentType === 8 /* LinkedAlias */) {
                    emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
                }
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        let token = { type: 14 /* EOF */ };
        if (context.braceNest > 0) {
            return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        }
        if (context.inLinked) {
            return readTokenInLinked(scnr, context) || getEndToken(context);
        }
        const ch = scnr.currentChar();
        switch (ch) {
            case "{" /* BraceLeft */:
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* BraceRight */:
                emitError(CompileErrorCodes.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* BraceRight */, "}" /* BraceRight */);
            case "@" /* LinkedAlias */:
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                const { isModulo, hasSpace } = detectModuloStart(scnr);
                if (isModulo) {
                    return hasSpace
                        ? getToken(context, 0 /* Text */, readText(scnr))
                        : getToken(context, 4 /* Modulo */, readModulo(scnr));
                }
                if (isTextStart(scnr)) {
                    return getToken(context, 0 /* Text */, readText(scnr));
                }
                break;
        }
        return token;
    }
    function nextToken() {
        const { currentType, offset, startLoc, endLoc } = _context;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === EOF) {
            return getToken(_context, 14 /* EOF */);
        }
        return readToken(_scnr, _context);
    }
    return {
        nextToken,
        currentOffset,
        currentPosition,
        context
    };
}

const ERROR_DOMAIN = 'parser';
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
const KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function fromEscapeSequence(match, codePoint4, codePoint6) {
    switch (match) {
        case `\\\\`:
            return `\\`;
        case `\\\'`:
            return `\'`;
        default: {
            const codePoint = parseInt(codePoint4 || codePoint6, 16);
            if (codePoint <= 0xd7ff || codePoint >= 0xe000) {
                return String.fromCodePoint(codePoint);
            }
            // invalid ...
            // Replace them with U+FFFD REPLACEMENT CHARACTER.
            return '�';
        }
    }
}
function createParser(options = {}) {
    const location = options.location !== false;
    const { onError } = options;
    function emitError(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            const loc = createLocation(start, end);
            const err = createCompileError(code, loc, {
                domain: ERROR_DOMAIN,
                args
            });
            onError(err);
        }
    }
    function startNode(type, offset, loc) {
        const node = {
            type,
            start: offset,
            end: offset
        };
        if (location) {
            node.loc = { start: loc, end: loc };
        }
        return node;
    }
    function endNode(node, offset, pos, type) {
        node.end = offset;
        if (type) {
            node.type = type;
        }
        if (location && node.loc) {
            node.loc.end = pos;
        }
    }
    function parseText(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(3 /* Text */, context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(5 /* List */, offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(4 /* Named */, offset, loc);
        node.key = key;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(9 /* Literal */, offset, loc);
        node.value = value.replace(KNOWN_ESCAPES, fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        const token = tokenizer.nextToken();
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get linked dot loc
        const node = startNode(8 /* LinkedModifier */, offset, loc);
        if (token.type !== 12 /* LinkedModifier */) {
            // empty modifier
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = '';
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node
            };
        }
        // check token
        if (token.value == null) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        node.value = token.value || '';
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(7 /* LinkedKey */, context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        const context = tokenizer.context();
        const linkedNode = startNode(6 /* Linked */, context.offset, context.startLoc);
        let token = tokenizer.nextToken();
        if (token.type === 9 /* LinkedDot */) {
            const parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 10 /* LinkedDelimiter */) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* BraceLeft */) {
            token = tokenizer.nextToken();
        }
        switch (token.type) {
            case 11 /* LinkedKey */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseLinkedKey(tokenizer, token.value || '');
                break;
            case 5 /* Named */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseNamed(tokenizer, token.value || '');
                break;
            case 6 /* List */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseList(tokenizer, token.value || '');
                break;
            case 7 /* Literal */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseLiteral(tokenizer, token.value || '');
                break;
            default:
                // empty key
                emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                const nextContext = tokenizer.context();
                const emptyLinkedKeyNode = startNode(7 /* LinkedKey */, nextContext.offset, nextContext.startLoc);
                emptyLinkedKeyNode.value = '';
                endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                linkedNode.key = emptyLinkedKeyNode;
                endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                return {
                    nextConsumeToken: token,
                    node: linkedNode
                };
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        const context = tokenizer.context();
        const startOffset = context.currentType === 1 /* Pipe */
            ? tokenizer.currentOffset()
            : context.offset;
        const startLoc = context.currentType === 1 /* Pipe */
            ? context.endLoc
            : context.startLoc;
        const node = startNode(2 /* Message */, startOffset, startLoc);
        node.items = [];
        let nextToken = null;
        do {
            const token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch (token.type) {
                case 0 /* Text */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseText(tokenizer, token.value || ''));
                    break;
                case 6 /* List */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseList(tokenizer, token.value || ''));
                    break;
                case 5 /* Named */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseNamed(tokenizer, token.value || ''));
                    break;
                case 7 /* Literal */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseLiteral(tokenizer, token.value || ''));
                    break;
                case 8 /* LinkedAlias */:
                    const parsed = parseLinked(tokenizer);
                    node.items.push(parsed.node);
                    nextToken = parsed.nextConsumeToken || null;
                    break;
            }
        } while (context.currentType !== 14 /* EOF */ &&
            context.currentType !== 1 /* Pipe */);
        // adjust message node loc
        const endOffset = context.currentType === 1 /* Pipe */
            ? context.lastOffset
            : tokenizer.currentOffset();
        const endLoc = context.currentType === 1 /* Pipe */
            ? context.lastEndLoc
            : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        const context = tokenizer.context();
        let hasEmptyMessage = msgNode.items.length === 0;
        const node = startNode(1 /* Plural */, offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            const msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) {
                hasEmptyMessage = msg.items.length === 0;
            }
            node.cases.push(msg);
        } while (context.currentType !== 14 /* EOF */);
        if (hasEmptyMessage) {
            emitError(tokenizer, CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        }
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        const context = tokenizer.context();
        const { offset, startLoc } = context;
        const msgNode = parseMessage(tokenizer);
        if (context.currentType === 14 /* EOF */) {
            return msgNode;
        }
        else {
            return parsePlural(tokenizer, offset, startLoc, msgNode);
        }
    }
    function parse(source) {
        const tokenizer = createTokenizer(source, assign({}, options));
        const context = tokenizer.context();
        const node = startNode(0 /* Resource */, context.offset, context.startLoc);
        if (location && node.loc) {
            node.loc.source = source;
        }
        node.body = parseResource(tokenizer);
        // assert whether achieved to EOF
        if (context.currentType !== 14 /* EOF */) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || '');
        }
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return { parse };
}
function getTokenCaption(token) {
    if (token.type === 14 /* EOF */) {
        return 'EOF';
    }
    const name = (token.value || '').replace(/\r?\n/gu, '\\n');
    return name.length > 10 ? name.slice(0, 9) + '…' : name;
}

function createTransformer(ast, options = {} // eslint-disable-line
) {
    const _context = {
        ast,
        helpers: new Set()
    };
    const context = () => _context;
    const helper = (name) => {
        _context.helpers.add(name);
        return name;
    };
    return { context, helper };
}
function traverseNodes(nodes, transformer) {
    for (let i = 0; i < nodes.length; i++) {
        traverseNode(nodes[i], transformer);
    }
}
function traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch (node.type) {
        case 1 /* Plural */:
            traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* PLURAL */);
            break;
        case 2 /* Message */:
            traverseNodes(node.items, transformer);
            break;
        case 6 /* Linked */:
            const linked = node;
            traverseNode(linked.key, transformer);
            transformer.helper("linked" /* LINKED */);
            transformer.helper("type" /* TYPE */);
            break;
        case 5 /* List */:
            transformer.helper("interpolate" /* INTERPOLATE */);
            transformer.helper("list" /* LIST */);
            break;
        case 4 /* Named */:
            transformer.helper("interpolate" /* INTERPOLATE */);
            transformer.helper("named" /* NAMED */);
            break;
    }
    // TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function transform(ast, options = {} // eslint-disable-line
) {
    const transformer = createTransformer(ast);
    transformer.helper("normalize" /* NORMALIZE */);
    // traverse
    ast.body && traverseNode(ast.body, transformer);
    // set meta information
    const context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}

function createCodeGenerator(ast, options) {
    const { sourceMap, filename, breakLineCode, needIndent: _needIndent } = options;
    const _context = {
        source: ast.loc.source,
        filename,
        code: '',
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    const context = () => _context;
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n, withBreakLine = true) {
        const _breakLineCode = withBreakLine ? breakLineCode : '';
        push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
    }
    function indent(withNewLine = true) {
        const level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent(withNewLine = true) {
        const level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    const helper = (key) => `_${key}`;
    const needIndent = () => _context.needIndent;
    return {
        context,
        push,
        indent,
        deindent,
        newline,
        helper,
        needIndent
    };
}
function generateLinkedNode(generator, node) {
    const { helper } = generator;
    generator.push(`${helper("linked" /* LINKED */)}(`);
    generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(`, `);
        generateNode(generator, node.modifier);
        generator.push(`, _type`);
    }
    else {
        generator.push(`, undefined, _type`);
    }
    generator.push(`)`);
}
function generateMessageNode(generator, node) {
    const { helper, needIndent } = generator;
    generator.push(`${helper("normalize" /* NORMALIZE */)}([`);
    generator.indent(needIndent());
    const length = node.items.length;
    for (let i = 0; i < length; i++) {
        generateNode(generator, node.items[i]);
        if (i === length - 1) {
            break;
        }
        generator.push(', ');
    }
    generator.deindent(needIndent());
    generator.push('])');
}
function generatePluralNode(generator, node) {
    const { helper, needIndent } = generator;
    if (node.cases.length > 1) {
        generator.push(`${helper("plural" /* PLURAL */)}([`);
        generator.indent(needIndent());
        const length = node.cases.length;
        for (let i = 0; i < length; i++) {
            generateNode(generator, node.cases[i]);
            if (i === length - 1) {
                break;
            }
            generator.push(', ');
        }
        generator.deindent(needIndent());
        generator.push(`])`);
    }
}
function generateResource(generator, node) {
    if (node.body) {
        generateNode(generator, node.body);
    }
    else {
        generator.push('null');
    }
}
function generateNode(generator, node) {
    const { helper } = generator;
    switch (node.type) {
        case 0 /* Resource */:
            generateResource(generator, node);
            break;
        case 1 /* Plural */:
            generatePluralNode(generator, node);
            break;
        case 2 /* Message */:
            generateMessageNode(generator, node);
            break;
        case 6 /* Linked */:
            generateLinkedNode(generator, node);
            break;
        case 8 /* LinkedModifier */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* LinkedKey */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* List */:
            generator.push(`${helper("interpolate" /* INTERPOLATE */)}(${helper("list" /* LIST */)}(${node.index}))`, node);
            break;
        case 4 /* Named */:
            generator.push(`${helper("interpolate" /* INTERPOLATE */)}(${helper("named" /* NAMED */)}(${JSON.stringify(node.key)}))`, node);
            break;
        case 9 /* Literal */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* Text */:
            generator.push(JSON.stringify(node.value), node);
            break;
    }
}
// generate code from AST
const generate = (ast, options = {} // eslint-disable-line
) => {
    const mode = isString(options.mode) ? options.mode : 'normal';
    const filename = isString(options.filename)
        ? options.filename
        : 'message.intl';
    const sourceMap = !!options.sourceMap;
    // prettier-ignore
    const breakLineCode = options.breakLineCode != null
        ? options.breakLineCode
        : mode === 'arrow'
            ? ';'
            : '\n';
    const needIndent = options.needIndent ? options.needIndent : mode !== 'arrow';
    const helpers = ast.helpers || [];
    const generator = createCodeGenerator(ast, {
        mode,
        filename,
        sourceMap,
        breakLineCode,
        needIndent
    });
    generator.push(mode === 'normal' ? `function __msg__ (ctx) {` : `(ctx) => {`);
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push(`const { ${helpers.map(s => `${s}: _${s}`).join(', ')} } = ctx`);
        generator.newline();
    }
    generator.push(`return `);
    generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push(`}`);
    const { code, map } = generator.context();
    return {
        ast,
        code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};

function baseCompile(source, options = {}) {
    const assignedOptions = assign({}, options);
    // parse source codes
    const parser = createParser(assignedOptions);
    const ast = parser.parse(source);
    // transform ASTs
    transform(ast, assignedOptions);
    // generate javascript codes
    return generate(ast, assignedOptions);
}

/*!
  * devtools-if v9.2.0
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */
const IntlifyDevToolsHooks =  {
    I18nInit: 'i18n:init',
    FunctionTranslate: 'function:translate'
};

/*!
  * core-base v9.2.0
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */

const pathStateMachine =  [];
pathStateMachine[0 /* BEFORE_PATH */] = {
    ["w" /* WORKSPACE */]: [0 /* BEFORE_PATH */],
    ["i" /* IDENT */]: [3 /* IN_IDENT */, 0 /* APPEND */],
    ["[" /* LEFT_BRACKET */]: [4 /* IN_SUB_PATH */],
    ["o" /* END_OF_FAIL */]: [7 /* AFTER_PATH */]
};
pathStateMachine[1 /* IN_PATH */] = {
    ["w" /* WORKSPACE */]: [1 /* IN_PATH */],
    ["." /* DOT */]: [2 /* BEFORE_IDENT */],
    ["[" /* LEFT_BRACKET */]: [4 /* IN_SUB_PATH */],
    ["o" /* END_OF_FAIL */]: [7 /* AFTER_PATH */]
};
pathStateMachine[2 /* BEFORE_IDENT */] = {
    ["w" /* WORKSPACE */]: [2 /* BEFORE_IDENT */],
    ["i" /* IDENT */]: [3 /* IN_IDENT */, 0 /* APPEND */],
    ["0" /* ZERO */]: [3 /* IN_IDENT */, 0 /* APPEND */]
};
pathStateMachine[3 /* IN_IDENT */] = {
    ["i" /* IDENT */]: [3 /* IN_IDENT */, 0 /* APPEND */],
    ["0" /* ZERO */]: [3 /* IN_IDENT */, 0 /* APPEND */],
    ["w" /* WORKSPACE */]: [1 /* IN_PATH */, 1 /* PUSH */],
    ["." /* DOT */]: [2 /* BEFORE_IDENT */, 1 /* PUSH */],
    ["[" /* LEFT_BRACKET */]: [4 /* IN_SUB_PATH */, 1 /* PUSH */],
    ["o" /* END_OF_FAIL */]: [7 /* AFTER_PATH */, 1 /* PUSH */]
};
pathStateMachine[4 /* IN_SUB_PATH */] = {
    ["'" /* SINGLE_QUOTE */]: [5 /* IN_SINGLE_QUOTE */, 0 /* APPEND */],
    ["\"" /* DOUBLE_QUOTE */]: [6 /* IN_DOUBLE_QUOTE */, 0 /* APPEND */],
    ["[" /* LEFT_BRACKET */]: [
        4 /* IN_SUB_PATH */,
        2 /* INC_SUB_PATH_DEPTH */
    ],
    ["]" /* RIGHT_BRACKET */]: [1 /* IN_PATH */, 3 /* PUSH_SUB_PATH */],
    ["o" /* END_OF_FAIL */]: 8 /* ERROR */,
    ["l" /* ELSE */]: [4 /* IN_SUB_PATH */, 0 /* APPEND */]
};
pathStateMachine[5 /* IN_SINGLE_QUOTE */] = {
    ["'" /* SINGLE_QUOTE */]: [4 /* IN_SUB_PATH */, 0 /* APPEND */],
    ["o" /* END_OF_FAIL */]: 8 /* ERROR */,
    ["l" /* ELSE */]: [5 /* IN_SINGLE_QUOTE */, 0 /* APPEND */]
};
pathStateMachine[6 /* IN_DOUBLE_QUOTE */] = {
    ["\"" /* DOUBLE_QUOTE */]: [4 /* IN_SUB_PATH */, 0 /* APPEND */],
    ["o" /* END_OF_FAIL */]: 8 /* ERROR */,
    ["l" /* ELSE */]: [6 /* IN_DOUBLE_QUOTE */, 0 /* APPEND */]
};
/**
 * Check if an expression is a literal value.
 */
const literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral(exp) {
    return literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */
function stripQuotes(str) {
    const a = str.charCodeAt(0);
    const b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */
function getPathCharType(ch) {
    if (ch === undefined || ch === null) {
        return "o" /* END_OF_FAIL */;
    }
    const code = ch.charCodeAt(0);
    switch (code) {
        case 0x5b: // [
        case 0x5d: // ]
        case 0x2e: // .
        case 0x22: // "
        case 0x27: // '
            return ch;
        case 0x5f: // _
        case 0x24: // $
        case 0x2d: // -
            return "i" /* IDENT */;
        case 0x09: // Tab (HT)
        case 0x0a: // Newline (LF)
        case 0x0d: // Return (CR)
        case 0xa0: // No-break space (NBSP)
        case 0xfeff: // Byte Order Mark (BOM)
        case 0x2028: // Line Separator (LS)
        case 0x2029: // Paragraph Separator (PS)
            return "w" /* WORKSPACE */;
    }
    return "i" /* IDENT */;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */
function formatSubPath(path) {
    const trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === '0' && isNaN(parseInt(path))) {
        return false;
    }
    return isLiteral(trimmed)
        ? stripQuotes(trimmed)
        : "*" /* ASTARISK */ + trimmed;
}
/**
 * Parse a string path into an array of segments
 */
function parse$1(path) {
    const keys = [];
    let index = -1;
    let mode = 0 /* BEFORE_PATH */;
    let subPathDepth = 0;
    let c;
    let key; // eslint-disable-line
    let newChar;
    let type;
    let transition;
    let action;
    let typeMap;
    const actions = [];
    actions[0 /* APPEND */] = () => {
        if (key === undefined) {
            key = newChar;
        }
        else {
            key += newChar;
        }
    };
    actions[1 /* PUSH */] = () => {
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* INC_SUB_PATH_DEPTH */] = () => {
        actions[0 /* APPEND */]();
        subPathDepth++;
    };
    actions[3 /* PUSH_SUB_PATH */] = () => {
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* IN_SUB_PATH */;
            actions[0 /* APPEND */]();
        }
        else {
            subPathDepth = 0;
            if (key === undefined) {
                return false;
            }
            key = formatSubPath(key);
            if (key === false) {
                return false;
            }
            else {
                actions[1 /* PUSH */]();
            }
        }
    };
    function maybeUnescapeQuote() {
        const nextChar = path[index + 1];
        if ((mode === 5 /* IN_SINGLE_QUOTE */ &&
            nextChar === "'" /* SINGLE_QUOTE */) ||
            (mode === 6 /* IN_DOUBLE_QUOTE */ &&
                nextChar === "\"" /* DOUBLE_QUOTE */)) {
            index++;
            newChar = '\\' + nextChar;
            actions[0 /* APPEND */]();
            return true;
        }
    }
    while (mode !== null) {
        index++;
        c = path[index];
        if (c === '\\' && maybeUnescapeQuote()) {
            continue;
        }
        type = getPathCharType(c);
        typeMap = pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* ELSE */] || 8 /* ERROR */;
        // check parse error
        if (transition === 8 /* ERROR */) {
            return;
        }
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) {
                    return;
                }
            }
        }
        // check parse finish
        if (mode === 7 /* AFTER_PATH */) {
            return keys;
        }
    }
}
// path token cache
const cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */
function resolveWithKeyValue(obj, path) {
    return isObject$2(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */
function resolveValue(obj, path) {
    // check object
    if (!isObject$2(obj)) {
        return null;
    }
    // parse path
    let hit = cache.get(path);
    if (!hit) {
        hit = parse$1(path);
        if (hit) {
            cache.set(path, hit);
        }
    }
    // check hit
    if (!hit) {
        return null;
    }
    // resolve path value
    const len = hit.length;
    let last = obj;
    let i = 0;
    while (i < len) {
        const val = last[hit[i]];
        if (val === undefined) {
            return null;
        }
        last = val;
        i++;
    }
    return last;
}

const DEFAULT_MODIFIER = (str) => str;
const DEFAULT_MESSAGE = (ctx) => ''; // eslint-disable-line
const DEFAULT_MESSAGE_DATA_TYPE = 'text';
const DEFAULT_NORMALIZE = (values) => values.length === 0 ? '' : values.join('');
const DEFAULT_INTERPOLATE = toDisplayString;
function pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) {
        // prettier-ignore
        return choice
            ? choice > 1
                ? 1
                : 0
            : 1;
    }
    return choice ? Math.min(choice, 2) : 0;
}
function getPluralIndex(options) {
    // prettier-ignore
    const index = isNumber$1(options.pluralIndex)
        ? options.pluralIndex
        : -1;
    // prettier-ignore
    return options.named && (isNumber$1(options.named.count) || isNumber$1(options.named.n))
        ? isNumber$1(options.named.count)
            ? options.named.count
            : isNumber$1(options.named.n)
                ? options.named.n
                : index
        : index;
}
function normalizeNamed(pluralIndex, props) {
    if (!props.count) {
        props.count = pluralIndex;
    }
    if (!props.n) {
        props.n = pluralIndex;
    }
}
function createMessageContext(options = {}) {
    const locale = options.locale;
    const pluralIndex = getPluralIndex(options);
    const pluralRule = isObject$2(options.pluralRules) &&
        isString(locale) &&
        isFunction$1(options.pluralRules[locale])
        ? options.pluralRules[locale]
        : pluralDefault;
    const orgPluralRule = isObject$2(options.pluralRules) &&
        isString(locale) &&
        isFunction$1(options.pluralRules[locale])
        ? pluralDefault
        : undefined;
    const plural = (messages) => {
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    const _list = options.list || [];
    const list = (index) => _list[index];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _named = options.named || {};
    isNumber$1(options.pluralIndex) && normalizeNamed(pluralIndex, _named);
    const named = (key) => _named[key];
    function message(key) {
        // prettier-ignore
        const msg = isFunction$1(options.messages)
            ? options.messages(key)
            : isObject$2(options.messages)
                ? options.messages[key]
                : false;
        return !msg
            ? options.parent
                ? options.parent.message(key) // resolve from parent messages
                : DEFAULT_MESSAGE
            : msg;
    }
    const _modifier = (name) => options.modifiers
        ? options.modifiers[name]
        : DEFAULT_MODIFIER;
    const normalize = isPlainObject$1(options.processor) && isFunction$1(options.processor.normalize)
        ? options.processor.normalize
        : DEFAULT_NORMALIZE;
    const interpolate = isPlainObject$1(options.processor) &&
        isFunction$1(options.processor.interpolate)
        ? options.processor.interpolate
        : DEFAULT_INTERPOLATE;
    const type = isPlainObject$1(options.processor) && isString(options.processor.type)
        ? options.processor.type
        : DEFAULT_MESSAGE_DATA_TYPE;
    const linked = (key, ...args) => {
        const [arg1, arg2] = args;
        let type = 'text';
        let modifier = '';
        if (args.length === 1) {
            if (isObject$2(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            }
            else if (isString(arg1)) {
                modifier = arg1 || modifier;
            }
        }
        else if (args.length === 2) {
            if (isString(arg1)) {
                modifier = arg1 || modifier;
            }
            if (isString(arg2)) {
                type = arg2 || type;
            }
        }
        let msg = message(key)(ctx);
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        if (type === 'vnode' && isArray$1(msg) && modifier) {
            msg = msg[0];
        }
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    const ctx = {
        ["list" /* LIST */]: list,
        ["named" /* NAMED */]: named,
        ["plural" /* PLURAL */]: plural,
        ["linked" /* LINKED */]: linked,
        ["message" /* MESSAGE */]: message,
        ["type" /* TYPE */]: type,
        ["interpolate" /* INTERPOLATE */]: interpolate,
        ["normalize" /* NORMALIZE */]: normalize
    };
    return ctx;
}

let devtools = null;
/* #__PURE__*/ createDevToolsHook(IntlifyDevToolsHooks.FunctionTranslate);
function createDevToolsHook(hook) {
    return (payloads) => devtools ;
}

const CoreWarnCodes = {
    NOT_FOUND_KEY: 1,
    FALLBACK_TO_TRANSLATE: 2,
    CANNOT_FORMAT_NUMBER: 3,
    FALLBACK_TO_NUMBER_FORMAT: 4,
    CANNOT_FORMAT_DATE: 5,
    FALLBACK_TO_DATE_FORMAT: 6,
    __EXTEND_POINT__: 7
};

/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */
function fallbackWithSimple(ctx, fallback, start // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    // prettier-ignore
    return [...new Set([
            start,
            ...(isArray$1(fallback)
                ? fallback
                : isObject$2(fallback)
                    ? Object.keys(fallback)
                    : isString(fallback)
                        ? [fallback]
                        : [start])
        ])];
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */
function fallbackWithLocaleChain(ctx, fallback, start) {
    const startLocale = isString(start) ? start : DEFAULT_LOCALE;
    const context = ctx;
    if (!context.__localeChainCache) {
        context.__localeChainCache = new Map();
    }
    let chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        let block = [start];
        // while any intervening block found
        while (isArray$1(block)) {
            block = appendBlockToChain(chain, block, fallback);
        }
        // prettier-ignore
        // last block defined by default
        const defaults = isArray$1(fallback) || !isPlainObject$1(fallback)
            ? fallback
            : fallback['default']
                ? fallback['default']
                : null;
        // convert defaults to array
        block = isString(defaults) ? [defaults] : defaults;
        if (isArray$1(block)) {
            appendBlockToChain(chain, block, false);
        }
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function appendBlockToChain(chain, block, blocks) {
    let follow = true;
    for (let i = 0; i < block.length && isBoolean(follow); i++) {
        const locale = block[i];
        if (isString(locale)) {
            follow = appendLocaleToChain(chain, block[i], blocks);
        }
    }
    return follow;
}
function appendLocaleToChain(chain, locale, blocks) {
    let follow;
    const tokens = locale.split('-');
    do {
        const target = tokens.join('-');
        follow = appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    } while (tokens.length && follow === true);
    return follow;
}
function appendItemToChain(chain, target, blocks) {
    let follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== '!';
            const locale = target.replace(/!/g, '');
            chain.push(locale);
            if ((isArray$1(blocks) || isPlainObject$1(blocks)) &&
                blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                follow = blocks[locale];
            }
        }
    }
    return follow;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Intlify core-base version
 * @internal
 */
const VERSION$1 = '9.2.0';
const NOT_REOSLVED = -1;
const DEFAULT_LOCALE = 'en-US';
const MISSING_RESOLVE_VALUE = '';
const capitalize = (str) => `${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function getDefaultLinkedModifiers() {
    return {
        upper: (val, type) => {
            // prettier-ignore
            return type === 'text' && isString(val)
                ? val.toUpperCase()
                : type === 'vnode' && isObject$2(val) && '__v_isVNode' in val
                    ? val.children.toUpperCase()
                    : val;
        },
        lower: (val, type) => {
            // prettier-ignore
            return type === 'text' && isString(val)
                ? val.toLowerCase()
                : type === 'vnode' && isObject$2(val) && '__v_isVNode' in val
                    ? val.children.toLowerCase()
                    : val;
        },
        capitalize: (val, type) => {
            // prettier-ignore
            return (type === 'text' && isString(val)
                ? capitalize(val)
                : type === 'vnode' && isObject$2(val) && '__v_isVNode' in val
                    ? capitalize(val.children)
                    : val);
        }
    };
}
let _compiler;
function registerMessageCompiler(compiler) {
    _compiler = compiler;
}
let _resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */
function registerMessageResolver(resolver) {
    _resolver = resolver;
}
let _fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */
function registerLocaleFallbacker(fallbacker) {
    _fallbacker = fallbacker;
}
// ID for CoreContext
let _cid = 0;
function createCoreContext(options = {}) {
    // setup options
    const version = isString(options.version) ? options.version : VERSION$1;
    const locale = isString(options.locale) ? options.locale : DEFAULT_LOCALE;
    const fallbackLocale = isArray$1(options.fallbackLocale) ||
        isPlainObject$1(options.fallbackLocale) ||
        isString(options.fallbackLocale) ||
        options.fallbackLocale === false
        ? options.fallbackLocale
        : locale;
    const messages = isPlainObject$1(options.messages)
        ? options.messages
        : { [locale]: {} };
    const datetimeFormats = isPlainObject$1(options.datetimeFormats)
            ? options.datetimeFormats
            : { [locale]: {} }
        ;
    const numberFormats = isPlainObject$1(options.numberFormats)
            ? options.numberFormats
            : { [locale]: {} }
        ;
    const modifiers = assign({}, options.modifiers || {}, getDefaultLinkedModifiers());
    const pluralRules = options.pluralRules || {};
    const missing = isFunction$1(options.missing) ? options.missing : null;
    const missingWarn = isBoolean(options.missingWarn) || isRegExp(options.missingWarn)
        ? options.missingWarn
        : true;
    const fallbackWarn = isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn)
        ? options.fallbackWarn
        : true;
    const fallbackFormat = !!options.fallbackFormat;
    const unresolving = !!options.unresolving;
    const postTranslation = isFunction$1(options.postTranslation)
        ? options.postTranslation
        : null;
    const processor = isPlainObject$1(options.processor) ? options.processor : null;
    const warnHtmlMessage = isBoolean(options.warnHtmlMessage)
        ? options.warnHtmlMessage
        : true;
    const escapeParameter = !!options.escapeParameter;
    const messageCompiler = isFunction$1(options.messageCompiler)
        ? options.messageCompiler
        : _compiler;
    const messageResolver = isFunction$1(options.messageResolver)
        ? options.messageResolver
        : _resolver || resolveWithKeyValue;
    const localeFallbacker = isFunction$1(options.localeFallbacker)
        ? options.localeFallbacker
        : _fallbacker || fallbackWithSimple;
    const fallbackContext = isObject$2(options.fallbackContext)
        ? options.fallbackContext
        : undefined;
    const onWarn = isFunction$1(options.onWarn) ? options.onWarn : warn;
    // setup internal options
    const internalOptions = options;
    const __datetimeFormatters = isObject$2(internalOptions.__datetimeFormatters)
            ? internalOptions.__datetimeFormatters
            : new Map()
        ;
    const __numberFormatters = isObject$2(internalOptions.__numberFormatters)
            ? internalOptions.__numberFormatters
            : new Map()
        ;
    const __meta = isObject$2(internalOptions.__meta) ? internalOptions.__meta : {};
    _cid++;
    const context = {
        version,
        cid: _cid,
        locale,
        fallbackLocale,
        messages,
        modifiers,
        pluralRules,
        missing,
        missingWarn,
        fallbackWarn,
        fallbackFormat,
        unresolving,
        postTranslation,
        processor,
        warnHtmlMessage,
        escapeParameter,
        messageCompiler,
        messageResolver,
        localeFallbacker,
        fallbackContext,
        onWarn,
        __meta
    };
    {
        context.datetimeFormats = datetimeFormats;
        context.numberFormats = numberFormats;
        context.__datetimeFormatters = __datetimeFormatters;
        context.__numberFormatters = __numberFormatters;
    }
    return context;
}
/** @internal */
function handleMissing(context, key, locale, missingWarn, type) {
    const { missing, onWarn } = context;
    if (missing !== null) {
        const ret = missing(context, locale, key, type);
        return isString(ret) ? ret : key;
    }
    else {
        return key;
    }
}
/** @internal */
function updateFallbackLocale(ctx, locale, fallback) {
    const context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
const defaultOnCacheKey = (source) => source;
let compileCache = Object.create(null);
function compileToFunction(source, options = {}) {
    {
        // check caches
        const onCacheKey = options.onCacheKey || defaultOnCacheKey;
        const key = onCacheKey(source);
        const cached = compileCache[key];
        if (cached) {
            return cached;
        }
        // compile error detecting
        let occurred = false;
        const onError = options.onError || defaultOnError;
        options.onError = (err) => {
            occurred = true;
            onError(err);
        };
        // compile
        const { code } = baseCompile(source, options);
        // evaluate function
        const msg = new Function(`return ${code}`)();
        // if occurred compile error, don't cache
        return !occurred ? (compileCache[key] = msg) : msg;
    }
}

let code$1 = CompileErrorCodes.__EXTEND_POINT__;
const inc$1 = () => ++code$1;
const CoreErrorCodes = {
    INVALID_ARGUMENT: code$1,
    INVALID_DATE_ARGUMENT: inc$1(),
    INVALID_ISO_DATE_ARGUMENT: inc$1(),
    __EXTEND_POINT__: inc$1() // 18
};
function createCoreError(code) {
    return createCompileError(code, null, undefined);
}

const NOOP_MESSAGE_FUNCTION = () => '';
const isMessageFunction = (val) => isFunction$1(val);
// implementation of `translate` function
function translate(context, ...args) {
    const { fallbackFormat, postTranslation, unresolving, messageCompiler, fallbackLocale, messages } = context;
    const [key, options] = parseTranslateArgs(...args);
    const missingWarn = isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    const fallbackWarn = isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const escapeParameter = isBoolean(options.escapeParameter)
        ? options.escapeParameter
        : context.escapeParameter;
    const resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    const defaultMsgOrKey = isString(options.default) || isBoolean(options.default) // default by function option
        ? !isBoolean(options.default)
            ? options.default
            : (!messageCompiler ? () => key : key)
        : fallbackFormat // default by `fallbackFormat` option
            ? (!messageCompiler ? () => key : key)
            : '';
    const enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== '';
    const locale = isString(options.locale) ? options.locale : context.locale;
    // escape params
    escapeParameter && escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    let [formatScope, targetLocale, message] = !resolvedMessage
        ? resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn)
        : [
            key,
            locale,
            messages[locale] || {}
        ];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    let format = formatScope;
    // if you use default message, set it as message format!
    let cacheBaseKey = key;
    if (!resolvedMessage &&
        !(isString(format) || isMessageFunction(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage &&
        (!(isString(format) || isMessageFunction(format)) ||
            !isString(targetLocale))) {
        return unresolving ? NOT_REOSLVED : key;
    }
    // setup compile error detecting
    let occurred = false;
    const errorDetector = () => {
        occurred = true;
    };
    // compile message format
    const msg = !isMessageFunction(format)
        ? compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector)
        : format;
    // if occurred compile error, return the message format
    if (occurred) {
        return format;
    }
    // evaluate message with context
    const ctxOptions = getMessageContextOptions(context, targetLocale, message, options);
    const msgContext = createMessageContext(ctxOptions);
    const messaged = evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    const ret = postTranslation
        ? postTranslation(messaged, key)
        : messaged;
    return ret;
}
function escapeParams(options) {
    if (isArray$1(options.list)) {
        options.list = options.list.map(item => isString(item) ? escapeHtml(item) : item);
    }
    else if (isObject$2(options.named)) {
        Object.keys(options.named).forEach(key => {
            if (isString(options.named[key])) {
                options.named[key] = escapeHtml(options.named[key]);
            }
        });
    }
}
function resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    const { messages, onWarn, messageResolver: resolveValue, localeFallbacker } = context;
    const locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    let message = {};
    let targetLocale;
    let format = null;
    const type = 'translate';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = locales[i];
        message =
            messages[targetLocale] || {};
        if ((format = resolveValue(message, key)) === null) {
            // if null, resolve with object key path
            format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        }
        if (isString(format) || isFunction$1(format))
            break;
        const missingRet = handleMissing(context, // eslint-disable-line @typescript-eslint/no-explicit-any
        key, targetLocale, missingWarn, type);
        if (missingRet !== key) {
            format = missingRet;
        }
    }
    return [format, targetLocale, message];
}
function compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector) {
    const { messageCompiler, warnHtmlMessage } = context;
    if (isMessageFunction(format)) {
        const msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        const msg = (() => format);
        msg.locale = targetLocale;
        msg.key = key;
        return msg;
    }
    const msg = messageCompiler(format, getCompileOptions(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, errorDetector));
    msg.locale = targetLocale;
    msg.key = key;
    msg.source = format;
    return msg;
}
function evaluateMessage(context, msg, msgCtx) {
    const messaged = msg(msgCtx);
    return messaged;
}
/** @internal */
function parseTranslateArgs(...args) {
    const [arg1, arg2, arg3] = args;
    const options = {};
    if (!isString(arg1) && !isNumber$1(arg1) && !isMessageFunction(arg1)) {
        throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
    }
    // prettier-ignore
    const key = isNumber$1(arg1)
        ? String(arg1)
        : isMessageFunction(arg1)
            ? arg1
            : arg1;
    if (isNumber$1(arg2)) {
        options.plural = arg2;
    }
    else if (isString(arg2)) {
        options.default = arg2;
    }
    else if (isPlainObject$1(arg2) && !isEmptyObject(arg2)) {
        options.named = arg2;
    }
    else if (isArray$1(arg2)) {
        options.list = arg2;
    }
    if (isNumber$1(arg3)) {
        options.plural = arg3;
    }
    else if (isString(arg3)) {
        options.default = arg3;
    }
    else if (isPlainObject$1(arg3)) {
        assign(options, arg3);
    }
    return [key, options];
}
function getCompileOptions(context, locale, key, source, warnHtmlMessage, errorDetector) {
    return {
        warnHtmlMessage,
        onError: (err) => {
            errorDetector && errorDetector(err);
            {
                throw err;
            }
        },
        onCacheKey: (source) => generateFormatCacheKey(locale, key, source)
    };
}
function getMessageContextOptions(context, locale, message, options) {
    const { modifiers, pluralRules, messageResolver: resolveValue, fallbackLocale, fallbackWarn, missingWarn, fallbackContext } = context;
    const resolveMessage = (key) => {
        let val = resolveValue(message, key);
        // fallback to root context
        if (val == null && fallbackContext) {
            const [, , message] = resolveMessageFormat(fallbackContext, key, locale, fallbackLocale, fallbackWarn, missingWarn);
            val = resolveValue(message, key);
        }
        if (isString(val)) {
            let occurred = false;
            const errorDetector = () => {
                occurred = true;
            };
            const msg = compileMessageFormat(context, key, locale, val, key, errorDetector);
            return !occurred
                ? msg
                : NOOP_MESSAGE_FUNCTION;
        }
        else if (isMessageFunction(val)) {
            return val;
        }
        else {
            // TODO: should be implemented warning message
            return NOOP_MESSAGE_FUNCTION;
        }
    };
    const ctxOptions = {
        locale,
        modifiers,
        pluralRules,
        messages: resolveMessage
    };
    if (context.processor) {
        ctxOptions.processor = context.processor;
    }
    if (options.list) {
        ctxOptions.list = options.list;
    }
    if (options.named) {
        ctxOptions.named = options.named;
    }
    if (isNumber$1(options.plural)) {
        ctxOptions.pluralIndex = options.plural;
    }
    return ctxOptions;
}

// implementation of `datetime` function
function datetime(context, ...args) {
    const { datetimeFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
    const { __datetimeFormatters } = context;
    const [key, value, options, overrides] = parseDateTimeArgs(...args);
    const missingWarn = isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const part = !!options.part;
    const locale = isString(options.locale) ? options.locale : context.locale;
    const locales = localeFallbacker(context, // eslint-disable-line @typescript-eslint/no-explicit-any
    fallbackLocale, locale);
    if (!isString(key) || key === '') {
        return new Intl.DateTimeFormat(locale, overrides).format(value);
    }
    // resolve format
    let datetimeFormat = {};
    let targetLocale;
    let format = null;
    const type = 'datetime format';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = locales[i];
        datetimeFormat =
            datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if (isPlainObject$1(format))
            break;
        handleMissing(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
    }
    // checking format and target locale
    if (!isPlainObject$1(format) || !isString(targetLocale)) {
        return unresolving ? NOT_REOSLVED : key;
    }
    let id = `${targetLocale}__${key}`;
    if (!isEmptyObject(overrides)) {
        id = `${id}__${JSON.stringify(overrides)}`;
    }
    let formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, assign({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */
const DATETIME_FORMAT_OPTIONS_KEYS = [
    'localeMatcher',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'formatMatcher',
    'hour12',
    'timeZone',
    'dateStyle',
    'timeStyle',
    'calendar',
    'dayPeriod',
    'numberingSystem',
    'hourCycle',
    'fractionalSecondDigits'
];
/** @internal */
function parseDateTimeArgs(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    let value;
    if (isString(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) {
            throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
        }
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        const dateTime = matches[3]
            ? matches[3].trim().startsWith('T')
                ? `${matches[1].trim()}${matches[3].trim()}`
                : `${matches[1].trim()}T${matches[3].trim()}`
            : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        }
        catch (e) {
            throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
        }
    }
    else if (isDate(arg1)) {
        if (isNaN(arg1.getTime())) {
            throw createCoreError(CoreErrorCodes.INVALID_DATE_ARGUMENT);
        }
        value = arg1;
    }
    else if (isNumber$1(arg1)) {
        value = arg1;
    }
    else {
        throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
    }
    if (isString(arg2)) {
        options.key = arg2;
    }
    else if (isPlainObject$1(arg2)) {
        Object.keys(arg2).forEach(key => {
            if (DATETIME_FORMAT_OPTIONS_KEYS.includes(key)) {
                overrides[key] = arg2[key];
            }
            else {
                options[key] = arg2[key];
            }
        });
    }
    if (isString(arg3)) {
        options.locale = arg3;
    }
    else if (isPlainObject$1(arg3)) {
        overrides = arg3;
    }
    if (isPlainObject$1(arg4)) {
        overrides = arg4;
    }
    return [options.key || '', value, options, overrides];
}
/** @internal */
function clearDateTimeFormat(ctx, locale, format) {
    const context = ctx;
    for (const key in format) {
        const id = `${locale}__${key}`;
        if (!context.__datetimeFormatters.has(id)) {
            continue;
        }
        context.__datetimeFormatters.delete(id);
    }
}

// implementation of `number` function
function number(context, ...args) {
    const { numberFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
    const { __numberFormatters } = context;
    const [key, value, options, overrides] = parseNumberArgs(...args);
    const missingWarn = isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const part = !!options.part;
    const locale = isString(options.locale) ? options.locale : context.locale;
    const locales = localeFallbacker(context, // eslint-disable-line @typescript-eslint/no-explicit-any
    fallbackLocale, locale);
    if (!isString(key) || key === '') {
        return new Intl.NumberFormat(locale, overrides).format(value);
    }
    // resolve format
    let numberFormat = {};
    let targetLocale;
    let format = null;
    const type = 'number format';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = locales[i];
        numberFormat =
            numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if (isPlainObject$1(format))
            break;
        handleMissing(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
    }
    // checking format and target locale
    if (!isPlainObject$1(format) || !isString(targetLocale)) {
        return unresolving ? NOT_REOSLVED : key;
    }
    let id = `${targetLocale}__${key}`;
    if (!isEmptyObject(overrides)) {
        id = `${id}__${JSON.stringify(overrides)}`;
    }
    let formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, assign({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */
const NUMBER_FORMAT_OPTIONS_KEYS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'currencySign',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    'compactDisplay',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'roundingMode',
    'roundingPriority',
    'roundingIncrement',
    'trailingZeroDisplay'
];
/** @internal */
function parseNumberArgs(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    if (!isNumber$1(arg1)) {
        throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
    }
    const value = arg1;
    if (isString(arg2)) {
        options.key = arg2;
    }
    else if (isPlainObject$1(arg2)) {
        Object.keys(arg2).forEach(key => {
            if (NUMBER_FORMAT_OPTIONS_KEYS.includes(key)) {
                overrides[key] = arg2[key];
            }
            else {
                options[key] = arg2[key];
            }
        });
    }
    if (isString(arg3)) {
        options.locale = arg3;
    }
    else if (isPlainObject$1(arg3)) {
        overrides = arg3;
    }
    if (isPlainObject$1(arg4)) {
        overrides = arg4;
    }
    return [options.key || '', value, options, overrides];
}
/** @internal */
function clearNumberFormat(ctx, locale, format) {
    const context = ctx;
    for (const key in format) {
        const id = `${locale}__${key}`;
        if (!context.__numberFormatters.has(id)) {
            continue;
        }
        context.__numberFormatters.delete(id);
    }
}

// TODO: we could not exports for Node native ES Moudles yet...
{
    {
        getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
    }
}

/*!
  * vue-i18n v9.2.0
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */

/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */
const VERSION = '9.2.0';
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */
function initFeatureFlags() {
    {
        getGlobalThis().__VUE_I18N_FULL_INSTALL__ = true;
    }
    {
        getGlobalThis().__VUE_I18N_LEGACY_API__ = true;
    }
    {
        getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
    }
}

CoreWarnCodes.__EXTEND_POINT__;

let code = CompileErrorCodes.__EXTEND_POINT__;
const inc = () => ++code;
const I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: code,
    // legacy module errors
    INVALID_ARGUMENT: inc(),
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: inc(),
    NOT_INSLALLED: inc(),
    NOT_AVAILABLE_IN_LEGACY_MODE: inc(),
    // directive module errors
    REQUIRED_VALUE: inc(),
    INVALID_VALUE: inc(),
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: inc(),
    NOT_INSLALLED_WITH_PROVIDE: inc(),
    // unexpected error
    UNEXPECTED_ERROR: inc(),
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: inc(),
    // bridge support vue 2.x only
    BRIDGE_SUPPORT_VUE_2_ONLY: inc(),
    // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
    MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: inc(),
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: inc(),
    // for enhancement
    __EXTEND_POINT__: inc() // 29
};
function createI18nError(code, ...args) {
    return createCompileError(code, null, undefined);
}

const TransrateVNodeSymbol = 
/* #__PURE__*/ makeSymbol('__transrateVNode');
const DatetimePartsSymbol = /* #__PURE__*/ makeSymbol('__datetimeParts');
const NumberPartsSymbol = /* #__PURE__*/ makeSymbol('__numberParts');
const SetPluralRulesSymbol = makeSymbol('__setPluralRules');
makeSymbol('__intlifyMeta');
const InejctWithOption = /* #__PURE__*/ makeSymbol('__injectWithOption');

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Transform flat json in obj to normal json in obj
 */
function handleFlatJson(obj) {
    // check obj
    if (!isObject$2(obj)) {
        return obj;
    }
    for (const key in obj) {
        // check key
        if (!hasOwn(obj, key)) {
            continue;
        }
        // handle for normal json
        if (!key.includes('.')) {
            // recursive process value if value is also a object
            if (isObject$2(obj[key])) {
                handleFlatJson(obj[key]);
            }
        }
        // handle for flat json, transform to normal json
        else {
            // go to the last object
            const subKeys = key.split('.');
            const lastIndex = subKeys.length - 1;
            let currentObj = obj;
            for (let i = 0; i < lastIndex; i++) {
                if (!(subKeys[i] in currentObj)) {
                    currentObj[subKeys[i]] = {};
                }
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            currentObj[subKeys[lastIndex]] = obj[key];
            delete obj[key];
            // recursive process value if value is also a object
            if (isObject$2(currentObj[subKeys[lastIndex]])) {
                handleFlatJson(currentObj[subKeys[lastIndex]]);
            }
        }
    }
    return obj;
}
function getLocaleMessages(locale, options) {
    const { messages, __i18n, messageResolver, flatJson } = options;
    // prettier-ignore
    const ret = isPlainObject$1(messages)
        ? messages
        : isArray$1(__i18n)
            ? {}
            : { [locale]: {} };
    // merge locale messages of i18n custom block
    if (isArray$1(__i18n)) {
        __i18n.forEach(custom => {
            if ('locale' in custom && 'resource' in custom) {
                const { locale, resource } = custom;
                if (locale) {
                    ret[locale] = ret[locale] || {};
                    deepCopy(resource, ret[locale]);
                }
                else {
                    deepCopy(resource, ret);
                }
            }
            else {
                isString(custom) && deepCopy(JSON.parse(custom), ret);
            }
        });
    }
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for (const key in ret) {
            if (hasOwn(ret, key)) {
                handleFlatJson(ret[key]);
            }
        }
    }
    return ret;
}
const isNotObjectOrIsArray = (val) => !isObject$2(val) || isArray$1(val);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function deepCopy(src, des) {
    // src and des should both be objects, and non of then can be a array
    if (isNotObjectOrIsArray(src) || isNotObjectOrIsArray(des)) {
        throw createI18nError(I18nErrorCodes.INVALID_VALUE);
    }
    for (const key in src) {
        if (hasOwn(src, key)) {
            if (isNotObjectOrIsArray(src[key]) || isNotObjectOrIsArray(des[key])) {
                // replace with src[key] when:
                // src[key] or des[key] is not a object, or
                // src[key] or des[key] is a array
                des[key] = src[key];
            }
            else {
                // src[key] and des[key] are both object, merge them
                deepCopy(src[key], des[key]);
            }
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getComponentOptions(instance) {
    return instance.type ;
}
function adjustI18nResources(global, options, componentOptions // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    let messages = isObject$2(options.messages) ? options.messages : {};
    if ('__i18nGlobal' in componentOptions) {
        messages = getLocaleMessages(global.locale.value, {
            messages,
            __i18n: componentOptions.__i18nGlobal
        });
    }
    // merge locale messages
    const locales = Object.keys(messages);
    if (locales.length) {
        locales.forEach(locale => {
            global.mergeLocaleMessage(locale, messages[locale]);
        });
    }
    {
        // merge datetime formats
        if (isObject$2(options.datetimeFormats)) {
            const locales = Object.keys(options.datetimeFormats);
            if (locales.length) {
                locales.forEach(locale => {
                    global.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
                });
            }
        }
        // merge number formats
        if (isObject$2(options.numberFormats)) {
            const locales = Object.keys(options.numberFormats);
            if (locales.length) {
                locales.forEach(locale => {
                    global.mergeNumberFormat(locale, options.numberFormats[locale]);
                });
            }
        }
    }
}
function createTextNode(key) {
    return createVNode(Text, null, key, 0)
        ;
}
let composerID = 0;
function defineCoreMissingHandler(missing) {
    return ((ctx, locale, key, type) => {
        return missing(locale, key, getCurrentInstance() || undefined, type);
    });
}
/**
 * Create composer interface factory
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function createComposer(options = {}, VueI18nLegacy) {
    const { __root } = options;
    const _isGlobal = __root === undefined;
    let _inheritLocale = isBoolean(options.inheritLocale)
        ? options.inheritLocale
        : true;
    const _locale = ref(
    // prettier-ignore
    __root && _inheritLocale
        ? __root.locale.value
        : isString(options.locale)
            ? options.locale
            : DEFAULT_LOCALE);
    const _fallbackLocale = ref(
    // prettier-ignore
    __root && _inheritLocale
        ? __root.fallbackLocale.value
        : isString(options.fallbackLocale) ||
            isArray$1(options.fallbackLocale) ||
            isPlainObject$1(options.fallbackLocale) ||
            options.fallbackLocale === false
            ? options.fallbackLocale
            : _locale.value);
    const _messages = ref(getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = ref(isPlainObject$1(options.datetimeFormats)
            ? options.datetimeFormats
            : { [_locale.value]: {} })
        ;
    // prettier-ignore
    const _numberFormats = ref(isPlainObject$1(options.numberFormats)
            ? options.numberFormats
            : { [_locale.value]: {} })
        ;
    // warning suppress options
    // prettier-ignore
    let _missingWarn = __root
        ? __root.missingWarn
        : isBoolean(options.missingWarn) || isRegExp(options.missingWarn)
            ? options.missingWarn
            : true;
    // prettier-ignore
    let _fallbackWarn = __root
        ? __root.fallbackWarn
        : isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn)
            ? options.fallbackWarn
            : true;
    // prettier-ignore
    let _fallbackRoot = __root
        ? __root.fallbackRoot
        : isBoolean(options.fallbackRoot)
            ? options.fallbackRoot
            : true;
    // configure fall back to root
    let _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    let _missing = isFunction$1(options.missing) ? options.missing : null;
    let _runtimeMissing = isFunction$1(options.missing)
        ? defineCoreMissingHandler(options.missing)
        : null;
    // postTranslation handler
    let _postTranslation = isFunction$1(options.postTranslation)
        ? options.postTranslation
        : null;
    // prettier-ignore
    let _warnHtmlMessage = __root
        ? __root.warnHtmlMessage
        : isBoolean(options.warnHtmlMessage)
            ? options.warnHtmlMessage
            : true;
    let _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    const _modifiers = __root
        ? __root.modifiers
        : isPlainObject$1(options.modifiers)
            ? options.modifiers
            : {};
    // pluralRules
    let _pluralRules = options.pluralRules || (__root && __root.pluralRules);
    // runtime context
    // eslint-disable-next-line prefer-const
    let _context;
    function getCoreContext() {
        const ctxOptions = {
            version: VERSION,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            __meta: { framework: 'vue' }
        };
        {
            ctxOptions.datetimeFormats = _datetimeFormats.value;
            ctxOptions.numberFormats = _numberFormats.value;
            ctxOptions.__datetimeFormatters = isPlainObject$1(_context)
                ? _context.__datetimeFormatters
                : undefined;
            ctxOptions.__numberFormatters = isPlainObject$1(_context)
                ? _context.__numberFormatters
                : undefined;
        }
        const ctx = createCoreContext(ctxOptions);
        return ctx;
    }
    _context = getCoreContext();
    updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
                _locale.value,
                _fallbackLocale.value,
                _messages.value,
                _datetimeFormats.value,
                _numberFormats.value
            ]
            ;
    }
    // locale
    const locale = computed({
        get: () => _locale.value,
        set: val => {
            _locale.value = val;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    const fallbackLocale = computed({
        get: () => _fallbackLocale.value,
        set: val => {
            _fallbackLocale.value = val;
            _context.fallbackLocale = _fallbackLocale.value;
            updateFallbackLocale(_context, _locale.value, val);
        }
    });
    // messages
    const messages = computed(() => _messages.value);
    // datetimeFormats
    const datetimeFormats = /* #__PURE__*/ computed(() => _datetimeFormats.value);
    // numberFormats
    const numberFormats = /* #__PURE__*/ computed(() => _numberFormats.value);
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return isFunction$1(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler) {
        _postTranslation = handler;
        _context.postTranslation = handler;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler) {
        if (handler !== null) {
            _runtimeMissing = defineCoreMissingHandler(handler);
        }
        _missing = handler;
        _context.missing = _runtimeMissing;
    }
    function wrapWithDeps(fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition) {
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        let ret;
        {
            ret = fn(_context);
        }
        if (isNumber$1(ret) && ret === NOT_REOSLVED) {
            const [key, arg2] = argumentParser();
            return __root && _fallbackRoot
                ? fallbackSuccess(__root)
                : fallbackFail(key);
        }
        else if (successCondition(ret)) {
            return ret;
        }
        else {
            /* istanbul ignore next */
            throw createI18nError(I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
        }
    }
    // t
    function t(...args) {
        return wrapWithDeps(context => Reflect.apply(translate, null, [context, ...args]), () => parseTranslateArgs(...args), 'translate', root => Reflect.apply(root.t, root, [...args]), key => key, val => isString(val));
    }
    // rt
    function rt(...args) {
        const [arg1, arg2, arg3] = args;
        if (arg3 && !isObject$2(arg3)) {
            throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        }
        return t(...[arg1, arg2, assign({ resolvedMessage: true }, arg3 || {})]);
    }
    // d
    function d(...args) {
        return wrapWithDeps(context => Reflect.apply(datetime, null, [context, ...args]), () => parseDateTimeArgs(...args), 'datetime format', root => Reflect.apply(root.d, root, [...args]), () => MISSING_RESOLVE_VALUE, val => isString(val));
    }
    // n
    function n(...args) {
        return wrapWithDeps(context => Reflect.apply(number, null, [context, ...args]), () => parseNumberArgs(...args), 'number format', root => Reflect.apply(root.n, root, [...args]), () => MISSING_RESOLVE_VALUE, val => isString(val));
    }
    // for custom processor
    function normalize(values) {
        return values.map(val => isString(val) || isNumber$1(val) || isBoolean(val)
            ? createTextNode(String(val))
            : val);
    }
    const interpolate = (val) => val;
    const processor = {
        normalize,
        interpolate,
        type: 'vnode'
    };
    // transrateVNode, using for `i18n-t` component
    function transrateVNode(...args) {
        return wrapWithDeps(context => {
            let ret;
            const _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply(translate, null, [_context, ...args]);
            }
            finally {
                _context.processor = null;
            }
            return ret;
        }, () => parseTranslateArgs(...args), 'translate', 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        root => root[TransrateVNodeSymbol](...args), key => [createTextNode(key)], val => isArray$1(val));
    }
    // numberParts, using for `i18n-n` component
    function numberParts(...args) {
        return wrapWithDeps(context => Reflect.apply(number, null, [context, ...args]), () => parseNumberArgs(...args), 'number format', 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        root => root[NumberPartsSymbol](...args), () => [], val => isString(val) || isArray$1(val));
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts(...args) {
        return wrapWithDeps(context => Reflect.apply(datetime, null, [context, ...args]), () => parseDateTimeArgs(...args), 'datetime format', 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        root => root[DatetimePartsSymbol](...args), () => [], val => isString(val) || isArray$1(val));
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        const targetLocale = isString(locale) ? locale : _locale.value;
        const message = getLocaleMessage(targetLocale);
        return _context.messageResolver(message, key) !== null;
    }
    function resolveMessages(key) {
        let messages = null;
        const locales = fallbackWithLocaleChain(_context, _fallbackLocale.value, _locale.value);
        for (let i = 0; i < locales.length; i++) {
            const targetLocaleMessages = _messages.value[locales[i]] || {};
            const messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        const messages = resolveMessages(key);
        // prettier-ignore
        return messages != null
            ? messages
            : __root
                ? __root.tm(key) || {}
                : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return (_messages.value[locale] || {});
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        deepCopy(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        clearDateTimeFormat(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = assign(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        clearDateTimeFormat(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        clearNumberFormat(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = assign(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        clearNumberFormat(_context, locale, format);
    }
    // for debug
    composerID++;
    // watch root locale & fallbackLocale
    if (__root && inBrowser) {
        watch(__root.locale, (val) => {
            if (_inheritLocale) {
                _locale.value = val;
                _context.locale = val;
                updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
        watch(__root.fallbackLocale, (val) => {
            if (_inheritLocale) {
                _fallbackLocale.value = val;
                _context.fallbackLocale = val;
                updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    const composer = {
        id: composerID,
        locale,
        fallbackLocale,
        get inheritLocale() {
            return _inheritLocale;
        },
        set inheritLocale(val) {
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales() {
            return Object.keys(_messages.value).sort();
        },
        messages,
        get modifiers() {
            return _modifiers;
        },
        get pluralRules() {
            return _pluralRules || {};
        },
        get isGlobal() {
            return _isGlobal;
        },
        get missingWarn() {
            return _missingWarn;
        },
        set missingWarn(val) {
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn() {
            return _fallbackWarn;
        },
        set fallbackWarn(val) {
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot() {
            return _fallbackRoot;
        },
        set fallbackRoot(val) {
            _fallbackRoot = val;
        },
        get fallbackFormat() {
            return _fallbackFormat;
        },
        set fallbackFormat(val) {
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage() {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage(val) {
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter() {
            return _escapeParameter;
        },
        set escapeParameter(val) {
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t,
        getLocaleMessage,
        setLocaleMessage,
        mergeLocaleMessage,
        getPostTranslationHandler,
        setPostTranslationHandler,
        getMissingHandler,
        setMissingHandler,
        [SetPluralRulesSymbol]: setPluralRules
    };
    {
        composer.datetimeFormats = datetimeFormats;
        composer.numberFormats = numberFormats;
        composer.rt = rt;
        composer.te = te;
        composer.tm = tm;
        composer.d = d;
        composer.n = n;
        composer.getDateTimeFormat = getDateTimeFormat;
        composer.setDateTimeFormat = setDateTimeFormat;
        composer.mergeDateTimeFormat = mergeDateTimeFormat;
        composer.getNumberFormat = getNumberFormat;
        composer.setNumberFormat = setNumberFormat;
        composer.mergeNumberFormat = mergeNumberFormat;
        composer[InejctWithOption] = options.__injectWithOption;
        composer[TransrateVNodeSymbol] = transrateVNode;
        composer[DatetimePartsSymbol] = datetimeParts;
        composer[NumberPartsSymbol] = numberParts;
    }
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

const baseFormatProps = {
    tag: {
        type: [String, Object]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: (val /* ComponetI18nScope */) => val === 'parent' || val === 'global',
        default: 'parent' /* ComponetI18nScope */
    },
    i18n: {
        type: Object
    }
};

function getInterpolateArg(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ slots }, // SetupContext,
keys) {
    if (keys.length === 1 && keys[0] === 'default') {
        // default slot with list
        const ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce((slot, current) => {
            return (slot = [
                ...slot,
                ...(isArray$1(current.children) ? current.children : [current])
            ]);
        }, []);
    }
    else {
        // named slots
        return keys.reduce((arg, key) => {
            const slot = slots[key];
            if (slot) {
                arg[key] = slot();
            }
            return arg;
        }, {});
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getFragmentableTag(tag) {
    return Fragment ;
}

/**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n path="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */
/* defineComponent */ ({
    /* eslint-disable */
    name: 'i18n-t',
    props: assign({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [Number, String],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validator: (val) => isNumber$1(val) || !isNaN(val)
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const { slots, attrs } = context;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        const i18n = props.i18n ||
            useI18n({
                useScope: props.scope,
                __useComponent: true
            });
        return () => {
            const keys = Object.keys(slots).filter(key => key !== '_');
            const options = {};
            if (props.locale) {
                options.locale = props.locale;
            }
            if (props.plural !== undefined) {
                options.plural = isString(props.plural) ? +props.plural : props.plural;
            }
            const arg = getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = i18n[TransrateVNodeSymbol](props.keypath, arg, options);
            const assignedAttrs = assign({}, attrs);
            const tag = isString(props.tag) || isObject$2(props.tag)
                ? props.tag
                : getFragmentableTag();
            return h(tag, assignedAttrs, children);
        };
    }
});

function isVNode(target) {
    return isArray$1(target) && !isString(target[0]);
}
function renderFormatter(props, context, slotKeys, partFormatter) {
    const { slots, attrs } = context;
    return () => {
        const options = { part: true };
        let overrides = {};
        if (props.locale) {
            options.locale = props.locale;
        }
        if (isString(props.format)) {
            options.key = props.format;
        }
        else if (isObject$2(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (isString(props.format.key)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                options.key = props.format.key;
            }
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce((options, prop) => {
                return slotKeys.includes(prop)
                    ? assign({}, options, { [prop]: props.format[prop] }) // eslint-disable-line @typescript-eslint/no-explicit-any
                    : options;
            }, {});
        }
        const parts = partFormatter(...[props.value, options, overrides]);
        let children = [options.key];
        if (isArray$1(parts)) {
            children = parts.map((part, index) => {
                const slot = slots[part.type];
                const node = slot
                    ? slot({ [part.type]: part.value, index, parts })
                    : [part.value];
                if (isVNode(node)) {
                    node[0].key = `${part.type}-${index}`;
                }
                return node;
            });
        }
        else if (isString(parts)) {
            children = [parts];
        }
        const assignedAttrs = assign({}, attrs);
        const tag = isString(props.tag) || isObject$2(props.tag)
            ? props.tag
            : getFragmentableTag();
        return h(tag, assignedAttrs, children);
    };
}

/**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */
/* defineComponent */ ({
    /* eslint-disable */
    name: 'i18n-n',
    props: assign({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [String, Object]
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const i18n = props.i18n ||
            useI18n({ useScope: 'parent', __useComponent: true });
        return renderFormatter(props, context, NUMBER_FORMAT_OPTIONS_KEYS, (...args) => 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        i18n[NumberPartsSymbol](...args));
    }
});

/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */
/*defineComponent */ ({
    /* eslint-disable */
    name: 'i18n-d',
    props: assign({
        value: {
            type: [Number, Date],
            required: true
        },
        format: {
            type: [String, Object]
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const i18n = props.i18n ||
            useI18n({ useScope: 'parent', __useComponent: true });
        return renderFormatter(props, context, DATETIME_FORMAT_OPTIONS_KEYS, (...args) => 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        i18n[DatetimePartsSymbol](...args));
    }
});

/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */
const I18nInjectionKey = 
/* #__PURE__*/ makeSymbol('global-vue-i18n');
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function createI18n(options = {}, VueI18nLegacy) {
    // prettier-ignore
    const __globalInjection = isBoolean(options.globalInjection)
        ? options.globalInjection
        : true;
    // prettier-ignore
    const __allowComposition = true;
    const __instances = new Map();
    const [globalScope, __global] = createGlobal(options);
    const symbol = makeSymbol('');
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    {
        const i18n = {
            // mode
            get mode() {
                return 'composition';
            },
            // allowComposition
            get allowComposition() {
                return __allowComposition;
            },
            // install plugin
            async install(app, ...options) {
                // setup global provider
                app.__VUE_I18N_SYMBOL__ = symbol;
                app.provide(app.__VUE_I18N_SYMBOL__, i18n);
                // global method and properties injection for Composition API
                if (__globalInjection) {
                    injectGlobalFields(app, i18n.global);
                }
                // release global scope
                const unmountApp = app.unmount;
                app.unmount = () => {
                    i18n.dispose();
                    unmountApp();
                };
            },
            // global accessor
            get global() {
                return __global;
            },
            dispose() {
                globalScope.stop();
            },
            // @internal
            __instances,
            // @internal
            __getInstance,
            // @internal
            __setInstance,
            // @internal
            __deleteInstance
        };
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function useI18n(options = {}) {
    const instance = getCurrentInstance();
    if (instance == null) {
        throw createI18nError(I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    }
    if (!instance.isCE &&
        instance.appContext.app != null &&
        !instance.appContext.app.__VUE_I18N_SYMBOL__) {
        throw createI18nError(I18nErrorCodes.NOT_INSLALLED);
    }
    const i18n = getI18nInstance(instance);
    const global = getGlobalComposer(i18n);
    const componentOptions = getComponentOptions(instance);
    const scope = getScope(options, componentOptions);
    if (scope === 'global') {
        adjustI18nResources(global, options, componentOptions);
        return global;
    }
    if (scope === 'parent') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let composer = getComposer(i18n, instance, options.__useComponent);
        if (composer == null) {
            composer = global;
        }
        return composer;
    }
    const i18nInternal = i18n;
    let composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        const composerOptions = assign({}, options);
        if ('__i18n' in componentOptions) {
            composerOptions.__i18n = componentOptions.__i18n;
        }
        if (global) {
            composerOptions.__root = global;
        }
        composer = createComposer(composerOptions);
        setupLifeCycle(i18nInternal, instance);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
function createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const scope = effectScope();
    {
        const obj = scope.run(() => createComposer(options));
        if (obj == null) {
            throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
        }
        return [scope, obj];
    }
}
function getI18nInstance(instance) {
    {
        const i18n = inject(!instance.isCE
            ? instance.appContext.app.__VUE_I18N_SYMBOL__
            : I18nInjectionKey);
        /* istanbul ignore if */
        if (!i18n) {
            throw createI18nError(!instance.isCE
                ? I18nErrorCodes.UNEXPECTED_ERROR
                : I18nErrorCodes.NOT_INSLALLED_WITH_PROVIDE);
        }
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getScope(options, componentOptions) {
    // prettier-ignore
    return isEmptyObject(options)
        ? ('__i18n' in componentOptions)
            ? 'local'
            : 'global'
        : !options.useScope
            ? 'local'
            : options.useScope;
}
function getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === 'composition'
            ? i18n.global
            : i18n.global.__composer
        ;
}
function getComposer(i18n, target, useComponent = false) {
    let composer = null;
    const root = target.root;
    let current = target.parent;
    while (current != null) {
        const i18nInternal = i18n;
        if (i18n.mode === 'composition') {
            composer = i18nInternal.__getInstance(current);
        }
        if (composer != null) {
            break;
        }
        if (root === current) {
            break;
        }
        current = current.parent;
    }
    return composer;
}
function setupLifeCycle(i18n, target, composer) {
    {
        onMounted(() => {
        }, target);
        onUnmounted(() => {
            i18n.__deleteInstance(target);
        }, target);
    }
}
const globalExportProps = [
    'locale',
    'fallbackLocale',
    'availableLocales'
];
const globalExportMethods = ['t', 'rt', 'd', 'n', 'tm'] ;
function injectGlobalFields(app, composer) {
    const i18n = Object.create(null);
    globalExportProps.forEach(prop => {
        const desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) {
            throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
        }
        const wrap = isRef(desc.value) // check computed props
            ? {
                get() {
                    return desc.value.value;
                },
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                set(val) {
                    desc.value.value = val;
                }
            }
            : {
                get() {
                    return desc.get && desc.get();
                }
            };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    globalExportMethods.forEach(method => {
        const desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) {
            throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
        }
        Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
    });
}

// register message compiler at vue-i18n
registerMessageCompiler(compileToFunction);
// register message resolver at vue-i18n
registerMessageResolver(resolveValue);
// register fallback locale at vue-i18n
registerLocaleFallbacker(fallbackWithLocaleChain);
{
    initFeatureFlags();
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$d.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$c.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$b = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$9).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$8.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$7.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$5 = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$5) {
    _defineProperty$5(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq_1(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$6.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike_1(value) && isArrayLike_1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$6 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$5.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] =
typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$4.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$2.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, keysIn_1(value));
}

var toPlainObject_1 = toPlainObject;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray_1(srcValue),
        isBuff = !isArr && isBuffer_1(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray_1(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject_1(objValue)) {
        newValue = _copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
      newValue = objValue;
      if (isArguments_1(objValue)) {
        newValue = toPlainObject_1(objValue);
      }
      else if (!isObject_1(objValue) || isFunction_1(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    stack || (stack = new _Stack);
    if (isObject_1(srcValue)) {
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, keysIn_1);
}

var _baseMerge = baseMerge;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$1(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$1(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty$5 ? identity_1 : function(func, string) {
  return _defineProperty$5(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function(object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

var merge_1 = merge;

var en={SARAKE_STORYBOOK_COOKIE_MODAL:{HEADING:"Our site uses cookies",BODY:"Our site uses cookies to enhance user experience, site functionality, as well as for statistics and analytics. By clicking “Accept All”, you are consenting to the usage of cookies for previously mentioned usages. You can read more about our usage of cookies by clicking the link below.",ACCEPT_ALL:"accept all",ACCEPT_MANDATORY:"accept necessary",READ_MORE:"Read more about our cookies"},SARAKE_STORYBOOK_ARIA:{ObjectTable:{SORT_BUTTON_ARIA_LABEL:"Sort the table based on {column}"},PaginatedTable:{NEXT:"Next",PREVIOUS:"Previous"},HTMLEditor:{TEXT_EDITOR:{BIGGER_TEXT_SIZE:"Bigger Text Size",BOLD:"Bold",CHANGE_TEXT_COLOR:"Change Text Color",DEFAULT_TEXT_COLOR:"Default Text Color",ITALIC:"Italic",NORMAL_TEXT_SIZE:"Normal Text Size",ORDERED_LIST:"Ordered List",REMOVE_TEXT_FORMATTING:"Remove Text Formatting",SMALLER_TEXT_SIZE:"Smaller Text Size",STRIKE_TROUGH:"Strike Trough",SUBSCRIPT:"Subscript",SUPERSCRIPT:"Superscript",UNDERLINE:"Underline",UNORDERED_LIST:"Unordered List"}}},SARAKE_STORYBOOK_DEMO:{EXAMPLE_LABEL:"Example label {n}"},SR_LABEL:{MSG_LANGUAGE_DROPDOWN:"Select language in which you want to use Sign and receive notifications"}};var fi={SARAKE_STORYBOOK_COOKIE_MODAL:{HEADING:"Käytämme sivustollamme evästeitä",BODY:"Sivustollamme on käytössä evästeitä käyttäjäkokemuksen parantamiseen, sivuston välttämättömiin toimintoihin, tilastoihin ja analytiikkaan. Klikkaa “Hyväksy kaikki” hyväksyäksesi evästeiden käytön ilmoittamiimme tarkoituksiin. Halutessasi voit lukea lisää tietoa evästeiden käytöstä sivuillamme alla olevasta linkistä.",ACCEPT_ALL:"hyväksy kaikki",ACCEPT_MANDATORY:"hyväksy välttämättömät",READ_MORE:"lue lisää evästeistämme"},SARAKE_STORYBOOK_ARIA:{ObjectTable:{SORT_BUTTON_ARIA_LABEL:"Järjestä taulukko sarakkeen {column} perusteella"},PaginatedTable:{NEXT:"Seuraava",PREVIOUS:"Edellinen"},HTMLEditor:{TEXT_EDITOR:{BIGGER_TEXT_SIZE:"Isompi teksti",BOLD:"Lihavoitu",CHANGE_TEXT_COLOR:"Vaihda tekstin väriä",DEFAULT_TEXT_COLOR:"Tekstin oletusväri",ITALIC:"Kursivoitu",NORMAL_TEXT_SIZE:"Normaali teksti",ORDERED_LIST:"Numeroitu lista",REMOVE_TEXT_FORMATTING:"Poista tekstin muotoilu",SMALLER_TEXT_SIZE:"Pienempi teksti",STRIKE_TROUGH:"Yliviivaus",SUBSCRIPT:"Alaindeksi",SUPERSCRIPT:"Yläindeksi",UNDERLINE:"Alleviivaus",UNORDERED_LIST:"Lista"}}},SARAKE_STORYBOOK_DEMO:{EXAMPLE_LABEL:"Esimerkki nimike {n}"},SR_LABEL:{MSG_LANGUAGE_DROPDOWN:"Valitse kieli, jolla käytät Sign-sovellusta ja vastaanotat sähköpostiviestejä"}};var sv={SARAKE_STORYBOOK_COOKIE_MODAL:{HEADING:"Käytämme sivustollamme evästeitä",BODY:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",ACCEPT_ALL:"hyväksy kaikki",ACCEPT_MANDATORY:"hyväksy välttämättömät",READ_MORE:"lue lisää evästeistämme"},SARAKE_STORYBOOK_ARIA:{ObjectTable:{SORT_BUTTON_ARIA_LABEL:"Sortera tabellen utifrån {column}"},PaginatedTable:{NEXT:"Nästa",PREVIOUS:"Tidigare"},HTMLEditor:{TEXT_EDITOR:{BIGGER_TEXT_SIZE:"Större textstorlek",BOLD:"Djärv",CHANGE_TEXT_COLOR:"Ändra textfärg",DEFAULT_TEXT_COLOR:"Standardtextfärg",ITALIC:"Kursiv",NORMAL_TEXT_SIZE:"Normal textstorlek",ORDERED_LIST:"Beställd lista",REMOVE_TEXT_FORMATTING:"Ta bort textformatering",SMALLER_TEXT_SIZE:"Mindre textstorlek",STRIKE_TROUGH:"Strike Trough",SUBSCRIPT:"Index",SUPERSCRIPT:"Exponent",UNDERLINE:"Understrykning",UNORDERED_LIST:"Oordnad lista"}}},SARAKE_STORYBOOK_DEMO:{EXAMPLE_LABEL:"Exempeletikett {n}"},SR_LABEL:{MSG_LANGUAGE_DROPDOWN:"Välj det språk du vill använda för Sign och att ta emot aviseringar"}};var messages = {en:en,fi:fi,sv:sv};

/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
var faChevronDown$1 = {
  prefix: 'fas',
  iconName: 'chevron-down',
  icon: [448, 512, [], "f078", "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"]
};
var faChevronUp$1 = {
  prefix: 'fas',
  iconName: 'chevron-up',
  icon: [448, 512, [], "f077", "M416 352c-8.188 0-16.38-3.125-22.62-9.375L224 173.3l-169.4 169.4c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25C432.4 348.9 424.2 352 416 352z"]
};
var faCircleInfo$1 = {
  prefix: 'fas',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 128c17.67 0 32 14.33 32 32c0 17.67-14.33 32-32 32S224 177.7 224 160C224 142.3 238.3 128 256 128zM296 384h-80C202.8 384 192 373.3 192 360s10.75-24 24-24h16v-64H224c-13.25 0-24-10.75-24-24S210.8 224 224 224h32c13.25 0 24 10.75 24 24v88h16c13.25 0 24 10.75 24 24S309.3 384 296 384z"]
};
var faInfoCircle$1 = faCircleInfo$1;
var faCircleXmark = {
  prefix: 'fas',
  iconName: 'circle-xmark',
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM175 208.1L222.1 255.1L175 303C165.7 312.4 165.7 327.6 175 336.1C184.4 346.3 199.6 346.3 208.1 336.1L255.1 289.9L303 336.1C312.4 346.3 327.6 346.3 336.1 336.1C346.3 327.6 346.3 312.4 336.1 303L289.9 255.1L336.1 208.1C346.3 199.6 346.3 184.4 336.1 175C327.6 165.7 312.4 165.7 303 175L255.1 222.1L208.1 175C199.6 165.7 184.4 165.7 175 175C165.7 184.4 165.7 199.6 175 208.1V208.1z"]
};
var faTimesCircle = faCircleXmark;
var faEye = {
  prefix: 'fas',
  iconName: 'eye',
  icon: [576, 512, [128065], "f06e", "M279.6 160.4C282.4 160.1 285.2 160 288 160C341 160 384 202.1 384 256C384 309 341 352 288 352C234.1 352 192 309 192 256C192 253.2 192.1 250.4 192.4 247.6C201.7 252.1 212.5 256 224 256C259.3 256 288 227.3 288 192C288 180.5 284.1 169.7 279.6 160.4zM480.6 112.6C527.4 156 558.7 207.1 573.5 243.7C576.8 251.6 576.8 260.4 573.5 268.3C558.7 304 527.4 355.1 480.6 399.4C433.5 443.2 368.8 480 288 480C207.2 480 142.5 443.2 95.42 399.4C48.62 355.1 17.34 304 2.461 268.3C-.8205 260.4-.8205 251.6 2.461 243.7C17.34 207.1 48.62 156 95.42 112.6C142.5 68.84 207.2 32 288 32C368.8 32 433.5 68.84 480.6 112.6V112.6zM288 112C208.5 112 144 176.5 144 256C144 335.5 208.5 400 288 400C367.5 400 432 335.5 432 256C432 176.5 367.5 112 288 112z"]
};
var faEyeSlash = {
  prefix: 'fas',
  iconName: 'eye-slash',
  icon: [640, 512, [], "f070", "M150.7 92.77C195 58.27 251.8 32 320 32C400.8 32 465.5 68.84 512.6 112.6C559.4 156 590.7 207.1 605.5 243.7C608.8 251.6 608.8 260.4 605.5 268.3C592.1 300.6 565.2 346.1 525.6 386.7L630.8 469.1C641.2 477.3 643.1 492.4 634.9 502.8C626.7 513.2 611.6 515.1 601.2 506.9L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196C13.29-1.236 28.37-3.065 38.81 5.112L150.7 92.77zM223.1 149.5L313.4 220.3C317.6 211.8 320 202.2 320 191.1C320 180.5 316.1 169.7 311.6 160.4C314.4 160.1 317.2 159.1 320 159.1C373 159.1 416 202.1 416 255.1C416 269.7 413.1 282.7 407.1 294.5L446.6 324.7C457.7 304.3 464 280.9 464 255.1C464 176.5 399.5 111.1 320 111.1C282.7 111.1 248.6 126.2 223.1 149.5zM320 480C239.2 480 174.5 443.2 127.4 399.4C80.62 355.1 49.34 304 34.46 268.3C31.18 260.4 31.18 251.6 34.46 243.7C44 220.8 60.29 191.2 83.09 161.5L177.4 235.8C176.5 242.4 176 249.1 176 255.1C176 335.5 240.5 400 320 400C338.7 400 356.6 396.4 373 389.9L446.2 447.5C409.9 467.1 367.8 480 320 480H320z"]
};
var faGear$1 = {
  prefix: 'fas',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", "M495.9 166.6C499.2 175.2 496.4 184.9 489.6 191.2L446.3 230.6C447.4 238.9 448 247.4 448 256C448 264.6 447.4 273.1 446.3 281.4L489.6 320.8C496.4 327.1 499.2 336.8 495.9 345.4C491.5 357.3 486.2 368.8 480.2 379.7L475.5 387.8C468.9 398.8 461.5 409.2 453.4 419.1C447.4 426.2 437.7 428.7 428.9 425.9L373.2 408.1C359.8 418.4 344.1 427 329.2 433.6L316.7 490.7C314.7 499.7 307.7 506.1 298.5 508.5C284.7 510.8 270.5 512 255.1 512C241.5 512 227.3 510.8 213.5 508.5C204.3 506.1 197.3 499.7 195.3 490.7L182.8 433.6C167 427 152.2 418.4 138.8 408.1L83.14 425.9C74.3 428.7 64.55 426.2 58.63 419.1C50.52 409.2 43.12 398.8 36.52 387.8L31.84 379.7C25.77 368.8 20.49 357.3 16.06 345.4C12.82 336.8 15.55 327.1 22.41 320.8L65.67 281.4C64.57 273.1 64 264.6 64 256C64 247.4 64.57 238.9 65.67 230.6L22.41 191.2C15.55 184.9 12.82 175.3 16.06 166.6C20.49 154.7 25.78 143.2 31.84 132.3L36.51 124.2C43.12 113.2 50.52 102.8 58.63 92.95C64.55 85.8 74.3 83.32 83.14 86.14L138.8 103.9C152.2 93.56 167 84.96 182.8 78.43L195.3 21.33C197.3 12.25 204.3 5.04 213.5 3.51C227.3 1.201 241.5 0 256 0C270.5 0 284.7 1.201 298.5 3.51C307.7 5.04 314.7 12.25 316.7 21.33L329.2 78.43C344.1 84.96 359.8 93.56 373.2 103.9L428.9 86.14C437.7 83.32 447.4 85.8 453.4 92.95C461.5 102.8 468.9 113.2 475.5 124.2L480.2 132.3C486.2 143.2 491.5 154.7 495.9 166.6V166.6zM256 336C300.2 336 336 300.2 336 255.1C336 211.8 300.2 175.1 256 175.1C211.8 175.1 176 211.8 176 255.1C176 300.2 211.8 336 256 336z"]
};
var faUser = {
  prefix: 'fas',
  iconName: 'user',
  icon: [448, 512, [62144, 128100], "f007", "M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z"]
};

/*!
 * Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2022 Fonticons, Inc.
 */
var faArrowRightFromBracket = {
  prefix: 'fal',
  iconName: 'arrow-right-from-bracket',
  icon: [512, 512, ["sign-out"], "f08b", "M507.3 244.7l-144-144c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62L457.4 240H176C167.2 240 160 247.2 160 256s7.156 16 16 16h281.4l-116.7 116.7c-6.25 6.25-6.25 16.38 0 22.62s16.38 6.25 22.62 0l144-144C510.4 264.2 512 260.1 512 256S510.4 247.8 507.3 244.7zM176 448h-96C53.53 448 32 426.5 32 400v-288C32 85.53 53.53 64 80 64h96C184.8 64 192 56.84 192 48S184.8 32 176 32h-96C35.88 32 0 67.88 0 112v288C0 444.1 35.88 480 80 480h96C184.8 480 192 472.8 192 464S184.8 448 176 448z"]
};
var faSignOut = faArrowRightFromBracket;
var faBars = {
  prefix: 'fal',
  iconName: 'bars',
  icon: [448, 512, ["navicon"], "f0c9", "M0 80C0 71.16 7.164 64 16 64H432C440.8 64 448 71.16 448 80C448 88.84 440.8 96 432 96H16C7.164 96 0 88.84 0 80zM0 240C0 231.2 7.164 224 16 224H432C440.8 224 448 231.2 448 240C448 248.8 440.8 256 432 256H16C7.164 256 0 248.8 0 240zM432 416H16C7.164 416 0 408.8 0 400C0 391.2 7.164 384 16 384H432C440.8 384 448 391.2 448 400C448 408.8 440.8 416 432 416z"]
};
var faBold = {
  prefix: 'fal',
  iconName: 'bold',
  icon: [384, 512, [], "f032", "M314.7 251.7C346.8 230.1 368 193.5 368 152C368 85.84 314.2 32 248 32H16C7.156 32 0 39.16 0 48S7.156 64 16 64H32v384H16C7.156 448 0 455.2 0 464S7.156 480 16 480h248c66.17 0 120-53.84 120-120C384 312 355.5 270.8 314.7 251.7zM64 64h184c48.53 0 88 39.47 88 88S296.5 240 248 240H64V64zM264 448H64V272h200c48.53 0 88 39.47 88 88S312.5 448 264 448z"]
};
var faCaretDown = {
  prefix: 'fal',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", "M287.1 192H32c-28.37 0-42.74 34.5-22.62 54.63l127.1 128c12.5 12.5 32.75 12.5 45.25 0l127.1-128C330.7 226.5 316.5 192 287.1 192zM159.1 352L32.01 224h255.9L159.1 352z"]
};
var faCaretUp = {
  prefix: 'fal',
  iconName: 'caret-up',
  icon: [320, 512, [], "f0d8", "M32.01 320h255.1c28.37 0 42.74-34.5 22.62-54.63l-127.1-128c-12.5-12.5-32.75-12.5-45.25 0l-127.1 128C-10.73 285.5 3.519 320 32.01 320zM160 160l127.1 128H32.04L160 160z"]
};
var faCircleCheck = {
  prefix: 'fal',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M235.3 331.3C229.1 337.6 218.9 337.6 212.7 331.3L148.7 267.3C142.4 261.1 142.4 250.9 148.7 244.7C154.9 238.4 165.1 238.4 171.3 244.7L224 297.4L340.7 180.7C346.9 174.4 357.1 174.4 363.3 180.7C369.6 186.9 369.6 197.1 363.3 203.3L235.3 331.3zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 32C132.3 32 32 132.3 32 256C32 379.7 132.3 480 256 480C379.7 480 480 379.7 480 256C480 132.3 379.7 32 256 32z"]
};
var faCheckCircle = faCircleCheck;
var faCircleInfo = {
  prefix: 'fal',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM256 184c13.25 0 24-10.74 24-24c0-13.25-10.75-24-24-24S232 146.7 232 160C232 173.3 242.7 184 256 184zM304 352h-32V240C272 231.2 264.8 224 256 224H224C215.2 224 208 231.2 208 240S215.2 256 224 256h16v96h-32C199.2 352 192 359.2 192 368C192 376.8 199.2 384 208 384h96c8.836 0 16-7.164 16-16C320 359.2 312.8 352 304 352z"]
};
var faInfoCircle = faCircleInfo;
var faEyeDropper = {
  prefix: 'fal',
  iconName: 'eye-dropper',
  icon: [512, 512, ["eye-dropper-empty", "eyedropper"], "f1fb", "M180.7 155.3C174.4 149.1 174.4 138.9 180.7 132.7C186.9 126.4 197.1 126.4 203.3 132.7L220.7 150.1L341.6 29.23C380.6-9.744 443.8-9.744 482.8 29.23C521.7 68.21 521.7 131.4 482.8 170.4L361.9 291.3L379.3 308.7C385.6 314.9 385.6 325.1 379.3 331.3C373.1 337.6 362.9 337.6 356.7 331.3L180.7 155.3zM339.3 268.6L460.1 147.8C486.6 121.3 486.6 78.34 460.1 51.86C433.7 25.38 390.7 25.38 364.2 51.86L243.4 172.7L339.3 268.6zM78.06 344.6C69.06 353.6 64 365.8 64 378.5V428.2L37.67 474.3L83.75 448H133.5C146.2 448 158.4 442.9 167.4 433.9L276.7 324.7C282.9 318.4 293.1 318.4 299.3 324.7C305.6 330.9 305.6 341.1 299.3 347.3L190.1 456.6C175.1 471.6 154.7 480 133.5 480H92.25L42.85 508.2C38.53 510.7 33.63 512 28.64 512C12.82 512 0 499.2 0 483.4C0 478.4 1.301 473.5 3.774 469.1L32 419.8V378.5C32 357.3 40.43 336.9 55.43 321.9L164.7 212.7C170.9 206.4 181.1 206.4 187.3 212.7C193.6 218.9 193.6 229.1 187.3 235.3L78.06 344.6z"]
};
var faGear = {
  prefix: 'fal',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", "M168 255.1C168 207.4 207.4 167.1 256 167.1C304.6 167.1 344 207.4 344 255.1C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 255.1zM256 199.1C225.1 199.1 200 225.1 200 255.1C200 286.9 225.1 311.1 256 311.1C286.9 311.1 312 286.9 312 255.1C312 225.1 286.9 199.1 256 199.1zM65.67 230.6L25.34 193.8C14.22 183.7 11.66 167.2 19.18 154.2L49.42 101.8C56.94 88.78 72.51 82.75 86.84 87.32L138.8 103.9C152.2 93.56 167 84.96 182.8 78.43L194.5 25.16C197.7 10.47 210.7 0 225.8 0H286.2C301.3 0 314.3 10.47 317.5 25.16L329.2 78.43C344.1 84.96 359.8 93.56 373.2 103.9L425.2 87.32C439.5 82.75 455.1 88.78 462.6 101.8L492.8 154.2C500.3 167.2 497.8 183.7 486.7 193.8L446.3 230.6C447.4 238.9 448 247.4 448 255.1C448 264.6 447.4 273.1 446.3 281.4L486.7 318.2C497.8 328.3 500.3 344.8 492.8 357.8L462.6 410.2C455.1 423.2 439.5 429.2 425.2 424.7L373.2 408.1C359.8 418.4 344.1 427 329.2 433.6L317.5 486.8C314.3 501.5 301.3 512 286.2 512H225.8C210.7 512 197.7 501.5 194.5 486.8L182.8 433.6C167 427 152.2 418.4 138.8 408.1L86.84 424.7C72.51 429.2 56.94 423.2 49.42 410.2L19.18 357.8C11.66 344.8 14.22 328.3 25.34 318.2L65.67 281.4C64.57 273.1 64 264.6 64 255.1C64 247.4 64.57 238.9 65.67 230.6V230.6zM158.4 129.2L145.1 139.5L77.13 117.8L46.89 170.2L99.58 218.2L97.39 234.8C96.47 241.7 96 248.8 96 255.1C96 263.2 96.47 270.3 97.39 277.2L99.58 293.8L46.89 341.8L77.13 394.2L145.1 372.5L158.4 382.8C169.5 391.4 181.9 398.6 195 403.1L210.5 410.4L225.8 480H286.2L301.5 410.4L316.1 403.1C330.1 398.6 342.5 391.4 353.6 382.8L366.9 372.5L434.9 394.2L465.1 341.8L412.4 293.8L414.6 277.2C415.5 270.3 416 263.2 416 256C416 248.8 415.5 241.7 414.6 234.8L412.4 218.2L465.1 170.2L434.9 117.8L366.9 139.5L353.6 129.2C342.5 120.6 330.1 113.4 316.1 108L301.5 101.6L286.2 32H225.8L210.5 101.6L195 108C181.9 113.4 169.5 120.6 158.4 129.2H158.4z"]
};
var faCog = faGear;
var faItalic = {
  prefix: 'fal',
  iconName: 'italic',
  icon: [384, 512, [], "f033", "M384 48C384 56.84 376.8 64 368 64h-83.27L132.1 448H208c8.844 0 16 7.156 16 16S216.8 480 208 480h-192C7.156 480 0 472.8 0 464S7.156 448 16 448h83.27l152.6-384H176C167.2 64 160 56.84 160 48S167.2 32 176 32h192C376.8 32 384 39.16 384 48z"]
};
var faListOl = {
  prefix: 'fal',
  iconName: 'list-ol',
  icon: [576, 512, ["list-1-2", "list-numeric"], "f0cb", "M64 48.04C64 39.2 71.16 32.04 80 32.04H112C120.8 32.04 128 39.2 128 48.04V192H160C168.8 192 176 199.2 176 208C176 216.9 168.8 224 160 224H64C55.16 224 48 216.9 48 208C48 199.2 55.16 192 64 192H96V64.04H80C71.16 64.04 64 56.87 64 48.04V48.04zM224 96C224 87.16 231.2 80 240 80H528C536.8 80 544 87.16 544 96C544 104.8 536.8 112 528 112H240C231.2 112 224 104.8 224 96zM224 256C224 247.2 231.2 240 240 240H528C536.8 240 544 247.2 544 256C544 264.8 536.8 272 528 272H240C231.2 272 224 264.8 224 256zM224 416C224 407.2 231.2 400 240 400H528C536.8 400 544 407.2 544 416C544 424.8 536.8 432 528 432H240C231.2 432 224 424.8 224 416zM75.31 339.3C69.07 345.6 58.94 345.6 52.69 339.3C46.44 333.1 46.44 322.9 52.69 316.7L68.1 301.3C92.28 277.1 131.9 278.4 154.4 304.1C174.4 326.1 173.8 361.2 153.1 383.4L92.82 448H160C168.8 448 176 455.2 176 464C176 472.8 168.8 480 160 480H56C49.63 480 43.87 476.2 41.33 470.4C38.79 464.5 39.96 457.7 44.3 453.1L129.7 361.6C139.2 351.4 139.5 335.7 130.3 325.2C119.1 313.4 101.8 312.8 90.73 323.9L75.31 339.3z"]
};
var faListUl = {
  prefix: 'fal',
  iconName: 'list-ul',
  icon: [512, 512, ["list-dots"], "f0ca", "M64 64C81.67 64 96 78.33 96 96C96 113.7 81.67 128 64 128C46.33 128 32 113.7 32 96C32 78.33 46.33 64 64 64zM496 80C504.8 80 512 87.16 512 96C512 104.8 504.8 112 496 112H176C167.2 112 160 104.8 160 96C160 87.16 167.2 80 176 80H496zM496 240C504.8 240 512 247.2 512 256C512 264.8 504.8 272 496 272H176C167.2 272 160 264.8 160 256C160 247.2 167.2 240 176 240H496zM496 400C504.8 400 512 407.2 512 416C512 424.8 504.8 432 496 432H176C167.2 432 160 424.8 160 416C160 407.2 167.2 400 176 400H496zM64 288C46.33 288 32 273.7 32 256C32 238.3 46.33 224 64 224C81.67 224 96 238.3 96 256C96 273.7 81.67 288 64 288zM64 384C81.67 384 96 398.3 96 416C96 433.7 81.67 448 64 448C46.33 448 32 433.7 32 416C32 398.3 46.33 384 64 384z"]
};
var faStrikethrough = {
  prefix: 'fal',
  iconName: 'strikethrough',
  icon: [512, 512, [], "f0cc", "M496 256h-184.3c-16.93-5.691-34.37-10.77-51.52-15.49L241.3 235.3C159.1 212 119.3 189.8 129.6 132.5c9.484-52.77 72.56-78.39 160.7-65.03c18.53 2.796 40.34 8.48 68.61 17.9c8.453 2.796 17.45-1.734 20.23-10.1c2.797-8.387-1.734-17.45-10.11-20.23C339 44.1 315.5 38.91 295.1 35.81c-106.9-16.1-184.2 19.65-197 91.02C83.89 205.9 145.4 238.1 199.2 256H16c-8.844 0-16 7.162-16 16s7.156 15.98 16 15.98h480c8.844 0 16-7.144 16-15.98S504.8 256 496 256zM382.4 351.1c1.51 8.233 1.887 17.15 .0156 27.57c-9.469 52.79-72.61 78.26-160.8 65.03c-28.48-4.139-61.03-15.43-89.75-25.38l-14.66-5.06c-8.359-2.889-17.45 1.609-20.31 9.964c-2.86 8.371 1.609 17.46 9.969 20.3l14.5 4.998c30.08 10.43 64.16 22.26 95.56 26.82C233.9 478.8 250.2 480 265.5 480c81.2 0 137.6-34.8 148.4-94.82c2.197-12.23 2.451-23.16 1.422-33.22H382.4z"]
};
var faSubscript = {
  prefix: 'fal',
  iconName: 'subscript',
  icon: [512, 512, [], "f12c", "M336 96C344.8 96 352 88.84 352 80S344.8 64 336 64L288 64.01c-5.469 0-10.56 2.79-13.5 7.399L176 226.2L77.5 71.41C74.56 66.8 69.47 64.01 64 64.01L16 64C7.156 64 0 71.16 0 80S7.156 96 16 96h39.22l101.8 160l-101.8 160H16C7.156 416 0 423.2 0 432S7.156 448 16 448L64 448c5.469 0 10.56-2.804 13.5-7.414L176 285.8l98.5 154.8c2.938 4.609 8.031 7.414 13.5 7.414L336 448c8.844 0 16-7.156 16-16S344.8 416 336 416h-39.22L194.1 256l101.8-160H336zM496 480h-32v-144c0-8.844-7.156-16-16-16h-32c-8.844 0-16 7.156-16 16S407.2 352 416 352h16v128h-32c-8.844 0-16 7.156-16 16s7.156 16 16 16h96c8.844 0 16-7.156 16-16S504.8 480 496 480z"]
};
var faSuperscript = {
  prefix: 'fal',
  iconName: 'superscript',
  icon: [512, 512, [], "f12b", "M336 96C344.8 96 352 88.84 352 80S344.8 64 336 64L288 64.01c-5.469 0-10.56 2.79-13.5 7.399L176 226.2L77.5 71.41C74.56 66.8 69.47 64.01 64 64.01L16 64C7.156 64 0 71.16 0 80S7.156 96 16 96h39.22l101.8 160l-101.8 160H16C7.156 416 0 423.2 0 432S7.156 448 16 448L64 448c5.469 0 10.56-2.804 13.5-7.414L176 285.8l98.5 154.8c2.938 4.609 8.031 7.414 13.5 7.414L336 448c8.844 0 16-7.156 16-16S344.8 416 336 416h-39.22L194.1 256l101.8-160H336zM496 160h-32V16C464 7.156 456.8 0 448 0h-32c-8.844 0-16 7.156-16 16S407.2 32 416 32h16v128h-32C391.2 160 384 167.2 384 176S391.2 192 400 192h96C504.8 192 512 184.8 512 176S504.8 160 496 160z"]
};
var faTextSize = {
  prefix: 'fal',
  iconName: 'text-size',
  icon: [640, 512, [], "f894", "M0 48l0 96C0 152.8 7.156 160 16 160S32 152.8 32 144V64h144v384h-64C103.2 448 96 455.2 96 464S103.2 480 112 480h160C280.8 480 288 472.8 288 464S280.8 448 272 448h-64V64H352v80C352 152.8 359.2 160 368 160S384 152.8 384 144v-96C384 39.16 376.8 32 368 32h-352C7.156 32 0 39.16 0 48zM320 240v64c0 8.844 7.156 16 16 16S352 312.8 352 304V256h112v192H416c-8.844 0-16 7.156-16 16S407.2 480 416 480h128c8.844 0 16-7.156 16-16S552.8 448 544 448h-48V256H608v48c0 8.844 7.156 16 16 16S640 312.8 640 304v-64C640 231.2 632.8 224 624 224h-288C327.2 224 320 231.2 320 240z"]
};
var faTextSlash = {
  prefix: 'fal',
  iconName: 'text-slash',
  icon: [640, 512, ["remove-format"], "f87d", "M347.9 64l-25.86 112l27.78 21.94l30.92-133.1h163.3v47.1c0 8.799 7.199 15.1 16 15.1c8.801 0 16-7.201 16-15.1V48c0-8.838-7.164-15.1-16-15.1H143.1c-1.248 0-2.352 .4414-3.518 .7109l39.63 31.29H347.9zM352 448H292.1l25.86-112.1l-27.78-21.94l-30.92 133.1H191.1c-8.801 0-16 7.199-16 15.1c0 8.799 7.2 16.01 16 16.01h160c8.801 0 16-7.208 16-16.01C368 455.2 360.8 448 352 448zM633.9 483.4L25.92 3.42c-6.938-5.453-17-4.25-22.48 2.641C-2.032 12.1-.8446 23.06 6.077 28.55l608 480C617 510.9 620.5 512 623.1 512c4.734 0 9.422-2.094 12.58-6.078C642 498.1 640.8 488.9 633.9 483.4z"]
};
var faRemoveFormat = faTextSlash;
var faTriangleExclamation = {
  prefix: 'fal',
  iconName: 'triangle-exclamation',
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 360c-13.25 0-23.1 10.74-23.1 24c0 13.25 10.75 24 23.1 24c13.25 0 23.1-10.75 23.1-24C280 370.7 269.3 360 256 360zM256 320c8.843 0 15.1-7.156 15.1-16V160c0-8.844-7.155-16-15.1-16S240 151.2 240 160v144C240 312.8 247.2 320 256 320zM504.3 397.3L304.5 59.38C294.4 42.27 276.2 32.03 256 32C235.8 32 217.7 42.22 207.5 59.36l-199.9 338c-10.05 16.97-10.2 37.34-.4218 54.5C17.29 469.5 35.55 480 56.1 480h399.9c20.51 0 38.75-10.53 48.81-28.17C514.6 434.7 514.4 414.3 504.3 397.3zM476.1 435.1C472.7 443.5 464.8 448 455.1 448H56.1c-8.906 0-16.78-4.484-21.08-12c-4.078-7.156-4.015-15.3 .1562-22.36L235.1 75.66C239.4 68.36 247.2 64 256 64c0 0-.0156 0 0 0c8.765 .0156 16.56 4.359 20.86 11.64l199.9 338C480.1 420.7 481.1 428.8 476.1 435.1z"]
};
var faUnderline = {
  prefix: 'fal',
  iconName: 'underline',
  icon: [448, 512, [], "f0cd", "M16 32.01L64 32v218.4c0 85.15 64.14 159.6 149.1 165.3C306.3 421.8 384 347.9 384 256V32l48 .0098c8.801 0 16-7.211 16-16.01C448 7.199 440.8 0 432 0l-128 .0098c-8.799 0-16 7.189-16 15.99C288 24.8 295.2 32 304 32H352v219.7c0 68.21-51.53 127.7-119.6 132.1C157.8 388.5 96 329.5 96 256V32h48C152.8 32 160 24.8 160 16c0-8.801-7.199-15.99-16-15.99L16 0C7.201 0 0 7.199 0 16C0 24.8 7.201 32.01 16 32.01zM432 480h-416C7.201 480 0 487.2 0 496C0 504.8 7.201 512 16 512h416c8.801 0 16-7.201 16-16C448 487.2 440.8 480 432 480z"]
};

/*!
 * Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2022 Fonticons, Inc.
 */
var faChevronDown = {
  prefix: 'far',
  iconName: 'chevron-down',
  icon: [448, 512, [], "f078", "M432.6 209.3l-191.1 183.1C235.1 397.8 229.1 400 224 400s-11.97-2.219-16.59-6.688L15.41 209.3C5.814 200.2 5.502 184.1 14.69 175.4c9.125-9.625 24.38-9.938 33.91-.7187L224 342.8l175.4-168c9.5-9.219 24.78-8.906 33.91 .7187C442.5 184.1 442.2 200.2 432.6 209.3z"]
};
var faChevronLeft = {
  prefix: 'far',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", "M206.7 464.6l-183.1-191.1C18.22 267.1 16 261.1 16 256s2.219-11.97 6.688-16.59l183.1-191.1c9.152-9.594 24.34-9.906 33.9-.7187c9.625 9.125 9.938 24.37 .7187 33.91L73.24 256l168 175.4c9.219 9.5 8.906 24.78-.7187 33.91C231 474.5 215.8 474.2 206.7 464.6z"]
};
var faChevronRight = {
  prefix: 'far',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", "M113.3 47.41l183.1 191.1c4.469 4.625 6.688 10.62 6.688 16.59s-2.219 11.97-6.688 16.59l-183.1 191.1c-9.152 9.594-24.34 9.906-33.9 .7187c-9.625-9.125-9.938-24.38-.7187-33.91l168-175.4L78.71 80.6c-9.219-9.5-8.906-24.78 .7187-33.91C88.99 37.5 104.2 37.82 113.3 47.41z"]
};
var faChevronUp = {
  prefix: 'far',
  iconName: 'chevron-up',
  icon: [448, 512, [], "f077", "M15.41 302.7l191.1-183.1C212 114.2 218 111.1 224 111.1s11.97 2.219 16.59 6.688l191.1 183.1c9.594 9.152 9.906 24.34 .7187 33.9c-9.125 9.625-24.38 9.938-33.91 .7187L224 169.2l-175.4 168c-9.5 9.219-24.78 8.906-33.91-.7187C5.502 327 5.814 311.8 15.41 302.7z"]
};
var faXmark = {
  prefix: 'far',
  iconName: 'xmark',
  icon: [320, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"]
};
var faTimes = faXmark;

// ObjectTable symbols
var keySymbol = Symbol();
var cssClassSymbol = Symbol();
var componentTypeMapSymbol = Symbol();
var componentPropMapSymbol = Symbol();
var originalObjectSymbol = Symbol(); // form/input symbols.
// FIXME, make this work by using InjectionKey<SBFormInputHandler>

var registerInputFieldSymbol = Symbol();
var unregisterInputFieldSymbol = Symbol(); // Cookie modal

var cookieModalSingletonSymbol = Symbol();

/*
 * Helper constants and functions
 */
var Keys;

(function (Keys) {
  Keys["Backspace"] = "Backspace";
  Keys["Clear"] = "Clear";
  Keys["Down"] = "ArrowDown";
  Keys["End"] = "End";
  Keys["Enter"] = "Enter";
  Keys["Escape"] = "Escape";
  Keys["Home"] = "Home";
  Keys["Left"] = "ArrowLeft";
  Keys["PageDown"] = "PageDown";
  Keys["PageUp"] = "PageUp";
  Keys["Right"] = "ArrowRight";
  Keys["Space"] = " ";
  Keys["Tab"] = "Tab";
  Keys["Up"] = "ArrowUp";
})(Keys || (Keys = {}));

var MenuActions;

(function (MenuActions) {
  MenuActions[MenuActions["Close"] = 0] = "Close";
  MenuActions[MenuActions["CloseSelect"] = 1] = "CloseSelect";
  MenuActions[MenuActions["First"] = 2] = "First";
  MenuActions[MenuActions["Last"] = 3] = "Last";
  MenuActions[MenuActions["Next"] = 4] = "Next";
  MenuActions[MenuActions["Open"] = 5] = "Open";
  MenuActions[MenuActions["Previous"] = 6] = "Previous";
  MenuActions[MenuActions["Select"] = 7] = "Select";
  MenuActions[MenuActions["Space"] = 8] = "Space";
  MenuActions[MenuActions["Type"] = 9] = "Type";
})(MenuActions || (MenuActions = {}));

var ComboBoxUtil = /*#__PURE__*/function () {
  function ComboBoxUtil() {
    _classCallCheck$4(this, ComboBoxUtil);
  }

  _createClass$4(ComboBoxUtil, null, [{
    key: "getActionFromKey",
    value: // return combobox action from key press
    function getActionFromKey(key, menuOpen) {
      // handle opening when closed
      if (!menuOpen && key === Keys.Down) {
        return MenuActions.Open;
      } // handle keys when open


      if (key === Keys.Down) {
        return MenuActions.Next;
      } else if (key === Keys.Up) {
        return MenuActions.Previous;
      } else if (key === Keys.Home) {
        return MenuActions.First;
      } else if (key === Keys.End) {
        return MenuActions.Last;
      } else if (key === Keys.Escape) {
        return MenuActions.Close;
      } else if (key === Keys.Enter) {
        return MenuActions.CloseSelect;
      } else if (key === Keys.Backspace || key === Keys.Clear || key.length === 1) {
        return MenuActions.Type;
      } else {
        return null;
      }
    } // get updated option index

  }, {
    key: "getUpdatedIndex",
    value: function getUpdatedIndex(current, max, action) {
      switch (action) {
        case MenuActions.First:
          return 0;

        case MenuActions.Last:
          return max;

        case MenuActions.Previous:
          return Math.max(0, current - 1);

        case MenuActions.Next:
          return Math.min(max, current + 1);

        default:
          return current;
      }
    } // check if an element is currently scrollable

  }, {
    key: "isScrollable",
    value: function isScrollable(element) {
      return element && element.clientHeight < element.scrollHeight;
    } // ensure given child element is within the parent's visible scroll area

  }, {
    key: "maintainScrollVisibility",
    value: function maintainScrollVisibility(activeElement, scrollParent) {
      var offsetHeight = activeElement.offsetHeight,
          offsetTop = activeElement.offsetTop;
      var parentOffsetHeight = scrollParent.offsetHeight,
          scrollTop = scrollParent.scrollTop;
      var isAbove = offsetTop < scrollTop;
      var isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;

      if (isAbove) {
        scrollParent.scrollTo(0, offsetTop);
      } else if (isBelow) {
        scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
      }
    }
  }]);

  return ComboBoxUtil;
}();

function isEmptyOrNull(val) {
  var _val;

  var trimFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  val = (_val = val) !== null && _val !== void 0 ? _val : "";

  if (trimFirst) {
    val = val.trim();
  }

  return val.length === 0;
}
/**
 * Generate a unique id.
 *
 * This id is guaranteed to be unique among the entire project, so is suitable for html element id, v-for keys etc.
 */

function uuid() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "uuid-";
  var time = Date.now().toString(36); // .substring(2) is to remove period from math.random

  var randomString = Math.random().toString(36).substring(2);
  return prefix + time + randomString;
}
/**
 * Return true, if the value is a number or a string that is a valid number
 *
 *  Returns false for infinities and NaN
 * @param val
 */

function isNumber(val) {
  // val - val === 0 is Number.isFinite with IE9 support
  if (typeof val === "number") {
    return val - val === 0;
  } // +"" = 0


  if (typeof val === "string" && val.trim().length > 0) {
    return +val - +val === 0;
  }

  return false;
}

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$2);
}

var isSymbol_1 = isSymbol;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

/**
 * Handle comparison, returns 0 if both are equal -1 or 1 otherwise (depending on asc)
 *
 * Handles number/boolean/null/string/Date types (but not arrays)
 *
 * @returns {-1 | 1 | 0} 0 if equal, -1 or 1 otherwise
 */
function compare$1(a, b, asc) {
  if (a == null && b == null) {
    return 0;
  } // Handle nulls as smaller than any other value


  if (a == null) {
    return -1 * asc;
  }

  if (b == null) {
    return asc;
  } // Check if we can turn a and b safely to a number


  if (isNumber(a) && isNumber(b)) {
    a = +a;
    b = +b;
  } // If strings, compareIgnoring case


  if (typeof a === "string") {
    a = a.toLowerCase();
  }

  if (typeof b === "string") {
    b = b.toLowerCase();
  } // Convert boolean to int


  if (typeof a === "boolean") {
    a = +a;
  }

  if (typeof b === "boolean") {
    b = +b;
  } // Finally, let js handle any missing conversions and compare (note dates have not modified and js handles compare fine)


  if (a > b) return asc * 1;
  if (a < b) return asc * -1;
  return 0;
}
/**
 * Sort array of items
 *
 * @param list Array to sort
 * @param path path of the object property
 * @param asc Sort ascending true/false
 */


function sort(list, path, asc) {
  // No array, do nothing
  if (Array.isArray(list) === false) return; // No sort attribute, do nothing

  if (typeof path !== "string") return; // Transform asc to multiplier 1 or -1

  var ascMultiplier = asc ? 1 : -1; // Sort the array
  //FIXME, this function could be more elegant

  list.sort(function (a, b) {
    if (a == null || b == null) {
      return compare$1(a, b, ascMultiplier);
    }

    var valA, valB;
    valA = get_1(a, path);
    valB = get_1(b, path); //Treat empty string as null

    if (typeof valA === "string" && valA.trim() === "") {
      valA = null;
    }

    if (typeof valB === "string" && valB.trim() === "") {
      valB = null;
    } // FIXME; treat NaN/ infinity as null?
    //treat empty array as null


    if (Array.isArray(valA) && valA.length === 0) {
      valA = null;
    }

    if (Array.isArray(valB) && valB.length === 0) {
      valB = null;
    } // If either value is null, return


    if (valA == null || valB == null) {
      return compare$1(valA, valB, ascMultiplier);
    } //If only one is an array, convert other to an array with a single element


    if (Array.isArray(valB) && !Array.isArray(valA)) {
      valA = [valA];
    }

    if (Array.isArray(valA) && !Array.isArray(valB)) {
      valB = [valB];
    } // Compare element by element until we find unequal elements, or B runs out of elements
    //FIXME, handles one array being longer than the other as if the array had null as elements, is this ok?


    if (Array.isArray(valA) && Array.isArray(valB)) {
      for (var index = 0; index < valA.length; index++) {
        var aElement = valA[index];
        var bElement = valB[index]; // this can be undefined, if valB length is exceeded

        var compareRes = compare$1(aElement, bElement, ascMultiplier);
        if (compareRes !== 0) return compareRes;
      } // We have checked, that every element in A matched the same element in B
      // If A is longer than B, we have already returned,
      // here we return that either B is larger (since it has more elements) or 0 if lengths are equal


      return compare$1(valA.length, valB.length, ascMultiplier);
    } // Fallback
    // FIXME valA is a date, valB is not?
    // Compare handles null/ string / date / int sorting


    return compare$1(valA, valB, ascMultiplier);
  });
}
/**
 * Format the passed value for display
 * @param val
 */

function formatDisplayValue(val) {
  if (val instanceof Date) {
    return val.toLocaleDateString();
  }

  if (Array.isArray(val)) {
    return val.map(formatDisplayValue).join(", ");
  }

  return String(val !== null && val !== void 0 ? val : "");
}
/**
 * Resolve component type and props from the given factory
 *
 * The return value is a tuple, the first value should be passed to component :is and the second to v-bind,
 *
 * &lt;component :is="ret[0]" v-bind="ret[1]" &gt;
 *
 *
 * @param factory
 * @param args
 * @param defaultComponent
 * @returns
 */

function resolveComponentFromCustomFactory(factory, args, defaultComponent) {
  if (factory == null || typeof factory !== "function") {
    var _defaultComponent$is;

    return [(_defaultComponent$is = defaultComponent.is) !== null && _defaultComponent$is !== void 0 ? _defaultComponent$is : "div", _objectSpread2$2({}, defaultComponent.props)];
  }

  var retValue = factory.apply(void 0, _toConsumableArray$2(args));

  if (retValue == null) {
    var _defaultComponent$is2;

    return [(_defaultComponent$is2 = defaultComponent.is) !== null && _defaultComponent$is2 !== void 0 ? _defaultComponent$is2 : "div", _objectSpread2$2({}, defaultComponent.props)];
  }

  var ret;

  if (typeof retValue === "string") {
    ret = [retValue, _objectSpread2$2({}, defaultComponent.props)];
  } else {
    var _ref, _retValue$is, _ref2, _retValue$props;

    ret = [(_ref = (_retValue$is = retValue.is) !== null && _retValue$is !== void 0 ? _retValue$is : defaultComponent.is) !== null && _ref !== void 0 ? _ref : "div", _objectSpread2$2({}, (_ref2 = (_retValue$props = retValue.props) !== null && _retValue$props !== void 0 ? _retValue$props : defaultComponent.props) !== null && _ref2 !== void 0 ? _ref2 : {})];
  }

  return ret;
}

/**
 * Boolean flag controlling, if we are building the bundle for dev or not.
 *
 * Usage:
 * @example
 * if(IS_DEV) {
 * // Anything in this branch will be removed from the final production build
 * }
 */
var IS_DEV = "production" !== "production";
/**
 * Boolean flag telling, if we are running in a browser or not
 */

var IS_SSR = typeof window === "undefined";

/**
 * Check if the given mouseevent is a ctrl click, or cmd click for macos.
 *
 * @param {MouseEvent} event
 */

function isCtrlClick(event) {
  //metaKey can be true for windows if win key is pressed, but I think we can live with that
  return (event === null || event === void 0 ? void 0 : event.ctrlKey) === true || (event === null || event === void 0 ? void 0 : event.metaKey) === true;
}
/**
 * Check if the given mouseevent is a shift click
 *
 * @param {MouseEvent} event
 */

function isShiftClick(event) {
  //metaKey can be true for windows if win key is pressed, but I think we can live with that
  return !!(event !== null && event !== void 0 && event.shiftKey);
}
/**
 * Helper to set a cookie.
 *
 * Payload must contain only ascii [a-z], [A-Z], [0-9] or you will be very sad
 *
 * Use encodeToString for any potential dynamic input (if it may contain even simple ascii characters like '=')
 *
 * First two argument are the cookie name and payload, the third argument is an optional options object, that can be used to set the various cookie options
 *
 * Default expiration is 1 day, same-site "None", path=/ and no domain
 *
 * @param {string} name, make sure this only contains plain ascii ([a-z], [A-Z], [0-9] and '-')
 * @param {string} payload, make sure this only contains plain ascii ([a-z], [A-Z], [0-9] and '-')
 * @param {object} options, set cookie options
 * @param {number} options.maxAge cookie max age in seconds. Use null/undefined for a session cookie (deleted when the browser window closes). Value of 0 deletes the cookie. Default value is 1 day
 * @param {string} options.sameSite sameSite value. Default to None (is included in CORS request, if the server uses an appropriate CORS config)
 * @param {string} options.domain Cookie domain, null/undefined (the default) omits this field. Use "sarake.fi" value for a cookie included for all sarake.fi domains (including subdomains)
 * @param {string} options.path Cookie path. Defaults to "/" (all paths)
 */

function setCookie(name, payload) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$maxAge = _ref.maxAge,
      maxAge = _ref$maxAge === void 0 ? 60 * 60 * 24 : _ref$maxAge,
      _ref$sameSite = _ref.sameSite,
      sameSite = _ref$sameSite === void 0 ? "Lax" : _ref$sameSite,
      _ref$domain = _ref.domain,
      domain = _ref$domain === void 0 ? undefined : _ref$domain,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? "/" : _ref$path,
      _ref$secure = _ref.secure,
      secure = _ref$secure === void 0 ? false : _ref$secure;

  var cookie = "".concat(name, "=").concat(payload, "; path=").concat(path, "; SameSite=").concat(sameSite);

  if (domain != null) {
    cookie += "; Domain=" + domain;
  }

  if (maxAge != null) {
    cookie += "; Max-Age=" + maxAge;
  }

  if (secure) {
    cookie += "; Secure";
  }

  document.cookie = cookie;
}
/**
 * Helper to get a cookie string value as is
 *
 * Returns undefined, if no matching cookie is found
 */

function getCookie(target) {
  var _iterator = _createForOfIteratorHelper(document.cookie.split(";")),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cookie = _step.value;
      // Everything after the first "=" is the cookie
      var name = cookie.substring(0, cookie.indexOf("="));

      if (name.trim().toLowerCase() === target.trim().toLowerCase()) {
        var payload = cookie.substring(name.length + 1, cookie.length);
        return payload;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return undefined;
}
/**
 * Helper to remove a cookie with the given name
 */

function removeCookie(name) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$sameSite = _ref2.sameSite,
      sameSite = _ref2$sameSite === void 0 ? "None" : _ref2$sameSite,
      _ref2$domain = _ref2.domain,
      domain = _ref2$domain === void 0 ? undefined : _ref2$domain,
      _ref2$path = _ref2.path,
      path = _ref2$path === void 0 ? "/" : _ref2$path;

  setCookie(name, "", {
    sameSite: sameSite,
    domain: domain,
    path: path,
    maxAge: 0
  });
}

/**
 * A simple wrapper around an input field and it's label. Supports utility values for positioning the label. Note using components are responsible for rendering the label lag, this wrapper is just a helper to position the label
 *
 * Note for rendering, please make sure the label is first in DOM order
 */

var script$q = defineComponent({
  name: "InputLabelWrapper",
  data: function data() {
    var id = uuid(); // Injectable handler. Create handler inside method for better tsc stuff

    var inputFieldHandler = this.getSBHandler();
    return {
      inputHasFocus: false,

      /**
       * Updated to true, after the input has been touched
       */
      isTouched: false,
      // id for debugging. FIXME, get the actual id from our children
      id: id,
      inputFieldHandler: inputFieldHandler,
      forceDisplayError: false
    };
  },
  created: function created() {
    if (this[registerInputFieldSymbol]) {
      this[registerInputFieldSymbol](this.inputFieldHandler);
    }
  },
  unmounted: function unmounted() {
    if (this[unregisterInputFieldSymbol]) {

      this[unregisterInputFieldSymbol](this.inputFieldHandler);
    }
  },
  setup: function setup() {
    var _ref;

    return _ref = {}, _defineProperty$8(_ref, registerInputFieldSymbol, inject(registerInputFieldSymbol, function () {
    }, false)), _defineProperty$8(_ref, unregisterInputFieldSymbol, inject(unregisterInputFieldSymbol, function () {
    }, false)), _ref;
  },
  props: {
    /**
     * Label position
     */
    labelPosition: {
      type: String,
      required: false
    },

    /**
     * Indicate this field as mandatory.
     *
     * Note this simply renders a '*' next to the label, we do not validate the user input in anyway
     */
    indicateMandatory: {
      type: Boolean,
      required: false
    },

    /**
     * If the error message should shown, even if the user is currently modifying the text field.
     *
     * By default errors are only shown, when the field is inactive
     */
    showErrorWhenFocused: {
      type: Boolean,
      required: false
    },

    /**
     * If the error message should shown, even if the user has never blurred the input field
     *
     * By default errors are only shown, after the user has interacted with the input field.
     */
    showErrorOnMount: {
      type: Boolean,
      required: false
    },

    /**
     * True, if the field value is currently invalid
     */
    invalid: {
      type: Boolean,
      required: true
    },

    /**
     * True, if the label is not given or empty
     */
    noLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    labelPositionVal: function labelPositionVal() {
      switch (this.labelPosition) {
        case "bottom":
        case "left":
        case "right":
        case "top":
          return this.labelPosition;

        case null:
        case undefined:
          // return default, but do not print a warning
          return "left";

        default:
          console.error("Invalid label position ", this.labelPosition, "Supported values are bottom, left, right, top", "Defaulting to left");
          return "left";
      }
    },
    shouldShowError: function shouldShowError() {
      if (this.forceDisplayError) return true;

      if (this.inputHasFocus) {
        if (this.showErrorWhenFocused) {
          return true;
        }

        return false;
      }

      if (this.showErrorOnMount) {
        return true;
      }

      return this.isTouched;
    }
  },
  methods: {
    handleFocusOut: function handleFocusOut() {
      this.inputHasFocus = false;
      this.isTouched = true;
      this.forceDisplayError = false;
    },
    didSubmit: function didSubmit() {
      this.isTouched = true;
      this.forceDisplayError = true;
    },

    /**
     * Create the handler in a method for better ts support
     */
    getSBHandler: function getSBHandler() {
      var _this = this;

      return {
        id: this.id,
        didSubmit: function didSubmit() {
          _this.didSubmit();
        },
        isInvalid: function isInvalid() {
          return _this.invalid;
        },
        focusWithError: function focusWithError() {
          var _input$focus;

          var wrapper = _this.$refs.wrapper;
          if (!wrapper) return; // Find our child input

          var input = wrapper.querySelector("input");

          if (!input) {

            return;
          }

          _this.forceDisplayError = true;
          (_input$focus = input.focus) === null || _input$focus === void 0 ? void 0 : _input$focus.call(input);
        }
      };
    }
  }
});

var _hoisted_1$r = ["id"];
var _hoisted_2$p = {
  class: "sb-label"
};
var _hoisted_3$m = {
  key: 0,
  class: "sb-mandatory-indicator"
};
function render$u(_ctx, _cache, $props, $setup, $data, $options) {
  var _ref;

  return openBlock(), createElementBlock("span", {
    id: _ctx.id,
    class: normalizeClass(["sb-input-wrapper", (_ref = {}, _defineProperty$8(_ref, _ctx.labelPositionVal, true), _defineProperty$8(_ref, 'sb-touched', _ctx.isTouched), _defineProperty$8(_ref, 'no-label', _ctx.noLabel), _ref)]),
    ref: "wrapper"
  }, [createElementVNode("div", _hoisted_2$p, [renderSlot(_ctx.$slots, "label"), _ctx.indicateMandatory === true ? (openBlock(), createElementBlock("div", _hoisted_3$m, " * ")) : createCommentVNode("", true)]), createElementVNode("div", {
    class: "sb-input",
    onFocusin: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.inputHasFocus = true;
    }),
    onFocusout: _cache[1] || (_cache[1] = function () {
      return _ctx.handleFocusOut && _ctx.handleFocusOut.apply(_ctx, arguments);
    })
  }, [renderSlot(_ctx.$slots, "input")], 32), renderSlot(_ctx.$slots, "default"), createElementVNode("div", {
    class: normalizeClass(["sb-error", {
      'visually-hidden': !_ctx.shouldShowError
    }]),
    "aria-live": "polite"
  }, [renderSlot(_ctx.$slots, "error")], 2)], 10, _hoisted_1$r);
}

script$q.render = render$u;
script$q.__scopeId = "data-v-0f7e4347";

/**
 * Mimics a select field, but adds a search bar to allow filtering displayed values.
 *
 * Custom properties:
 * <ul>
 * <li>--sb-label-input-gap: control how much margin is between the input field and labelS </li>
 *  <li>--sb-list-select-no-item-color: color property for the no item message </li>
 *  <li> --sb-list-select-item-color: color property for all (selectable) items  </li>
 *  <li> --sb-list-select-border-color: selection box border color </li>
 *  <li> --sb-list-select-highlight-color: color for the currently highlighted item (currently hovered item is also the selected item) </li>
 *  <li> --sb-list-select-highlight-background: background for the currently highlighted item (currently hovered item is also the selected item) </li>
 *   <li>--outline-width: outline width, this is needed to correctly align items </li>
 *   <li>--sb-item-height: Height of a single item </li>
 * </ul>
 */
var script$p = defineComponent({
  name: "SearchableSelectField",
  //FIXME; add support for disabled options
  components: {
    FontAwesomeIcon: FontAwesomeIcon,
    InputLabelWrapper: script$q
  },
  data: function data() {
    return {
      id: uuid(),
      search: "",
      searchIsDirty: false,
      isFocused: false,
      lastValidValue: null,
      highLightedIndex: null
    };
  },
  emits: {
    "update:modelValue": function updateModelValue() {
      return true;
    },
    search: function search() {
      return true;
    },
    blur: function blur() {
      return true;
    },
    focus: function focus() {
      return true;
    }
  },
  props: {
    /**
     * Currently selected value. A null value is used to indicate no selection.
     *
     * Note, that this is marked as optional simply to allow passing null/undefined, but this component should always be used in combination with v-model
     *
     * Value MUST be one of the values in the values array (identically same).
     *
     * Each value must have a label attribute, which is displayed to the user (should be localized) and optionally a key attribute.
     *
     * Key optional must be unique for each value, and should be provided if the label is expected to change. If no key is provided, it is defaulted to label.
     *
     * All other attributes are ignored (values can have arbitrary attributes besides these 2).
     *
     */
    modelValue: {
      type: Object,
      required: false
    },

    /**
     * Message to display, when no items match the user's search criteria
     */
    noItemsMessage: {
      type: String,
      required: true
    },

    /**
     * List of allowed values
     *
     * Each value must have a label attribute, which is displayed to the user (should be localized) and optionally a key attribute.
     *
     * Key optional must be unique for each value, and should be provided if the label is expected to change. If no key is provided, it is defaulted to label.
     *
     * All other attributes are ignored (values are allowed to have arbitrary attributes besides these 2).
     *
     * Note, modelValue will always be identically same to one of these values or null
     */
    values: {
      type: Array,
      required: true
    },

    /**
     * Placeholder to display, when no value is selected
     */
    placeholder: String,

    /**
     * Readonly mode disables all modifications on the dropdown
     */
    readonly: Boolean,

    /**
     * Disable the search input. In this case the input field acts as if a regular dropdown
     */
    disableSearch: Boolean,

    /**
     * How many items are displayed in the dropdown at once (at maximum).
     *
     * Defaults to 8
     *
     * If you want to display all possible items without a scrollbar, you can safely pass a high value here, Number.MAX_SAFE_INTEGER etc.)
     */
    numberOfItemsToDisplay: {
      type: Number,
      required: false,
      default: 8
    },

    /**
     * Input label.
     *
     * Note, if you do no want to render a label, don't simply pass an empty value, but pass a valid value (that will be read by screenreaders) and hide the label with css
     */
    label: {
      type: String,
      required: true
    },

    /**
     * the aria-label html property.
     *
     * Note, do not pass this prop if the label attribute is already good enough for screen readers, if for some reason you want screenreaders to see a different label than regular users, use this property
     */
    ariaLabel: {
      type: String,
      required: false
    },

    /**
     * Label position, defaults to left
     */
    labelPosition: {
      type: String,
      required: false
    },

    /**
     * Indicate this field as mandatory.
     *
     * Note this simply renders a '*' next to the label, we do not validate the user value in anyway
     */
    indicateMandatory: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    wrapperStyle: function wrapperStyle() {
      return {
        display: this.isFocused ? "block" : "none"
      };
    },
    dropdownContainerStyle: function dropdownContainerStyle() {
      return {
        maxHeight: "calc(".concat(this.numberOfItemsToDisplay || 8, " * var(--sb-item-height))")
      };
    },
    filteredOptions: function filteredOptions() {
      var _this = this;

      return this.values.filter(function (item) {
        // If search is not dirty , do nothing
        if (!_this.searchIsDirty) return true;

        if (isEmptyOrNull(_this.search, true)) {
          return true;
        } // Check if search matches the full word (this can happen, if the search contains stop characters)


        if (item.label.toLowerCase().startsWith(_this.search.toLowerCase())) {
          return true;
        } // word separators are whitespace, '.', ',' '-', ';' and '_'


        var wordSeparatorRegex = /\s|\.|,|-|;|_/g; // Split into words and filter empty strings

        var labelWords = item.label.toLowerCase().split(wordSeparatorRegex).filter(function (w) {
          return !!w;
        });

        var searchWords = _this.search.toLowerCase().split(wordSeparatorRegex).filter(function (w) {
          return !!w;
        }); // labelWords.length === 0 is a sanity check, there should be no reason to use a label made entirely with whitespace


        if (labelWords.length === 0 || searchWords.length === 0) return true; // check that each word in search has a equivalent in the label (in the correct order)

        var searchIndex = 0;
        var currentSearchWord = searchWords[0];

        var _iterator = _createForOfIteratorHelper(labelWords),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var currentLabelWord = _step.value;
            if (currentSearchWord == null) break; // (index overflowed, we could return here)

            if (currentLabelWord.startsWith(currentSearchWord)) {
              currentSearchWord = searchWords[++searchIndex];
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return searchIndex >= searchWords.length;
      });
    }
  },
  mounted: function mounted() {
    // Note, vue handles binding
    window.addEventListener("keydown", this.handleKeyboardInputs);
  },
  unmounted: function unmounted() {
    // Note, vue handles binding
    window.removeEventListener("keydown", this.handleKeyboardInputs);
  },
  methods: {
    getKey: function getKey(v) {
      var _v$key;

      return (_v$key = v.key) !== null && _v$key !== void 0 ? _v$key : v.label;
    },

    /**
     *
     * @param {KeyboardEvent} event
     */
    handleKeyboardInputs: function handleKeyboardInputs(event) {
      // If we are not focused, ignore everything
      if (!this.isFocused) return; // Ignore tab

      if (event.key === "Tab" || event.keyCode === 9) {
        return;
      } // Scroll only if we changed the index because of down or up keys


      var scrollIsNeeded = false; // If enter, and we have a highlight, handle as if we clicked the highlighted (if no highlight, do nothing)

      if (event.key === "Enter" || event.keyCode === 13) {
        if (this.highLightedIndex != null && this.filteredOptions[this.highLightedIndex] != null) {
          // We handled enter, nobody else needs to do anything
          event.preventDefault();
          event.stopPropagation();
          this.clickItem(this.filteredOptions[this.highLightedIndex]);
        }

        return;
      } // Unfocus on escape without modifying selection
      else if (event.key === "Escape" || event.keyCode === 27) {
        var _this$modelValue$labe, _this$modelValue, _this$modelValue2, _searchRef, _searchRef$blur;

        // reset search value to value
        this.search = (_this$modelValue$labe = (_this$modelValue = this.modelValue) === null || _this$modelValue === void 0 ? void 0 : _this$modelValue.label) !== null && _this$modelValue$labe !== void 0 ? _this$modelValue$labe : "";
        this.lastValidValue = (_this$modelValue2 = this.modelValue) !== null && _this$modelValue2 !== void 0 ? _this$modelValue2 : null;
        (_searchRef = this.$refs.searchRef) === null || _searchRef === void 0 ? void 0 : (_searchRef$blur = _searchRef.blur) === null || _searchRef$blur === void 0 ? void 0 : _searchRef$blur.call(_searchRef);
        return;
      } // if up or down arrows, move highlighted selection
      else if (event.key === "ArrowUp" || event.keyCode === 38) {
        var _this$highLightedInde;

        event.preventDefault();
        this.highLightedIndex = ((_this$highLightedInde = this.highLightedIndex) !== null && _this$highLightedInde !== void 0 ? _this$highLightedInde : 1) - 1;
        scrollIsNeeded = true;
      } else if (event.key === "ArrowDown" || event.keyCode === 40) {
        var _this$highLightedInde2;

        event.preventDefault();
        this.highLightedIndex = ((_this$highLightedInde2 = this.highLightedIndex) !== null && _this$highLightedInde2 !== void 0 ? _this$highLightedInde2 : -1) + 1;
        scrollIsNeeded = true;
      } else {
        // Event is a generic keyboard input.
        // preventDefault, if search is disabled (prevents keyboard input from firing)
        // FIXME, this is ugly
        if (this.disableSearch === true) {
          event.preventDefault();
        }
      }

      if (this.highLightedIndex == null) return; // Note, this is done even if we didn't change the index here, because keyboard input can have shortened filteredOptions (search)

      if (this.filteredOptions.length === 0) {
        // Remove index, if we have no valid items
        this.highLightedIndex = null; // otherwise, clamp index to 0 or length if we overflowed
      } else if (this.highLightedIndex < 0) {
        this.highLightedIndex = 0;
      } else if (this.highLightedIndex > this.filteredOptions.length - 1) {
        this.highLightedIndex = this.filteredOptions.length - 1;
      } // Scroll after we have set the final values for highLightedIndex
      // Scroll if we changed the highLight because of up/down keys (so hover doesn't cause unexpected scrolling)


      if (scrollIsNeeded) {
        this.scrollIfNeeded();
      }
    },
    handleBlur: function handleBlur(e) {
      this.isFocused = false; // Remove highlight

      this.highLightedIndex = null;
      this.$emit("blur", e);
    },
    handleFocus: function handleFocus(e) {
      this.isFocused = true;
      this.searchIsDirty = false;
      this.$emit("focus", e);
    },

    /**
     *
     * @param {InputEvent} event
     */
    handleSearchInput: function handleSearchInput(event) {
      var _this$search;

      if (this.disableSearch === true) {
        event.preventDefault();
        return;
      }

      this.$emit("search", (_this$search = this.search) !== null && _this$search !== void 0 ? _this$search : "");
      this.searchIsDirty = true;
    },
    clickItem: function clickItem(option) {
      var _option$label, _this$$refs$searchRef, _this$$refs$searchRef2;

      // Blur handles emitting, clamp the search to selection
      this.search = (_option$label = option === null || option === void 0 ? void 0 : option.label) !== null && _option$label !== void 0 ? _option$label : "";

      this.emitChange(option);
      (_this$$refs$searchRef = this.$refs.searchRef) === null || _this$$refs$searchRef === void 0 ? void 0 : (_this$$refs$searchRef2 = _this$$refs$searchRef.blur) === null || _this$$refs$searchRef2 === void 0 ? void 0 : _this$$refs$searchRef2.call(_this$$refs$searchRef);
    },
    emitChange: function emitChange(newValue) {
      var _newValue, _this$modelValue$labe2, _this$modelValue3;

      newValue = (_newValue = newValue) !== null && _newValue !== void 0 ? _newValue : null; // Clamp search to modelValue,
      // it is expected that this will be set to newValue soon, but this way search is correct if the parent is misbehaving

      this.search = (_this$modelValue$labe2 = (_this$modelValue3 = this.modelValue) === null || _this$modelValue3 === void 0 ? void 0 : _this$modelValue3.label) !== null && _this$modelValue$labe2 !== void 0 ? _this$modelValue$labe2 : ""; // emit change if and only if we actually changed our value
      // Note, uses identity checks, we could check key/label here? The parent must pass identically equal items to us

      if (newValue !== this.modelValue) {

        this.$emit("update:modelValue", newValue);
      } // Update valid and emitted value


      this.lastValidValue = newValue;
    },
    clickIcon: function clickIcon(event) {
      // toggle focus
      if (!this.isFocused) {
        var _searchRef2, _searchRef2$focus, _event$preventDefault;

        (_searchRef2 = this.$refs.searchRef) === null || _searchRef2 === void 0 ? void 0 : (_searchRef2$focus = _searchRef2.focus) === null || _searchRef2$focus === void 0 ? void 0 : _searchRef2$focus.call(_searchRef2);
        event === null || event === void 0 ? void 0 : (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 ? void 0 : _event$preventDefault.call(event);
      }
    },
    scrollIfNeeded: function scrollIfNeeded() {
      var _, _this$$refs, _this$$refs2, _this$$refs3, _this$$refs3$opt;

      // If highlighted index changes to a non null value, scroll the selection into view
      if (this.highLightedIndex == null) return; // Both versions of using list refs, because there is some inconsistency in the documentation for vue2 vs 3

      var target = (_ = (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs2 = _this$$refs["opt" + this.highLightedIndex]) === null || _this$$refs2 === void 0 ? void 0 : _this$$refs2[0]) !== null && _ !== void 0 ? _ : (_this$$refs3 = this.$refs) === null || _this$$refs3 === void 0 ? void 0 : (_this$$refs3$opt = _this$$refs3.opt) === null || _this$$refs3$opt === void 0 ? void 0 : _this$$refs3$opt[this.highLightedIndex];
      if (!target) return; // FIXME, this scroll is a bit bloated, equivalent in a modern browser would be
      // target.scrollIntoView?.({ block: "nearest" });
      // But this is not supported in IE or safari

      var container = this.$refs.dropdownContainer;
      if (!container) return;
      var targetRect = target.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect(); // console output for debugging scrolling


      if (containerRect.y + containerRect.height - 1 <= targetRect.y + targetRect.height) {
        // +1 so there is no gap when scrolling down between the highlighted element and the container top
        container.scrollTop = target.offsetTop + 1;
      } else if (targetRect.y < containerRect.y) {
        // FIXME; rewrite this, scroll below the currently bottom visible element instead
        var slotsToScroll = Math.max((this.numberOfItemsToDisplay || 8) - 1, 1);
        container.scrollTop = Math.max(0, target.offsetTop - targetRect.height * slotsToScroll);
      }
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler: function handler(newValue) {
        var _newValue$label;

        // clamp search if value is changed by our parent
        var label = (_newValue$label = newValue === null || newValue === void 0 ? void 0 : newValue.label) !== null && _newValue$label !== void 0 ? _newValue$label : "";

        if (this.search !== label) {
          this.search = label;
        }
      }
    },
    values: {
      immediate: true,
      handler: function handler(values) {
        var _this2 = this;

        // Make sure our modelValue is still a part of values
        // Note the identity checks
        var val = values.find(function (v) {
          return v === _this2.modelValue;
        });

        if (val == null && this.modelValue != null) {

          this.emitChange(null);
        }
      }
    },
    search: function search(newValue) {
      // If we input a valid search, make it our last know valid value
      var opt = this.values.find(function (o) {
        var _ref, _o$label, _o$label$toLowerCase, _newValue$toLowerCase;

        return (_ref = (o === null || o === void 0 ? void 0 : (_o$label = o.label) === null || _o$label === void 0 ? void 0 : (_o$label$toLowerCase = _o$label.toLowerCase) === null || _o$label$toLowerCase === void 0 ? void 0 : _o$label$toLowerCase.call(_o$label)) === (newValue === null || newValue === void 0 ? void 0 : (_newValue$toLowerCase = newValue.toLowerCase) === null || _newValue$toLowerCase === void 0 ? void 0 : _newValue$toLowerCase.call(newValue))) !== null && _ref !== void 0 ? _ref : "";
      });

      if (opt !== undefined) {
        this.lastValidValue = opt;
      }
    }
  }
});

var _hoisted_1$q = ["htmlFor"];
var _hoisted_2$o = ["id", "placeholder", "disabled", "aria-label", "aria-required"];
var _hoisted_3$l = {
  key: 1
};
var _hoisted_4$e = {
  key: 2,
  class: "sb-dropdown-wrapper"
};
var _hoisted_5$c = {
  key: 0,
  class: "sb-item sb-no-items"
};
var _hoisted_6$b = ["onMousedown", "onMousemove"];
function render$t(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _component_input_label_wrapper = resolveComponent("input-label-wrapper");

  return openBlock(), createBlock(_component_input_label_wrapper, {
    "label-position": _ctx.labelPosition,
    class: "sb-search-select-input-wrapper",
    "indicate-mandatory": _ctx.indicateMandatory,
    "no-label": !_ctx.label
  }, {
    label: withCtx(function () {
      return [createElementVNode("label", {
        htmlFor: _ctx.id
      }, toDisplayString$1(_ctx.label), 9, _hoisted_1$q)];
    }),
    input: withCtx(function () {
      return [createElementVNode("span", {
        class: normalizeClass(["sb-searchable-dropdown", [_ctx.isFocused ? 'active' : '', _ctx.disableSearch ? 'no-search' : '']])
      }, [withDirectives(createElementVNode("input", {
        id: _ctx.id,
        ref: "searchRef",
        placeholder: _ctx.placeholder,
        disabled: _ctx.readonly === true,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.search = $event;
        }),
        onFocus: _cache[1] || (_cache[1] = function () {
          return _ctx.handleFocus && _ctx.handleFocus.apply(_ctx, arguments);
        }),
        onBlur: _cache[2] || (_cache[2] = function () {
          return _ctx.handleBlur && _ctx.handleBlur.apply(_ctx, arguments);
        }),
        onInput: _cache[3] || (_cache[3] = function () {
          return _ctx.handleSearchInput && _ctx.handleSearchInput.apply(_ctx, arguments);
        }),
        "aria-label": _ctx.ariaLabel || undefined,
        "aria-required": _ctx.indicateMandatory
      }, null, 40, _hoisted_2$o), [[vModelText, _ctx.search]]), _ctx.readonly !== true ? (openBlock(), createBlock(_component_font_awesome_icon, {
        key: 0,
        class: "sb-chev-icon",
        icon: !_ctx.isFocused ? 'chevron-down' : 'chevron-up'
      }, null, 8, ["icon"])) : (openBlock(), createElementBlock("div", _hoisted_3$l)), _ctx.readonly !== true ? (openBlock(), createElementBlock("div", _hoisted_4$e, [createElementVNode("div", {
        class: "sb-overflow-wrapper",
        style: normalizeStyle(_ctx.wrapperStyle)
      }, [createElementVNode("ol", {
        class: "sb-items",
        ref: "dropdownContainer",
        style: normalizeStyle(_ctx.dropdownContainerStyle)
      }, [_ctx.filteredOptions.length === 0 ? (openBlock(), createElementBlock("li", _hoisted_5$c, toDisplayString$1(_ctx.noItemsMessage), 1)) : (openBlock(true), createElementBlock(Fragment, {
        key: 1
      }, renderList(_ctx.filteredOptions, function (o, index) {
        return openBlock(), createElementBlock("li", {
          class: normalizeClass(["sb-item", {
            highlighted: index === _ctx.highLightedIndex
          }]),
          key: _ctx.getKey(o),
          ref_for: true,
          ref: 'opt' + index,
          onMousedown: function onMousedown($event) {
            return _ctx.clickItem(o);
          },
          onMousemove: function onMousemove($event) {
            return _ctx.highLightedIndex = index;
          }
        }, [renderSlot(_ctx.$slots, "item", {
          value: o
        }, function () {
          return [createTextVNode(toDisplayString$1(o.label), 1)];
        })], 42, _hoisted_6$b);
      }), 128))], 4)], 4)])) : createCommentVNode("", true)], 2)];
    }),
    _: 3
  }, 8, ["label-position", "indicate-mandatory", "no-label"]);
}

script$p.render = render$t;
script$p.__scopeId = "data-v-67c1271f";

/**
 * A simple text field and label.
 *
 * Any unrecognized props are passed directly to the input field (so specifying any aria tags, placeholder, type, autocomplete etc. work as expected).
 *
 * The wrapper will have the css class 'invalid', if the field is invalid (an error message is passed) and 'is-empty', if the field is empty.
 *
 * Custom properties:
 * <ul>
 *  <li>--sb-label-input-gap: control how much margin is between the input field and label</li>
 *  <li>--sb-error-color: color used to indicate an invalid input value</li>
 * </ul>
 */
var script$o = defineComponent({
  name: "TextField",
  components: {
    InputLabelWrapper: script$q,
    FontAwesomeIcon: FontAwesomeIcon
  },
  data: function data() {
    return {
      errorSpanId: uuid(),
      passwordVisible: false
    };
  },
  methods: {
    handleInput: function handleInput(e) {
      var _e$target$value, _e$target;

      //@ts-ignore
      var newVal = (_e$target$value = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) !== null && _e$target$value !== void 0 ? _e$target$value : "";

      if (this.limitLength) {
        newVal = newVal.slice(0, this.limitLength);
        var input = this.$refs.input;
        input.value = newVal;
      }

      this.$emit("update:modelValue", newVal);
    },
    focus: function focus() {
      var _input$focus;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$focus = input.focus) === null || _input$focus === void 0 ? void 0 : _input$focus.call(input);
    },
    blur: function blur() {
      var _input$blur;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$blur = input.blur) === null || _input$blur === void 0 ? void 0 : _input$blur.call(input);
    },
    select: function select() {
      var _input$select;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$select = input.select) === null || _input$select === void 0 ? void 0 : _input$select.call(input);
    }
  },
  computed: {
    inputType: function inputType() {
      if (this.type === "password" && this.passwordVisible) {
        return "text";
      }

      return this.type || "text";
    },
    hasError: function hasError() {
      //FIXME; we could help validate a required attribute on blur/focus
      return !!this.errorMessage;
    }
  },
  props: {
    /**
     * A custom id for the input field.
     *
     * Should only be used, if you intend to render a custom label for the input
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return uuid();
      }
    },

    /**
     * Label position, defaults to left
     */
    labelPosition: {
      type: String,
      required: false
    },

    /**
     * Current field value
     */
    modelValue: {
      type: String,
      required: true
    },

    /**
     *
     */
    passwordEye: {
      type: Boolean,
      required: false,
      default: function _default() {
        return true;
      }
    },

    /**
     * Input label.
     *
     * Note, if you want to render a custom label, don't pass a title, but pass an explicit id, with the htmlFor attribute set accordingly
     */
    label: {
      type: String,
      required: false
    },

    /**
     * the aria-label html property.
     *
     * Note, do not pass this prop, if the label attribute is already good enough for screen readers, if for some reason you want screenreaders to see a different label than regular users, use this property
     */
    ariaLabel: {
      type: String,
      required: false
    },

    /**
     * Input field type.
     * Passed directly to the underlying input field (so pass for example password, if you want to render a password field etc.)
     */
    type: {
      type: String,
      required: false
    },

    /**
     * Indicate this field as mandatory.
     *
     * Note this simply renders a '*' next to the label (and adds appropriate aria-attributes), we do not validate the user input in anyway
     */
    indicateMandatory: {
      type: Boolean,
      required: false
    },

    /**
     * Error message to render below the input field.
     *
     * Note, any non empty string value indicates that this input field is somehow invalid, and this will be indicated both visually and accessability wise.
     *
     * Note, that this error message will be used by screenreaders as well.
     *
     * Note, if you do not wish to show an error message for visual users, please include the error message anyway, but hide it with css (do not use display none, so screenreaders can understand what is wrong)
     */
    errorMessage: {
      type: String,
      required: false
    },

    /**
     * If the error message should shown, even if the user is currently modifying the text field.
     *
     * By default errors are only shown, when the text field is inactive
     */
    showErrorWhenFocused: {
      type: Boolean,
      required: false
    },

    /**
     * Set the limit length for input field.
     */
    limitLength: {
      type: Number,
      required: false
    }
  }
});

var _hoisted_1$p = ["htmlFor"];
var _hoisted_2$n = ["id", "value", "type", "aria-label", "aria-required", "aria-invalid", "aria-errormessage"];
var _hoisted_3$k = ["id"];
function render$s(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _component_InputLabelWrapper = resolveComponent("InputLabelWrapper");

  return openBlock(), createBlock(_component_InputLabelWrapper, {
    labelPosition: _ctx.labelPosition,
    class: normalizeClass(["sb-text-input-wrapper", [_ctx.hasError ? 'sb-invalid' : '', !_ctx.modelValue ? 'sb-is-empty' : '', _ctx.passwordEye && _ctx.type === 'password' ? 'sb-relative' : '', _ctx.$attrs.disabled ? 'sb-disabled' : '']]),
    "indicate-mandatory": _ctx.indicateMandatory,
    showErrorWhenFocused: _ctx.showErrorWhenFocused,
    invalid: !!_ctx.errorMessage,
    "no-label": !_ctx.label
  }, {
    label: withCtx(function () {
      return [createElementVNode("label", {
        htmlFor: _ctx.id
      }, toDisplayString$1(_ctx.label), 9, _hoisted_1$p)];
    }),
    input: withCtx(function () {
      return [createElementVNode("input", mergeProps({
        id: _ctx.id,
        value: _ctx.modelValue,
        onInput: _cache[0] || (_cache[0] = function () {
          return _ctx.handleInput && _ctx.handleInput.apply(_ctx, arguments);
        }),
        type: _ctx.inputType,
        "aria-label": _ctx.ariaLabel || undefined,
        "aria-required": _ctx.indicateMandatory,
        "aria-invalid": _ctx.hasError,
        "aria-errormessage": _ctx.errorSpanId
      }, _ctx.$attrs, {
        class: {
          password: _ctx.type === 'password' && _ctx.passwordEye
        },
        ref: "input"
      }), null, 16, _hoisted_2$n), _ctx.type === 'password' && _ctx.passwordEye && !_ctx.passwordVisible ? (openBlock(), createBlock(_component_font_awesome_icon, {
        key: 0,
        class: "eye-icon",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.passwordVisible = !_ctx.passwordVisible;
        }),
        icon: ['fas', 'eye']
      })) : _ctx.type === 'password' && _ctx.passwordEye ? (openBlock(), createBlock(_component_font_awesome_icon, {
        key: 1,
        class: "eye-icon",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.passwordVisible = !_ctx.passwordVisible;
        }),
        icon: ['fas', 'eye-slash']
      })) : createCommentVNode("", true)];
    }),
    error: withCtx(function () {
      return [_ctx.hasError ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "sb-error-message",
        id: _ctx.errorSpanId
      }, toDisplayString$1(_ctx.errorMessage), 9, _hoisted_3$k)) : createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["labelPosition", "class", "indicate-mandatory", "showErrorWhenFocused", "invalid", "no-label"]);
}

script$o.render = render$s;
script$o.__scopeId = "data-v-dc226d50";

/**
 * A simple number field and label.
 *
 * To indicate no selection, pass either NaN or null as modelValue
 *
 * Any unrecognized props are passed directly to the input field (so specifying any aria tags, placeholder, type, autocomplete etc. work as expected).
 *
 * The wrapper will have the css class 'invalid', if the field is invalid (an error message is passed) and 'is-empty', if the field is empty.
 *
 * Custom properties:
 * <ul>
 *  <li>--sb-label-input-gap: control how much margin is between the input field and label</li>
 *  <li>--sb-error-color: color used to indicate an invalid input value</li>
 * </ul>
 */
var script$n = defineComponent({
  name: "IntegerField",
  components: {
    InputLabelWrapper: script$q
  },
  data: function data() {
    return {
      errorSpanId: uuid()
    };
  },
  methods: {
    handleKeydown: function handleKeydown(e) {
      switch (e.key) {
        case "Down":
        case "ArrowDown":
        case "Tab":
        case "Up":
        case "ArrowUp":
        case "Left":
        case "ArrowLeft":
        case "Right":
        case "ArrowRight":
        case "Enter":
        case "Esc":
        case "Escape":
        case "Backspace":
        case "Home":
        case "CapsLock":
        case "F1":
        case "F2":
        case "F3":
        case "F4":
        case "F5":
        case "F6":
        case "F7":
        case "F8":
        case "F9":
        case "F10":
        case "F11":
        case "F12":

          break;

        default:
          if (!isNumber(e.key)) {

            e.preventDefault();
          }

        // FIXME; prevent leading 0
      }
    },
    handleInput: function handleInput(e) {
      var _e$target$value, _e$target;

      //@ts-ignore
      var newVal = (_e$target$value = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) !== null && _e$target$value !== void 0 ? _e$target$value : ""; // Remove leading 0s

      while (newVal[0] === "0" && newVal.length > 1) {

        newVal = newVal.slice(1, newVal.length);
      }

      if (newVal.trim() === "") {

        this.$emit("update:modelValue", Number.NaN);
      } else if (isNumber(newVal)) {

        this.$emit("update:modelValue", +newVal);
      } else {

        this.$emit("update:modelValue", Number.NaN);
      }
    },
    focus: function focus() {
      var _input$focus;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$focus = input.focus) === null || _input$focus === void 0 ? void 0 : _input$focus.call(input);
    },
    blur: function blur() {
      var _input$blur;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$blur = input.blur) === null || _input$blur === void 0 ? void 0 : _input$blur.call(input);
    },
    select: function select() {
      var _input$select;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$select = input.select) === null || _input$select === void 0 ? void 0 : _input$select.call(input);
    }
  },
  computed: {
    hasError: function hasError() {
      //FIXME; we could help validate a required attribute on blur/focus
      return !!this.errorMessage;
    },
    formattedValue: function formattedValue() {
      if (this.modelValue == null) return "";
      if (Number.isNaN(this.modelValue)) return ""; // FIXME; clamp float to integer

      return this.modelValue.toString(10);
    }
  },
  props: {
    /**
     * A custom id for the input field.
     *
     * Should only be used, if you intend to render a custom label for the input
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return uuid();
      }
    },

    /**
     * Label position, defaults to left
     */
    labelPosition: {
      type: String,
      required: false
    },

    /**
     * Current field value.
     *
     * If the current value is not a valid number (such as empty), Number.NaN is used
     */
    modelValue: {
      type: Number,
      required: true
    },

    /**
     * Input label.
     *
     * Note, if you do no want to render a label, don't simply pass an empty value, but pass a valid value (that will be read by screenreaders) and hide the label with css
     */
    label: {
      type: String,
      required: true
    },

    /**
     * the aria-label html property.
     *
     * Note, do not pass this prop, if the label attribute is already good enough for screen readers, if for some reason you want screenreaders to see a different label than regular users, use this property
     */
    ariaLabel: {
      type: String,
      required: false
    },

    /**
     * Indicate this field as mandatory.
     *
     * Note this simply renders a '*' next to the label (and adds appropriate aria-attributes), we do not validate the user input in anyway
     */
    indicateMandatory: {
      type: Boolean,
      required: false
    },

    /**
     * Error message to render below the input field.
     *
     * Note, any non empty string value indicates that this input field is somehow invalid, and this will be indicated both visually and accessability wise.
     *
     * Note, that this error message will be used by screenreaders as well.
     *
     * Note, if you do not wish to show an error message for visual users, please include the error message anyway, but hide it with css (do not use display none, so screenreaders can understand what is wrong)
     */
    errorMessage: {
      type: String,
      required: false
    },

    /**
     * If the error message should shown, even if the user is currently modifying the text field.
     *
     * By default errors are only shown, when the text field is inactive
     */
    showErrorWhenFocused: {
      type: Boolean,
      required: false
    }
  }
});

var _hoisted_1$o = ["htmlFor"];
var _hoisted_2$m = ["id", "value", "aria-label", "aria-required", "aria-invalid", "aria-errormessage"];
var _hoisted_3$j = ["id"];
function render$r(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_InputLabelWrapper = resolveComponent("InputLabelWrapper");

  return openBlock(), createBlock(_component_InputLabelWrapper, {
    labelPosition: _ctx.labelPosition,
    class: normalizeClass(['sb-number-input-wrapper', _ctx.hasError ? 'sb-invalid' : '', !_ctx.modelValue ? 'is-empty' : '']),
    "indicate-mandatory": _ctx.indicateMandatory,
    showErrorWhenFocused: _ctx.showErrorWhenFocused,
    invalid: !!_ctx.errorMessage,
    "no-label": !_ctx.label
  }, {
    label: withCtx(function () {
      return [createElementVNode("label", {
        htmlFor: _ctx.id
      }, toDisplayString$1(_ctx.label), 9, _hoisted_1$o)];
    }),
    input: withCtx(function () {
      return [createElementVNode("input", mergeProps({
        type: "number"
      }, _ctx.$attrs, {
        id: _ctx.id,
        value: _ctx.formattedValue,
        onInput: _cache[0] || (_cache[0] = function () {
          return _ctx.handleInput && _ctx.handleInput.apply(_ctx, arguments);
        }),
        onKeydown: _cache[1] || (_cache[1] = function () {
          return _ctx.handleKeydown && _ctx.handleKeydown.apply(_ctx, arguments);
        }),
        "aria-label": _ctx.ariaLabel || undefined,
        "aria-required": _ctx.indicateMandatory,
        "aria-invalid": _ctx.hasError,
        "aria-errormessage": _ctx.errorSpanId,
        ref: "input"
      }), null, 16, _hoisted_2$m)];
    }),
    error: withCtx(function () {
      return [_ctx.hasError ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "sb-error-message",
        id: _ctx.errorSpanId
      }, toDisplayString$1(_ctx.errorMessage), 9, _hoisted_3$j)) : createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["labelPosition", "class", "indicate-mandatory", "showErrorWhenFocused", "invalid", "no-label"]);
}

script$n.render = render$r;
script$n.__scopeId = "data-v-20063624";

/**
 * A html select field
 *
 * Custom properties:
 * <ul>
 *  <li>--sb-label-input-gap: control how much margin is between the input field and label</li>
 * </ul>
 */
var script$m = defineComponent({
  name: "SelectField",
  components: {
    InputLabelWrapper: script$q
  },
  data: function data() {
    var _this = this;

    var chosenLabel = this.values.find(function (v) {
      return _this.getKey(v) === _this.getKey(_this.modelValue);
    });
    return {
      id: uuid(),
      chosenLabel: chosenLabel
    };
  },
  methods: {
    getKey: function getKey(opt) {
      var _opt$key;

      return (_opt$key = opt === null || opt === void 0 ? void 0 : opt.key) !== null && _opt$key !== void 0 ? _opt$key : opt === null || opt === void 0 ? void 0 : opt.label;
    }
  },
  props: {
    /**
     * Label position, defaults to left
     */
    labelPosition: {
      type: String,
      required: false
    },

    /**
     * Currently selected value. A null value is used to indicate no selection.
     *
     * Note, that this is marked as optional simply to allow passing null/undefined, but this component should always be used in combination with v-model
     *
     * Value MUST be one of the values in the values array (identically same).
     *
     * Each value must have a label attribute, which is displayed to the user (should be localized) and optionally a key attribute.
     *
     * Key optional must be unique for each value, and should be provided if the label is expected to change. If no key is provided, it is defaulted to label.
     *
     * All other attributes are ignored (values can have arbitrary attributes besides these 2).
     *
     */
    modelValue: {
      type: Object,
      required: true
    },

    /**
     * Input label.
     *
     * Note, if you do no want to render a label, don't simply pass an empty value, but pass a valid value (that will be read by screenreaders) and hide the label with css
     */
    label: {
      type: String,
      required: true
    },

    /**
     * the aria-label html property.
     *
     * Note, do not pass this prop, if the label attribute is already good enough for screen readers, if for some reason you want screenreaders to see a different label than regular users, use this property
     */
    ariaLabel: {
      type: String,
      required: false
    },

    /**
     * List of allowed values
     *
     * Each value must have a label attribute, which is displayed to the user (should be localized) and optionally a key attribute.
     *
     * Key optional must be unique for each value, and should be provided if the label is expected to change. If no key is provided, it is defaulted to label.
     *
     * All other attributes are ignored (values are allowed to have arbitrary attributes besides these 2).
     *
     * Note, modelValue will always be identically same to one of these values or null
     */
    values: {
      type: Array,
      required: true
    },

    /**
     * Indicate this field as mandatory.
     *
     * Note this simply renders a '*' next to the label, we do not validate the user value in anyway
     */
    indicateMandatory: {
      type: Boolean,
      required: false
    }
  },
  watch: {
    chosenLabel: {
      immediate: true,
      handler: function handler(newVal) {
        var _this$values$find,
            _this2 = this;

        var chosenObj = (_this$values$find = this.values.find(function (v) {
          return _this2.getKey(v) === newVal;
        })) !== null && _this$values$find !== void 0 ? _this$values$find : null;

        this.$emit("update:modelValue", chosenObj);
      }
    }
  }
});

var _hoisted_1$n = ["htmlFor"];
var _hoisted_2$l = ["id", "aria-label", "aria-required"];
var _hoisted_3$i = ["value", "disabled"];
function render$q(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_InputLabelWrapper = resolveComponent("InputLabelWrapper");

  return openBlock(), createBlock(_component_InputLabelWrapper, {
    labelPosition: _ctx.labelPosition,
    class: "sb-select-input-wrapper",
    "indicate-mandatory": _ctx.indicateMandatory,
    invalid: !!_ctx.errorMessage,
    "no-label": !_ctx.label
  }, {
    label: withCtx(function () {
      return [createElementVNode("label", {
        htmlFor: _ctx.id
      }, toDisplayString$1(_ctx.label), 9, _hoisted_1$n)];
    }),
    input: withCtx(function () {
      return [withDirectives(createElementVNode("select", {
        id: _ctx.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.chosenLabel = $event;
        }),
        "aria-label": _ctx.ariaLabel || undefined,
        "aria-required": _ctx.indicateMandatory
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.values, function (opt) {
        var _opt$isDisabled;

        return openBlock(), createElementBlock("option", {
          key: _ctx.getKey(opt),
          value: _ctx.getKey(opt),
          disabled: (_opt$isDisabled = opt.isDisabled) !== null && _opt$isDisabled !== void 0 ? _opt$isDisabled : false
        }, toDisplayString$1(opt.label), 9, _hoisted_3$i);
      }), 128))], 8, _hoisted_2$l), [[vModelSelect, _ctx.chosenLabel]])];
    }),
    _: 1
  }, 8, ["labelPosition", "indicate-mandatory", "invalid", "no-label"]);
}

script$m.render = render$q;
script$m.__scopeId = "data-v-05a670a6";

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$1.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
    (_Map && getTag(new _Map) != mapTag$3) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$3) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$3;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$3;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return _cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$1:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$1;
}

var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$1;
}

var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn_1 : keys_1);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

var cloneDeep_1 = cloneDeep;

/**
 * A simple text field and label.
 *
 * All input fields have the same basic functionality as with TextInput (so passing labelPosition, errorMessage etc. works as expected)
 *
 * Custom properties:
 * <ul>
 * <li>--sb-label-input-gap: control how much margin is between the input field and label</li>
 * <li>--sb-checkbox-size: control checkbox size. Note, do not attempt to set the checkbox width in any other way, setting this property will automatically scale the checkmark accordingly </li>
 * <li>--sb-checkbox-color: the checkbox checked color. Note, the checkmark is white by default, if you set this to some light color, you might have to update checkmark color as well</li>
 * </ul>
 */
var script$l = defineComponent({
  name: "CheckboxField",
  components: {
    InputLabelWrapper: script$q
  },
  data: function data() {
    return {
      errorSpanId: uuid()
    };
  },
  computed: {
    hasError: function hasError() {
      //FIXME; we could help validate a required attribute on blur/focus
      return !!this.errorMessage;
    }
  },
  methods: {
    handleInput: function handleInput(e) {
      var _e$target$checked, _e$target;

      //@ts-ignore
      var newVal = (_e$target$checked = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.checked) !== null && _e$target$checked !== void 0 ? _e$target$checked : false;

      if (!this.isDisabled) {
        this.$emit("update:modelValue", newVal);
      }
    },
    toggleValue: function toggleValue() {

      if (!this.isDisabled) {
        this.$emit("update:modelValue", !this.modelValue);
      }
    },
    focus: function focus() {
      var _input$focus;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$focus = input.focus) === null || _input$focus === void 0 ? void 0 : _input$focus.call(input);
    },
    blur: function blur() {
      var _input$blur;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$blur = input.blur) === null || _input$blur === void 0 ? void 0 : _input$blur.call(input);
    },
    select: function select() {
      var _input$select;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$select = input.select) === null || _input$select === void 0 ? void 0 : _input$select.call(input);
    }
  },
  props: {
    /**
     * A custom id for the input field.
     *
     * Should only be used, if you intend to render a custom label for the input
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return uuid();
      }
    },

    /**
     * Label position, defaults to left
     */
    labelPosition: {
      type: String,
      required: false
    },

    /**
     * Current field value
     */
    modelValue: {
      type: Boolean,
      required: true
    },

    /**
     * Input label.
     *
     * Note, if you do no want to render a label, don't simply pass an empty value, but pass a valid value (that will be read by screenreaders) and hide the label with css
     */
    label: {
      type: String,
      required: true
    },

    /**
     * the aria-label html property.
     *
     * Note, do not pass this prop, if the label attribute is already good enough for screen readers, if for some reason you want screenreaders to see a different label than regular users, use this property
     */
    ariaLabel: {
      type: String,
      required: false
    },

    /**
     * Indicate this field as mandatory.
     *
     * Note this simply renders a '*' next to the label, we do not validate the user value in anyway
     */
    indicateMandatory: {
      type: Boolean,
      required: false
    },

    /**
     * Error message to render below the input field.
     *
     * Note, any non empty string value indicates that this input field is somehow invalid, and this will be indicated both visually and accessability wise.
     *
     * Note, that this error message will be used by screenreaders as well.
     *
     * Note, if you do not wish to show an error message for visual users, please include the error message anyway, but hide it with css (do not use display none, so screenreaders can understand what is wrong)
     */
    errorMessage: {
      type: String,
      required: false
    },

    /**
     * Disable checkbox field
     */
    isDisabled: {
      type: Boolean,
      required: false
    }
  }
});

var _hoisted_1$m = ["htmlFor"];
var _hoisted_2$k = ["id", "value", "checked", "aria-label", "aria-required", "aria-invalid", "aria-errormessage", "disabled"];
var _hoisted_3$h = ["id"];
function render$p(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_InputLabelWrapper = resolveComponent("InputLabelWrapper");

  return openBlock(), createBlock(_component_InputLabelWrapper, {
    labelPosition: _ctx.labelPosition,
    class: normalizeClass(['sb-checkbox-input-wrapper', _ctx.hasError ? 'sb-invalid' : '', _ctx.modelValue ? 'sb-checked' : '']),
    "indicate-mandatory": _ctx.indicateMandatory,
    "show-error-when-focused": true,
    invalid: !!_ctx.errorMessage,
    "no-label": !_ctx.label
  }, {
    label: withCtx(function () {
      return [createElementVNode("label", {
        htmlFor: _ctx.id
      }, toDisplayString$1(_ctx.label), 9, _hoisted_1$m)];
    }),
    input: withCtx(function () {
      return [createElementVNode("input", mergeProps(_ctx.$attrs, {
        id: _ctx.id,
        value: _ctx.modelValue,
        class: "sb-checkbox",
        type: "checkbox",
        onInput: _cache[0] || (_cache[0] = function () {
          return _ctx.handleInput && _ctx.handleInput.apply(_ctx, arguments);
        }),
        checked: _ctx.modelValue,
        "aria-label": _ctx.ariaLabel || undefined,
        "aria-required": _ctx.indicateMandatory,
        "aria-invalid": _ctx.hasError,
        "aria-errormessage": _ctx.errorSpanId,
        disabled: _ctx.isDisabled
      }), null, 16, _hoisted_2$k), createElementVNode("span", null, [createElementVNode("span", {
        class: "sb-checkmark",
        onClick: _cache[1] || (_cache[1] = function () {
          return _ctx.toggleValue && _ctx.toggleValue.apply(_ctx, arguments);
        })
      })])];
    }),
    error: withCtx(function () {
      return [_ctx.hasError ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "sb-error-message",
        id: _ctx.errorSpanId
      }, toDisplayString$1(_ctx.errorMessage), 9, _hoisted_3$h)) : createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["labelPosition", "class", "indicate-mandatory", "invalid", "no-label"]);
}

script$l.render = render$p;
script$l.__scopeId = "data-v-bb0a6586";

/**
 * Render a table of objects.
 *
 * See columnOptions for the full options to customize the final table output.
 *
 * If you wish to render custom complex content inside the table cell, the named slots "body-cell" and "heading-cell" can be used to style the body or heading content.
 *
 * See vue documentation on the usage of scoped slots: https://vuejs.org/guide/components/slots.html#scoped-slots
 *
 * The slots recieve 3 arguments, which can be used inside the slot: path, value and row.
 *
 * Path is the current path being rendered (matched one of the options in column-options), value is the formatted value of the cell and row is the full object for this row (identically one of those in data).
 *
 * Example syntax for using an object table this way wo
 *  <ObjectTable>
 *    <template #body-cell="{ row, path, value }">
 *      Do fancy stuff here
 *    </template>
 *  <ObjectTable>
 *
 * CSS note:
 *
 * Each table cell will have the following css class: "col-"+ key. Note, unlike most storybook components, this component doesn't use the "sb-" prefix for class names (expect for the outer container)
 *
 * You can target all cells with:  [class*="col-"] (target tbody/thead separately, if you want to style heading)
 *
 * Each row will have the following css class: row-<row index> (as well as any custom class you specify in columnOptions). Note that the heading row will always have the class row-0
 *
 * You can target all rows with:  [class*="row-"] (target tbody/thead separately, if you want to style the heading)
 *
 */

var script$k = defineComponent({
  name: "ObjectTable",
  components: {
    FontAwesomeIcon: FontAwesomeIcon,
    CheckboxField: script$l
  },
  emits: {
    sort: function sort(_) {
      return true;
    },
    "update:selectedRows": function updateSelectedRows(_) {
      return true;
    },
    rowClick: function rowClick(_) {
      return true;
    }
  },
  props: {
    /**
     * Data to render.
     *
     * An array of objects to render.
     *
     * Keys that are not specified in 'columnOptions' will be ignored.
     */
    data: {
      type: Array,
      required: true
    },

    /**
     * Options used to decide what data should be included in the table and to allow customizing table rendering
     *
     * The only mandatory attributes are 'path' and 'heading'
     *
     * The path can be a complex path, for example "foo.bar.baz" etc (we use lodash.get internally to get the value).
     *
     * For example:
     *
     * data = [{foo:{ bar: { baz: "some value"}}}]
     *
     * columnOptions = [{key: "foo.bar.baz", heading: "Complex key"}]
     *
     * Note that we will do some formatting to the data before displaying it to the user:
     *
     * Dates are formatted with 'toLocaleDateString'
     *
     * Arrays was joined with ", "
     *
     * If you need more complex formatting, either format the data you pass here yourself, use the {@link ObjectTableColumnOptions.formatter} option or use the customCellComponentFactory prop
     *
     * Refer to {@link ObjectTableColumnOptions} documentation for the full list of configuration values.
     *
     * @example
     * data = [{foo:2, bar: "something"}, {foo: "something else", bar: 2}]
     * columnOptions = [{path:"foo", heading: "Example key" }, { path: "bar", heading: "Another example key"}}]
     * // This renders a table with 2 rows (3, if you count the header) and 2 columns with the headings 'Example key' and 'Another example key'
     */
    columnOptions: {
      type: Array,
      required: true,
      validator: function validator(value) {
        if (!(value !== null && value !== void 0 && value.length)) {
          console.error("Invalid or missing column options ", value, "Expected a non empty array");
          return false;
        }

        var _iterator = _createForOfIteratorHelper(value),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var opt = _step.value;

            if (typeof opt.heading !== "string") {
              console.error("Invalid heading option ", opt.heading, "expected a string");
              return false;
            }

            if (typeof opt.path !== "string") {
              console.error("Invalid path ", opt.path, "expected a string");
              return false;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return true;
      }
    },

    /**
     * A css variant of the table.
     *
     * Supported values: 'plain' (no extra css) and 'striped' (add stripes)
     *
     * 'striped' color can be controlled with the custom property '--striped-cell-background-color'
     */
    variant: {
      type: String,
      required: false
    },

    /**
     * If cells of the table can be selected
     *
     * Selected tables are mapped to the model prop "selectedRows", and each cell will have the css class "sb-selected"
     */
    allowSelection: {
      type: Boolean,
      required: false
    },

    /**
     * If desktop controls (ctrl must be pressed, to expand selection) should be used
     */
    preferDesktopSelectionControls: {
      type: Boolean,
      required: false
    },

    /**
     * If the first column should be checkbox, displaying if the row is selected or not. (only if allowSelection is enabled)
     */
    includeSelectionCheckbox: {
      type: Boolean,
      required: false
    },

    /**
     * If the first column in the heading should be a checkbox to select all values
     */
    includeHeadingSelectAll: {
      type: Boolean,
      required: false
    },

    /**
     * Currently selected rows.
     *
     * Map with v-model:selectedRows.
     *
     * Only enabled, if the prop allowSelection is given
     */
    selectedRows: {
      type: Array,
      required: false
    },

    /**
     * NOTE, this option is deprecated, use the slots instead
     *
     * Override the default component factory, which determines what type of component to use for cell rendering
     *
     * Use this if you have to embed extra data to table cells, for example an icon after content, or if you want full control of how the data is formatted (for example to format dates yourself).
     *
     * The factory is a function, which is called with 3 argument, the current cell object, path we are rendering and the value mapped to this path.
     *
     * The return value should be an object with 2 attributes, "is" and "props"
     *
     * The return value will be used to render a dynamic component with the following jsx:
     *
     * &lt; component :is="ret.is" v-bind:"ret.props"&gt;
     *
     *      {{val}}
     *
     * &lt;/component&gt;
     *
     * Note the val embedded to the component default slot (if you are using a custom component, you might want to render this slot).
     *
     * The "is" field can either be the string name of the component you want to render, or the component itself (the value of an import).
     *
     * Note, unless you are rendering html tags (for example "div"), you probably want to use the component value here, since otherwise Vue will have to locate your component, which means it has to globally registered.
     *
     * Note, if you simply want to render a different html tag, the function can also return a plain string
     *
     * The "props" field can be used to pass dynamic props to the component.
     *
     * Note, you do not have to return a value for both fields, in case of undefined/null return values we will default to a span with no additional props
     *
     * For example, to implement conditional styling:
     *
     * A return value of {props: {class: "my-css-class"}} would render a span (our default tag) with an extra CSS class "my-css-class".
     *
     * NOTE, this option is deprecated, use the slots instead
     *
     * @deprecated
     *
     */
    customCellComponentFactory: {
      type: Function,
      required: false
    },

    /**
     * If this component should show data as is, without sorting
     *
     * Note, this doesn't disable the up/down arrows, only that we don't actually touch the data, before displaying it to the user (use the column-options to disable/enable sorting on individual columns)
     *
     * Should be used ONLY if you you intend to implement custom sorting via listening to the "sort" event
     */
    doNotSort: {
      type: Boolean,
      required: false
    },

    /**
     * If selection should be reset when clicking outside the component
     */
    removeSelectionOnDocumentClick: {
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    // Find all keys we can sort
    var sortableKeys = {};
    this.columnOptions.filter(function (o) {
      return o.allowSorting === true;
    }).forEach(function (o) {
      sortableKeys[o.path] = false;
    });
    return {
      keySymbol: keySymbol,
      cssClassSymbol: cssClassSymbol,
      componentTypeMapSymbol: componentTypeMapSymbol,
      componentPropMapSymbol: componentPropMapSymbol,
      originalObjectSymbol: originalObjectSymbol,
      sortableKeys: sortableKeys,
      currentSortKey: null,
      // DEV note selectedRowsInternal must contain references to the original objects (ones passed as props) NOT those from formattedObjs
      selectedRowsInternal: this.allowSelection && this.selectedRows ? _toConsumableArray$2(this.selectedRows) : [],
      lastClickIndex: -1,

      /**
       * Preserving last click, if our data changes can lead to funky stuff, use this boolean to control, if our watcher resets click index or not
       */
      preserveLastClick: false
    };
  },
  methods: {
    toggleSelectAll: function toggleSelectAll() {
      var _this = this;

      if (!this.allowSelection) return;

      if (this.isSelectAll) {
        // REmove current rows
        this.$emit("update:selectedRows", this.selectedRowsInternal.filter(function (row) {
          return !_this.data.includes(row);
        }));
      } else {
        // Select everything (note the shallow copy)
        var allSelections = new Set([].concat(_toConsumableArray$2(this.selectedRowsInternal), _toConsumableArray$2(this.data)));
        this.$emit("update:selectedRows", _toConsumableArray$2(allSelections));
      }
    },
    setSort: function setSort(path) {
      this.lastClickIndex = -1; // Sanity check, shouldn't happen

      if (this.sortableKeys[path] == null) {

        return;
      }

      this.currentSortKey = path; // Make a copy, reactivity is a little weird otherwise

      var newSortableKeys = _objectSpread2$2({}, this.sortableKeys);

      newSortableKeys[path] = !newSortableKeys[path];
      this.sortableKeys = newSortableKeys;
      this.lastClickIndex = -1;
      this.$emit("sort", {
        sortBy: path,
        sortAsc: !newSortableKeys[path]
      });
    },
    formatValue: function formatValue(val, opts) {
      var _val;

      if (typeof opts.formatter === "function") {
        val = opts.formatter(val);
      }

      return formatDisplayValue((_val = val) !== null && _val !== void 0 ? _val : opts.defaultValue);
    },
    getHeadingComponentProps: function getHeadingComponentProps(col) {
      var _resolveComponentFrom = resolveComponentFromCustomFactory(this.customCellComponentFactory, [null, col.path, null, true], {
        is: "span"
      }),
          _resolveComponentFrom2 = _slicedToArray$3(_resolveComponentFrom, 2);
          _resolveComponentFrom2[0];
          var props = _resolveComponentFrom2[1];

      return props;
    },
    getHeadingComponentType: function getHeadingComponentType(col) {
      var _resolveComponentFrom3 = resolveComponentFromCustomFactory(this.customCellComponentFactory, [null, col.path, null, true], {
        is: "span"
      }),
          _resolveComponentFrom4 = _slicedToArray$3(_resolveComponentFrom3, 2),
          type = _resolveComponentFrom4[0];
          _resolveComponentFrom4[1];

      return type;
    },

    /**
     * Note opt is only used to ignore rowClick, passing null is safe for internal columns (like the selection checkbox)
     */
    handleClick: function handleClick(event, obj, opt) {
      var _this2 = this,
          _window$getSelection,
          _window,
          _window$getSelection$,
          _window$getSelection$2;

      if ((opt === null || opt === void 0 ? void 0 : opt.ignoreRowClick) === true) {

        return;
      }

      this.$emit("rowClick", obj[originalObjectSymbol]);
      if (!this.allowSelection) return;
      var index = this.formattedData.map(function (x) {
        return x[originalObjectSymbol];
      }).indexOf(obj[originalObjectSymbol]);

      if (index < 0) {

        return;
      } // Behavior is emulated from windows file manager


      if (!isCtrlClick(event) && this.preferDesktopSelectionControls) {
        var _obj$originalObjectSy;

        // Add specifc logic for toggling the current value (different from win file manager)
        if (this.selectedRowsInternal.includes((_obj$originalObjectSy = obj[originalObjectSymbol]) !== null && _obj$originalObjectSy !== void 0 ? _obj$originalObjectSy : obj)) {
          var _obj$originalObjectSy2;

          this.selectedRowsInternal = [(_obj$originalObjectSy2 = obj[originalObjectSymbol]) !== null && _obj$originalObjectSy2 !== void 0 ? _obj$originalObjectSy2 : obj];
        } else {
          this.selectedRowsInternal = [];
        }
      }

      var pushIfValid = function pushIfValid(val) {
        var _val$originalObjectSy;

        if (!val) {

          return;
        }

        if (!_this2.selectedRowsInternal.includes((_val$originalObjectSy = val[originalObjectSymbol]) !== null && _val$originalObjectSy !== void 0 ? _val$originalObjectSy : val)) {
          var _val$originalObjectSy2;

          _this2.selectedRowsInternal.push((_val$originalObjectSy2 = val[originalObjectSymbol]) !== null && _val$originalObjectSy2 !== void 0 ? _val$originalObjectSy2 : val);
        }
      };

      if (isShiftClick(event) && this.lastClickIndex >= 0) {
        var min = Math.min(index, this.lastClickIndex);
        var max = Math.max(index, this.lastClickIndex);

        for (var i = min; i <= max; ++i) {
          pushIfValid(this.formattedData[i]);
        }
      } else {
        // Otherwise toggle target (note we already cleared the arr for a non ctrl click)
        if (this.selectedRowsInternal.includes(obj[originalObjectSymbol])) {
          this.selectedRowsInternal = this.selectedRowsInternal.filter(function (x) {
            return x !== obj[originalObjectSymbol];
          });
        } else {
          pushIfValid(obj);
        }
      } // Shift click doesn't update last click


      if (!isShiftClick(event)) {

        this.lastClickIndex = index;
      }


      (_window$getSelection = (_window = window).getSelection) === null || _window$getSelection === void 0 ? void 0 : (_window$getSelection$ = _window$getSelection.call(_window)) === null || _window$getSelection$ === void 0 ? void 0 : (_window$getSelection$2 = _window$getSelection$.removeAllRanges) === null || _window$getSelection$2 === void 0 ? void 0 : _window$getSelection$2.call(_window$getSelection$);
      this.preserveLastClick = true;
      this.$emit("update:selectedRows", _toConsumableArray$2(this.selectedRowsInternal));
    }
  },
  watch: {
    columnOptions: function columnOptions() {
      var _this3 = this;

      var sortableKeys = {};
      this.columnOptions.filter(function (o) {
        return o.allowSorting === true;
      }).forEach(function (o) {
        var _this3$sortableKeys$o;

        sortableKeys[o.path] = (_this3$sortableKeys$o = _this3.sortableKeys[o.path]) !== null && _this3$sortableKeys$o !== void 0 ? _this3$sortableKeys$o : false;
      });
      this.lastClickIndex = -1;
      this.sortableKeys = sortableKeys;
    },
    selectedRows: function selectedRows(val) {
      if (!this.allowSelection) ;

      if (!this.preserveLastClick) {
        if (this.lastClickIndex !== -1) {

          this.lastClickIndex = -1;
        }
      } else {
        this.preserveLastClick = false;
      }

      if (val) {
        this.selectedRowsInternal = _toConsumableArray$2(val);
      } else {
        this.selectedRowsInternal = [];
      }
    }
  },
  computed: {
    isSelectAll: function isSelectAll() {
      // Note, we allow selection to include elements not in the current table
      var selected = new Set(this.selectedRowsInternal);
      var data = new Set(this.data.map(function (row) {
        return row;
      }));

      if (data.size > selected.size) {
        return false;
      }

      var _iterator2 = _createForOfIteratorHelper(data),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var row = _step2.value;

          if (!selected.has(row)) {
            return false;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return true;
    },
    headings: function headings() {
      return this.columnOptions.map(function (opt) {
        return opt.heading;
      });
    },
    keys: function keys() {
      return this.columnOptions.map(function (opt) {
        return opt.path;
      });
    },
    sortedData: function sortedData() {
      var _this4 = this;

      if (!this.data) {
        return [];
      } // Make a deep copy of the data to sort
      // this is because if somebody passes data straight from apollo here example (or any other context which has explictly disallwed object extension), we are stuck with a very hard to debug error message...


      var res = cloneDeep_1(this.data);
      this.data.forEach(function (x, i) {
        res[i][_this4.originalObjectSymbol] = x;
      });

      if (this.doNotSort) {
        return res;
      }

      if (this.currentSortKey) {
        sort(res, this.currentSortKey, this.sortableKeys[this.currentSortKey]);
      }

      return res;
    },
    columnOptionsWithKey: function columnOptionsWithKey() {
      var _this5 = this;

      return this.columnOptions.map(function (o) {
        var opt = _objectSpread2$2(_objectSpread2$2({}, o), {}, _defineProperty$8({}, _this5.keySymbol, uuid()));

        return opt;
      });
    },

    /**
     * Copy data from the requested paths and add symbols
     *
     * The final objects will be of the following schema:
     *
     * All string keys are from the original object (shallow copies), so using normal object API:s will work as expected (Object.keys for..in etc.)
     *
     * In addition, the following symbols are added to the data:
     * keySymbol: unique id for this row
     * originalObjectSymbol: IDENTICAL reference to the row used to make this object. Note, do not expose objects from formattedData directly (for example selection logic), always use the object behind this key
     *
     * componentTypeMapSymbol: deprecated, used by customCellComponentFactory
     * componentPropMapSymbol: deprecated, used by customCellComponentFactory
     *
     */
    formattedData: function formattedData() {
      var _this6 = this;

      var res = [];
      this.sortedData.forEach(function (obj) {
        var _obj$_this6$keySymbol;

        // Cache the key on the original data
        obj[_this6.keySymbol] = (_obj$_this6$keySymbol = obj[_this6.keySymbol]) !== null && _obj$_this6$keySymbol !== void 0 ? _obj$_this6$keySymbol : uuid();
        var formattedObj = {};
        formattedObj[_this6.keySymbol] = obj[_this6.keySymbol]; // Note, obj is not the original symbol, sortedData makes a copy

        formattedObj[originalObjectSymbol] = obj[originalObjectSymbol]; // Initialize type/prop maps

        formattedObj[_this6.componentTypeMapSymbol] = {};
        formattedObj[_this6.componentPropMapSymbol] = {};

        _this6.columnOptions.forEach(function (opt) {
          // Copy values (flatten path)
          var val = get_1(obj, opt.path);
          formattedObj[opt.path] = val; // Add dynamic component type and props

          var _resolveComponentFrom5 = resolveComponentFromCustomFactory(_this6.customCellComponentFactory, [obj[originalObjectSymbol], opt.path, val, false], {
            is: "span"
          }),
              _resolveComponentFrom6 = _slicedToArray$3(_resolveComponentFrom5, 2),
              type = _resolveComponentFrom6[0],
              props = _resolveComponentFrom6[1];

          formattedObj[_this6.componentTypeMapSymbol][opt.path] = type;
          formattedObj[_this6.componentPropMapSymbol][opt.path] = props;
        });

        res.push(formattedObj);
      });
      return res;
    }
  }
});

var _hoisted_1$l = {
  class: "row-0"
};
var _hoisted_2$j = {
  key: 0,
  class: "sb-selection col-selected"
};
var _hoisted_3$g = ["onClick", "aria-label"];
var _hoisted_4$d = {
  key: 0,
  class: "sb-selection"
};
var _hoisted_5$b = ["onClick"];
function render$o(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$variant;

  var _component_CheckboxField = resolveComponent("CheckboxField");

  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock("table", {
    class: normalizeClass(["sb-object-table", (_ctx$variant = _ctx.variant) !== null && _ctx$variant !== void 0 ? _ctx$variant : 'plain']),
    ref: "container"
  }, [createElementVNode("thead", null, [createElementVNode("tr", _hoisted_1$l, [_ctx.allowSelection && _ctx.includeSelectionCheckbox ? (openBlock(), createElementBlock("th", _hoisted_2$j, [_ctx.includeHeadingSelectAll ? (openBlock(), createBlock(_component_CheckboxField, {
    key: 0,
    label: "",
    "model-value": _ctx.isSelectAll,
    onClick: _ctx.toggleSelectAll,
    "label-position": "bottom"
  }, null, 8, ["model-value", "onClick"])) : createCommentVNode("", true)])) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.columnOptionsWithKey, function (opt) {
    var _opt$cellCssClass;

    return openBlock(), createElementBlock("th", {
      key: opt[_ctx.keySymbol],
      class: normalizeClass(['col-' + opt.path, (_opt$cellCssClass = opt.cellCssClass) !== null && _opt$cellCssClass !== void 0 ? _opt$cellCssClass : ''])
    }, [_ctx.customCellComponentFactory === undefined ? renderSlot(_ctx.$slots, "heading-cell", {
      key: 0,
      path: opt.path,
      value: opt.heading
    }, function () {
      return [createTextVNode(toDisplayString$1(opt.heading), 1)];
    }) : (openBlock(), createBlock(resolveDynamicComponent(_ctx.getHeadingComponentType(opt)), normalizeProps(mergeProps({
      key: 1
    }, _ctx.getHeadingComponentProps(opt))), {
      default: withCtx(function () {
        return [createTextVNode(toDisplayString$1(opt.heading), 1)];
      }),
      _: 2
    }, 1040)), _ctx.sortableKeys[opt.path] != null ? (openBlock(), createElementBlock("button", {
      key: 2,
      onClick: function onClick($event) {
        return _ctx.setSort(opt.path);
      },
      class: "sort-icon",
      "aria-label": _ctx.$t('SARAKE_STORYBOOK_ARIA.ObjectTable.SORT_BUTTON_ARIA_LABEL', {
        column: opt.heading
      })
    }, [createVNode(_component_font_awesome_icon, {
      icon: _ctx.sortableKeys[opt.path] ? 'fa-regular fa-chevron-up' : 'fa-regular fa-chevron-down'
    }, null, 8, ["icon"])], 8, _hoisted_3$g)) : createCommentVNode("", true)], 2);
  }), 128))])]), createElementVNode("tbody", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.formattedData, function (obj, index) {
    return openBlock(), createElementBlock("tr", {
      key: obj[_ctx.keySymbol],
      class: normalizeClass(['row-' + (index + 1), _ctx.selectedRowsInternal.includes(obj[_ctx.originalObjectSymbol]) ? 'sb-selected' : ''])
    }, [_ctx.allowSelection && _ctx.includeSelectionCheckbox ? (openBlock(), createElementBlock("td", _hoisted_4$d, [createVNode(_component_CheckboxField, {
      label: "",
      "label-position": "bottom",
      "model-value": _ctx.selectedRowsInternal.includes(obj[_ctx.originalObjectSymbol]),
      onClick: function onClick($event) {
        return _ctx.handleClick($event, obj, null);
      }
    }, null, 8, ["model-value", "onClick"])])) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.columnOptionsWithKey, function (opt) {
      var _opt$cellCssClass2;

      return openBlock(), createElementBlock("td", {
        key: opt[_ctx.keySymbol],
        class: normalizeClass(['col-' + opt.path, (_opt$cellCssClass2 = opt.cellCssClass) !== null && _opt$cellCssClass2 !== void 0 ? _opt$cellCssClass2 : '']),
        onClick: function onClick($event) {
          return _ctx.handleClick($event, obj, opt);
        }
      }, [_ctx.customCellComponentFactory === undefined ? renderSlot(_ctx.$slots, "body-cell", {
        key: 0,
        row: obj[_ctx.originalObjectSymbol],
        path: opt.path,
        value: _ctx.formatValue(obj[opt.path], opt)
      }, function () {
        return [createTextVNode(toDisplayString$1(_ctx.formatValue(obj[opt.path], opt)), 1)];
      }) : (openBlock(), createBlock(resolveDynamicComponent(obj[_ctx.componentTypeMapSymbol][opt.path]), normalizeProps(mergeProps({
        key: 1
      }, obj[_ctx.componentPropMapSymbol][opt.path])), {
        default: withCtx(function () {
          return [createTextVNode(toDisplayString$1(_ctx.formatValue(obj[opt.path], opt)), 1)];
        }),
        _: 2
      }, 1040))], 10, _hoisted_5$b);
    }), 128))], 2);
  }), 128))])], 2);
}

script$k.render = render$o;
script$k.__scopeId = "data-v-37250304";

/**
  Expanded Panel
  This component displays a panel with a header that holds "show/hide" logic for the panel

  Component properties

  caption - text to show in the header
  expanded - indicates whether associated panel is expanded (true) or closed (false)
  disabled - whether toggle buttons should be visible

 */

var script$j = defineComponent({
  name: "ExpandedPanel",
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    /**
     * Text to show in panel header
     */
    caption: {
      type: String,
      default: ""
    },

    /**
     * Html tag for panel header
     */
    captionType: {
      type: String,
      default: "h3"
    },

    /**
     * the aria-label html property for panel header toggle icon
     */
    panelIconAriaLabel: {
      type: String,
      required: false
    },

    /**
     * Indicates whether associated panel is expanded (true) or closed (false)
     */
    expanded: {
      type: Boolean,
      default: false
    },

    /**
     * Indicates whether toggle buttons should be visible
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      // unique id of this expanded panel
      uniqueId: uuid(),
      panelVisible: false
    };
  },
  watch: {
    expanded: {
      handler: function handler() {
        this.panelVisible = this.expanded;
      },
      immediate: true
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.disabled === true) return;
      this.panelVisible = !this.panelVisible;
    }
  }
});

var _hoisted_1$k = {
  class: "sb-expanded-panel"
};
var _hoisted_2$i = ["aria-label", "aria-describedby", "aria-expanded"];
var _hoisted_3$f = {
  key: 0,
  class: "sb-panel"
};
function render$n(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock("div", _hoisted_1$k, [createElementVNode("div", {
    class: normalizeClass(["sb-expanded-header-block", {
      'sb-disabled': _ctx.disabled
    }]),
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.toggle && _ctx.toggle.apply(_ctx, arguments);
    })
  }, [(openBlock(), createBlock(resolveDynamicComponent(_ctx.captionType), {
    id: "s-expanded-panel-".concat(_ctx.uniqueId),
    class: "sb-expanded-header"
  }, {
    default: withCtx(function () {
      return [renderSlot(_ctx.$slots, "caption", {}, function () {
        return [createTextVNode(toDisplayString$1(_ctx.caption), 1)];
      })];
    }),
    _: 3
  }, 8, ["id"])), _ctx.disabled !== true ? (openBlock(), createElementBlock("button", {
    key: 0,
    "aria-label": _ctx.panelIconAriaLabel,
    "aria-describedby": "s-expanded-panel-".concat(_ctx.uniqueId),
    "aria-expanded": _ctx.panelVisible ? 'true' : 'false',
    class: "sb-expanded-icon"
  }, [_ctx.panelVisible === false ? (openBlock(), createBlock(_component_font_awesome_icon, {
    key: 0,
    icon: ['fas', 'chevron-down']
  })) : createCommentVNode("", true), _ctx.panelVisible === true ? (openBlock(), createBlock(_component_font_awesome_icon, {
    key: 1,
    icon: ['fas', 'chevron-up']
  })) : createCommentVNode("", true)], 8, _hoisted_2$i)) : createCommentVNode("", true)], 2), createVNode(Transition, {
    name: "s-panel"
  }, {
    default: withCtx(function () {
      return [_ctx.panelVisible ? (openBlock(), createElementBlock("div", _hoisted_3$f, [renderSlot(_ctx.$slots, "default")])) : createCommentVNode("", true)];
    }),
    _: 3
  })]);
}

script$j.render = render$n;
script$j.__scopeId = "data-v-b856d7fe";

/**
 * Different supported table variants
 *
 * Used by ObjectTable
 */
var TableVariant = {
  PLAIN: "plain",
  STRIPED: "striped"
};
/**
 * Different possible modal sizes
 *
 * Used by ModalOverlay
 */

var ModalSize = {
  BIG: "big",
  SMALL: "small"
};
/**
 * List of toast types
 *
 * Used by Toast
 */

var ToastType = {
  Success: "success",
  Error: "error",
  Info: "info",
  Warning: "warning",
  Warn: "warn"
};
/**
 * Cookie used to track cookie acceptance across domains
 *
 * Value is either "0" meaning only mandatory or "1" meaning all
 */

var COOKIE_POLICY_COOKIE = "sarake-cookie-accepted";

/**
  Toast
  This component displays a toast on the bottom right of the screen

  Component properties

  toasts - a list of toasts to be shown

  This component emits the following events:
  removeToast - Triggered when delete icon was clicked on a toast

  DEVELOPER NOTE:
    In Sign, Toast component is put only in App.vue so all the toasts can be in the same place on screen
    The toasts list is managed in Vuex store, with actions to 'addToast' or 'removeToast' that can be
      dispatched from all components
    Timeout for each toast can be called with setTimeout inside 'addToast' action
      to automatically hide the toast

 */
var script$i = defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Toast",
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    /**
     * An array of toast objects to render.
     * For example:
     * toasts = [{
     *
     *       id: uuid(), // Unique id of this toast
     *
     *       type: "success", // Type of this toast, Valid values are 'success', 'error', 'info'
     *
     *       title: "Success title",
     *
     *       body: "Success body",
     *
     *       timeout: 8, // Timeout for this toast to disappear
     *
     *       sr_only: false, // Should the toast be visible only for screen reader
     *
     * }]
     */
    toasts: {
      type: Array,
      required: true,
      validator: function validator(toasts) {
        var _iterator = _createForOfIteratorHelper(toasts),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var toast = _step.value;

            if (isEmptyOrNull(toast.id, true)) {
              console.error("Toast id is required");
              return false;
            }

            if (!Object.values(ToastType).includes(toast.type)) {
              console.error("Toast type is invalid: " + toast.type);
              return false;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return true;
      }
    }
  },
  emits: {
    /**
     * Triggered when delete icon was clicked on a toast
     *
     * Remove toast by id in 'toasts' array
     */
    removeToast: function removeToast() {
      return true;
    }
  },
  computed: {
    // display the toast message to screen reader user separately
    // announce the last item in the toasts array
    srMessage: function srMessage() {
      if (this.toasts && this.toasts.length > 0) {
        var lastToast = this.toasts[this.toasts.length - 1];
        return lastToast ? "".concat(lastToast.title, " ").concat(lastToast.body) : "";
      } else {
        return "";
      }
    }
  },
  methods: {
    type: function type(_type) {
      switch (_type) {
        case ToastType.Error:
          return "is-danger";

        case ToastType.Success:
          return "is-success";

        case ToastType.Info:
          return "is-info";

        default:
          return "is-info";
      }
    },
    icon: function icon(type) {
      switch (type) {
        case ToastType.Error:
          return "times-circle";

        case ToastType.Success:
          return "check-circle";

        case ToastType.Info:
          return "info-circle";

        default:
          return "info-circle";
      }
    }
  }
});

var _hoisted_1$j = {
  role: "status",
  "aria-live": "polite",
  key: "srMessage",
  class: "sb-sr-only"
};
var _hoisted_2$h = {
  key: 0,
  class: "sb-message-icon"
};
var _hoisted_3$e = {
  class: "sb-message-content"
};
var _hoisted_4$c = {
  class: "sb-message-header"
};
var _hoisted_5$a = ["onClick"];
var _hoisted_6$a = {
  class: "sb-message-title"
};
var _hoisted_7$8 = {
  class: "sb-message-body sb-normal-text"
};
function render$m(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock("div", null, [createElementVNode("div", _hoisted_1$j, toDisplayString$1(_ctx.srMessage), 1), createVNode(TransitionGroup, {
    "aria-hidden": "true",
    name: "s-toast-list",
    tag: "ul",
    class: "sb-toast-list"
  }, {
    default: withCtx(function () {
      return [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.toasts, function (toast) {
        return openBlock(), createElementBlock("li", {
          class: normalizeClass(["sb-toast-message sb-toast-list-item", [_ctx.type(toast.type), toast.sr_only ? 'sb-sr-only' : '']]),
          key: toast.id
        }, [toast.type ? (openBlock(), createElementBlock("div", _hoisted_2$h, [createVNode(_component_font_awesome_icon, {
          icon: ['fas', _ctx.icon(toast.type)]
        }, null, 8, ["icon"])])) : createCommentVNode("", true), createElementVNode("div", _hoisted_3$e, [createElementVNode("div", _hoisted_4$c, [createElementVNode("div", {
          class: "sb-close-icon",
          onClick: function onClick($event) {
            return _ctx.$emit('removeToast', toast.id);
          }
        }, [createVNode(_component_font_awesome_icon, {
          icon: ['far', 'times']
        })], 8, _hoisted_5$a), createElementVNode("div", _hoisted_6$a, toDisplayString$1(toast.title), 1)]), createElementVNode("div", _hoisted_7$8, toDisplayString$1(toast.body), 1)])], 2);
      }), 128))];
    }),
    _: 1
  })]);
}

script$i.render = render$m;
script$i.__scopeId = "data-v-efec474e";

/**
 Toast
 This component displays a toast at the top of the screen

 Component properties

 toast - a toast object to be shown

 This component emits the following events:
 removeToast - Triggered when delete icon was clicked on a toast

 DEVELOPER NOTE:
 Single Toast component is put only in App.vue so all the toast can be in the same place on screen
 The toast is managed in Vuex store, with actions to 'addToast' or 'removeToast' that can be
 dispatched from all components
 Timeout for each toast can be called with setTimeout inside 'addToast' action
 to automatically hide the toast

 */
var __default__$3 = defineComponent({
  name: "SingleToast",
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  data: function data() {
    return {
      timeoutId: null
    };
  },
  props: {
    /**
     * A toast objects to render.
     * For example:
     * toast = {
     *
     *       type: "success", // Type of this toast, Valid values are 'success', 'error', 'info', 'warn' or 'warning'
     *
     *       body: "Success body",
     *
     *       timeout: 8, // Timeout for this toast to disappear
     *
     *       sr_only: false // Only for screen reader
     *
     * }
     */
    toast: {
      type: Object,
      required: true,
      validator: function validator(toast) {
        if (!toast) return false;

        if (!Object.values(ToastType).includes(toast.type)) {
          console.warn("@sarake/sarake-storybook", "SingleToast", "Toast type is invalid: " + toast.type);
          return false;
        }

        return true;
      }
    },

    /**
     * Change the position of toast
     */
    topPosition: [Number, String]
  },
  emits: {
    /**
     * Triggered when delete icon was clicked on a toast
     *
     * Remove toast
     */
    removeToast: function removeToast() {
      return true;
    }
  },
  computed: {
    customTopPosition: function customTopPosition() {
      return this.resolveWithUnit(this.topPosition);
    }
  },
  methods: {
    resolveWithUnit: function resolveWithUnit(val) {
      if (!val) {
        return 0;
      }

      if (isNumber(val)) {
        return val + "px";
      } // Assume our user passed a unit, for example '100%'


      return val;
    },
    type: function type(_type) {
      switch (_type) {
        case ToastType.Error:
          return "isb-danger";

        case ToastType.Warning:
        case ToastType.Warn:
          return "isb-warning";

        case ToastType.Success:
          return "isb-success";

        case ToastType.Info:
          return "isb-info";

        default:
          return "isb-info";
      }
    },
    icon: function icon(type) {
      switch (type) {
        case ToastType.Error:
          return "triangle-exclamation";

        case ToastType.Warning:
        case ToastType.Warn:
          return "triangle-exclamation";

        case ToastType.Success:
          return "check-circle";

        case ToastType.Info:
          return "circle-info";

        default:
          return "circle-info";
      }
    }
  },
  watch: {
    toast: {
      handler: function handler(val) {
        var _this = this;

        if (!val) return;
        if (this.timeoutId) clearTimeout(this.timeoutId);

        if (val.timeout != null && val.timeoutId > 0) {
          this.timeoutId = window.setTimeout(function () {
            _this.$emit("removeToast");
          }, val.timeout);
        }
      },
      immediate: true,
      deep: true
    }
  }
});

var __injectCSSVars__$3 = function __injectCSSVars__() {
  useCssVars(function (_ctx) {
    return {
      "81286620": _ctx.customTopPosition
    };
  });
};

var __setup__$3 = __default__$3.setup;
__default__$3.setup = __setup__$3 ? function (props, ctx) {
  __injectCSSVars__$3();

  return __setup__$3(props, ctx);
} : __injectCSSVars__$3;

var _hoisted_1$i = {
  class: "sb-message-content"
};
function render$l(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$toast, _ctx$toast2, _ctx$toast3, _ctx$toast$body, _ctx$toast4;

  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return _ctx.toast ? (openBlock(), createElementBlock("ul", {
    key: 0,
    class: normalizeClass(["sb-toast-list", Object.keys((_ctx$toast = _ctx.toast) !== null && _ctx$toast !== void 0 ? _ctx$toast : {}).length === 0 ? 'hide' : ''])
  }, [createElementVNode("li", {
    class: normalizeClass(["sb-toast-message sb-toast-list-item", [_ctx.type((_ctx$toast2 = _ctx.toast) === null || _ctx$toast2 === void 0 ? void 0 : _ctx$toast2.type), _ctx.toast.sr_only ? 'sb-sr-only' : '']]),
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$emit('removeToast');
    })
  }, [createVNode(_component_font_awesome_icon, {
    class: "sb-message-icon",
    icon: ['fa-light', _ctx.icon((_ctx$toast3 = _ctx.toast) === null || _ctx$toast3 === void 0 ? void 0 : _ctx$toast3.type)]
  }, null, 8, ["icon"]), createElementVNode("div", _hoisted_1$i, toDisplayString$1((_ctx$toast$body = (_ctx$toast4 = _ctx.toast) === null || _ctx$toast4 === void 0 ? void 0 : _ctx$toast4.body) !== null && _ctx$toast$body !== void 0 ? _ctx$toast$body : ""), 1), createVNode(_component_font_awesome_icon, {
    class: "icon-close tablet-and-up",
    icon: "fa-regular fa-times"
  })], 2)], 2)) : createCommentVNode("", true);
}

__default__$3.render = render$l;
__default__$3.__scopeId = "data-v-17b5bee0";

/**
  ModalOverlay

  This component displays a modal dialog on top on application content.
  An overlay is applied which blur out content beneath the modal

  Original focus element is saved when modal opened and refocus once modal closes
  Prevent navigation to outer content with mouse, keyboard and screen reader.
  The focus is trap within the dialog focusable elements while the modal dialog is active

  The modal dialog can be opened by calling open() method,
  The modal dialog can be closed using the 'Close button', by pressing ESC key (keycode 27),
    or by calling close() method,
  After 'Close button' or ESC key is clicked, this component will emit 'closeModal' event

  Component properties:
  modalId - uniqueId of modal
  modalSize - modal size(big/small)
  modalIcon - font awesome icon to be used with modal e.g: ["fas", "info-circle"]

  Component methods:
  open - used to set modal dialog visible, save previously focused element
  close - used to set modal dialog hidden, set focus to previously save focused element

 */
var script$h = defineComponent({
  name: "ModalOverlay",
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    /**
     * Unique id to control show/hide logic
     */
    modalId: {
      type: String,
      required: true
    },

    /**
     * Size of the modal
     * Valid values are small/big
     */
    modalSize: {
      type: String,
      default: "small",
      // validator to show runtime warning if modalSize value is invalid
      validator: function validator(size) {
        return Object.values(ModalSize).includes(size);
      }
    },

    /**
     * Icon to use with the modal e.g: ["fas", "info-circle"]
     *
     * TODO: add ability to include other Illustration icons/image files
     */
    modalIcon: {
      type: [Object, Array],
      default: null
    },

    /**
     * Aria label for close button
     */
    closeButtonAriaLabel: {
      type: String,
      default: "Close button"
    }
  },
  data: function data() {
    return {
      active: false,
      originalFocusElement: null
    };
  },
  created: function created() {
    document.addEventListener("keydown", this.close);
    document.addEventListener("keydown", this.trapFocus);
  },
  beforeUnmount: function beforeUnmount() {
    document.removeEventListener("keydown", this.close);
    document.removeEventListener("keydown", this.trapFocus);

    if (this.active) {
      // remove noscroll class on component destroyed
      document.body.classList.toggle("s-noscroll", false);
    }
  },
  emits: {
    /**
     * Triggered after 'Close button' or ESC key is clicked
     */
    closeModal: function closeModal() {
      return true;
    }
  },
  methods: {
    open: function open() {
      this.active = true;
      this.originalFocusElement = document.activeElement;
      var modal = document.getElementById(this.modalId);

      if (modal) {
        modal.style.display = "flex";
        modal.focus();
      } // prevent scrolling of background content


      document.body.classList.toggle("s-noscroll", true);
    },
    close: function close(e) {
      if (this.active && (!e || e && e.type === "click" || e && e.key === "Escape")) {
        this.active = false;

        if (this.originalFocusElement) {
          this.originalFocusElement.focus();
          this.originalFocusElement = null;
        }

        var modal = document.getElementById(this.modalId);

        if (modal) {
          modal.style.display = "none";
        } // remove noscroll class on close modal


        document.body.classList.toggle("s-noscroll", false); // emit 'closeModal' event if user close modal by 'Esc' key

        if (e && e.key === "Escape") {
          this.$emit("closeModal");
          e.preventDefault();
        }
      }
    },
    // trap focus element within modal(using Tab or Shift + Tab)
    trapFocus: function trapFocus(e) {
      var _modal$querySelectorA;

      var isTabPressed = e.key === "Tab";

      if (!this.active || !isTabPressed) {
        return;
      } // add all the elements inside modal which are focusable'


      var focusableElements = 'a:not([disabled]), button:not([disabled]), input:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])';
      var modal = document.getElementById(this.modalId); // select the modal by its id

      var focusableContent = (_modal$querySelectorA = modal === null || modal === void 0 ? void 0 : modal.querySelectorAll(focusableElements)) !== null && _modal$querySelectorA !== void 0 ? _modal$querySelectorA : []; // get first element to be focused inside modal

      var firstFocusableElement = focusableContent[0]; // get last element to be focused inside modal

      var lastFocusableElement = focusableContent[focusableContent.length - 1];

      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (modal === document.activeElement || document.activeElement === firstFocusableElement) {
          lastFocusableElement === null || lastFocusableElement === void 0 ? void 0 : lastFocusableElement.focus(); // add focus for the last focusable element

          e === null || e === void 0 ? void 0 : e.preventDefault();
        }
      } else {
        // if tab key is pressed
        if (document.activeElement === lastFocusableElement) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus(); // add focus for the first focusable element

          e.preventDefault();
        }
      }
    }
  }
});

var _withScopeId$3 = function _withScopeId(n) {
  return pushScopeId("data-v-64b3c614"), n = n(), popScopeId(), n;
};

var _hoisted_1$h = ["id", "aria-labelledby"];
var _hoisted_2$g = {
  key: 0,
  class: "sb-modal-content sb-modal-content-small"
};
var _hoisted_3$d = {
  class: "sb-modal-header"
};
var _hoisted_4$b = ["id"];
var _hoisted_5$9 = ["title", "aria-label"];
var _hoisted_6$9 = {
  class: "sb-modal-body"
};
var _hoisted_7$7 = {
  class: "sb-modal-body-icon"
};
var _hoisted_8$3 = {
  class: "sb-modal-body-disclaimer sb-subtitle"
};
var _hoisted_9$3 = {
  class: "sb-modal-footer"
};
var _hoisted_10$3 = {
  key: 1,
  class: "sb-modal-content sb-modal-content-big"
};
var _hoisted_11$3 = {
  class: "sb-modal-header"
};
var _hoisted_12$1 = {
  class: "sb-modal-header-icon sb-icon-big"
};
var _hoisted_13$1 = ["id"];
var _hoisted_14$1 = ["title", "aria-label"];
var _hoisted_15$1 = {
  class: "sb-modal-body"
};
var _hoisted_16$1 = {
  class: "sb-modal-footer"
};

var _hoisted_17 = /*#__PURE__*/_withScopeId$3(function () {
  return /*#__PURE__*/createElementVNode("div", {
    class: "modal-overlay"
  }, null, -1);
});

function render$k(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock("div", {
    id: _ctx.modalId,
    class: "sb-modal",
    role: "dialog",
    "aria-modal": true,
    "aria-labelledby": "".concat(_ctx.modalId, "-header"),
    tabindex: "-1"
  }, [createElementVNode("div", {
    role: "document",
    class: normalizeClass(["sb-modal-dialog", {
      active: _ctx.active
    }])
  }, [_ctx.modalSize === 'small' ? (openBlock(), createElementBlock("div", _hoisted_2$g, [createElementVNode("div", _hoisted_3$d, [createElementVNode("h2", {
    id: "".concat(_ctx.modalId, "-header")
  }, [renderSlot(_ctx.$slots, "modalHeader")], 8, _hoisted_4$b), createElementVNode("button", {
    title: _ctx.closeButtonAriaLabel,
    "aria-label": _ctx.closeButtonAriaLabel,
    class: "sb-modal-close",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      _ctx.close($event);

      _ctx.$emit('closeModal');
    })
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['far', 'times']
  })], 8, _hoisted_5$9)]), createElementVNode("div", _hoisted_6$9, [createElementVNode("div", _hoisted_7$7, [_ctx.modalIcon !== null ? renderSlot(_ctx.$slots, "modalIcon", {
    key: 0
  }, function () {
    return [createVNode(_component_font_awesome_icon, {
      icon: _ctx.modalIcon
    }, null, 8, ["icon"])];
  }) : createCommentVNode("", true)]), createElementVNode("div", _hoisted_8$3, [renderSlot(_ctx.$slots, "modalBody")])]), createElementVNode("div", _hoisted_9$3, [renderSlot(_ctx.$slots, "modalFooter")])])) : (openBlock(), createElementBlock("div", _hoisted_10$3, [createElementVNode("div", _hoisted_11$3, [createElementVNode("div", _hoisted_12$1, [_ctx.modalIcon !== null ? renderSlot(_ctx.$slots, "modalIcon", {
    key: 0
  }, function () {
    return [createVNode(_component_font_awesome_icon, {
      icon: _ctx.modalIcon
    }, null, 8, ["icon"])];
  }) : createCommentVNode("", true)]), createElementVNode("h2", {
    class: "sb-page-heading",
    id: "".concat(_ctx.modalId, "-header")
  }, [renderSlot(_ctx.$slots, "modalHeader")], 8, _hoisted_13$1), createElementVNode("button", {
    title: _ctx.closeButtonAriaLabel,
    "aria-label": _ctx.closeButtonAriaLabel,
    class: "sb-modal-close",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      _ctx.close($event);

      _ctx.$emit('closeModal');
    })
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['far', 'times']
  })], 8, _hoisted_14$1)]), createElementVNode("div", _hoisted_15$1, [renderSlot(_ctx.$slots, "modalBody")]), createElementVNode("div", _hoisted_16$1, [renderSlot(_ctx.$slots, "modalFooter")])]))], 2), _hoisted_17], 8, _hoisted_1$h);
}

script$h.render = render$k;
script$h.__scopeId = "data-v-64b3c614";

/**
 * A simplified version of ModalOverlay.
 *
 * Open the modal by calling open/close on this component, for example this.$refs.modal.open() (assuming "modal", is the ref for this component)
 *
 * Note, we disable scrolling on the main document while the modal is active, but scrolling inside the modal wrapper is undefined behavior (add a fixed max-width/height to the content you put inside the modal, and scroll inside that)
 */

var script$g = defineComponent({
  name: "BasicModal",
  props: {
    /**
     * Unique id to control show/hide logic
     */
    id: {
      type: String,
      required: false
    },

    /**
     * Value to enable click outside to close modal
     */
    disableClickOutside: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Class to inject to document body INSTEAD of the basic style
     * 'overflow: hidden'. Defaults to null if omitted.
     *
     * If omitted, a default class 'sb-modal-open' is injected
     */
    customInjectedClassOnOpen: {
      type: String,
      required: false,
      default: function _default() {
        return "sb-basic-modal-open";
      }
    }
  },
  computed: {
    modalId: function modalId() {
      var _this$id;

      return (_this$id = this.id) !== null && _this$id !== void 0 ? _this$id : uuid();
    }
  },
  data: function data() {
    return {
      active: false,
      isDrag: false,
      originalFocusElement: null
    };
  },
  beforeUnmount: function beforeUnmount() {
    // Make sure to remove listeners, if we are unmounted while active
    this.removeEventHandlers();
  },
  emits: {
    /**
     * Triggered after 'Close button' or ESC key is clicked
     */
    closeModal: function closeModal() {
      return true;
    }
  },
  watch: {
    documentClassName: function documentClassName(oldClass, newClass) {
      var _document$body, _document$body$classL, _document$body2, _document$body2$class;

      if (!this.active) return;
      if (oldClass) (_document$body = document.body) === null || _document$body === void 0 ? void 0 : (_document$body$classL = _document$body.classList) === null || _document$body$classL === void 0 ? void 0 : _document$body$classL.remove(oldClass);
      if (newClass) (_document$body2 = document.body) === null || _document$body2 === void 0 ? void 0 : (_document$body2$class = _document$body2.classList) === null || _document$body2$class === void 0 ? void 0 : _document$body2$class.add(newClass);
    }
  },
  methods: {
    handleDocumentMouseDown: function handleDocumentMouseDown(e) {
      var modalWrapper = this.$refs.modalWrapper;
      var target = e.target;

      if (!this.disableClickOutside) {
        this.isDrag = target !== modalWrapper;
      }
    },
    handleDocumentClick: function handleDocumentClick(e) {
      if (!this.active || this.isDrag) return;
      // NOTE, we can't check if we clicked outside the modal, because we might be registering this event in response to a click event on a button etc.
      // this means, that this event could be in response to the event used to open this modal in the first place


      var modalWrapper = this.$refs.modalWrapper;
      var target = e.target;

      if (target === modalWrapper && !this.disableClickOutside) {

        this.close();
      }
    },
    open: function open() {
      var _this = this;

      if (this.active) return;

      this.active = true;
      this.originalFocusElement = document.activeElement; // Move focus inside modal

      this.$nextTick(function () {
        var _this$$refs$modalWrap, _this$$refs$modalWrap2;

        // @ts-ignore
        (_this$$refs$modalWrap = _this.$refs.modalWrapper) === null || _this$$refs$modalWrap === void 0 ? void 0 : (_this$$refs$modalWrap2 = _this$$refs$modalWrap.focus) === null || _this$$refs$modalWrap2 === void 0 ? void 0 : _this$$refs$modalWrap2.call(_this$$refs$modalWrap);
      });
      this.addEventHandlers();
    },
    addEventHandlers: function addEventHandlers() {

      document.addEventListener("click", this.handleDocumentClick);
      document.addEventListener("mousedown", this.handleDocumentMouseDown);
      document.addEventListener("keydown", this.handleDocumentKeydown);

      if (this.customInjectedClassOnOpen) {
        var _document$body3, _document$body3$class;

        (_document$body3 = document.body) === null || _document$body3 === void 0 ? void 0 : (_document$body3$class = _document$body3.classList) === null || _document$body3$class === void 0 ? void 0 : _document$body3$class.add(this.customInjectedClassOnOpen);
      }
    },
    removeEventHandlers: function removeEventHandlers() {
      document.removeEventListener("click", this.handleDocumentClick);
      document.removeEventListener("mousedown", this.handleDocumentMouseDown);
      document.removeEventListener("keydown", this.handleDocumentKeydown);

      if (this.customInjectedClassOnOpen) {
        var _document$body4, _document$body4$class;

        (_document$body4 = document.body) === null || _document$body4 === void 0 ? void 0 : (_document$body4$class = _document$body4.classList) === null || _document$body4$class === void 0 ? void 0 : _document$body4$class.remove(this.customInjectedClassOnOpen);
      }
    },
    close: function close() {
      var _this2 = this;

      if (!this.active) return;

      this.active = false;

      if (this.originalFocusElement) {
        this.$nextTick(function () {
          var _this2$originalFocusE, _this2$originalFocusE2;

          (_this2$originalFocusE = _this2.originalFocusElement) === null || _this2$originalFocusE === void 0 ? void 0 : (_this2$originalFocusE2 = _this2$originalFocusE.focus) === null || _this2$originalFocusE2 === void 0 ? void 0 : _this2$originalFocusE2.call(_this2$originalFocusE);
          _this2.originalFocusElement = null;
        });
      }

      this.removeEventHandlers();
      this.$emit("closeModal");
    },
    // trap focus element within modal(using Tab or Shift + Tab)
    handleDocumentKeydown: function handleDocumentKeydown(e) {
      var _modal$querySelectorA;

      // ignore while not active
      if (!this.active) return;

      if (e.key === "Escape") {
        this.close();
        return;
      } // check if tab is pressed, if yes prevent focus from escaping modal


      var isTabPressed = e.key === "Tab";

      if (!isTabPressed) {
        return;
      }


      var focusableElements = 'a:not([disabled]), button:not([disabled]), input:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])';
      var modal = this.$refs.modalWrapper;
      var focusableContent = (_modal$querySelectorA = modal === null || modal === void 0 ? void 0 : modal.querySelectorAll(focusableElements)) !== null && _modal$querySelectorA !== void 0 ? _modal$querySelectorA : []; // get first element to be focused inside modal

      var firstFocusableElement = focusableContent[0]; // get last element to be focused inside modal

      var lastFocusableElement = focusableContent[focusableContent.length - 1];

      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (modal === document.activeElement || document.activeElement === firstFocusableElement) {
          lastFocusableElement === null || lastFocusableElement === void 0 ? void 0 : lastFocusableElement.focus(); // add focus for the last focusable element

          e === null || e === void 0 ? void 0 : e.preventDefault();
        }
      } else {
        // if tab key is pressed
        if (document.activeElement === lastFocusableElement) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus(); // add focus for the first focusable element

          e.preventDefault();
        }
      }
    }
  }
});

var _hoisted_1$g = ["id", "aria-labelledby"];
var _hoisted_2$f = {
  class: "sb-modal-content"
};
var _hoisted_3$c = ["id"];
var _hoisted_4$a = {
  class: "sb-modal-body"
};
function render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    id: _ctx.modalId,
    class: normalizeClass(["sb-basic-modal", {
      'sb-active': _ctx.active
    }]),
    role: "dialog",
    "aria-modal": true,
    "aria-labelledby": "".concat(_ctx.modalId, "-header"),
    tabindex: "-1",
    ref: "modalWrapper"
  }, [createElementVNode("div", _hoisted_2$f, [createElementVNode("div", {
    class: "sb-modal-header",
    id: "".concat(_ctx.modalId, "-header")
  }, [renderSlot(_ctx.$slots, "modalHeader")], 8, _hoisted_3$c), createElementVNode("div", _hoisted_4$a, [renderSlot(_ctx.$slots, "modalBody")])])], 10, _hoisted_1$g);
}

script$g.render = render$j;
script$g.__scopeId = "data-v-738d8e3a";

/**
  Custom Dropdown

  This component is a custom dropdown select field, it consists of a button and a list-box of selectable items

  This component displays a button to open the selectable listbox

  This component displays a selectable listbox of options
  Clicking or selecting listbox items will emit 'update:modelValue' to parent component
  The list can be navigated through using mouse or keyboard tracked by 'activeIndex' index which will add class 'sb-item-active'
    to the current selected option (add hover effect)

  This component emits the following events:

  update:modelValue          Triggered when an option is selected(connected to v-model)

  Component properties:
  options - option list from parent component
  modelValue - currently selected value from parent(use with v-model, MUST be one of the values in the options array(same object reference))
  placeHolder - placeholder of the dropdown select
  buttonStyle - classnames for button
  buttonLabelledBy - button aria-labelled-by ids
  buttonLabel - button label

  Custom properties:
    --sb-custom-select-field-active-bg-color 
    --sb-custom-select-field-active-color
    --sb-custom-select-field-bottom-border-radius
 */
var script$f = defineComponent({
  name: "CustomSelectField",
  components: {
    FontAwesomeIcon: FontAwesomeIcon,
    InputLabelWrapper: script$q
  },
  props: {
    /**
     * An array contain values of selection
     */
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Currently selected value. A null value is used to indicate no selection.
     *
     * Note, this component should always be used in combination with v-model to manage value in parent component
     *  however, in case there's no need to keep track of current value, skip v-model and listen to @update:modelValue to get selected option
     *
     * If value is an object, it MUST be one of the values in the options array(same object reference).
     */
    modelValue: [String, Object],

    /**
     * Optional placeholder of dropdown when there is no selectedItem
     */
    placeHolder: String,

    /**
     * button style
     */
    buttonStyle: {
      type: String,
      default: ""
    },

    /**
     * button aria-labelled-by ids
     */
    buttonLabelledBy: {
      type: String,
      default: ""
    },

    /**
     * popup button aria-label
     *
     * NOTE: For accessibility purpose, one of buttonLabelledBy or buttonLabel should be set
     */
    buttonLabel: {
      type: String,
      default: ""
    },

    /**
     * Label position, defaults to left
     */
    labelPosition: {
      type: String,
      required: false
    },

    /**
     * Indicate this field as mandatory.
     *
     * Note this simply renders a '*' next to the label (and adds appropriate aria-attributes), we do not validate the user input in anyway
     */
    indicateMandatory: {
      type: Boolean,
      required: false
    },

    /**
     * Error message to render below the input field.
     *
     * Note, any non empty string value indicates that this input field is somehow invalid, and this will be indicated both visually and accessability wise.
     *
     * Note, that this error message will be used by screenreaders as well.
     *
     * Note, if you do not wish to show an error message for visual users, please include the error message anyway, but hide it with css (do not use display none, so screenreaders can understand what is wrong)
     */
    errorMessage: {
      type: String,
      required: false
    },

    /**
     * If the error message should shown, even if the user is currently modifying the text field.
     *
     * By default errors are only shown, when the text field is inactive
     */
    showErrorWhenFocused: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      // unique id of this dropdown
      uniqueId: uuid(),
      errorSpanId: uuid(),
      // active dropdown option
      selected: null,
      buttonEl: null,
      listboxEl: null,
      // state for options list
      open: false,
      activeIndex: 0,
      ignoreBlur: false,
      ignoreClick: false
    };
  },
  computed: {
    hasError: function hasError() {
      //FIXME; we could help validate a required attribute on blur/focus
      return !!this.errorMessage;
    }
  },
  mounted: function mounted() {
    this.buttonEl = this.$el.querySelector("button");
    this.listboxEl = this.$el.querySelector("[role=listbox]");
  },
  emits: ["update:modelValue"],
  watch: {
    /**
     * watch for changes in modelValue from parent component and setDropDownValue accordingly
     */
    modelValue: {
      handler: "setDropDownValue",
      // handler methods to be called when component created
      immediate: true
    },
    options: {
      handler: function handler(val) {
        if (!val) return;
        if (!this.modelValue) return;


        var _iterator = _createForOfIteratorHelper(val),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var option = _step.value;

            if (option === this.modelValue) {
              if (IS_DEV) ;

              return;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (typeof this.modelValue === "string") {
          this.$emit("update:modelValue", null);
          return;
        }

        var _iterator2 = _createForOfIteratorHelper(val),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _this$modelValue;

            var _option = _step2.value;

            if (_typeof$5(_option) === "object" && (_option === null || _option === void 0 ? void 0 : _option.key) === ((_this$modelValue = this.modelValue) === null || _this$modelValue === void 0 ? void 0 : _this$modelValue.key)) {
              if (IS_DEV) ;

              this.$emit("update:modelValue", _option);
              return;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        this.$emit("update:modelValue", null);
      },
      // FIXME, make this deep?
      // Our user should not be stupid
      immediate: true
    }
  },
  methods: {
    getKey: function getKey(option, index) {
      if (_typeof$5(option) === "object") {
        if ((option === null || option === void 0 ? void 0 : option.key) != null) {
          return option.key;
        }
      } // FIXME; just return index?


      return "".concat(option, "-").concat(index);
    },
    onButtonKeyDown: function onButtonKeyDown(event) {
      var key = event.key;
      var action = ComboBoxUtil.getActionFromKey(key, this.open);

      switch (action) {
        case MenuActions.Close:

          event.preventDefault();
          return this.updateMenuState(false);

        case MenuActions.Open:
          return this.updateMenuState(true);
      }
    },
    consumeIgnoreClick: function consumeIgnoreClick(event) {
      if (!this.ignoreClick) return;

      this.ignoreClick = false;
    },
    onButtonMousedown: function onButtonMousedown() {
      if (this.open) {

        this.ignoreClick = true;
      } else {
        if (this.ignoreClick) {

          this.ignoreClick = false;
        }
      }
    },
    onButtonClick: function onButtonClick() {
      if (this.ignoreClick) {

        this.ignoreClick = false;
        return;
      }

      this.updateMenuState(true, true);
    },
    onComboBlur: function onComboBlur() {
      if (this.ignoreBlur) {

        this.ignoreBlur = false;
        return;
      }

      this.updateMenuState(false, false);
    },
    onListboxKeyDown: function onListboxKeyDown(event) {
      var key = event.key;
      var max = this.options.length - 1;
      var action = ComboBoxUtil.getActionFromKey(key, this.open);

      switch (action) {
        case MenuActions.Next:
        case MenuActions.Last:
        case MenuActions.First:
        case MenuActions.Previous:

          event.preventDefault();
          return this.onOptionChange(ComboBoxUtil.getUpdatedIndex(this.activeIndex, max, action));

        case MenuActions.CloseSelect:

          event.preventDefault();
          this.selectOption(this.activeIndex);
          return this.updateMenuState(false);

        case MenuActions.Close:

          event.preventDefault();
          return this.updateMenuState(false);
      }
    },
    onOptionChange: function onOptionChange(index) {
      var _this$listboxEl;

      this.activeIndex = index;
      (_this$listboxEl = this.listboxEl) === null || _this$listboxEl === void 0 ? void 0 : _this$listboxEl.setAttribute("aria-activedescendant", "s-dropdown-".concat(this.uniqueId, "-").concat(index));
    },
    onOptionClick: function onOptionClick(index) {

      this.onOptionChange(index);
      this.selectOption(index);
      this.updateMenuState(false);
    },
    onOptionMouseDown: function onOptionMouseDown() {

      this.ignoreBlur = true;
    },
    selectOption: function selectOption(index) {
      this.selected = this.options[index];
      this.activeIndex = index;
      this.$emit("update:modelValue", this.selected);
    },
    updateMenuState: function updateMenuState(open) {
      var callFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.open = open;
      var focusEl = open ? this.listboxEl : this.buttonEl;
      this.ignoreBlur = callFocus;
      this.$nextTick(function () {

        callFocus && (focusEl === null || focusEl === void 0 ? void 0 : focusEl.focus());
      });
    },
    // set selected dropdown value and activeIndex
    // in case value is null, display placeholder text as selected option
    setDropDownValue: function setDropDownValue() {
      var _this = this;

      if (!this.modelValue) {
        var _this$placeHolder;

        this.selected = (_this$placeHolder = this.placeHolder) !== null && _this$placeHolder !== void 0 ? _this$placeHolder : null;
      } else {
        this.activeIndex = this.options.findIndex(function (option) {
          return option === _this.modelValue;
        });
        this.selected = this.modelValue;
      }
    },

    /**
     * clearValue can be called manually clear selected dropdown value
     * e.g: in case there's no need to keep track of current value
     */
    clearValue: function clearValue() {
      var _this$placeHolder2;

      this.selected = (_this$placeHolder2 = this.placeHolder) !== null && _this$placeHolder2 !== void 0 ? _this$placeHolder2 : null;
    }
  }
});

var _hoisted_1$f = {
  class: "sb-dropdown"
};
var _hoisted_2$e = ["aria-label", "aria-labelledby", "aria-expanded", "id"];
var _hoisted_3$b = {
  class: "sb-selected-text"
};
var _hoisted_4$9 = {
  class: "sb-selected-icon"
};
var _hoisted_5$8 = ["aria-selected", "id", "onMouseover", "onClick"];
var _hoisted_6$8 = ["id"];
function render$i(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _component_InputLabelWrapper = resolveComponent("InputLabelWrapper");

  return openBlock(), createBlock(_component_InputLabelWrapper, {
    labelPosition: _ctx.labelPosition,
    class: normalizeClass(["sb-text-input-wrapper", [_ctx.hasError ? 'sb-invalid' : '', !_ctx.modelValue ? 'sb-is-empty' : '', _ctx.$attrs.disabled ? 'sb-disabled' : '']]),
    "indicate-mandatory": _ctx.indicateMandatory,
    showErrorWhenFocused: _ctx.showErrorWhenFocused,
    invalid: !!_ctx.errorMessage
  }, {
    label: withCtx(function () {
      return [];
    }),
    input: withCtx(function () {
      return [createElementVNode("div", _hoisted_1$f, [createElementVNode("button", {
        "aria-label": _ctx.buttonLabel,
        "aria-labelledby": "".concat(_ctx.buttonLabelledBy, " s-dropdown-button-").concat(_ctx.uniqueId),
        "aria-haspopup": "listbox",
        "aria-expanded": _ctx.open ? 'true' : 'false',
        id: "s-dropdown-button-".concat(_ctx.uniqueId),
        class: normalizeClass(["sb-selection", [{
          'sb-selection-open': _ctx.open
        }, _ctx.buttonStyle]]),
        type: "button",
        onBlur: _cache[0] || (_cache[0] = function () {
          return _ctx.onComboBlur && _ctx.onComboBlur.apply(_ctx, arguments);
        }),
        onClick: _cache[1] || (_cache[1] = function () {
          return _ctx.onButtonClick && _ctx.onButtonClick.apply(_ctx, arguments);
        }),
        onMousedown: _cache[2] || (_cache[2] = function () {
          return _ctx.onButtonMousedown && _ctx.onButtonMousedown.apply(_ctx, arguments);
        }),
        onKeydown: _cache[3] || (_cache[3] = function () {
          return _ctx.onButtonKeyDown && _ctx.onButtonKeyDown.apply(_ctx, arguments);
        })
      }, [createElementVNode("span", _hoisted_3$b, [renderSlot(_ctx.$slots, "selected-item", {
        selectedItem: _ctx.selected
      }, function () {
        return [createTextVNode(toDisplayString$1(_ctx.selected ? _ctx.selected.title ? _ctx.selected.title : _ctx.selected : ""), 1)];
      })]), createElementVNode("span", _hoisted_4$9, [_ctx.open ? (openBlock(), createBlock(_component_font_awesome_icon, {
        key: 0,
        onClick: _ctx.consumeIgnoreClick,
        icon: ['fas', 'chevron-up']
      }, null, 8, ["onClick"])) : (openBlock(), createBlock(_component_font_awesome_icon, {
        key: 1,
        onClick: _ctx.consumeIgnoreClick,
        icon: ['fas', 'chevron-down']
      }, null, 8, ["onClick"]))])], 42, _hoisted_2$e), withDirectives(createElementVNode("div", {
        "aria-activedescendant": "",
        tabindex: "-1",
        role: "listbox",
        class: "sb-items",
        onBlur: _cache[5] || (_cache[5] = function () {
          return _ctx.onComboBlur && _ctx.onComboBlur.apply(_ctx, arguments);
        }),
        onKeydown: _cache[6] || (_cache[6] = function () {
          return _ctx.onListboxKeyDown && _ctx.onListboxKeyDown.apply(_ctx, arguments);
        })
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, function (option, index) {
        return openBlock(), createElementBlock("div", {
          key: _ctx.getKey(option, index),
          role: "option",
          "aria-selected": _ctx.activeIndex === index ? 'true' : 'false',
          id: "s-dropdown-".concat(_ctx.uniqueId, "-").concat(index),
          class: normalizeClass(["sb-item", {
            'sb-item-active': _ctx.activeIndex === index
          }]),
          onMouseover: function onMouseover($event) {
            return _ctx.onOptionChange(index);
          },
          onClick: function onClick($event) {
            return _ctx.onOptionClick(index);
          },
          onMousedown: _cache[4] || (_cache[4] = function () {
            return _ctx.onOptionMouseDown && _ctx.onOptionMouseDown.apply(_ctx, arguments);
          })
        }, [renderSlot(_ctx.$slots, "list-item", {
          listItem: option
        }, function () {
          return [createTextVNode(toDisplayString$1(option.title ? option.title : option), 1)];
        })], 42, _hoisted_5$8);
      }), 128))], 544), [[vShow, _ctx.open]])])];
    }),
    error: withCtx(function () {
      return [_ctx.hasError ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "sb-error-message",
        id: _ctx.errorSpanId
      }, toDisplayString$1(_ctx.errorMessage), 9, _hoisted_6$8)) : createCommentVNode("", true)];
    }),
    _: 3
  }, 8, ["labelPosition", "class", "indicate-mandatory", "showErrorWhenFocused", "invalid"]);
}

script$f.render = render$i;
script$f.__scopeId = "data-v-423dd701";

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root.Date.now();
};

var now_1 = now;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

/**
    Custom Type To Search Component

    This component is a multi-select combo-box, it consists of an input field, a list-box of selectable items
        and a list of results(modelValue) beneath the combo-box

    This component displays an input for type to search filter
    Input have a debounce delay of 300ms before updating searchString value
    When searchString changes, this components will $emit("keywordChanged", this.searchString) to fetch new options lists
    Click on input will open dropdown list and show selectable options if exist
    Press enter on input will $emit("selectOption", option) event to parent if the option correspond to activeIndex isNotNull
    Press enter on input will also $emit("update:modelValue", newResults) to update component modelValue

    This component displays a list of selectable tts-options, with the options lists coming from parent component
    Clicking an option will also emit 'selectOption' event to parent component
    Clicking an option will also $emit("update:modelValue", newResults) to update component modelValue
    The list can be navigated through using mouse or keyboard which will update 'activeIndex' variables

    This component also displays a result list displaying previously selected options
    Each ListItem will display icon, title and has a delete button to emit 'removeItem' event to parent component

    On emitting 'selectOption' method or 'searchString' is cleared, resetComponentProperties will be triggered



    This component emits the following events:

    keywordChanged     Triggered when searchString updated to fetch new options lists from parent component
    update:modelValue  Triggered when an option is selected by clicking/keyboard enter, add option to results and update modelValue
    selectOption       Triggered when an option is selected by clicking/keyboard enter, sent option to parent and resetComponentProperties
    removeItem         Triggered when delete button is click on result list item to remove an item from modelValue

    Component properties:

    placeholder - placeholder of input
    options - updated options list from parent component
    modelValue - updated results list from parent component
    resultsIcon - icon of results list item
    inputDescribedBy - input aria-describedby element id
    inputLabel - input label

*/

var script$e = defineComponent({
  name: "TypeToSearch",
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    /**
     * Input placeholder
     */
    placeholder: String,

    /**
     * An array contain values of available selection options
     */
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * An array of selected items
     */
    modelValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * icon of results list item e.g: ["fas", "info-circle"]
     *
     * TODO: add ability to include other Illustration icons/image files
     */
    resultsIcon: {
      type: [Object, Array],
      default: null
    },

    /**
     * input aria-describedby element id
     */
    inputDescribedBy: String,

    /**
     * input aria-label
     *
     * NOTE: For accessibility purpose, one of inputDescribedBy or inputLabel should be set
     */
    inputLabel: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      // unique id of this tts
      uniqueId: uuid(),
      debounceInput: null,
      inputEl: null,
      searchString: "",
      // state for options list
      open: false,
      activeIndex: 0,
      ignoreBlur: false
    };
  },
  created: function created() {
    var _this = this;

    // debounce tts input by 300ms
    this.debounceInput = debounce_1(function (e) {
      _this.searchString = e.target.value;
    }, 300);
  },
  mounted: function mounted() {
    this.inputEl = this.$el.querySelector("input");
  },
  emits: ["keywordChanged", "update:modelValue", "selectOption", "removeItem"],
  watch: {
    // handle searchString changes
    searchString: function searchString() {
      if (this.searchString !== "") {
        this.getUpdateResultList();
      } else {
        this.resetComponentProperties();
      }
    },
    // handle tts options changes
    options: function options() {
      // reset active option
      this.onOptionChange(-1); // updateMenuState depending on new option list length > 0

      var menuState = this.options.length > 0;

      if (this.open !== menuState) {
        this.updateMenuState(menuState, false);
      }
    }
  },
  methods: {
    getKey: function getKey(opt) {
      var _opt$key;

      return this.uniqueId + ((_opt$key = opt === null || opt === void 0 ? void 0 : opt.key) !== null && _opt$key !== void 0 ? _opt$key : opt === null || opt === void 0 ? void 0 : opt.label);
    },
    onInputKeyDown: function onInputKeyDown(event) {
      var key = event.key;
      var max = this.options.length - 1;
      var action = ComboBoxUtil.getActionFromKey(key, this.open); // Check that dropdown is open to execute action

      if (this.open === true) {
        switch (action) {
          case MenuActions.Next:
          case MenuActions.Last:
          case MenuActions.First:
          case MenuActions.Previous:
            event.preventDefault();
            return this.onOptionChange(ComboBoxUtil.getUpdatedIndex(this.activeIndex, max, action));

          case MenuActions.CloseSelect:
            event.preventDefault();
            this.selectOption(this.activeIndex);
            return this.updateMenuState(false);

          case MenuActions.Close:
            event.preventDefault();
            return this.updateMenuState(false);
        }
      } else if (action === MenuActions.Open) {
        return this.updateMenuState(true);
      }
    },
    onInputBlur: function onInputBlur() {
      if (this.ignoreBlur) {
        this.ignoreBlur = false;
        return;
      }

      if (this.open) {
        this.updateMenuState(false, false);
      }
    },
    onOptionChange: function onOptionChange(index) {
      var _this2 = this;

      this.activeIndex = index;
      this.$nextTick(function () {
        var option = _this2.$el.querySelectorAll("[role=option]")[index];

        if (option) {
          var _this2$inputEl;

          (_this2$inputEl = _this2.inputEl) === null || _this2$inputEl === void 0 ? void 0 : _this2$inputEl.setAttribute("aria-activedescendant", "s-tts-".concat(_this2.uniqueId, "-").concat(index));

          var listboxEl = _this2.$el.querySelector("[role=listbox]");

          if (_this2.open && ComboBoxUtil.isScrollable(listboxEl)) {
            ComboBoxUtil.maintainScrollVisibility(option, listboxEl);
          }
        } else {
          var _this2$inputEl2;

          (_this2$inputEl2 = _this2.inputEl) === null || _this2$inputEl2 === void 0 ? void 0 : _this2$inputEl2.setAttribute("aria-activedescendant", "");
        }
      });
    },
    onOptionClick: function onOptionClick(index) {
      this.onOptionChange(index);
      this.selectOption(index);
      this.updateMenuState(false, true);
    },
    onOptionMouseDown: function onOptionMouseDown() {
      this.ignoreBlur = true;
    },
    selectOption: function selectOption(index) {
      var option = this.options[index];

      if (option) {
        var newResults = [].concat(_toConsumableArray$2(this.modelValue), [option]);
        this.open = false;
        this.$emit("update:modelValue", newResults);
        this.$emit("selectOption", option);
        this.resetComponentProperties();
      }
    },
    updateMenuState: function updateMenuState(open) {
      var _this$inputEl;

      var callFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.open = open;
      callFocus && ((_this$inputEl = this.inputEl) === null || _this$inputEl === void 0 ? void 0 : _this$inputEl.focus());
    },
    getUpdateResultList: function getUpdateResultList() {
      this.$emit("keywordChanged", this.searchString);
    },
    resetComponentProperties: function resetComponentProperties() {
      // clear all value after add new value
      this.searchString = "";
      this.activeIndex = 0; // clear ttsInput

      var ttsInput = this.$refs.ttsInput;

      if (ttsInput) {
        ttsInput.value = "";
      }
    },
    removeItem: function removeItem(item) {
      var newResults = _toConsumableArray$2(this.modelValue.filter(function (val) {
        return val.key ? val.key !== item.key : val.label !== item.label;
      }));

      this.$emit("update:modelValue", newResults);
      this.$emit("removeItem", item);
    }
  }
});

var _hoisted_1$e = {
  class: "sb-type-to-search"
};
var _hoisted_2$d = ["aria-expanded", "aria-owns"];
var _hoisted_3$a = ["id", "aria-label", "aria-describedby", "placeholder"];
var _hoisted_4$8 = ["id"];
var _hoisted_5$7 = ["aria-selected", "id", "onMouseover", "onClick"];
var _hoisted_6$7 = {
  class: "sb-tts-results"
};
var _hoisted_7$6 = {
  key: 0,
  class: "tts-item-icon"
};
var _hoisted_8$2 = {
  class: "sb-tts-item-details"
};
var _hoisted_9$2 = {
  class: "sb-tts-item-title"
};
var _hoisted_10$2 = {
  class: "sb-tts-item-btn-groups"
};
var _hoisted_11$2 = ["title", "aria-label", "onClick"];
function render$h(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock("div", _hoisted_1$e, [createElementVNode("div", {
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-expanded": _ctx.open ? 'true' : 'false',
    "aria-owns": "s-tts-".concat(_ctx.uniqueId, "-list-options")
  }, [createElementVNode("input", {
    ref: "ttsInput",
    id: "s-tts-".concat(_ctx.uniqueId, "-combo-input"),
    "aria-activedescendant": "",
    "aria-label": _ctx.inputLabel,
    "aria-describedby": _ctx.inputDescribedBy,
    class: "sb-tts-input",
    autocomplete: "new-password",
    placeholder: _ctx.placeholder,
    onKeydown: _cache[0] || (_cache[0] = function () {
      return _ctx.onInputKeyDown && _ctx.onInputKeyDown.apply(_ctx, arguments);
    }),
    onInput: _cache[1] || (_cache[1] = function () {
      return _ctx.debounceInput && _ctx.debounceInput.apply(_ctx, arguments);
    }),
    onBlur: _cache[2] || (_cache[2] = function () {
      return _ctx.onInputBlur && _ctx.onInputBlur.apply(_ctx, arguments);
    }),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.updateMenuState(true);
    })
  }, null, 40, _hoisted_3$a)], 8, _hoisted_2$d), _ctx.open && _ctx.options.length && _ctx.searchString.length ? (openBlock(), createElementBlock("div", {
    key: 0,
    role: "listbox",
    "aria-multiselectable": "true",
    id: "s-tts-".concat(_ctx.uniqueId, "-list-options"),
    class: "sb-tts-options"
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, function (option, index) {
    return openBlock(), createElementBlock("div", {
      role: "option",
      "aria-selected": _ctx.activeIndex === index ? 'true' : 'false',
      id: "s-tts-".concat(_ctx.uniqueId, "-").concat(index),
      key: _ctx.getKey(option),
      class: normalizeClass(["sb-tts-option", {
        'sb-tts-option-active': _ctx.activeIndex === index
      }]),
      onMouseover: function onMouseover($event) {
        return _ctx.onOptionChange(index);
      },
      onClick: function onClick($event) {
        return _ctx.onOptionClick(index);
      },
      onMousedown: _cache[4] || (_cache[4] = function () {
        return _ctx.onOptionMouseDown && _ctx.onOptionMouseDown.apply(_ctx, arguments);
      })
    }, [renderSlot(_ctx.$slots, "option", {
      option: option
    }, function () {
      return [createTextVNode(toDisplayString$1(option.label), 1)];
    })], 42, _hoisted_5$7);
  }), 128))], 8, _hoisted_4$8)) : createCommentVNode("", true), createElementVNode("ul", _hoisted_6$7, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modelValue, function (item) {
    return openBlock(), createElementBlock("li", {
      key: _ctx.getKey(item),
      class: "tts-item"
    }, [_ctx.resultsIcon ? (openBlock(), createElementBlock("div", _hoisted_7$6, [createVNode(_component_font_awesome_icon, {
      icon: _ctx.resultsIcon
    }, null, 8, ["icon"])])) : createCommentVNode("", true), createElementVNode("div", _hoisted_8$2, [createElementVNode("div", _hoisted_9$2, toDisplayString$1(item.label), 1)]), createElementVNode("div", _hoisted_10$2, [createElementVNode("button", {
      title: 'Remove' + item.label,
      "aria-label": 'Remove' + item.label,
      class: "sb-tts-item-btn-remove",
      onClick: function onClick($event) {
        return _ctx.removeItem(item);
      }
    }, [createVNode(_component_font_awesome_icon, {
      icon: ['far', 'times']
    })], 8, _hoisted_11$2)])]);
  }), 128))])]);
}

script$e.render = render$h;
script$e.__scopeId = "data-v-4c140831";

/**
 * A dropdown menu
 *
 * Use the DropdownMenuItem components to create menu items (pass into default slot).
 *
 * Note, make sure the DropdownMenuItem content is focusable (use button, a etc.)
 *
 * Note, you probably have to set menu-wrapper and menu-item widths yourself
 *
 * Note, currently you HAVE TO make sure that you on blur the target of a click inside the menu after navigation.
 * This due to the fact, that we use :focus-within to show the dropdown, the user tabs to it (and clicking a button/a focuses it).
 *
 * The easiest way to do this is to add a @mousedown.prevent to you clickable elements
 *
 * Developer note, if you wish to create buttons etc. that you can click inside menu items, that do not close the outer menu, call stopPropagation on any click events inside MenuItems, to stop them from reaching the DropdownMenu component.
 *
 * Note, that DropdownMenu supports nested dropdowns
 */

var script$d = defineComponent({
  name: "DropdownMenu",
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  inject: {
    dropdownMenuDepth: {
      default: 0
    }
  },
  provide: function provide() {
    return {
      dropdownMenuDepth: this.dropdownMenuDepth + 1,
      dropdownParentMenuForceOpen: this.forceOpen,
      dropdownParentMenuForceClose: this.forceClose
    };
  },
  emits: {
    open: function open() {
      return true;
    },
    close: function close() {
      return true;
    }
  },
  data: function data() {
    return {
      isOpen: false,
      expectButtonFocus: false
    };
  },
  methods: {
    toggleDropdown: function toggleDropdown() {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this.$emit("open");
      } else {
        this.$emit("close");
      }
    },
    forceClose: function forceClose() {
      var _menu$contains;

      if (!this.isOpen) return;

      var menu = this.$refs.menuContents;

      if (document.activeElement != null && (menu === document.activeElement || menu !== null && menu !== void 0 && (_menu$contains = menu.contains) !== null && _menu$contains !== void 0 && _menu$contains.call(menu, document.activeElement))) {
        var _document;

        if (((_document = document) === null || _document === void 0 ? void 0 : _document.activeElement) instanceof HTMLElement) {
          var _document2, _document2$activeElem, _document2$activeElem2;

          (_document2 = document) === null || _document2 === void 0 ? void 0 : (_document2$activeElem = _document2.activeElement) === null || _document2$activeElem === void 0 ? void 0 : (_document2$activeElem2 = _document2$activeElem.blur) === null || _document2$activeElem2 === void 0 ? void 0 : _document2$activeElem2.call(_document2$activeElem);
        }
      }

      this.isOpen = false;
      this.$emit("close");
    },
    forceOpen: function forceOpen() {
      if (this.isOpen) return;

      this.isOpen = true;
      this.$emit("open");
    },
    handleMousedown: function handleMousedown(event) {
      if (!this.isOpen) return;

      this.expectButtonFocus = true;
    },
    documentClickHandler: function documentClickHandler(event) {
      this.$refs.wrapper;
      var button = this.$refs.toggleButton;
      var menuContents = this.$refs.menuContents;
      var target = event.target; // Blur, if clicked outside the button

      if (button === target || button !== null && button !== void 0 && button.contains(target)) {

        this.expectButtonFocus = true;
        this.toggleDropdown();
      } else if (menuContents !== null && menuContents !== void 0 && menuContents.contains(target)) ; else if (menuContents === target) ; else {

        this.isOpen = false;
        this.$emit("close");
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener("click", this.documentClickHandler);
  },
  unmounted: function unmounted() {
    // Note, Vue does binding
    document.removeEventListener("click", this.documentClickHandler);
  },
  props: {
    /**
     * Dropdown button label
     */
    label: {
      type: String,
      required: false
    },

    /**
     * Dropdown button label
     */
    iconToLeftOfLabel: {
      type: Boolean,
      required: false
    },

    /**
     * Icon to display when the menu is open.
     *
     * Defaults to chevron-up
     */
    openIcon: {
      type: String,
      required: false,
      default: "chevron-up"
    },

    /**
     * Icon to display when the menu is open
     *
     * Defaults to chevron-down
     */
    closeIcon: {
      type: String,
      required: false,
      default: "chevron-down"
    },

    /**
     * If menu item should be aligned at button right edge (by default aligns left)
     */
    alignRight: {
      type: Boolean,
      required: false
    }
  }
});

var _withScopeId$2 = function _withScopeId(n) {
  return pushScopeId("data-v-5c03ce6e"), n = n(), popScopeId(), n;
};

var _hoisted_1$d = {
  class: "sb-icon-wrapper"
};

var _hoisted_2$c = /*#__PURE__*/_withScopeId$2(function () {
  return /*#__PURE__*/createElementVNode("div", {
    class: "sb-filler"
  }, null, -1);
});

var _hoisted_3$9 = {
  class: "sb-label"
};
var _hoisted_4$7 = {
  class: "sb-label"
};

var _hoisted_5$6 = /*#__PURE__*/_withScopeId$2(function () {
  return /*#__PURE__*/createElementVNode("div", {
    class: "sb-filler"
  }, null, -1);
});

var _hoisted_6$6 = {
  class: "sb-icon-wrapper"
};
function render$g(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["sb-menu-wrapper", {
      open: _ctx.isOpen
    }]),
    ref: "wrapper"
  }, [createElementVNode("button", {
    class: "sb-menu-button",
    onMousedown: _cache[0] || (_cache[0] = function () {
      return _ctx.handleMousedown && _ctx.handleMousedown.apply(_ctx, arguments);
    }),
    type: "button",
    ref: "toggleButton"
  }, [_ctx.iconToLeftOfLabel === true ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createElementVNode("div", _hoisted_1$d, [_ctx.openIcon && _ctx.closeIcon ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createVNode(_component_font_awesome_icon, {
    class: "sb-open-icon",
    icon: _ctx.openIcon
  }, null, 8, ["icon"]), createVNode(_component_font_awesome_icon, {
    class: "sb-close-icon",
    icon: _ctx.closeIcon
  }, null, 8, ["icon"])], 64)) : createCommentVNode("", true)]), _hoisted_2$c, createElementVNode("div", _hoisted_3$9, [renderSlot(_ctx.$slots, "label")])], 64)) : (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [createElementVNode("div", _hoisted_4$7, [renderSlot(_ctx.$slots, "label")]), _hoisted_5$6, createElementVNode("div", _hoisted_6$6, [_ctx.openIcon && _ctx.closeIcon ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createVNode(_component_font_awesome_icon, {
    class: "sb-open-icon",
    icon: _ctx.openIcon
  }, null, 8, ["icon"]), createVNode(_component_font_awesome_icon, {
    class: "sb-close-icon",
    icon: _ctx.closeIcon
  }, null, 8, ["icon"])], 64)) : createCommentVNode("", true)])], 64))], 544), createElementVNode("ul", {
    class: normalizeClass([[_ctx.alignRight ? 'right-align' : 'left-align'], "sb-dropdown-menu"]),
    style: normalizeStyle({
      zIndex: 1000 + this.dropdownMenuDepth
    }),
    ref: "menuContents"
  }, [renderSlot(_ctx.$slots, "default")], 6)], 2);
}

script$d.render = render$g;
script$d.__scopeId = "data-v-5c03ce6e";

/**
 * A dropdown menu item. Use only with DropdownMenu.
 *
 * Pass any content to the default slot, note this component is a very simple wrapper around li, do any functionality with the dropdown item yourself.
 *
 * Note, by default we style the item to be clickable (cursor, hover etc.), if you have non clickable items in your dropdown (such as headers etc.), make sure to override our default styling.
 *
 * Developer note, if you wish to create buttons etc. that you can click inside menu items, that do not close the outer menu, call stopPropagation on any click events, to stop them from reaching the DropdownMenu component
 */

var script$c = defineComponent({
  name: "DropdownMenuItem",
  components: {},
  inject: ["dropdownParentMenuForceClose"],
  data: function data() {
    return {};
  },
  methods: {
    handleClick: function handleClick(event) {
      // FIXME; do some provide/inject shenanignans, so we don't need to trap the event like this
      // this will mess up with any @click stuff our user is doing
      if (this.notClickable === true) {
        event.preventDefault();
        event.stopPropagation();
      } else if (this.forceCloseOnClick === true) {
        var _this$dropdownParentM;


        (_this$dropdownParentM = this.dropdownParentMenuForceClose) === null || _this$dropdownParentM === void 0 ? void 0 : _this$dropdownParentM.call(this);
      }
    }
  },
  props: {
    /**
     * Whether we trap any click events inside this component or not.
     *
     * Note, we will trap any click events inside this element, so do not use this, if the some of children are clickable, but you wish to stop clicking them from closing the menu.
     *
     * Guarantees, that any click events inside this menu item will not reach the parent menu (and for example the menu will never toggle open/close state due to clicks here)
     */
    notClickable: {
      type: Boolean,
      required: false
    },

    /**
     * If a click inside the menu item should force the parent to close, no matter what.
     *
     * Note, if an element inside has focus after the click, we will blur it
     */
    forceCloseOnClick: {
      type: Boolean,
      required: false
    }
  }
});

function render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", {
    class: normalizeClass(["sb-menu-item", {
      'not-clickable': _ctx.notClickable
    }]),
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.handleClick && _ctx.handleClick.apply(_ctx, arguments);
    })
  }, [renderSlot(_ctx.$slots, "default")], 2);
}

script$c.render = render$f;
script$c.__scopeId = "data-v-dcff244c";

var script$b = defineComponent({
  name: "InfoBox",
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    type: {
      type: String,
      default: "info"
    },
    noIcon: {
      type: Boolean
    },
    overrideIcon: {
      type: [String, Array]
    }
  },
  computed: {
    icon: function icon() {
      if (this.overrideIcon) {
        return this.overrideIcon;
      }

      switch (this.type) {
        case "success":
          return "fa-light fa-circle-check";

        case "error":
        case "warn":
          return "fa-light fa-triangle-exclamation";

        case "info":
        case "disabled":
        default:
          return "fa-light fa-info-circle";
      }
    }
  }
});

var _hoisted_1$c = {
  key: 0,
  class: "sb-icon-container"
};
var _hoisted_2$b = {
  class: "sb-text-container"
};
function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["sb-info-box", _ctx.type || 'info'])
  }, [_ctx.noIcon != true ? (openBlock(), createElementBlock("div", _hoisted_1$c, [createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: _ctx.icon
  }, null, 8, ["icon"])])) : createCommentVNode("", true), createElementVNode("div", _hoisted_2$b, [renderSlot(_ctx.$slots, "default")])], 2);
}

script$b.render = render$e;
script$b.__scopeId = "data-v-738d87de";

const allCountries = [
  [
    "Afghanistan (\u202B\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646\u202C\u200E)",
    "af",
    "93"
  ],
  [
    "Albania (Shqip\xEBri)",
    "al",
    "355"
  ],
  [
    "Algeria (\u202B\u0627\u0644\u062C\u0632\u0627\u0626\u0631\u202C\u200E)",
    "dz",
    "213"
  ],
  [
    "American Samoa",
    "as",
    "1684"
  ],
  [
    "Andorra",
    "ad",
    "376"
  ],
  [
    "Angola",
    "ao",
    "244"
  ],
  [
    "Anguilla",
    "ai",
    "1264"
  ],
  [
    "Antigua and Barbuda",
    "ag",
    "1268"
  ],
  [
    "Argentina",
    "ar",
    "54"
  ],
  [
    "Armenia (\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576)",
    "am",
    "374"
  ],
  [
    "Aruba",
    "aw",
    "297"
  ],
  [
    "Australia",
    "au",
    "61"
  ],
  [
    "Austria (\xD6sterreich)",
    "at",
    "43"
  ],
  [
    "Azerbaijan (Az\u0259rbaycan)",
    "az",
    "994"
  ],
  [
    "Bahamas",
    "bs",
    "1242"
  ],
  [
    "Bahrain (\u202B\u0627\u0644\u0628\u062D\u0631\u064A\u0646\u202C\u200E)",
    "bh",
    "973"
  ],
  [
    "Bangladesh (\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)",
    "bd",
    "880"
  ],
  [
    "Barbados",
    "bb",
    "1246"
  ],
  [
    "Belarus (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)",
    "by",
    "375"
  ],
  [
    "Belgium (Belgi\xEB)",
    "be",
    "32"
  ],
  [
    "Belize",
    "bz",
    "501"
  ],
  [
    "Benin (B\xE9nin)",
    "bj",
    "229"
  ],
  [
    "Bermuda",
    "bm",
    "1441"
  ],
  [
    "Bhutan (\u0F60\u0F56\u0FB2\u0F74\u0F42)",
    "bt",
    "975"
  ],
  [
    "Bolivia",
    "bo",
    "591"
  ],
  [
    "Bosnia and Herzegovina (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)",
    "ba",
    "387"
  ],
  [
    "Botswana",
    "bw",
    "267"
  ],
  [
    "Brazil (Brasil)",
    "br",
    "55"
  ],
  [
    "British Indian Ocean Territory",
    "io",
    "246"
  ],
  [
    "British Virgin Islands",
    "vg",
    "1284"
  ],
  [
    "Brunei",
    "bn",
    "673"
  ],
  [
    "Bulgaria (\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F)",
    "bg",
    "359"
  ],
  [
    "Burkina Faso",
    "bf",
    "226"
  ],
  [
    "Burundi (Uburundi)",
    "bi",
    "257"
  ],
  [
    "Cambodia (\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6)",
    "kh",
    "855"
  ],
  [
    "Cameroon (Cameroun)",
    "cm",
    "237"
  ],
  [
    "Canada",
    "ca",
    "1"
  ],
  [
    "Cape Verde (Kabu Verdi)",
    "cv",
    "238"
  ],
  [
    "Caribbean Netherlands",
    "bq",
    "599"
  ],
  [
    "Cayman Islands",
    "ky",
    "1345"
  ],
  [
    "Central African Republic (R\xE9publique centrafricaine)",
    "cf",
    "236"
  ],
  [
    "Chad (Tchad)",
    "td",
    "235"
  ],
  [
    "Chile",
    "cl",
    "56"
  ],
  [
    "China (\u4E2D\u56FD)",
    "cn",
    "86"
  ],
  [
    "Christmas Island",
    "cx",
    "61"
  ],
  [
    "Cocos (Keeling) Islands",
    "cc",
    "61"
  ],
  [
    "Colombia",
    "co",
    "57"
  ],
  [
    "Comoros (\u202B\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631\u202C\u200E)",
    "km",
    "269"
  ],
  [
    "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    "cd",
    "243"
  ],
  [
    "Congo (Republic) (Congo-Brazzaville)",
    "cg",
    "242"
  ],
  [
    "Cook Islands",
    "ck",
    "682"
  ],
  [
    "Costa Rica",
    "cr",
    "506"
  ],
  [
    "C\xF4te d\u2019Ivoire",
    "ci",
    "225"
  ],
  [
    "Croatia (Hrvatska)",
    "hr",
    "385"
  ],
  [
    "Cuba",
    "cu",
    "53"
  ],
  [
    "Cura\xE7ao",
    "cw",
    "599"
  ],
  [
    "Cyprus (\u039A\u03CD\u03C0\u03C1\u03BF\u03C2)",
    "cy",
    "357"
  ],
  [
    "Czech Republic (\u010Cesk\xE1 republika)",
    "cz",
    "420"
  ],
  [
    "Denmark (Danmark)",
    "dk",
    "45"
  ],
  [
    "Djibouti",
    "dj",
    "253"
  ],
  [
    "Dominica",
    "dm",
    "1767"
  ],
  [
    "Dominican Republic (Rep\xFAblica Dominicana)",
    "do",
    "1"
  ],
  [
    "Ecuador",
    "ec",
    "593"
  ],
  [
    "Egypt (\u202B\u0645\u0635\u0631\u202C\u200E)",
    "eg",
    "20"
  ],
  [
    "El Salvador",
    "sv",
    "503"
  ],
  [
    "Equatorial Guinea (Guinea Ecuatorial)",
    "gq",
    "240"
  ],
  [
    "Eritrea",
    "er",
    "291"
  ],
  [
    "Estonia (Eesti)",
    "ee",
    "372"
  ],
  [
    "Ethiopia",
    "et",
    "251"
  ],
  [
    "Falkland Islands (Islas Malvinas)",
    "fk",
    "500"
  ],
  [
    "Faroe Islands (F\xF8royar)",
    "fo",
    "298"
  ],
  [
    "Fiji",
    "fj",
    "679"
  ],
  [
    "Finland (Suomi)",
    "fi",
    "358"
  ],
  [
    "France",
    "fr",
    "33"
  ],
  [
    "French Guiana (Guyane fran\xE7aise)",
    "gf",
    "594"
  ],
  [
    "French Polynesia (Polyn\xE9sie fran\xE7aise)",
    "pf",
    "689"
  ],
  [
    "Gabon",
    "ga",
    "241"
  ],
  [
    "Gambia",
    "gm",
    "220"
  ],
  [
    "Georgia (\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD)",
    "ge",
    "995"
  ],
  [
    "Germany (Deutschland)",
    "de",
    "49"
  ],
  [
    "Ghana (Gaana)",
    "gh",
    "233"
  ],
  [
    "Gibraltar",
    "gi",
    "350"
  ],
  [
    "Greece (\u0395\u03BB\u03BB\u03AC\u03B4\u03B1)",
    "gr",
    "30"
  ],
  [
    "Greenland (Kalaallit Nunaat)",
    "gl",
    "299"
  ],
  [
    "Grenada",
    "gd",
    "1473"
  ],
  [
    "Guadeloupe",
    "gp",
    "590"
  ],
  [
    "Guam",
    "gu",
    "1671"
  ],
  [
    "Guatemala",
    "gt",
    "502"
  ],
  [
    "Guernsey",
    "gg",
    "44",
    1
  ],
  [
    "Guinea (Guin\xE9e)",
    "gn",
    "224"
  ],
  [
    "Guinea-Bissau (Guin\xE9 Bissau)",
    "gw",
    "245"
  ],
  [
    "Guyana",
    "gy",
    "592"
  ],
  [
    "Haiti",
    "ht",
    "509"
  ],
  [
    "Honduras",
    "hn",
    "504"
  ],
  [
    "Hong Kong (\u9999\u6E2F)",
    "hk",
    "852"
  ],
  [
    "Hungary (Magyarorsz\xE1g)",
    "hu",
    "36"
  ],
  [
    "Iceland (\xCDsland)",
    "is",
    "354"
  ],
  [
    "India (\u092D\u093E\u0930\u0924)",
    "in",
    "91"
  ],
  [
    "Indonesia",
    "id",
    "62"
  ],
  [
    "Iran (\u202B\u0627\u06CC\u0631\u0627\u0646\u202C\u200E)",
    "ir",
    "98"
  ],
  [
    "Iraq (\u202B\u0627\u0644\u0639\u0631\u0627\u0642\u202C\u200E)",
    "iq",
    "964"
  ],
  [
    "Ireland",
    "ie",
    "353"
  ],
  [
    "Isle of Man",
    "im",
    "44"
  ],
  [
    "Israel (\u202B\u05D9\u05E9\u05E8\u05D0\u05DC\u202C\u200E)",
    "il",
    "972"
  ],
  [
    "Italy (Italia)",
    "it",
    "39"
  ],
  [
    "Jamaica",
    "jm",
    "1876"
  ],
  [
    "Japan (\u65E5\u672C)",
    "jp",
    "81"
  ],
  [
    "Jersey",
    "je",
    "44"
  ],
  [
    "Jordan (\u202B\u0627\u0644\u0623\u0631\u062F\u0646\u202C\u200E)",
    "jo",
    "962"
  ],
  [
    "Kazakhstan (\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D)",
    "kz",
    "7"
  ],
  [
    "Kenya",
    "ke",
    "254"
  ],
  [
    "Kiribati",
    "ki",
    "686"
  ],
  [
    "Kosovo",
    "xk",
    "383"
  ],
  [
    "Kuwait (\u202B\u0627\u0644\u0643\u0648\u064A\u062A\u202C\u200E)",
    "kw",
    "965"
  ],
  [
    "Kyrgyzstan (\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D)",
    "kg",
    "996"
  ],
  [
    "Laos (\u0EA5\u0EB2\u0EA7)",
    "la",
    "856"
  ],
  [
    "Latvia (Latvija)",
    "lv",
    "371"
  ],
  [
    "Lebanon (\u202B\u0644\u0628\u0646\u0627\u0646\u202C\u200E)",
    "lb",
    "961"
  ],
  [
    "Lesotho",
    "ls",
    "266"
  ],
  [
    "Liberia",
    "lr",
    "231"
  ],
  [
    "Libya (\u202B\u0644\u064A\u0628\u064A\u0627\u202C\u200E)",
    "ly",
    "218"
  ],
  [
    "Liechtenstein",
    "li",
    "423"
  ],
  [
    "Lithuania (Lietuva)",
    "lt",
    "370"
  ],
  [
    "Luxembourg",
    "lu",
    "352"
  ],
  [
    "Macau (\u6FB3\u9580)",
    "mo",
    "853"
  ],
  [
    "Macedonia (FYROM) (\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430)",
    "mk",
    "389"
  ],
  [
    "Madagascar (Madagasikara)",
    "mg",
    "261"
  ],
  [
    "Malawi",
    "mw",
    "265"
  ],
  [
    "Malaysia",
    "my",
    "60"
  ],
  [
    "Maldives",
    "mv",
    "960"
  ],
  [
    "Mali",
    "ml",
    "223"
  ],
  [
    "Malta",
    "mt",
    "356"
  ],
  [
    "Marshall Islands",
    "mh",
    "692"
  ],
  [
    "Martinique",
    "mq",
    "596"
  ],
  [
    "Mauritania (\u202B\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627\u202C\u200E)",
    "mr",
    "222"
  ],
  [
    "Mauritius (Moris)",
    "mu",
    "230"
  ],
  [
    "Mayotte",
    "yt",
    "262"
  ],
  [
    "Mexico (M\xE9xico)",
    "mx",
    "52"
  ],
  [
    "Micronesia",
    "fm",
    "691"
  ],
  [
    "Moldova (Republica Moldova)",
    "md",
    "373"
  ],
  [
    "Monaco",
    "mc",
    "377"
  ],
  [
    "Mongolia (\u041C\u043E\u043D\u0433\u043E\u043B)",
    "mn",
    "976"
  ],
  [
    "Montenegro (Crna Gora)",
    "me",
    "382"
  ],
  [
    "Montserrat",
    "ms",
    "1664"
  ],
  [
    "Morocco (\u202B\u0627\u0644\u0645\u063A\u0631\u0628\u202C\u200E)",
    "ma",
    "212"
  ],
  [
    "Mozambique (Mo\xE7ambique)",
    "mz",
    "258"
  ],
  [
    "Myanmar (Burma) (\u1019\u103C\u1014\u103A\u1019\u102C)",
    "mm",
    "95"
  ],
  [
    "Namibia (Namibi\xEB)",
    "na",
    "264"
  ],
  [
    "Nauru",
    "nr",
    "674"
  ],
  [
    "Nepal (\u0928\u0947\u092A\u093E\u0932)",
    "np",
    "977"
  ],
  [
    "Netherlands (Nederland)",
    "nl",
    "31"
  ],
  [
    "New Caledonia (Nouvelle-Cal\xE9donie)",
    "nc",
    "687"
  ],
  [
    "New Zealand",
    "nz",
    "64"
  ],
  [
    "Nicaragua",
    "ni",
    "505"
  ],
  [
    "Niger (Nijar)",
    "ne",
    "227"
  ],
  [
    "Nigeria",
    "ng",
    "234"
  ],
  [
    "Niue",
    "nu",
    "683"
  ],
  [
    "Norfolk Island",
    "nf",
    "672"
  ],
  [
    "North Korea (\uC870\uC120 \uBBFC\uC8FC\uC8FC\uC758 \uC778\uBBFC \uACF5\uD654\uAD6D)",
    "kp",
    "850"
  ],
  [
    "Northern Mariana Islands",
    "mp",
    "1670"
  ],
  [
    "Norway (Norge)",
    "no",
    "47"
  ],
  [
    "Oman (\u202B\u0639\u064F\u0645\u0627\u0646\u202C\u200E)",
    "om",
    "968"
  ],
  [
    "Pakistan (\u202B\u067E\u0627\u06A9\u0633\u062A\u0627\u0646\u202C\u200E)",
    "pk",
    "92"
  ],
  [
    "Palau",
    "pw",
    "680"
  ],
  [
    "Palestine (\u202B\u0641\u0644\u0633\u0637\u064A\u0646\u202C\u200E)",
    "ps",
    "970"
  ],
  [
    "Panama (Panam\xE1)",
    "pa",
    "507"
  ],
  [
    "Papua New Guinea",
    "pg",
    "675"
  ],
  [
    "Paraguay",
    "py",
    "595"
  ],
  [
    "Peru (Per\xFA)",
    "pe",
    "51"
  ],
  [
    "Philippines",
    "ph",
    "63"
  ],
  [
    "Poland (Polska)",
    "pl",
    "48"
  ],
  [
    "Portugal",
    "pt",
    "351"
  ],
  [
    "Puerto Rico",
    "pr",
    "1"
  ],
  [
    "Qatar (\u202B\u0642\u0637\u0631\u202C\u200E)",
    "qa",
    "974"
  ],
  [
    "R\xE9union (La R\xE9union)",
    "re",
    "262"
  ],
  [
    "Romania (Rom\xE2nia)",
    "ro",
    "40"
  ],
  [
    "Russia (\u0420\u043E\u0441\u0441\u0438\u044F)",
    "ru",
    "7"
  ],
  [
    "Rwanda",
    "rw",
    "250"
  ],
  [
    "Saint Barth\xE9lemy",
    "bl",
    "590"
  ],
  [
    "Saint Helena",
    "sh",
    "290"
  ],
  [
    "Saint Kitts and Nevis",
    "kn",
    "1869"
  ],
  [
    "Saint Lucia",
    "lc",
    "1758"
  ],
  [
    "Saint Martin (Saint-Martin (partie fran\xE7aise))",
    "mf",
    "590"
  ],
  [
    "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    "pm",
    "508"
  ],
  [
    "Saint Vincent and the Grenadines",
    "vc",
    "1784"
  ],
  [
    "Samoa",
    "ws",
    "685"
  ],
  [
    "San Marino",
    "sm",
    "378"
  ],
  [
    "S\xE3o Tom\xE9 and Pr\xEDncipe (S\xE3o Tom\xE9 e Pr\xEDncipe)",
    "st",
    "239"
  ],
  [
    "Saudi Arabia (\u202B\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629\u202C\u200E)",
    "sa",
    "966"
  ],
  [
    "Senegal (S\xE9n\xE9gal)",
    "sn",
    "221"
  ],
  [
    "Serbia (\u0421\u0440\u0431\u0438\u0458\u0430)",
    "rs",
    "381"
  ],
  [
    "Seychelles",
    "sc",
    "248"
  ],
  [
    "Sierra Leone",
    "sl",
    "232"
  ],
  [
    "Singapore",
    "sg",
    "65"
  ],
  [
    "Sint Maarten",
    "sx",
    "1721"
  ],
  [
    "Slovakia (Slovensko)",
    "sk",
    "421"
  ],
  [
    "Slovenia (Slovenija)",
    "si",
    "386"
  ],
  [
    "Solomon Islands",
    "sb",
    "677"
  ],
  [
    "Somalia (Soomaaliya)",
    "so",
    "252"
  ],
  [
    "South Africa",
    "za",
    "27"
  ],
  [
    "South Korea (\uB300\uD55C\uBBFC\uAD6D)",
    "kr",
    "82"
  ],
  [
    "South Sudan (\u202B\u062C\u0646\u0648\u0628 \u0627\u0644\u0633\u0648\u062F\u0627\u0646\u202C\u200E)",
    "ss",
    "211"
  ],
  [
    "Spain (Espa\xF1a)",
    "es",
    "34"
  ],
  [
    "Sri Lanka (\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0)",
    "lk",
    "94"
  ],
  [
    "Sudan (\u202B\u0627\u0644\u0633\u0648\u062F\u0627\u0646\u202C\u200E)",
    "sd",
    "249"
  ],
  [
    "Suriname",
    "sr",
    "597"
  ],
  [
    "Svalbard and Jan Mayen",
    "sj",
    "47"
  ],
  [
    "Swaziland",
    "sz",
    "268"
  ],
  [
    "Sweden (Sverige)",
    "se",
    "46"
  ],
  [
    "Switzerland (Schweiz)",
    "ch",
    "41"
  ],
  [
    "Syria (\u202B\u0633\u0648\u0631\u064A\u0627\u202C\u200E)",
    "sy",
    "963"
  ],
  [
    "Taiwan (\u53F0\u7063)",
    "tw",
    "886"
  ],
  [
    "Tajikistan",
    "tj",
    "992"
  ],
  [
    "Tanzania",
    "tz",
    "255"
  ],
  [
    "Thailand (\u0E44\u0E17\u0E22)",
    "th",
    "66"
  ],
  [
    "Timor-Leste",
    "tl",
    "670"
  ],
  [
    "Togo",
    "tg",
    "228"
  ],
  [
    "Tokelau",
    "tk",
    "690"
  ],
  [
    "Tonga",
    "to",
    "676"
  ],
  [
    "Trinidad and Tobago",
    "tt",
    "1868"
  ],
  [
    "Tunisia (\u202B\u062A\u0648\u0646\u0633\u202C\u200E)",
    "tn",
    "216"
  ],
  [
    "Turkey (T\xFCrkiye)",
    "tr",
    "90"
  ],
  [
    "Turkmenistan",
    "tm",
    "993"
  ],
  [
    "Turks and Caicos Islands",
    "tc",
    "1649"
  ],
  [
    "Tuvalu",
    "tv",
    "688"
  ],
  [
    "U.S. Virgin Islands",
    "vi",
    "1340"
  ],
  [
    "Uganda",
    "ug",
    "256"
  ],
  [
    "Ukraine (\u0423\u043A\u0440\u0430\u0457\u043D\u0430)",
    "ua",
    "380"
  ],
  [
    "United Arab Emirates (\u202B\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629\u202C\u200E)",
    "ae",
    "971"
  ],
  [
    "United Kingdom",
    "gb",
    "44"
  ],
  [
    "United States",
    "us",
    "1"
  ],
  [
    "Uruguay",
    "uy",
    "598"
  ],
  [
    "Uzbekistan (O\u02BBzbekiston)",
    "uz",
    "998"
  ],
  [
    "Vanuatu",
    "vu",
    "678"
  ],
  [
    "Vatican City (Citt\xE0 del Vaticano)",
    "va",
    "39"
  ],
  [
    "Venezuela",
    "ve",
    "58"
  ],
  [
    "Vietnam (Vi\u1EC7t Nam)",
    "vn",
    "84"
  ],
  [
    "Wallis and Futuna (Wallis-et-Futuna)",
    "wf",
    "681"
  ],
  [
    "Western Sahara (\u202B\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629\u202C\u200E)",
    "eh",
    "212"
  ],
  [
    "Yemen (\u202B\u0627\u0644\u064A\u0645\u0646\u202C\u200E)",
    "ye",
    "967"
  ],
  [
    "Zambia",
    "zm",
    "260"
  ],
  [
    "Zimbabwe",
    "zw",
    "263"
  ],
  [
    "\xC5land Islands",
    "ax",
    "358"
  ]
];
var allCountries$1 = allCountries.map(([name, iso2, dialCode]) => ({
  name,
  iso2: iso2.toUpperCase(),
  dialCode
}));
function getCountry() {
  return fetch("https://ip2c.org/s").then((response) => response.text()).then((response) => {
    const result2 = (response || "").toString();
    if (!result2 || result2[0] !== "1") {
      throw new Error("unable to fetch the country");
    }
    return result2.substr(2, 2);
  });
}
function setCaretPosition(ctrl, pos) {
  if (ctrl.setSelectionRange) {
    ctrl.focus();
    ctrl.setSelectionRange(pos, pos);
  } else if (ctrl.createTextRange) {
    const range = ctrl.createTextRange();
    range.collapse(true);
    range.moveEnd("character", pos);
    range.moveStart("character", pos);
    range.select();
  }
}
const allProps = [
  {
    name: "allCountries",
    type: Array,
    default: allCountries$1,
    description: "All countries that are used in <code>libphonenumber-js</code>, can be overridden by this prop",
    inDemo: false
  },
  {
    name: "autoFormat",
    type: Boolean,
    default: true,
    description: "Auto update the input to the formatted phone number when it's valid",
    inDemo: true
  },
  {
    name: "customValidate",
    type: [Boolean, RegExp],
    default: false,
    description: "Custom validation RegExp for input",
    inDemo: false
  },
  {
    name: "defaultCountry",
    default: "",
    type: [String, Number],
    description: "Default country (by iso2 or dialCode), will override the country fetched from IP address of user",
    inDemo: false
  },
  {
    name: "disabled",
    default: false,
    type: Boolean,
    description: "Disable <code>vue-tel-input</code>, including the input & flag dropdown",
    inDemo: false
  },
  {
    name: "autoDefaultCountry",
    default: true,
    type: Boolean,
    description: "To fetch default country based on IP address of user",
    inDemo: false
  },
  {
    name: "dropdownOptions",
    type: Object,
    description: "Options for dropdown, see below",
    inDemo: false
  },
  {
    name: "dropdownOptions.disabled",
    default: false,
    type: Boolean,
    description: "Disable dropdown",
    inDemo: false
  },
  {
    name: "dropdownOptions.showDialCodeInList",
    default: true,
    type: Boolean,
    description: "Show dial code in the dropdown list",
    inDemo: true
  },
  {
    name: "dropdownOptions.showDialCodeInSelection",
    default: false,
    type: Boolean,
    description: "Show dial code in the dropdown selection",
    inDemo: true
  },
  {
    name: "dropdownOptions.showFlags",
    default: true,
    type: Boolean,
    description: "Show flags in the dropdown selection and list",
    inDemo: true
  },
  {
    name: "dropdownOptions.tabindex",
    default: 0,
    type: Number,
    description: "Native dropdown <code>tabindex</code> attribute",
    inDemo: false
  },
  {
    name: "ignoredCountries",
    default: [],
    type: Array,
    description: "List of countries will NOT be shown on the dropdown",
    inDemo: false
  },
  {
    name: "inputOptions",
    type: Object,
    description: "Options for input, see below",
    inDemo: false
  },
  {
    name: "inputOptions.autocomplete",
    type: String,
    default: "on",
    description: "Native input <code>autocomplete</code> attribute",
    inDemo: false
  },
  {
    name: "inputOptions.autofocus",
    type: Boolean,
    default: false,
    description: "Native input <code>autofocus</code> attribute",
    inDemo: false
  },
  {
    name: "inputOptions.aria-describedby",
    default: "",
    type: String,
    description: "Native input <code>aria-describedby</code> attribute",
    inDemo: false
  },
  {
    name: "inputOptions.id",
    default: "",
    type: String,
    description: "Native input <code>id</code> attribute",
    inDemo: false
  },
  {
    name: "inputOptions.maxlength",
    default: 25,
    type: Number,
    description: "Native input <code>maxlength</code> attribute",
    inDemo: false
  },
  {
    name: "inputOptions.name",
    default: "telephone",
    type: String,
    description: "Native input <code>name</code> attribute",
    inDemo: false
  },
  {
    name: "inputOptions.showDialCode",
    default: false,
    type: Boolean,
    description: "Show dial code in input",
    inDemo: false
  },
  {
    name: "inputOptions.placeholder",
    default: "Enter a phone number",
    type: String,
    description: "Placeholder for the input",
    inDemo: false
  },
  {
    name: "inputOptions.readonly",
    default: false,
    type: Boolean,
    description: "Native input <code>readonly</code> attribute",
    inDemo: false
  },
  {
    name: "inputOptions.required",
    default: false,
    type: Boolean,
    description: "Native input <code>required</code> attribute",
    inDemo: false
  },
  {
    name: "inputOptions.tabindex",
    default: 0,
    type: Number,
    description: "Native input <code>tabindex</code> attribute",
    inDemo: false
  },
  {
    name: "inputOptions.type",
    default: "tel",
    type: String,
    description: "Native input <code>type</code> attribute",
    inDemo: false
  },
  {
    name: "inputOptions.styleClasses",
    default: "",
    type: [String, Array, Object],
    description: "Custom classes for the <code>input</code>",
    inDemo: false
  },
  {
    name: "invalidMsg",
    default: "",
    type: String,
    description: "",
    inDemo: false
  },
  {
    name: "mode",
    default: "auto",
    type: String,
    description: "Allowed values: <code>'auto'</code> (Default set by phone),  <code>'international'</code> (Format number with the dial code i.e. + 61), <code>'national'</code> (Format number without dial code i.e. 0321232)",
    inDemo: true,
    options: ["auto", "national", "international"]
  },
  {
    name: "onlyCountries",
    default: [],
    type: Array,
    description: "List of countries will be shown on the dropdown",
    inDemo: false
  },
  {
    name: "preferredCountries",
    default: [],
    type: Array,
    description: "Preferred countries list, will be on top of the dropdown",
    inDemo: false
  },
  {
    name: "styleClasses",
    default: "",
    type: [String, Array, Object],
    description: "Custom classes for the wrapper",
    inDemo: false
  },
  {
    name: "validCharactersOnly",
    default: false,
    type: Boolean,
    description: "Only allow valid characters in a phone number (will also verify in <code>mounted</code>, so phone number with invalid characters will be shown as an empty string)",
    inDemo: false
  }
];
const defaultOptions = [...allProps].reduce((prv, crr) => {
  if (crr.name.includes(".")) {
    const [key, nestedKey] = crr.name.split(".");
    if (prv[key]) {
      Object.assign(prv[key], { [nestedKey]: crr.default });
    } else {
      Object.assign(prv, { [key]: { [nestedKey]: crr.default } });
    }
  } else {
    Object.assign(prv, { [crr.name]: crr.default });
  }
  return prv;
}, {});
var utils = {
  options: { ...defaultOptions }
};
var metadata = { "version": 4, "country_calling_codes": { "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], "7": ["RU", "KZ"], "20": ["EG"], "27": ["ZA"], "30": ["GR"], "31": ["NL"], "32": ["BE"], "33": ["FR"], "34": ["ES"], "36": ["HU"], "39": ["IT", "VA"], "40": ["RO"], "41": ["CH"], "43": ["AT"], "44": ["GB", "GG", "IM", "JE"], "45": ["DK"], "46": ["SE"], "47": ["NO", "SJ"], "48": ["PL"], "49": ["DE"], "51": ["PE"], "52": ["MX"], "53": ["CU"], "54": ["AR"], "55": ["BR"], "56": ["CL"], "57": ["CO"], "58": ["VE"], "60": ["MY"], "61": ["AU", "CC", "CX"], "62": ["ID"], "63": ["PH"], "64": ["NZ"], "65": ["SG"], "66": ["TH"], "81": ["JP"], "82": ["KR"], "84": ["VN"], "86": ["CN"], "90": ["TR"], "91": ["IN"], "92": ["PK"], "93": ["AF"], "94": ["LK"], "95": ["MM"], "98": ["IR"], "211": ["SS"], "212": ["MA", "EH"], "213": ["DZ"], "216": ["TN"], "218": ["LY"], "220": ["GM"], "221": ["SN"], "222": ["MR"], "223": ["ML"], "224": ["GN"], "225": ["CI"], "226": ["BF"], "227": ["NE"], "228": ["TG"], "229": ["BJ"], "230": ["MU"], "231": ["LR"], "232": ["SL"], "233": ["GH"], "234": ["NG"], "235": ["TD"], "236": ["CF"], "237": ["CM"], "238": ["CV"], "239": ["ST"], "240": ["GQ"], "241": ["GA"], "242": ["CG"], "243": ["CD"], "244": ["AO"], "245": ["GW"], "246": ["IO"], "247": ["AC"], "248": ["SC"], "249": ["SD"], "250": ["RW"], "251": ["ET"], "252": ["SO"], "253": ["DJ"], "254": ["KE"], "255": ["TZ"], "256": ["UG"], "257": ["BI"], "258": ["MZ"], "260": ["ZM"], "261": ["MG"], "262": ["RE", "YT"], "263": ["ZW"], "264": ["NA"], "265": ["MW"], "266": ["LS"], "267": ["BW"], "268": ["SZ"], "269": ["KM"], "290": ["SH", "TA"], "291": ["ER"], "297": ["AW"], "298": ["FO"], "299": ["GL"], "350": ["GI"], "351": ["PT"], "352": ["LU"], "353": ["IE"], "354": ["IS"], "355": ["AL"], "356": ["MT"], "357": ["CY"], "358": ["FI", "AX"], "359": ["BG"], "370": ["LT"], "371": ["LV"], "372": ["EE"], "373": ["MD"], "374": ["AM"], "375": ["BY"], "376": ["AD"], "377": ["MC"], "378": ["SM"], "380": ["UA"], "381": ["RS"], "382": ["ME"], "383": ["XK"], "385": ["HR"], "386": ["SI"], "387": ["BA"], "389": ["MK"], "420": ["CZ"], "421": ["SK"], "423": ["LI"], "500": ["FK"], "501": ["BZ"], "502": ["GT"], "503": ["SV"], "504": ["HN"], "505": ["NI"], "506": ["CR"], "507": ["PA"], "508": ["PM"], "509": ["HT"], "590": ["GP", "BL", "MF"], "591": ["BO"], "592": ["GY"], "593": ["EC"], "594": ["GF"], "595": ["PY"], "596": ["MQ"], "597": ["SR"], "598": ["UY"], "599": ["CW", "BQ"], "670": ["TL"], "672": ["NF"], "673": ["BN"], "674": ["NR"], "675": ["PG"], "676": ["TO"], "677": ["SB"], "678": ["VU"], "679": ["FJ"], "680": ["PW"], "681": ["WF"], "682": ["CK"], "683": ["NU"], "685": ["WS"], "686": ["KI"], "687": ["NC"], "688": ["TV"], "689": ["PF"], "690": ["TK"], "691": ["FM"], "692": ["MH"], "850": ["KP"], "852": ["HK"], "853": ["MO"], "855": ["KH"], "856": ["LA"], "880": ["BD"], "886": ["TW"], "960": ["MV"], "961": ["LB"], "962": ["JO"], "963": ["SY"], "964": ["IQ"], "965": ["KW"], "966": ["SA"], "967": ["YE"], "968": ["OM"], "970": ["PS"], "971": ["AE"], "972": ["IL"], "973": ["BH"], "974": ["QA"], "975": ["BT"], "976": ["MN"], "977": ["NP"], "992": ["TJ"], "993": ["TM"], "994": ["AZ"], "995": ["GE"], "996": ["KG"], "998": ["UZ"] }, "countries": { "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([457]\\d{6})$", "268$1", 0, "268"], "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2457]\\d{6})$", "264$1", 0, "264"], "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "1|([267]\\d{6})$", "684$1", 0, "684"], "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "0|(183[12])", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "246$1", 0, "246"], "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], "BF": ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], "BG": ["359", "00", "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]]], "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], "BJ": ["229", "00", "(?:[25689]\\d|40)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], "BL": ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "441$1", 0, "441"], "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], "BO": ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([3-8]\\d{6})$", "242$1", 0, "242"], "BT": ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], "CA": ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-7]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CD": ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "0|(1(?:[12]\\d|79)\\d\\d)", 0, 0, 0, 0, "00"], "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["[39]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0(4(?:[14]4|56)|[579])?"], "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], "CU": ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|[23]1|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "767$1", 0, "767"], "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], "0"], "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "FK": ["500", "00", "[2-7]\\d{4}", [5]], "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[01359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[0-79]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-26-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "473$1", 0, "473"], "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], "GF": ["594", "00", "(?:[56]94|80\\d|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "0|([25-9]\\d{5})$", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], "GI": ["350", "00", "(?:[25]\\d\\d|606)\\d{5}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], "GP": ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0-289]|7[08]|8[0-689]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], "GT": ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "1|([3-9]\\d{6})$", "671$1", 0, "671"], "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], "GY": ["592", "001", "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]]], "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], "HR": ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], "HT": ["509", "00", "[2-489]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]]], "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], "ID": ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([25-8]\\d{5})$", "1624$1", 0, "74576|(?:16|7[56])24"], "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "IT": ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([0-24-8]\\d{5})$", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "JP": ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0"], "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "KG": ["996", "00", "8\\d{9}|(?:[235-8]\\d|99)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "869$1", 0, "869"], "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "345$1", 0, "345"], "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "758$1", 0, "758"], "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "0|(1001)"], "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], "LR": ["231", "00", "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3578]"], "0$1"]], "0"], "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], "LV": ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[89]|389)", "5(?:29[89]|389)0"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:29(?:[189][05]|2[29]|3[01])|389[05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[08]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], "MF": ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "0|([24-9]\\d{6})$", "20$1"], "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "670$1", 0, "670"], "MQ": ["596", "00", "(?:69|80)\\d{7}|(?:59|97)6\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "1|([34]\\d{6})$", "664$1", 0, "664"], "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["5"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9[13-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MW": ["265", "00", "(?:[129]\\d|31|77|88)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], "MX": ["52", "0[09]", "1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]]], "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], "NG": ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|59"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], "NR": ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], "NU": ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], "NZ": ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], "PL": ["48", "00", "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], "PM": ["508", "00", "(?:[45]|80\\d\\d)\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], "QA": ["974", "00", "[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}", [7, 8, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]]]], "RE": ["262", "00", "976\\d{6}|(?:26|[68]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, "26[23]|69|[89]"], "RO": ["40", "00", "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0"], "SA": ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], "SB": ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], "SC": ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-5]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["24|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]], "0"], "SR": ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], "SV": ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|(5\\d{6})$", "721$1", 0, "721"], "SY": ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "1|([2-479]\\d{6})$", "649$1", 0, "649"], "TD": ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "TJ": ["992", "810", "(?:00|[1-57-9]\\d)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], "TM": ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-46-8]\\d{6})$", "868$1", 0, "868"], "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], "TZ": ["255", "00[056]", "(?:[26-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|22|33)|4(?:00|4[24]|65|82)|5(?:00|29|58|83)|6(?:00|66|82)|7(?:58|77)|8(?:00|42|5[25]|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}"]]], "UY": ["598", "0(?:0|1[3-9]\\d)", "4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], "UZ": ["998", "810", "(?:33|55|[679]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "784$1", 0, "784"], "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-578]\\d{6})$", "284$1", 0, "284"], "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "340$1", 0, "340"], "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], "WF": ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "XK": ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], "YT": ["262", "00", "80\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, "269|63"], "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "ZM": ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, "nonGeographic": { "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], "870": ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], "881": ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]], "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["4"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[19]"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-3]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]], "883": ["883", 0, "(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?", [9, 10, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["2"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[35]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}"]]], "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata);
  return func.apply(this, args);
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result2);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var ParseError = /* @__PURE__ */ function(_Error) {
  _inherits(ParseError2, _Error);
  var _super = _createSuper(ParseError2);
  function ParseError2(code) {
    var _this;
    _classCallCheck$2(this, ParseError2);
    _this = _super.call(this, code);
    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError2.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  return _createClass$2(ParseError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error));
var MIN_LENGTH_FOR_NSN = 2;
var MAX_LENGTH_FOR_NSN = 17;
var MAX_LENGTH_COUNTRY_CODE = 3;
var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
var TILDES = "~\u2053\u223C\uFF5E";
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B";
function compare(a, b) {
  a = a.split("-");
  b = b.split("-");
  var pa = a[0].split(".");
  var pb = b[0].split(".");
  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb)
      return 1;
    if (nb > na)
      return -1;
    if (!isNaN(na) && isNaN(nb))
      return 1;
    if (isNaN(na) && !isNaN(nb))
      return -1;
  }
  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }
  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var V3 = "1.2.0";
var V4 = "1.7.35";
var DEFAULT_EXT_PREFIX = " ext. ";
var CALLING_CODE_REG_EXP = /^\d+$/;
var Metadata = /* @__PURE__ */ function() {
  function Metadata2(metadata2) {
    _classCallCheck$1(this, Metadata2);
    validateMetadata(metadata2);
    this.metadata = metadata2;
    setVersion.call(this, metadata2);
  }
  _createClass$1(Metadata2, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function(_) {
        return _ !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3)
        return;
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== "001") {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = void 0;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata2 = this.nonGeographic()[callingCode];
        if (metadata2) {
          return metadata2;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return this.metadata.countries["001"];
        }
      }
    }
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }
  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    }
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1)
        return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== void 0;
    }
  }]);
  return Metadata2;
}();
var NumberingPlan = /* @__PURE__ */ function() {
  function NumberingPlan2(metadata2, globalMetadataObject) {
    _classCallCheck$1(this, NumberingPlan2);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata2;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  _createClass$1(NumberingPlan2, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2)
        return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1)
        return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata2) {
      return metadata2[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats2 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats2.map(function(_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata2) {
      return metadata2[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      if (this.types() && this.types().length === 0) {
        return false;
      }
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2)
        return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
  return NumberingPlan2;
}();
var Format = /* @__PURE__ */ function() {
  function Format2(format, metadata2) {
    _classCallCheck$1(this, Format2);
    this._format = format;
    this.metadata = metadata2;
  }
  _createClass$1(Format2, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
  return Format2;
}();
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /* @__PURE__ */ function() {
  function Type2(type, metadata2) {
    _classCallCheck$1(this, Type2);
    this.type = type;
    this.metadata = metadata2;
  }
  _createClass$1(Type2, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1)
        return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1)
        return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
  return Type2;
}();
function getType(types, type) {
  switch (type) {
    case "FIXED_LINE":
      return types[0];
    case "MOBILE":
      return types[1];
    case "TOLL_FREE":
      return types[2];
    case "PREMIUM_RATE":
      return types[3];
    case "PERSONAL_NUMBER":
      return types[4];
    case "VOICEMAIL":
      return types[5];
    case "UAN":
      return types[6];
    case "PAGER":
      return types[7];
    case "VOIP":
      return types[8];
    case "SHARED_COST":
      return types[9];
  }
}
function validateMetadata(metadata2) {
  if (!metadata2) {
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  }
  if (!is_object(metadata2) || !is_object(metadata2.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata2) ? "an object of shape: { " + Object.keys(metadata2).join(", ") + " }" : "a " + type_of(metadata2) + ": " + metadata2, "."));
  }
}
var is_object = function is_object2(_) {
  return _typeof$1(_) === "object";
};
var type_of = function type_of2(_) {
  return _typeof$1(_);
};
function getCountryCallingCode(country, metadata2) {
  metadata2 = new Metadata(metadata2);
  if (metadata2.hasCountry(country)) {
    return metadata2.country(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata2) {
  return metadata2.countries[country] !== void 0;
}
function setVersion(metadata2) {
  var version = metadata2.version;
  if (typeof version === "number") {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}
var RFC3966_EXTN_PREFIX = ";ext=";
var getExtensionDigitsPattern = function getExtensionDigitsPattern2(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = "20";
  var extLimitAfterLikelyLabel = "15";
  var extLimitAfterAmbiguousChar = "9";
  var extLimitWhenNotSure = "6";
  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  var optionalExtnSuffix = "#?";
  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
  var ambiguousSeparator = "[- ]+";
  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}";
var VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*";
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i");
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + "(?:" + createExtensionPattern() + ")?";
var VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$", "i");
function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}
function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;
  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }
    i++;
  }
}
var DIGITS = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "\uFF10": "0",
  "\uFF11": "1",
  "\uFF12": "2",
  "\uFF13": "3",
  "\uFF14": "4",
  "\uFF15": "5",
  "\uFF16": "6",
  "\uFF17": "7",
  "\uFF18": "8",
  "\uFF19": "9",
  "\u0660": "0",
  "\u0661": "1",
  "\u0662": "2",
  "\u0663": "3",
  "\u0664": "4",
  "\u0665": "5",
  "\u0666": "6",
  "\u0667": "7",
  "\u0668": "8",
  "\u0669": "9",
  "\u06F0": "0",
  "\u06F1": "1",
  "\u06F2": "2",
  "\u06F3": "3",
  "\u06F4": "4",
  "\u06F5": "5",
  "\u06F6": "6",
  "\u06F7": "7",
  "\u06F8": "8",
  "\u06F9": "9"
};
function parseDigit(character) {
  return DIGITS[character];
}
function _createForOfIteratorHelperLoose$5(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$6(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$6(o, minLen);
}
function _arrayLikeToArray$6(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function parseIncompletePhoneNumber(string) {
  var result2 = "";
  for (var _iterator = _createForOfIteratorHelperLoose$5(string.split("")), _step; !(_step = _iterator()).done; ) {
    var character = _step.value;
    result2 += parsePhoneNumberCharacter(character, result2) || "";
  }
  return result2;
}
function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  if (character === "+") {
    if (prevParsedCharacters) {
      return;
    }
    return "+";
  }
  return parseDigit(character);
}
function _createForOfIteratorHelperLoose$4(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$5(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$5(o, minLen);
}
function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function mergeArrays(a, b) {
  var merged = a.slice();
  for (var _iterator = _createForOfIteratorHelperLoose$4(b), _step; !(_step = _iterator()).done; ) {
    var element = _step.value;
    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }
  return merged.sort(function(a2, b2) {
    return a2 - b2;
  });
}
function checkNumberLength(nationalNumber, metadata2) {
  return checkNumberLengthForType(nationalNumber, void 0, metadata2);
}
function checkNumberLengthForType(nationalNumber, type, metadata2) {
  var type_info = metadata2.type(type);
  var possible_lengths = type_info && type_info.possibleLengths() || metadata2.possibleLengths();
  if (!possible_lengths) {
    return "IS_POSSIBLE";
  }
  if (type === "FIXED_LINE_OR_MOBILE") {
    if (!metadata2.type("FIXED_LINE")) {
      return checkNumberLengthForType(nationalNumber, "MOBILE", metadata2);
    }
    var mobile_type = metadata2.type("MOBILE");
    if (mobile_type) {
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths());
    }
  } else if (type && !type_info) {
    return "INVALID_LENGTH";
  }
  var actual_length = nationalNumber.length;
  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return "IS_POSSIBLE";
  }
  if (minimum_length > actual_length) {
    return "TOO_SHORT";
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return "TOO_LONG";
  }
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function isPossiblePhoneNumber(input, options, metadata2) {
  if (options === void 0) {
    options = {};
  }
  metadata2 = new Metadata(metadata2);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error("Invalid phone number object passed");
    }
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata2.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata2.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error("Invalid phone number object passed");
      }
      metadata2.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata2.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata2);
  } else {
    if (input.countryCallingCode && metadata2.isNonGeographicCallingCode(input.countryCallingCode)) {
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "IS_POSSIBLE":
      return true;
    default:
      return false;
  }
}
function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _createForOfIteratorHelperLoose$3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$4(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$4(o, minLen);
}
function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function parseRFC3966(text) {
  var number;
  var ext;
  text = text.replace(/^tel:/, "tel=");
  for (var _iterator = _createForOfIteratorHelperLoose$3(text.split(";")), _step; !(_step = _iterator()).done; ) {
    var part = _step.value;
    var _part$split = part.split("="), _part$split2 = _slicedToArray$1(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
    switch (name) {
      case "tel":
        number = value;
        break;
      case "ext":
        ext = value;
        break;
      case "phone-context":
        if (value[0] === "+") {
          number = value + number;
        }
        break;
    }
  }
  if (!isViablePhoneNumber(number)) {
    return {};
  }
  var result2 = {
    number
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function formatRFC3966(_ref) {
  var number = _ref.number, ext = _ref.ext;
  if (!number) {
    return "";
  }
  if (number[0] !== "+") {
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  }
  return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}
function matchesEntirely(text, regular_expression) {
  text = text || "";
  return new RegExp("^(?:" + regular_expression + ")$").test(text);
}
function _createForOfIteratorHelperLoose$2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$3(o, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(input, options, metadata2) {
  options = options || {};
  if (!input.country) {
    return;
  }
  metadata2 = new Metadata(metadata2);
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern())) {
    return;
  }
  if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata2)) {
    if (metadata2.type("MOBILE") && metadata2.type("MOBILE").pattern() === "") {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (!metadata2.type("MOBILE")) {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata2)) {
      return "FIXED_LINE_OR_MOBILE";
    }
    return "FIXED_LINE";
  }
  for (var _iterator = _createForOfIteratorHelperLoose$2(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done; ) {
    var type = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type, metadata2)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata2) {
  type = metadata2.type(type);
  if (!type || !type.pattern()) {
    return false;
  }
  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type.pattern());
}
function isValidNumber(input, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  if (!input.country) {
    return false;
  }
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  if (metadata2.hasTypes()) {
    return getNumberType(input, options, metadata2.metadata) !== void 0;
  }
  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(national_number, metadata2.nationalNumberPattern());
}
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix;
  _ref.carrierCode;
  _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata2) {
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
function _createForOfIteratorHelperLoose$1(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$2(o, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$4(Object(source), true).forEach(function(key) {
      _defineProperty$4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata2) {
    return "".concat(formattedNumber).concat(metadata2.ext()).concat(extension);
  }
};
function formatNumber(input, format, options, metadata2) {
  if (options) {
    options = _objectSpread$4(_objectSpread$4({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata2 = new Metadata(metadata2);
  if (input.country && input.country !== "001") {
    if (!metadata2.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata2.country(input.country);
  } else if (input.countryCallingCode) {
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else
    return input.phone || "";
  var countryCallingCode = metadata2.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  var number;
  switch (format) {
    case "NATIONAL":
      if (!nationalNumber) {
        return "";
      }
      number = formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata2, options);
      return addExtension(number, input.ext, metadata2, options.formatExtension);
    case "INTERNATIONAL":
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number = formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata2, options.formatExtension);
    case "E.164":
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    case "IDD":
      if (!options.fromCountry) {
        return;
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata2);
      return addExtension(formattedNumber, input.ext, metadata2, options.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
  }
}
function formatNationalNumber(number, carrierCode, formatAs, metadata2, options) {
  var format = chooseFormatForNumber(metadata2.formats(), number);
  if (!format) {
    return number;
  }
  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === "INTERNATIONAL",
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode,
    metadata: metadata2
  });
}
function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$1(availableFormats), _step; !(_step = _iterator()).done; ) {
    var format = _step.value;
    if (format.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    }
    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}
function addExtension(formattedNumber, ext, metadata2, formatExtension2) {
  return ext ? formatExtension2(formattedNumber, ext, metadata2) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata2) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata2.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata2);
    if (countryCallingCode === "1") {
      return countryCallingCode + " " + formattedNumber;
    }
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, void 0, metadata2.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2));
  }
}
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$3(Object(source), true).forEach(function(key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var PhoneNumber = /* @__PURE__ */ function() {
  function PhoneNumber2(countryCallingCode, nationalNumber, metadata2) {
    _classCallCheck(this, PhoneNumber2);
    if (!countryCallingCode) {
      throw new TypeError("`country` or `countryCallingCode` not passed");
    }
    if (!nationalNumber) {
      throw new TypeError("`nationalNumber` not passed");
    }
    if (!metadata2) {
      throw new TypeError("`metadata` not passed");
    }
    var _metadata = new Metadata(metadata2);
    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;
      _metadata.country(countryCallingCode);
      countryCallingCode = _metadata.countryCallingCode();
    }
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = "+" + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata2;
  }
  _createClass(PhoneNumber2, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata2 = new Metadata(this.metadata);
      return metadata2.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }
  }, {
    key: "getType",
    value: function getType2() {
      return getNumberType(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$3(_objectSpread$3({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format("NATIONAL", options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format("INTERNATIONAL", options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format("RFC3966", options);
    }
  }]);
  return PhoneNumber2;
}();
var isCountryCode = function isCountryCode2(value) {
  return /^[A-Z]{2}$/.test(value);
};
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number, country, callingCode, metadata2) {
  if (!country) {
    return;
  }
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  }
  number = number.slice(number.match(IDDPrefixPattern)[0].length);
  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === "0") {
      return;
    }
  }
  return number;
}
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata2) {
  if (number && metadata2.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp("^(?:" + metadata2.numberingPlan.nationalPrefixForParsing() + ")");
    var prefixMatch = prefixPattern.exec(number);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata2.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata2.nationalPrefixTransformRule());
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } else {
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length);
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup);
        if (possibleNationalPrefix === metadata2.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata2.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber,
        nationalPrefix,
        carrierCode
      };
    }
  }
  return {
    nationalNumber: number
  };
}
function extractNationalNumber(number, metadata2) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata2), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata2)) {
      return {
        nationalNumber: number
      };
    }
    if (metadata2.possibleLengths()) {
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata2)) {
        return {
          nationalNumber: number
        };
      }
    }
  }
  return {
    nationalNumber,
    carrierCode
  };
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata2) {
  if (matchesEntirely(nationalNumberBefore, metadata2.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata2.nationalNumberPattern())) {
    return false;
  }
  return true;
}
function isPossibleIncompleteNationalNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return false;
    default:
      return true;
  }
}
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata2) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata2) : callingCode;
  if (number.indexOf(countryCallingCode) === 0) {
    metadata2 = new Metadata(metadata2);
    metadata2.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata2), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number, metadata2), nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata2.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata2) === "TOO_LONG") {
      return {
        countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number
  };
}
function extractCountryCallingCode(number, country, callingCode, metadata2) {
  if (!number) {
    return {};
  }
  if (number[0] !== "+") {
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata2);
    if (numberWithoutIDD && numberWithoutIDD !== number) {
      number = "+" + numberWithoutIDD;
    } else {
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata2), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        number
      };
    }
  }
  if (number[1] === "0") {
    return {};
  }
  metadata2 = new Metadata(metadata2);
  var i = 2;
  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);
    if (metadata2.hasCallingCode(_countryCallingCode)) {
      metadata2.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }
    i++;
  }
  return {};
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata2) {
  var possibleCountries = metadata2.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata2.metadata);
}
function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata2) {
  metadata2 = new Metadata(metadata2);
  for (var _iterator = _createForOfIteratorHelperLoose(possibleCountries), _step; !(_step = _iterator()).done; ) {
    var country = _step.value;
    metadata2.country(country);
    if (metadata2.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata2.leadingDigits()) === 0) {
        return country;
      }
    } else if (getNumberType({
      phone: nationalPhoneNumber,
      country
    }, void 0, metadata2.metadata)) {
      return country;
    }
  }
}
var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]");
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
function parse(text, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  if (options.defaultCountry && !metadata2.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }
  var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === "TOO_SHORT") {
        throw new ParseError("TOO_SHORT");
      }
      throw new ParseError("NOT_A_NUMBER");
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber$1(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata2), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata2.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_SHORT");
    }
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_LONG");
    }
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata2.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    return phoneNumber;
  }
  var valid = (options.extended ? metadata2.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }
  return {
    country,
    countryCallingCode,
    carrierCode,
    valid,
    possible: valid ? true : options.extended === true && metadata2.possibleLengths() && isPossibleNumber(nationalNumber, metadata2) ? true : false,
    phone: nationalNumber,
    ext
  };
}
function extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError("TOO_LONG");
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
}
function parseInput(text, v2, extract) {
  if (text && text.indexOf("tel:") === 0) {
    return parseRFC3966(text);
  }
  var number = extractFormattedPhoneNumber(text, extract, v2);
  if (!number) {
    return {};
  }
  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: "TOO_SHORT"
      };
    }
    return {};
  }
  var withExtensionStripped = extractExtension(number);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number
  };
}
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function parsePhoneNumber$1(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata2) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata2.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
  var country;
  if (countryCallingCode) {
    metadata2.selectNumberingPlan(countryCallingCode);
  } else if (number && (defaultCountry || defaultCallingCode)) {
    metadata2.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata2.metadata);
  } else
    return {};
  if (!number) {
    return {
      countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata2), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
  var exactCountry = getCountryByCallingCode(countryCallingCode, nationalNumber, metadata2);
  if (exactCountry) {
    country = exactCountry;
    if (exactCountry === "001")
      ;
    else {
      metadata2.country(country);
    }
  }
  return {
    country,
    countryCallingCode,
    nationalNumber,
    carrierCode
  };
}
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumber(text, options, metadata2) {
  return parse(text, _objectSpread$2(_objectSpread$2({}, options), {}, {
    v2: true
  }), metadata2);
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata2;
  if (typeof arg_1 === "string") {
    text = arg_1;
  } else
    throw new TypeError("A text for parsing must be a string.");
  if (!arg_2 || typeof arg_2 === "string") {
    if (arg_4) {
      options = arg_3;
      metadata2 = arg_4;
    } else {
      options = void 0;
      metadata2 = arg_3;
    }
    if (arg_2) {
      options = _objectSpread$1({
        defaultCountry: arg_2
      }, options);
    }
  } else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata2 = arg_3;
    } else {
      metadata2 = arg_2;
    }
  } else
    throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text,
    options,
    metadata: metadata2
  };
}
var isObject = function isObject2(_) {
  return _typeof(_) === "object";
};
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumberFromString$2(text, options, metadata2) {
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata2)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      defaultCountry: void 0
    });
  }
  try {
    return parsePhoneNumber(text, options, metadata2);
  } catch (error) {
    if (error instanceof ParseError)
      ;
    else {
      throw error;
    }
  }
}
function parsePhoneNumberFromString$1() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata2 = _normalizeArguments.metadata;
  return parsePhoneNumberFromString$2(text, options, metadata2);
}
function parsePhoneNumberFromString() {
  return withMetadataArgument(parsePhoneNumberFromString$1, arguments);
}
var clickOutside = {
  beforeMount(el, binding, vNode) {
    if (typeof binding.value !== "function") {
      const compName = vNode.context.name;
      let warn = `[Vue-click-outside:] provided expression ${binding.expression} is not a function, but has to be`;
      if (compName) {
        warn += `Found in component ${compName}`;
      }
      console.warn(warn);
    }
    el.clickOutsideEvent = function(event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event, el);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
};
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function getDefault(key) {
  const value = utils.options[key];
  if (typeof value === "undefined") {
    return utils.options[key];
  }
  return value;
}
const _sfc_main = {
  name: "VueTelInput",
  directives: {
    clickOutside
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    allCountries: {
      type: Array,
      default: () => getDefault("allCountries")
    },
    autoFormat: {
      type: Boolean,
      default: () => getDefault("autoFormat")
    },
    customValidate: {
      type: [Boolean, RegExp],
      default: () => getDefault("customValidate")
    },
    defaultCountry: {
      type: [String, Number],
      default: () => getDefault("defaultCountry")
    },
    disabled: {
      type: Boolean,
      default: () => getDefault("disabled")
    },
    autoDefaultCountry: {
      type: Boolean,
      default: () => getDefault("autoDefaultCountry")
    },
    dropdownOptions: {
      type: Object,
      default: () => getDefault("dropdownOptions")
    },
    ignoredCountries: {
      type: Array,
      default: () => getDefault("ignoredCountries")
    },
    inputOptions: {
      type: Object,
      default: () => getDefault("inputOptions")
    },
    invalidMsg: {
      type: String,
      default: () => getDefault("invalidMsg")
    },
    mode: {
      type: String,
      default: () => getDefault("mode")
    },
    onlyCountries: {
      type: Array,
      default: () => getDefault("onlyCountries")
    },
    preferredCountries: {
      type: Array,
      default: () => getDefault("preferredCountries")
    },
    validCharactersOnly: {
      type: Boolean,
      default: () => getDefault("validCharactersOnly")
    },
    styleClasses: {
      type: [String, Array, Object],
      default: () => getDefault("styleClasses")
    }
  },
  data() {
    return {
      phone: "",
      activeCountryCode: "",
      open: false,
      finishMounted: false,
      selectedIndex: null,
      typeToFindInput: "",
      typeToFindTimer: null,
      dropdownOpenDirection: "below",
      parsedPlaceholder: this.inputOptions.placeholder
    };
  },
  computed: {
    activeCountry() {
      return this.findCountry(this.activeCountryCode);
    },
    parsedMode() {
      if (this.mode === "auto") {
        if (!this.phone || this.phone[0] !== "+") {
          return "national";
        }
        return "international";
      }
      if (!["international", "national"].includes(this.mode)) {
        console.error('Invalid value of prop "mode"');
        return "international";
      }
      return this.mode;
    },
    filteredCountries() {
      if (this.onlyCountries.length) {
        return this.allCountries.filter(({ iso2 }) => this.onlyCountries.some((c) => c.toUpperCase() === iso2));
      }
      if (this.ignoredCountries.length) {
        return this.allCountries.filter(({ iso2 }) => !this.ignoredCountries.includes(iso2.toUpperCase()) && !this.ignoredCountries.includes(iso2.toLowerCase()));
      }
      return this.allCountries;
    },
    sortedCountries() {
      const preferredCountries = this.getCountries(this.preferredCountries).map((country) => ({ ...country, preferred: true }));
      return [...preferredCountries, ...this.filteredCountries];
    },
    phoneObject() {
      var _a, _b, _c;
      let result2;
      if (((_a = this.phone) == null ? void 0 : _a[0]) === "+") {
        result2 = parsePhoneNumberFromString(this.phone) || {};
      } else {
        result2 = parsePhoneNumberFromString(this.phone, this.activeCountryCode) || {};
      }
      const {
        metadata: metadata2,
        ...phoneObject
      } = result2;
      let valid = (_b = result2.isValid) == null ? void 0 : _b.call(result2);
      let formatted = this.phone;
      if (valid) {
        formatted = (_c = result2.format) == null ? void 0 : _c.call(result2, this.parsedMode.toUpperCase());
      }
      if (result2.country && (this.ignoredCountries.length || this.onlyCountries.length)) {
        if (!this.findCountry(result2.country)) {
          valid = false;
          Object.assign(result2, { country: null });
        }
      }
      Object.assign(phoneObject, {
        countryCode: result2.country,
        valid,
        country: this.activeCountry,
        formatted
      });
      return phoneObject;
    }
  },
  watch: {
    activeCountry(value, oldValue) {
      if (!value && (oldValue == null ? void 0 : oldValue.iso2)) {
        this.activeCountryCode = oldValue.iso2;
        return;
      }
      if (value == null ? void 0 : value.iso2) {
        this.$emit("country-changed", value);
      }
    },
    "phoneObject.countryCode": function(value) {
      this.activeCountryCode = value || "";
    },
    "phoneObject.valid": function() {
      this.$emit("validate", this.phoneObject);
    },
    "phoneObject.formatted": function(value) {
      if (!this.autoFormat || this.customValidate) {
        return;
      }
      this.emitInput(value);
      this.$nextTick(() => {
        if (value && !this.modelValue) {
          this.phone = value;
        }
      });
    },
    "inputOptions.placeholder": function() {
      this.resetPlaceholder();
    },
    modelValue(value, oldValue) {
      if (!this.testCharacters()) {
        this.$nextTick(() => {
          this.phone = oldValue;
          this.onInput();
        });
      } else {
        this.phone = value;
      }
    },
    open(isDropdownOpened) {
      if (isDropdownOpened) {
        this.setDropdownPosition();
        this.$emit("open");
      } else {
        this.$emit("close");
      }
    }
  },
  mounted() {
    if (this.modelValue) {
      this.phone = this.modelValue.trim();
    }
    this.cleanInvalidCharacters();
    this.initializeCountry().then(() => {
      var _a;
      if (!this.phone && ((_a = this.inputOptions) == null ? void 0 : _a.showDialCode) && this.activeCountryCode) {
        this.phone = `+${this.activeCountryCode}`;
      }
      this.$emit("validate", this.phoneObject);
    }).catch(console.error).then(() => {
      this.finishMounted = true;
    });
  },
  methods: {
    resetPlaceholder() {
      this.parsedPlaceholder = this.inputOptions.placeholder;
    },
    initializeCountry() {
      return new Promise((resolve) => {
        var _a;
        if (((_a = this.phone) == null ? void 0 : _a[0]) === "+") {
          resolve();
          return;
        }
        if (this.defaultCountry) {
          if (typeof this.defaultCountry === "string") {
            this.choose(this.defaultCountry);
            resolve();
            return;
          }
          if (typeof this.defaultCountry === "number") {
            const country = this.findCountryByDialCode(this.defaultCountry);
            if (country) {
              this.choose(country.iso2);
              resolve();
              return;
            }
          }
        }
        const fallbackCountry = this.preferredCountries[0] || this.filteredCountries[0];
        if (this.autoDefaultCountry) {
          getCountry().then((res) => {
            this.choose(res || this.activeCountryCode);
          }).catch((error) => {
            console.warn(error);
            this.choose(fallbackCountry);
          }).then(() => {
            resolve();
          });
        } else {
          this.choose(fallbackCountry);
          resolve();
        }
      });
    },
    getCountries(list = []) {
      return list.map((countryCode) => this.findCountry(countryCode)).filter(Boolean);
    },
    findCountry(iso = "") {
      return this.filteredCountries.find((country) => country.iso2 === iso.toUpperCase());
    },
    findCountryByDialCode(dialCode) {
      return this.filteredCountries.find((country) => Number(country.dialCode) === dialCode);
    },
    getItemClass(index2, iso2) {
      const highlighted = this.selectedIndex === index2;
      const lastPreferred = index2 === this.preferredCountries.length - 1;
      const preferred = this.preferredCountries.some((c) => c.toUpperCase() === iso2);
      return {
        highlighted,
        "last-preferred": lastPreferred,
        preferred
      };
    },
    choose(country) {
      var _a, _b;
      let parsedCountry = country;
      if (typeof parsedCountry === "string") {
        parsedCountry = this.findCountry(parsedCountry);
      }
      if (!parsedCountry) {
        return;
      }
      if (((_a = this.phone) == null ? void 0 : _a[0]) === "+" && parsedCountry.iso2 && this.phoneObject.nationalNumber) {
        this.activeCountryCode = parsedCountry.iso2;
        this.phone = parsePhoneNumberFromString(this.phoneObject.nationalNumber, parsedCountry.iso2).formatInternational();
        return;
      }
      if (((_b = this.inputOptions) == null ? void 0 : _b.showDialCode) && parsedCountry) {
        this.phone = `+${parsedCountry.dialCode}`;
        this.activeCountryCode = parsedCountry.iso2 || "";
        return;
      }
      this.activeCountryCode = parsedCountry.iso2 || "";
      this.emitInput(this.phone);
    },
    cleanInvalidCharacters() {
      const currentPhone = this.phone;
      if (this.validCharactersOnly) {
        const results = this.phone.match(/[()\-+0-9\s]*/g);
        this.phone = results.join("");
      }
      if (this.customValidate && this.customValidate instanceof RegExp) {
        const results = this.phone.match(this.customValidate);
        this.phone = results.join("");
      }
      if (currentPhone !== this.phone) {
        this.emitInput(this.phone);
      }
    },
    testCharacters() {
      if (this.validCharactersOnly) {
        const result2 = /^[()\-+0-9\s]*$/.test(this.phone);
        if (!result2) {
          return false;
        }
      }
      if (this.customValidate) {
        return this.testCustomValidate();
      }
      return true;
    },
    testCustomValidate() {
      return this.customValidate instanceof RegExp ? this.customValidate.test(this.phone) : false;
    },
    onInput() {
      this.$refs.input.setCustomValidity(this.phoneObject.valid ? "" : this.invalidMsg);
      this.emitInput(this.phone);
    },
    emitInput(value) {
      this.$emit("update:modelValue", value);
      this.$emit("on-input", value, this.phoneObject, this.$refs.input);
    },
    onBlur() {
      this.$emit("blur");
    },
    onFocus() {
      setCaretPosition(this.$refs.input, this.phone.length);
      this.$emit("focus");
    },
    onEnter() {
      this.$emit("enter");
    },
    onSpace() {
      this.$emit("space");
    },
    focus() {
      this.$refs.input.focus();
    },
    toggleDropdown() {
      if (this.disabled || this.dropdownOptions.disabled) {
        return;
      }
      this.open = !this.open;
    },
    clickedOutside() {
      this.open = false;
    },
    keyboardNav(e) {
      if (e.keyCode === 40) {
        e.preventDefault();
        this.open = true;
        if (this.selectedIndex === null) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex = Math.min(this.sortedCountries.length - 1, this.selectedIndex + 1);
        }
        const selEle = this.$refs.list.children[this.selectedIndex];
        selEle.focus();
        if (selEle.offsetTop + selEle.clientHeight > this.$refs.list.scrollTop + this.$refs.list.clientHeight) {
          this.$refs.list.scrollTop = selEle.offsetTop - this.$refs.list.clientHeight + selEle.clientHeight;
        }
      } else if (e.keyCode === 38) {
        e.preventDefault();
        this.open = true;
        if (this.selectedIndex === null) {
          this.selectedIndex = this.sortedCountries.length - 1;
        } else {
          this.selectedIndex = Math.max(0, this.selectedIndex - 1);
        }
        const selEle = this.$refs.list.children[this.selectedIndex];
        selEle.focus();
        if (selEle.offsetTop < this.$refs.list.scrollTop) {
          this.$refs.list.scrollTop = selEle.offsetTop;
        }
      } else if (e.keyCode === 13) {
        if (this.selectedIndex !== null) {
          this.choose(this.sortedCountries[this.selectedIndex]);
        }
        this.open = !this.open;
      } else {
        this.typeToFindInput += e.key;
        clearTimeout(this.typeToFindTimer);
        this.typeToFindTimer = setTimeout(() => {
          this.typeToFindInput = "";
        }, 700);
        const typedCountryI = this.sortedCountries.slice(this.preferredCountries.length).findIndex((c) => c.name.toLowerCase().startsWith(this.typeToFindInput));
        if (typedCountryI >= 0) {
          this.selectedIndex = this.preferredCountries.length + typedCountryI;
          const selEle = this.$refs.list.children[this.selectedIndex];
          const needToScrollTop = selEle.offsetTop < this.$refs.list.scrollTop;
          const needToScrollBottom = selEle.offsetTop + selEle.clientHeight > this.$refs.list.scrollTop + this.$refs.list.clientHeight;
          if (needToScrollTop || needToScrollBottom) {
            this.$refs.list.scrollTop = selEle.offsetTop - this.$refs.list.clientHeight / 2;
          }
        }
      }
    },
    reset() {
      this.selectedIndex = this.sortedCountries.map((c) => c.iso2).indexOf(this.activeCountryCode);
      this.open = false;
    },
    setDropdownPosition() {
      const spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      const hasEnoughSpaceBelow = spaceBelow > 200;
      if (hasEnoughSpaceBelow) {
        this.dropdownOpenDirection = "below";
      } else {
        this.dropdownOpenDirection = "above";
      }
    }
  }
};
const _hoisted_1$b = ["aria-expanded", "tabindex"];
const _hoisted_2$a = { class: "vti__selection" };
const _hoisted_3$8 = {
  key: 1,
  class: "vti__country-code"
};
const _hoisted_4$6 = { class: "vti__dropdown-arrow" };
const _hoisted_5$5 = ["onClick", "onMousemove", "aria-selected"];
const _hoisted_6$5 = { key: 1 };
const _hoisted_7$5 = ["type", "autocomplete", "autofocus", "disabled", "id", "maxlength", "name", "placeholder", "readonly", "required", "tabindex", "value", "aria-describedby"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_click_outside = resolveDirective("click-outside");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["vue-tel-input", $props.styleClasses, { disabled: $props.disabled }])
  }, [
    withDirectives((openBlock(), createElementBlock("div", {
      "aria-label": "Country Code Selector",
      "aria-haspopup": "listbox",
      "aria-expanded": $data.open,
      role: "button",
      class: normalizeClass(["vti__dropdown", { open: $data.open, disabled: $props.dropdownOptions.disabled }]),
      tabindex: $props.dropdownOptions.tabindex,
      onKeydown: [
        _cache[0] || (_cache[0] = (...args) => $options.keyboardNav && $options.keyboardNav(...args)),
        _cache[2] || (_cache[2] = withKeys((...args) => $options.toggleDropdown && $options.toggleDropdown(...args), ["space"])),
        _cache[3] || (_cache[3] = withKeys((...args) => $options.reset && $options.reset(...args), ["esc"])),
        _cache[4] || (_cache[4] = withKeys((...args) => $options.reset && $options.reset(...args), ["tab"]))
      ],
      onClick: _cache[1] || (_cache[1] = (...args) => $options.toggleDropdown && $options.toggleDropdown(...args))
    }, [
      createElementVNode("span", _hoisted_2$a, [
        $props.dropdownOptions.showFlags ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(["vti__flag", $data.activeCountryCode.toLowerCase()])
        }, null, 2)) : createCommentVNode("", true),
        $props.dropdownOptions.showDialCodeInSelection ? (openBlock(), createElementBlock("span", _hoisted_3$8, " +" + toDisplayString$1($options.activeCountry && $options.activeCountry.dialCode), 1)) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "arrow-icon", { open: $data.open }, () => [
          createElementVNode("span", _hoisted_4$6, toDisplayString$1($data.open ? "\u25B2" : "\u25BC"), 1)
        ])
      ]),
      $data.open ? (openBlock(), createElementBlock("ul", {
        key: 0,
        ref: "list",
        class: normalizeClass(["vti__dropdown-list", $data.dropdownOpenDirection]),
        role: "listbox"
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($options.sortedCountries, (pb, index2) => {
          return openBlock(), createElementBlock("li", {
            role: "option",
            class: normalizeClass(["vti__dropdown-item", $options.getItemClass(index2, pb.iso2)]),
            key: pb.iso2 + (pb.preferred ? "-preferred" : ""),
            tabindex: "-1",
            onClick: ($event) => $options.choose(pb),
            onMousemove: ($event) => $data.selectedIndex = index2,
            "aria-selected": $data.activeCountryCode === pb.iso2 && !pb.preferred
          }, [
            $props.dropdownOptions.showFlags ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(["vti__flag", pb.iso2.toLowerCase()])
            }, null, 2)) : createCommentVNode("", true),
            createElementVNode("strong", null, toDisplayString$1(pb.name), 1),
            $props.dropdownOptions.showDialCodeInList ? (openBlock(), createElementBlock("span", _hoisted_6$5, " +" + toDisplayString$1(pb.dialCode), 1)) : createCommentVNode("", true)
          ], 42, _hoisted_5$5);
        }), 128))
      ], 2)) : createCommentVNode("", true)
    ], 42, _hoisted_1$b)), [
      [_directive_click_outside, $options.clickedOutside]
    ]),
    withDirectives(createElementVNode("input", {
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => $data.phone = $event),
      ref: "input",
      type: $props.inputOptions.type,
      autocomplete: $props.inputOptions.autocomplete,
      autofocus: $props.inputOptions.autofocus,
      class: normalizeClass(["vti__input", $props.inputOptions.styleClasses]),
      disabled: $props.disabled,
      id: $props.inputOptions.id,
      maxlength: $props.inputOptions.maxlength,
      name: $props.inputOptions.name,
      placeholder: $data.parsedPlaceholder,
      readonly: $props.inputOptions.readonly,
      required: $props.inputOptions.required,
      tabindex: $props.inputOptions.tabindex,
      value: $props.modelValue,
      "aria-describedby": $props.inputOptions["aria-describedby"],
      onBlur: _cache[6] || (_cache[6] = (...args) => $options.onBlur && $options.onBlur(...args)),
      onFocus: _cache[7] || (_cache[7] = (...args) => $options.onFocus && $options.onFocus(...args)),
      onInput: _cache[8] || (_cache[8] = (...args) => $options.onInput && $options.onInput(...args)),
      onKeyup: [
        _cache[9] || (_cache[9] = withKeys((...args) => $options.onEnter && $options.onEnter(...args), ["enter"])),
        _cache[10] || (_cache[10] = withKeys((...args) => $options.onSpace && $options.onSpace(...args), ["space"]))
      ]
    }, null, 42, _hoisted_7$5), [
      [vModelDynamic, $data.phone]
    ]),
    renderSlot(_ctx.$slots, "icon-right")
  ], 2);
}
var VueTelInput = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

/**
 * A simple Phone Number Field.
 *
 * The wrapper will have the css class 'invalid', if the field is invalid (an error message is passed) and 'is-empty', if the field is empty.
 *
 * Custom properties:
 * <ul>
 *  <li>--sb-label-input-gap: control how much margin is between the input field and label</li>
 *  <li>--sb-error-color: color used to indicate an invalid input value</li>
 * </ul>
 */

var script$a = defineComponent({
  name: "PhoneNumberField",
  components: {
    InputLabelWrapper: script$q,
    VueTelInput: VueTelInput
  },
  data: function data() {
    return {
      errorSpanId: uuid(),
      value: null,
      bindVueTelProps: {
        disabled: this.disabled,
        autoDefaultCountry: false,
        defaultCountry: "FI",
        autoFormat: true,
        validCharactersOnly: true,
        inputOptions: {
          showDialCode: false,
          tabindex: 0,
          placeholder: this.placeholder
        },
        dropdownOptions: {
          showDialCodeInList: true,
          showDialCodeInSelection: true,
          showFlags: true,
          tabindex: 0
        },
        dynamicPlaceholder: true,
        // Ignore Åland island numbers -> sorry, they are still Finnish
        ignoredCountries: ["AX"]
      }
    };
  },
  methods: {
    handlePhoneInput: function handlePhoneInput(number, phoneObject) {
      var _phoneObject$number;

      if (phoneObject !== null && phoneObject !== void 0 && phoneObject.nationalNumber) {
        this.value = phoneObject.nationalNumber;
      }

      this.$emit("update:modelValue", (_phoneObject$number = phoneObject === null || phoneObject === void 0 ? void 0 : phoneObject.number) !== null && _phoneObject$number !== void 0 ? _phoneObject$number : number);
    }
  },
  computed: {
    hasError: function hasError() {
      //FIXME; we could help validate a required attribute on blur/focus
      return !!this.errorMessage;
    }
  },
  watch: {
    modelValue: {
      handler: function handler(val) {
        this.value = val;
      },
      immediate: true
    },
    placeholder: {
      handler: function handler(value) {
        var _this = this;

        this.$nextTick(function () {
          var _ref;

          var phoneNumber = (_ref = _this.$refs.phoneNumberField.$el) !== null && _ref !== void 0 ? _ref : null;

          if (phoneNumber) {
            var input = phoneNumber.querySelector(".vti__input");
            input === null || input === void 0 ? void 0 : input.setAttribute("placeholder", value);
          }
        });
      },
      immediate: true
    }
  },
  props: {
    /**
     * A custom id for the input field.
     *
     * Should only be used, if you intend to render a custom label for the input
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return uuid();
      }
    },

    /**
     * Label position, defaults to left
     */
    labelPosition: {
      type: String,
      required: false
    },

    /**
     * Current field value
     */
    modelValue: {
      type: String,
      required: true
    },

    /**
     * Input label.
     *
     * Note, if you want to render a custom label, don't pass a title, but pass an explicit id, with the htmlFor attribute set accordingly
     */
    label: {
      type: String,
      required: false
    },

    /**
     * the aria-label html property.
     *
     * Note, do not pass this prop, if the label attribute is already good enough for screen readers, if for some reason you want screenreaders to see a different label than regular users, use this property
     */
    ariaLabel: {
      type: String,
      required: false
    },

    /**
     * Indicate this field as mandatory.
     *
     * Note this simply renders a '*' next to the label (and adds appropriate aria-attributes), we do not validate the user input in anyway
     */
    indicateMandatory: {
      type: Boolean,
      required: false
    },

    /**
     * Error message to render below the input field.
     *
     * Note, any non empty string value indicates that this input field is somehow invalid, and this will be indicated both visually and accessability wise.
     *
     * Note, that this error message will be used by screenreaders as well.
     *
     * Note, if you do not wish to show an error message for visual users, please include the error message anyway, but hide it with css (do not use display none, so screenreaders can understand what is wrong)
     */
    errorMessage: {
      type: String,
      required: false
    },

    /**
     * If the error message should shown, even if the user is currently modifying the text field.
     *
     * By default errors are only shown, when the text field is inactive
     */
    showErrorWhenFocused: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },

    /**
     * Input placeholder
     */
    placeholder: {
      type: String,
      required: false,
      default: function _default() {
        return "50 5555555";
      }
    }
  }
});

var _hoisted_1$a = ["htmlFor"];
var _hoisted_2$9 = ["id"];
function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_vue_tel_input = resolveComponent("vue-tel-input");

  var _component_InputLabelWrapper = resolveComponent("InputLabelWrapper");

  return openBlock(), createBlock(_component_InputLabelWrapper, {
    labelPosition: _ctx.labelPosition,
    class: normalizeClass(["sb-text-input-wrapper", [_ctx.hasError ? 'sb-invalid' : '', !_ctx.modelValue ? 'sb-is-empty' : '', _ctx.disabled ? 'sb-disabled' : '']]),
    "indicate-mandatory": _ctx.indicateMandatory,
    showErrorWhenFocused: _ctx.showErrorWhenFocused,
    ref: "phoneNumberField",
    invalid: !!_ctx.errorMessage,
    "no-label": !_ctx.label
  }, {
    label: withCtx(function () {
      return [createElementVNode("label", {
        htmlFor: _ctx.id
      }, toDisplayString$1(_ctx.label), 9, _hoisted_1$a)];
    }),
    input: withCtx(function () {
      return [createVNode(_component_vue_tel_input, mergeProps({
        id: _ctx.id,
        "aria-label": _ctx.ariaLabel || undefined,
        "aria-required": _ctx.indicateMandatory,
        "aria-invalid": _ctx.hasError,
        "aria-errormessage": _ctx.errorSpanId,
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.value = $event;
        })
      }, _ctx.bindVueTelProps, {
        onBlur: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.$emit('blur');
        }),
        onFocus: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.$emit('focus');
        }),
        onOnInput: _ctx.handlePhoneInput
      }), null, 16, ["id", "aria-label", "aria-required", "aria-invalid", "aria-errormessage", "modelValue", "onOnInput"])];
    }),
    error: withCtx(function () {
      return [_ctx.hasError ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "sb-error-message",
        id: _ctx.errorSpanId
      }, toDisplayString$1(_ctx.errorMessage), 9, _hoisted_2$9)) : createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["labelPosition", "class", "indicate-mandatory", "showErrorWhenFocused", "invalid", "no-label"]);
}

script$a.render = render$d;
script$a.__scopeId = "data-v-04c7e17f";

/**
 * An integer/select field hybrid. Choosing a value larger than max value, will convert the input field to an integer field
 */
var script$9 = defineComponent({
  name: "IntegerSelectField",
  components: {
    IntegerField: script$n,
    CustomSelectField: script$f,
    InputLabelWrapper: script$q
  },
  props: {
    /**
     * Current field value. Note the type must be a number, or null/NaN to indicate no selection
     */
    modelValue: {
      type: Number,
      required: false
    },

    /**
     * Smallest possible selection for the dropdown. Defaults to 0
     */
    minSelectValue: {
      type: Number,
      required: false,
      default: 0
    },

    /**
     * Max select field value
     */
    maxSelectValue: {
      type: Number,
      required: true
    },

    /**
     * A custom id for the input field.
     *
     * Should only be used, if you intend to render a custom label for the input
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return uuid();
      }
    },

    /**
     * Label position, defaults to left
     */
    labelPosition: {
      type: String,
      required: false
    },

    /**
     * Input label.
     *
     * Note, if you want to render a custom label, don't pass a title, but pass an explicit id, with the htmlFor attribute set accordingly
     */
    label: {
      type: String,
      required: false
    },

    /**
     * the aria-label html property.
     *
     * Note, do not pass this prop, if the label attribute is already good enough for screen readers, if for some reason you want screenreaders to see a different label than regular users, use this property
     */
    ariaLabel: {
      type: String,
      required: false
    },

    /**
     * Indicate this field as mandatory.
     *
     * Note this simply renders a '*' next to the label (and adds appropriate aria-attributes), we do not validate the user input in anyway
     */
    indicateMandatory: {
      type: Boolean,
      required: false
    },

    /**
     * Error message to render below the input field.
     *
     * Note, any non empty string value indicates that this input field is somehow invalid, and this will be indicated both visually and accessability wise.
     *
     * Note, that this error message will be used by screenreaders as well.
     *
     * Note, if you do not wish to show an error message for visual users, please include the error message anyway, but hide it with css (do not use display none, so screenreaders can understand what is wrong)
     */
    errorMessage: {
      type: String,
      required: false
    },

    /**
     * If the error message should shown, even if the user is currently modifying the text field.
     *
     * By default errors are only shown, when the text field is inactive
     */
    showErrorWhenFocused: {
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    return {
      errorSpanId: uuid(),
      fieldValue: this.modelValue,
      integerValue: NaN,
      selectValue: undefined,
      forceTextMode: false
    };
  },
  methods: {
    emitChange: function emitChange(newActualValue) {
      console.log(newActualValue);

      if (_typeof$5(newActualValue) === "object") {
        newActualValue = newActualValue.key;
      }


      if (Number.isNaN(newActualValue) || newActualValue == null) {
        if (this.modelValue != newActualValue) {
          console.log("Emitting", null);
          this.$emit("update:modelValue", null);
        }
      } else {
        if (this.modelValue != newActualValue) {
          console.log("Emitting", newActualValue);
          this.$emit("update:modelValue", newActualValue);
        }
      }
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler: function handler(newActualValue, oldVal) {
        var _this = this;


        if (Number.isNaN(newActualValue) || newActualValue == null) {
          // No selection
          this.integerValue = NaN;
          this.selectValue = undefined;
        } else {
          this.integerValue = newActualValue;
          this.selectValue = this.selectFieldValues.find(function (v) {
            return v.key === newActualValue;
          });

          if (!this.selectValue) ;

          if (newActualValue >= this.maxSelectValue && !this.forceTextMode) {
            // Note, force text mode can't be toggled to false
            this.forceTextMode = true;
            this.$nextTick(function () {
              if (oldVal != null) {
                var _this$$refs, _this$$refs$unitCount, _this$$refs$unitCount2;


                (_this$$refs = _this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$unitCount = _this$$refs.unitCountField) === null || _this$$refs$unitCount === void 0 ? void 0 : (_this$$refs$unitCount2 = _this$$refs$unitCount.select) === null || _this$$refs$unitCount2 === void 0 ? void 0 : _this$$refs$unitCount2.call(_this$$refs$unitCount);
              }
            });
          }
        }
      }
    }
  },
  computed: {
    selectFieldValues: function selectFieldValues() {
      if (this.maxSelectValue == null || this.minSelectValue == null) return [];

      if (this.minSelectValue > this.maxSelectValue) {
        console.warn("IntegerSelectField", "Invalid min/max value, min value ", this.minSelectValue, "was larger than max value ", this.maxSelectValue);
        return [];
      }

      var vals = [];
      var current = this.minSelectValue;

      do {
        vals.push(current++);
      } while (current <= this.maxSelectValue);

      return vals.map(function (val, i) {
        return {
          key: val,
          title: i === vals.length - 1 ? val + "+" : val.toString()
        };
      });
    },
    hasError: function hasError() {
      return !!this.errorMessage;
    }
  }
});

var _hoisted_1$9 = ["id"];
var _hoisted_2$8 = {
  class: "sb-integer-select-field"
};
var _hoisted_3$7 = ["id"];
function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_IntegerField = resolveComponent("IntegerField");

  var _component_CustomSelectField = resolveComponent("CustomSelectField");

  var _component_InputLabelWrapper = resolveComponent("InputLabelWrapper");

  return openBlock(), createBlock(_component_InputLabelWrapper, {
    labelPosition: _ctx.labelPosition,
    class: normalizeClass(["sb-text-input-wrapper", {
      'sb-invalid': _ctx.hasError
    }]),
    "indicate-mandatory": _ctx.indicateMandatory,
    showErrorWhenFocused: _ctx.showErrorWhenFocused,
    invalid: !!_ctx.errorMessage,
    "no-label": !_ctx.label
  }, {
    label: withCtx(function () {
      var _ctx$label;

      return [createElementVNode("label", {
        id: _ctx.id
      }, toDisplayString$1((_ctx$label = _ctx.label) !== null && _ctx$label !== void 0 ? _ctx$label : ""), 9, _hoisted_1$9)];
    }),
    input: withCtx(function () {
      return [createElementVNode("div", _hoisted_2$8, [_ctx.forceTextMode || _ctx.selectFieldValues.length === 0 ? (openBlock(), createBlock(_component_IntegerField, {
        key: 0,
        class: "sb-integer-select-input",
        modelValue: _ctx.integerValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.integerValue = $event;
        }),
        onBlur: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.emitChange(_ctx.integerValue);
        }),
        label: '',
        "label-position": "bottom",
        ref: "unitCountField"
      }, null, 8, ["modelValue"])) : (openBlock(), createBlock(_component_CustomSelectField, {
        key: 1,
        class: "sb-integer-select-input",
        options: _ctx.selectFieldValues,
        modelValue: _ctx.selectValue,
        "onUpdate:modelValue": [_cache[2] || (_cache[2] = function ($event) {
          return _ctx.selectValue = $event;
        }), _ctx.emitChange],
        buttonLabelledBy: _ctx.id,
        ref: "unitCountField"
      }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "buttonLabelledBy"]))])];
    }),
    error: withCtx(function () {
      return [_ctx.hasError ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "sb-error-message",
        id: _ctx.errorSpanId
      }, toDisplayString$1(_ctx.errorMessage), 9, _hoisted_3$7)) : createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["labelPosition", "class", "indicate-mandatory", "showErrorWhenFocused", "invalid", "no-label"]);
}

script$9.render = render$c;
script$9.__scopeId = "data-v-230fd350";

/**
 * A simple tooltip component
 *
 * Provides 2 slots, trigger and content which can be used to insert arbitrary content for the tooltip trigger or content.
 *
 * Note, for accessability, something inside the tooltip trigger must be able to receive focus and click events (for example a button).
 *
 * Tooltip can use 2 strategies for positioning itself, fixed or absolute. Either can be used, depending on other factors (for example, fixed won't be affected by any potential overflow etc, but will force itself to close when the user scrolls the screen)
 *
 * Gap between the tooltip and the trigger can be controlled with the css property --sb-tooltip-trigger-content-gap (default is 0)
 */
var __default__$2 = defineComponent({
  props: {
    /**
     * Position the tooltip should be relative to the trigger
     *
     * Supported values are top/bottom/left/right/bottom-center.
     *
     * Gap between the content and trigger is controlled with the custom property --sb-tooltip-trigger-content-gap
     */
    position: {
      type: String,
      default: "bottom"
    },

    /**
     * Which method should be used to position the tooltip content.
     *
     * Supported values absolute and fixed (default)
     */
    positionStrategy: {
      type: String,
      default: "fixed"
    },

    /**
     * If the tooltip should force itself to be closed
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Delay between hovering the tooltip, and when the tooltip is actually opened
     */
    hoverOpenDelayMS: {
      type: [Number, String],
      default: 500
    },

    /**
     * Disable hovering action
     */
    disableHovering: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data: function data() {
    return {
      openPopover: false,
      hovering: false
    };
  },
  computed: {
    delay: function delay() {
      var delay;

      if (isNumber(this.hoverOpenDelayMS)) {
        delay = Number(this.hoverOpenDelayMS);
      } else {
        delay = 500;
      }

      return delay;
    },
    tooltipContainerRect: function tooltipContainerRect() {
      // Touch this.openPopover and this.positionStrategy, to make sure this is re-evaluated, whenever the tooltip needs to be shown
      if (this.positionStrategy !== "fixed") return {
        top: 0,
        left: 0,
        transform: "none"
      };
      if (!this.openPopover) return {
        top: 0,
        left: 0,
        transform: "none"
      };
      var container = this.$refs.container;

      var _container$getBoundin = container.getBoundingClientRect(),
          x = _container$getBoundin.x,
          y = _container$getBoundin.y,
          width = _container$getBoundin.width,
          height = _container$getBoundin.height;


      switch (this.position) {
        case "left":
          return {
            top: y + "px",
            left: x + "px",
            transform: "translateX(calc(-100% - var(--sb-tooltip-trigger-content-gap, 0px)))"
          };

        case "right":
          return {
            top: y + "px",
            left: "calc(".concat(width, "px + ").concat(x, "px + var(--sb-tooltip-trigger-content-gap, 0px))"),
            transform: "none"
          };

        case "top":
          return {
            top: y + "px",
            left: x + "px",
            transform: "translateY(calc(-100% - var(--sb-tooltip-trigger-content-gap, 0px)))"
          };

        case "bottom-center":
          return {
            top: "calc(".concat(height, "px + ").concat(y, "px + var(--sb-tooltip-trigger-content-gap, 0px))"),
            left: x + "px",
            transform: "translateX(calc(-50% - var(--sb-tooltip-trigger-content-gap, 0px) + ".concat(width / 2, "px))")
          };

        case "bottom":
        default:
          return {
            top: "calc(".concat(height, "px + ").concat(y, "px + var(--sb-tooltip-trigger-content-gap, 0px))"),
            left: x + "px",
            transform: "none"
          };
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("scroll", this.onScroll);
  },
  unmounted: function unmounted() {
    document.removeEventListener("click", this.onDocumentClick);
    document.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onDocumentClick: function onDocumentClick(event) {
      var container = this.$refs.container;
      var target = event.target;

      if (!container.contains(target)) {
        this.openPopover = false;
      }
    },
    onScroll: function onScroll() {
      if (this.positionStrategy === "fixed") {

        this.openPopover = false;
      }
    },
    onClick: function onClick() {

      this.openPopover = !this.openPopover;
    },
    onMouseOver: function onMouseOver() {
      var _this = this;

      if (!this.disableHovering) {
        this.hovering = true;
      }

      setTimeout(function () {
        if (!_this.disableHovering) {
          _this.openPopover = _this.hovering;
        }
      }, this.delay);
    },
    onMouseLeave: function onMouseLeave() {
      var _this2 = this;

      if (!this.disableHovering) {
        this.hovering = false;
      }

      setTimeout(function () {
        if (!_this2.disableHovering) {
          _this2.openPopover = _this2.hovering;
        }
      }, this.delay);
    }
  },
  watch: {}
});

var __injectCSSVars__$2 = function __injectCSSVars__() {
  useCssVars(function (_ctx) {
    return {
      "1cbf1cd0": _ctx.tooltipContainerRect.top,
      "4269f824": _ctx.tooltipContainerRect.left,
      "22da9d6f": _ctx.tooltipContainerRect.transform
    };
  });
};

var __setup__$2 = __default__$2.setup;
__default__$2.setup = __setup__$2 ? function (props, ctx) {
  __injectCSSVars__$2();

  return __setup__$2(props, ctx);
} : __injectCSSVars__$2;

var _hoisted_1$8 = /*#__PURE__*/createTextVNode("Some content ");

function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "sb-popover",
    ref: "container",
    onMouseover: _cache[1] || (_cache[1] = withModifiers(function () {
      return _ctx.onMouseOver && _ctx.onMouseOver.apply(_ctx, arguments);
    }, ["stop"])),
    onMouseleave: _cache[2] || (_cache[2] = withModifiers(function () {
      return _ctx.onMouseLeave && _ctx.onMouseLeave.apply(_ctx, arguments);
    }, ["stop"]))
  }, [createElementVNode("div", {
    class: "sb-popover-trigger",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.onClick && _ctx.onClick.apply(_ctx, arguments);
    })
  }, [renderSlot(_ctx.$slots, "trigger", {
    expanded: _ctx.openPopover
  })]), createVNode(Transition, {
    name: "sb-popover-content"
  }, {
    default: withCtx(function () {
      return [createElementVNode("div", {
        class: normalizeClass(["sb-popover-content", [{
          'sb-popover-open': _ctx.openPopover && _ctx.disabled !== true
        }, _ctx.position, _ctx.positionStrategy]])
      }, [renderSlot(_ctx.$slots, "content", {}, function () {
        return [_hoisted_1$8];
      })], 2)];
    }),
    _: 3
  })], 544);
}

__default__$2.render = render$b;
__default__$2.__scopeId = "data-v-293f2ba0";

/**
 * A simple loading indicator.
 *
 * Loading animation can be controlled with the following custom properties
 *
 * --sb-content-loader-background-color-state-1;
 * --sb-content-loader-background-color-state-2;
 * --sb-content-loader-animation-delay;
 *
 * Content loader size is always fixed, size is passed as props.
 *
 * Size can either be responsive, (note, mobile/desktop breakpoints based on Hub).
 *
 * All units can be string with a unit, for example "100%" or numbers (or strings that parse to numbers), in which case we interpret the unit as px
 */
var __default__$1 = defineComponent({
  name: "ContentLoader",
  props: {
    width: [Number, String],
    height: [Number, String],
    mobileWidth: [Number, String],
    mobileHeight: [Number, String],
    tabletWidth: [Number, String],
    tabletHeight: [Number, String],
    desktopWidth: [Number, String],
    desktopHeight: [Number, String],
    marginTop: [Number, String],
    marginBottom: [Number, String],
    marginLeft: [Number, String],
    marginRight: [Number, String],
    isCenter: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    resolveWithUnit: function resolveWithUnit(val) {
      var falsy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "auto";

      if (!val) {
        return falsy;
      }

      if (isNumber(val)) {
        return val + "px";
      } // Assume our user passed a unit, for example '100%'


      return val;
    }
  },
  computed: {
    customWidth: function customWidth() {
      return this.resolveWithUnit(this.width);
    },
    customHeight: function customHeight() {
      return this.resolveWithUnit(this.height);
    },
    customMarginTop: function customMarginTop() {
      return this.resolveWithUnit(this.marginTop, "0px");
    },
    customMarginRight: function customMarginRight() {
      return this.resolveWithUnit(this.marginRight, "0px");
    },
    customMarginBottom: function customMarginBottom() {
      return this.resolveWithUnit(this.marginBottom, "0px");
    },
    customMarginLeft: function customMarginLeft() {
      return this.resolveWithUnit(this.marginLeft, this.isCenter ? "auto" : "0px");
    },
    customMobileWidth: function customMobileWidth() {
      var _this$mobileWidth;

      return this.resolveWithUnit((_this$mobileWidth = this.mobileWidth) !== null && _this$mobileWidth !== void 0 ? _this$mobileWidth : this.width);
    },
    customTabletWidth: function customTabletWidth() {
      var _ref, _this$tabletWidth;

      return this.resolveWithUnit((_ref = (_this$tabletWidth = this.tabletWidth) !== null && _this$tabletWidth !== void 0 ? _this$tabletWidth : this.mobileWidth) !== null && _ref !== void 0 ? _ref : this.width);
    },
    customDesktopWidth: function customDesktopWidth() {
      var _ref2, _ref3, _this$desktopWidth;

      return this.resolveWithUnit((_ref2 = (_ref3 = (_this$desktopWidth = this.desktopWidth) !== null && _this$desktopWidth !== void 0 ? _this$desktopWidth : this.tabletWidth) !== null && _ref3 !== void 0 ? _ref3 : this.mobileWidth) !== null && _ref2 !== void 0 ? _ref2 : this.width);
    },
    customMobileHeight: function customMobileHeight() {
      var _this$mobileHeight;

      return this.resolveWithUnit((_this$mobileHeight = this.mobileHeight) !== null && _this$mobileHeight !== void 0 ? _this$mobileHeight : this.height);
    },
    customTabletHeight: function customTabletHeight() {
      var _ref4, _this$tabletHeight;

      return this.resolveWithUnit((_ref4 = (_this$tabletHeight = this.tabletHeight) !== null && _this$tabletHeight !== void 0 ? _this$tabletHeight : this.mobileHeight) !== null && _ref4 !== void 0 ? _ref4 : this.height);
    },
    customDesktopHeight: function customDesktopHeight() {
      var _ref5, _ref6, _this$desktopHeight;

      return this.resolveWithUnit((_ref5 = (_ref6 = (_this$desktopHeight = this.desktopHeight) !== null && _this$desktopHeight !== void 0 ? _this$desktopHeight : this.tabletHeight) !== null && _ref6 !== void 0 ? _ref6 : this.mobileHeight) !== null && _ref5 !== void 0 ? _ref5 : this.height);
    }
  }
});

var __injectCSSVars__$1 = function __injectCSSVars__() {
  useCssVars(function (_ctx) {
    return {
      "b2d90c4c": _ctx.customMobileWidth,
      "120cc793": _ctx.customMobileHeight,
      "7fa661dd": _ctx.customMarginTop,
      "2f7660a4": _ctx.customMarginRight,
      "b73a66ba": _ctx.customMarginBottom,
      "7522107f": _ctx.customMarginLeft,
      "3bc0c696": _ctx.customTabletWidth,
      "22891257": _ctx.customTabletHeight,
      "1e66cb98": _ctx.customDesktopWidth,
      "0ef7b279": _ctx.customDesktopHeight
    };
  });
};

var __setup__$1 = __default__$1.setup;
__default__$1.setup = __setup__$1 ? function (props, ctx) {
  __injectCSSVars__$1();

  return __setup__$1(props, ctx);
} : __injectCSSVars__$1;

function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div");
}

__default__$1.render = render$a;
__default__$1.__scopeId = "data-v-06ffeffb";

/**
 * A wrapper around ObjectTable to implement pagination, data fetching and loading state
 *
 * columnOptions/customCellComponentFactory are identical to ObjectTable, refer to ObjectTable documentation for more details
 *
 * The key difference is, that instead of passing data here directly, instead the callback "loadData" prop is called, whenever new data is needed.
 *
 * This component makes no assumptions on how the data is fetched, but for example an easy implementation for loadData is a simple wrapper around $apollo.query
 *
 * DEV note, loadData is function, but we will treat is as reactive. if THE loadData REFERENCE CHANGES, WE WILL FORCE A REFETCH.
 *
 * loadData must return a promise with the key "data", which contains a list of rows to display.
 *
 * In addition on of the following 2 keys must be set "totalCount" or "hasMore", which are used to display page navigation links (hasMore shows only previous/next, totalCount displays fine tuned page links)
 *
 * This is key, if you are using reactive props inside your loadData, since we won't automatically refetch data in this case.
 *
 * A simple workaround this is making loadData a computed property, and make sure it is recreated, when ever your component changes (note that simply using the properties inside the function body won't be enough, you need to make sure to touch any properties before you return the function to us).
 *
 * Default styling is based on Hub, and has striping based on two css properties, var(--sb-gray-2) and var(--sb-gray-1)
 *
 *
 * If you wish to render custom complex content inside the table cell, the named slots "body-cell" and "heading-cell" can be used to style the body or heading content.
 *
 * See vue documentation on the usage of scoped slots: https://vuejs.org/guide/components/slots.html#scoped-slots
 *
 * The slots recieve 3 arguments, which can be used inside the slot: path, value and row.
 *
 * Path is the current path being rendered (matched one of the options in column-options), value is the formatted value of the cell and row is the full object for this row (identically one of those in data).
 *
 * Example syntax for using an object table this way would be:
 *  <PaginatedTable>
 *    <template #body-cell="{ row, path, value }">
 *      Do fancy stuff here
 *    </template>
 *  <PaginatedTable>
 */
var script$8 = defineComponent({
  components: {
    ObjectTable: script$k,
    ContentLoader: __default__$1
  },
  emits: {
    sort: function sort(_) {
      return true;
    },
    "update:selectedRows": function updateSelectedRows(_) {
      return true;
    },
    rowClick: function rowClick(_) {
      return true;
    }
  },
  props: {
    loadData: {
      type: Function,
      required: true
    },
    columnOptions: {
      type: Array,
      required: true
    },

    /**
     * NOTE, this option is deprecated, use the slots instead
     *
     * @deprecated
     */
    customCellComponentFactory: {
      type: Function,
      required: false
    },

    /**
     * Message to display, if the table is empty.
     *
     * By default rendered inside an h4 tag
     */
    emptyTableMessage: {
      type: String,
      required: false
    },

    /**
     * Custom label for Next -button
     */
    nextLabel: {
      type: String,
      required: false
    },

    /**
     * Custom label for Previous -button
     */
    previousLabel: {
      type: String,
      required: false
    },

    /**
     * Page size for desktops
     */
    desktopPageSize: {
      type: Number,
      required: false,
      default: function _default() {
        return 10;
      }
    },

    /**
     * Page size for mobile
     */
    mobilePageSize: {
      type: Number,
      required: false,
      default: function _default() {
        return 6;
      }
    },

    /**
     * If cells of the table can be selected
     *
     * Selected tables are mapped to the model prop "selectedRows", and each cell will have the css class "sb-selected"
     */
    allowSelection: {
      type: Boolean,
      required: false
    },

    /**
     * If desktop controls (ctrl must be pressed, to expand selection) should be used
     */
    preferDesktopSelectionControls: {
      type: Boolean,
      required: false
    },

    /**
     * If the first column should be checkbox, displaying if the row is selected or not. (only if allowSelection is enabled)
     */
    includeSelectionCheckbox: {
      type: Boolean,
      required: false
    },

    /**
     * If the first column in the heading should be a checkbox to select all values
     */
    includeHeadingSelectAll: {
      type: Boolean,
      required: false
    },

    /**
     * Currently selected rows.
     *
     * Map with v-model:selectedRows.
     *
     * Only enabled, if the prop allowSelection is given
     */
    selectedRows: {
      type: Array,
      required: false
    },

    /**
     * If selection should be reset when clicking outside the component
     */
    removeSelectionOnDocumentClick: {
      type: Boolean,
      required: false
    },

    /**
     * If page links should be hidden (only show previous/next)
     */
    hidePageLinks: {
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    var _this$selectedRows;

    return {
      data: [],
      currentBigPage: 0,
      currentMobilePage: 0,
      currentDesktopPage: 0,
      counter: 0,
      pendingQueries: 0,
      totalCount: null,
      sortBy: null,
      sortAsc: null,
      selectedRowsInternal: (_this$selectedRows = this.selectedRows) !== null && _this$selectedRows !== void 0 ? _this$selectedRows : [],
      hasMore: undefined
    };
  },
  computed: {
    bigPageSize: function bigPageSize() {
      // Optimization if mobile and desktop are equal
      if (this.mobilePageSize === this.desktopPageSize) {

        return this.desktopPageSize;
      }


      return this.mobilePageSize * this.desktopPageSize;
    },
    loading: function loading() {
      return this.pendingQueries > 0;
    },
    desktopPageLinks: function desktopPageLinks() {
      return this.createLinks(this.currentDesktopPage, this.desktopPageCount, 7);
    },
    bigPageCount: function bigPageCount() {
      var _this$totalCount;

      // totalCount not NaN here
      return Math.ceil(((_this$totalCount = this.totalCount) !== null && _this$totalCount !== void 0 ? _this$totalCount : 0) / this.bigPageSize);
    },
    mobilePageCount: function mobilePageCount() {
      var _this$totalCount2;

      // totalCount not NaN here
      return Math.ceil(((_this$totalCount2 = this.totalCount) !== null && _this$totalCount2 !== void 0 ? _this$totalCount2 : 0) / this.mobilePageSize);
    },
    desktopPageCount: function desktopPageCount() {
      var _this$totalCount3;

      // totalCount not NaN here
      return Math.ceil(((_this$totalCount3 = this.totalCount) !== null && _this$totalCount3 !== void 0 ? _this$totalCount3 : 0) / this.desktopPageSize);
    },
    internalData: function internalData() {
      var _this$data;

      return _toConsumableArray$2((_this$data = this.data) !== null && _this$data !== void 0 ? _this$data : []);
    },
    mobileData: function mobileData() {
      var offSet = this.currentMobilePage - this.bigPageSize / this.mobilePageSize * this.currentBigPage;
      return this.internalData.slice(offSet * this.mobilePageSize, offSet * this.mobilePageSize + this.mobilePageSize);
    },
    desktopData: function desktopData() {
      var offSet = this.currentDesktopPage - this.bigPageSize / this.desktopPageSize * this.currentBigPage;
      return this.internalData.slice(offSet * this.desktopPageSize, offSet * this.desktopPageSize + this.desktopPageSize);
    },
    propsWatcher: function propsWatcher() {
      // Trick to use the same handler for watching multiple props
      // Note that we are watching the loadData cb
      return {
        page: this.currentBigPage,
        pageSize: this.bigPageSize,
        loadData: this.loadData,
        sortAsc: this.sortAsc,
        sortBy: this.sortBy
      };
    }
  },
  methods: {
    uuid: uuid,
    createLinks: function createLinks(page, pageCount, linkCount) {
      if (this.hidePageLinks) {
        return [];
      }

      if (this.hasMore !== undefined) {
        return [];
      }

      if (pageCount <= 1) {
        return [];
      }

      var res = [];

      var pushIfValid = function pushIfValid(val) {
        // Note, we allow null, to indicate "..."
        if (val === undefined) return false;
        if (val < 0) return false;
        if (val >= pageCount) return false;
        if (res.includes(val)) return false;
        res.push(val);
        return true;
      }; // If length is less than linkCount, just add all numbers, without "..."s


      if (pageCount <= linkCount) {
        for (var _i = 0; _i < pageCount; _i++) {
          res.push(_i);
        }

        return res;
      }

      pushIfValid(page - 1);
      pushIfValid(page);
      pushIfValid(page + 1); // Add values from start/end, until we have enough elements

      var pushFromEnd = true; // If we pass the current, we only need 1 "...", so need to push until length is 6, otherwise leave space for 2 "..."
      // The algorithm below works for all other page/pageCounts, expect if we passed the current value in either page - 1 or page + 1

      var currentIsPassed = page === 2 || page === pageCount - 3;
      var i = 0;

      while (currentIsPassed ? res.length < linkCount - 1 : res.length < linkCount - 2) {
        if (pushFromEnd) {
          if (!pushIfValid(pageCount - 1 - i)) {
            currentIsPassed = true;
          }
        } else {
          if (!pushIfValid(i)) {
            currentIsPassed = true;
          }

          i++;
        }

        pushFromEnd = !pushFromEnd;
      } // Note, at this point res doesn't contain nulls (since the assertions)


      res.sort(function (a, b) {
        return a - b;
      }); // Add ... to the left

      for (var _i2 = 1; _i2 < res.length; _i2++) {
        if (res[_i2] - res[_i2 - 1] != 1) {
          res.splice(_i2, 0, null);
          break;
        }
      } // Add ... to the right.


      for (var _i3 = res.length - 2; _i3 > 0; _i3--) {
        // Note if we encounter the null we inserted before, we can break here
        if (res[_i3] == null) break;

        if (res[_i3 + 1] - res[_i3] != 1) {
          res.splice(_i3 + 1, 0, null);
          break;
        }
      }

      return res;
    },
    changeBigPageIfNeeded: function changeBigPageIfNeeded(currentPage, pageSize) {
      if (this.bigPageSize < pageSize || this.bigPageSize % pageSize !== 0) ; // Ensure first item in the currentPage is in the bigPage
      // This check is enough, because this.bigPageSize > currentPage and this.bigPageSize % currentPage === 0


      var index = currentPage * pageSize;

      if (index < this.currentBigPage * this.bigPageSize || index >= (this.currentBigPage + 1) * this.bigPageSize) {
        this.currentBigPage = Math.floor(index / this.bigPageSize);
      }
    },
    setDesktopPage: function setDesktopPage(page) {
      this.currentDesktopPage = Math.max(0, Math.min(page, this.desktopPageCount - 1));
      this.changeBigPageIfNeeded(this.currentDesktopPage, this.desktopPageSize);
      this.clampMobileToDesktop();
    },
    setMobilePage: function setMobilePage(page) {
      this.currentMobilePage = Math.max(0, Math.min(page, this.mobilePageCount - 1));
      this.changeBigPageIfNeeded(this.currentMobilePage, this.mobilePageSize);
      this.clampDesktopToMobile();
    },
    desktopPrevious: function desktopPrevious() {
      this.setDesktopPage(this.currentDesktopPage - 1);
    },
    desktopNext: function desktopNext() {
      this.setDesktopPage(this.currentDesktopPage + 1);
    },
    mobilePrevious: function mobilePrevious() {
      this.setMobilePage(this.currentMobilePage - 1);
    },
    mobileNext: function mobileNext() {
      this.setMobilePage(this.currentMobilePage + 1);
    },
    clampMobileToDesktop: function clampMobileToDesktop() {
      // Ensure the first desktop item is somewhere in the mobile page
      var index = this.currentDesktopPage * this.desktopPageSize;

      if (index < this.currentMobilePage * this.mobilePageSize || index >= (this.currentMobilePage + 1) * this.mobilePageSize) {
        this.currentMobilePage = Math.floor(index / this.mobilePageSize);
      }
    },
    clampDesktopToMobile: function clampDesktopToMobile() {
      // Ensure the first mobile item is somewhere in the desktop page
      var index = this.currentMobilePage * this.mobilePageSize;

      if (index < this.currentDesktopPage * this.desktopPageSize || index >= (this.currentDesktopPage + 1) * this.desktopPageSize) {
        this.currentDesktopPage = Math.floor(index / this.desktopPageSize);
      }
    },
    setSort: function setSort(_ref) {
      var sortAsc = _ref.sortAsc,
          sortBy = _ref.sortBy;
      this.sortBy = sortBy !== null && sortBy !== void 0 ? sortBy : null;
      this.sortAsc = sortAsc !== null && sortAsc !== void 0 ? sortAsc : null;
    }
  },
  watch: {
    propsWatcher: {
      immediate: true,
      handler: function handler(_ref2) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var page, pageSize, loadData, sortBy, sortAsc, count, res, _this$data2, _this$data4, _ref3, _this$data3;

          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  page = _ref2.page, pageSize = _ref2.pageSize, loadData = _ref2.loadData, sortBy = _ref2.sortBy, sortAsc = _ref2.sortAsc;
                  count = ++_this.counter;

                  _this.pendingQueries++;
                  _context.prev = 4;
                  _context.next = 7;
                  return loadData({
                    page: page,
                    pageSize: pageSize,
                    sortBy: sortBy,
                    sortAsc: sortAsc !== null && sortAsc !== void 0 ? sortAsc : true
                  });

                case 7:
                  res = _context.sent;

                  if (count === _this.counter) {


                    _this.pendingQueries = 1;
                    _this.data = res === null || res === void 0 ? void 0 : res.data;

                    if (!_this.data) {
                      console.error("@sarake/sarake-storybook", "PaginatedTable", "Invalid return value, data key is missing", res);
                    }

                    _this.totalCount = res === null || res === void 0 ? void 0 : res.totalCount;

                    if (_this.totalCount != null) {
                      _this.hasMore = undefined;

                      if (_this.totalCount > 0 && !((_this$data2 = _this.data) !== null && _this$data2 !== void 0 && _this$data2.length) && page > 0) {
                        // page selection is out of bounds, reset to largest valid
                        _this.setMobilePage(Number.POSITIVE_INFINITY);

                        console.warn("@sarake/sarake-storybook", "PaginatedTable", "Current page selection is out of bounds for total count, resetting to largest available page");
                      }
                    } else if ((res === null || res === void 0 ? void 0 : res.hasMore) != null) {

                      if (res.hasMore) {
                        // at least one item beyond the current page;
                        _this.totalCount = (page + 1) * pageSize + 1;
                      } else {
                        _this.totalCount = (_ref3 = page * pageSize + ((_this$data3 = _this.data) === null || _this$data3 === void 0 ? void 0 : _this$data3.length)) !== null && _ref3 !== void 0 ? _ref3 : 1;
                      }

                      _this.hasMore = res === null || res === void 0 ? void 0 : res.hasMore;

                      if (_this.hasMore === false && !((_this$data4 = _this.data) !== null && _this$data4 !== void 0 && _this$data4.length) && page > 0) {
                        console.warn("@sarake/sarake-storybook", "PaginatedTable", "Current page selection is out of bounds, and no total count found, resetting to 0");

                        _this.setMobilePage(0);
                      }
                    } else {
                      console.error("@sarake/sarake-storybook", "PaginatedTable", "Invalid return value, totalCount or hasMore key not found", res);
                    }
                  }

                  _context.next = 15;
                  break;

                case 12:
                  _context.prev = 12;
                  _context.t0 = _context["catch"](4);
                  console.error("@sarake/sarake-storybook", "PaginatedTable", "error fetching data", _context.t0);

                case 15:
                  _context.prev = 15;
                  _this.pendingQueries = Math.max(_this.pendingQueries - 1, 0);
                  return _context.finish(15);

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[4, 12, 15, 18]]);
        }))();
      }
    },
    selectedRowsInternal: function selectedRowsInternal(val) {
      if (val !== this.selectedRows) this.$emit("update:selectedRows", val);
    },
    selectedRows: function selectedRows(val) {
      if (val !== this.selectedRowsInternal) this.selectedRowsInternal = val;
    }
  }
});

var _hoisted_1$7 = {
  class: "sb-paginated-table"
};
var _hoisted_2$7 = {
  key: 0,
  class: "sb-empty"
};
var _hoisted_3$6 = {
  class: "sb-table-wrapper"
};
var _hoisted_4$5 = {
  key: 0,
  class: "sb-page-selection"
};
var _hoisted_5$4 = {
  class: "sb-pages"
};
var _hoisted_6$4 = ["onClick"];
var _hoisted_7$4 = {
  key: 1,
  class: "sb-more-indicator sb-tablet-and-up"
};
function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$allowSelection, _ctx$allowSelection2;

  var _component_content_loader = resolveComponent("content-loader");

  var _component_ObjectTable = resolveComponent("ObjectTable");

  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock("div", _hoisted_1$7, [_ctx.totalCount === 0 ? (openBlock(), createElementBlock("div", _hoisted_2$7, [createElementVNode("h4", null, toDisplayString$1(_ctx.emptyTableMessage), 1)])) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(["sb-table-page-wrapper", {
      loading: _ctx.loading
    }])
  }, [createElementVNode("div", _hoisted_3$6, [createVNode(_component_content_loader, {
    class: "sb-content-loader",
    height: "100%",
    width: "100%"
  }), createVNode(_component_ObjectTable, {
    class: "sb-table--plain sb-table sb-mobile-only",
    data: _ctx.mobileData,
    "selected-rows": _ctx.selectedRowsInternal,
    "onUpdate:selected-rows": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.selectedRowsInternal = $event;
    }),
    "column-options": _ctx.columnOptions,
    customCellComponentFactory: _ctx.customCellComponentFactory,
    onSort: _ctx.setSort,
    onRowClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$emit('rowClick', $event);
    }),
    "allow-selection": (_ctx$allowSelection = _ctx.allowSelection) !== null && _ctx$allowSelection !== void 0 ? _ctx$allowSelection : false,
    includeSelectionCheckbox: _ctx.includeSelectionCheckbox,
    preferDesktopSelectionControls: _ctx.preferDesktopSelectionControls,
    includeHeadingSelectAll: _ctx.includeHeadingSelectAll,
    removeSelectionOnDocumentClick: _ctx.removeSelectionOnDocumentClick,
    doNotSort: ""
  }, {
    "heading-cell": withCtx(function (_ref) {
      var path = _ref.path,
          value = _ref.value;
      return [renderSlot(_ctx.$slots, "heading-cell", {
        path: path,
        value: value
      }, function () {
        return [createTextVNode(toDisplayString$1(value), 1)];
      })];
    }),
    "body-cell": withCtx(function (_ref2) {
      var path = _ref2.path,
          value = _ref2.value,
          row = _ref2.row;
      return [renderSlot(_ctx.$slots, "body-cell", {
        path: path,
        value: value,
        row: row
      }, function () {
        return [createTextVNode(toDisplayString$1(value), 1)];
      })];
    }),
    _: 3
  }, 8, ["data", "selected-rows", "column-options", "customCellComponentFactory", "onSort", "allow-selection", "includeSelectionCheckbox", "preferDesktopSelectionControls", "includeHeadingSelectAll", "removeSelectionOnDocumentClick"]), createVNode(_component_ObjectTable, {
    class: "sb-table--plain sb-table sb-tablet-and-up",
    "selected-rows": _ctx.selectedRowsInternal,
    "onUpdate:selected-rows": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.selectedRowsInternal = $event;
    }),
    data: _ctx.desktopData,
    "column-options": _ctx.columnOptions,
    customCellComponentFactory: _ctx.customCellComponentFactory,
    "allow-selection": (_ctx$allowSelection2 = _ctx.allowSelection) !== null && _ctx$allowSelection2 !== void 0 ? _ctx$allowSelection2 : false,
    includeSelectionCheckbox: _ctx.includeSelectionCheckbox,
    preferDesktopSelectionControls: _ctx.preferDesktopSelectionControls,
    includeHeadingSelectAll: _ctx.includeHeadingSelectAll,
    removeSelectionOnDocumentClick: _ctx.removeSelectionOnDocumentClick,
    onSort: _ctx.setSort,
    onRowClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.$emit('rowClick', $event);
    }),
    doNotSort: ""
  }, {
    "heading-cell": withCtx(function (_ref3) {
      var path = _ref3.path,
          value = _ref3.value;
      return [renderSlot(_ctx.$slots, "heading-cell", {
        path: path,
        value: value
      }, function () {
        return [createTextVNode(toDisplayString$1(value), 1)];
      })];
    }),
    "body-cell": withCtx(function (_ref4) {
      var path = _ref4.path,
          value = _ref4.value,
          row = _ref4.row;
      return [renderSlot(_ctx.$slots, "body-cell", {
        path: path,
        value: value,
        row: row
      }, function () {
        return [createTextVNode(toDisplayString$1(value), 1)];
      })];
    }),
    _: 3
  }, 8, ["selected-rows", "data", "column-options", "customCellComponentFactory", "allow-selection", "includeSelectionCheckbox", "preferDesktopSelectionControls", "includeHeadingSelectAll", "removeSelectionOnDocumentClick", "onSort"])]), _ctx.totalCount ? (openBlock(), createElementBlock("div", _hoisted_4$5, [createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-mobile-only sb-previous", _ctx.currentMobilePage > 0 ? '' : 'hidden']),
    onClick: _cache[4] || (_cache[4] = function () {
      return _ctx.mobilePrevious && _ctx.mobilePrevious.apply(_ctx, arguments);
    })
  }, [createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-left"
  }), createTextVNode(" " + toDisplayString$1(_ctx.previousLabel ? _ctx.previousLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.PREVIOUS")), 1)], 2), createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-tablet-and-up sb-previous", _ctx.currentDesktopPage > 0 ? '' : 'hidden']),
    onClick: _cache[5] || (_cache[5] = function () {
      return _ctx.desktopPrevious && _ctx.desktopPrevious.apply(_ctx, arguments);
    })
  }, [createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-left"
  }), createTextVNode(" " + toDisplayString$1(_ctx.previousLabel ? _ctx.previousLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.PREVIOUS")), 1)], 2), createElementVNode("div", _hoisted_5$4, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.desktopPageLinks, function (page) {
    return openBlock(), createElementBlock(Fragment, {
      key: _ctx.uuid(page)
    }, [page !== null ? (openBlock(), createElementBlock("button", {
      key: 0,
      class: normalizeClass(["sb-button--link sb-text--caption-link sb-page-link sb-tablet-and-up", page === _ctx.currentDesktopPage ? 'current' : '']),
      onClick: function onClick($event) {
        return _ctx.setDesktopPage(page);
      }
    }, toDisplayString$1(page + 1), 11, _hoisted_6$4)) : (openBlock(), createElementBlock("div", _hoisted_7$4, "..."))], 64);
  }), 128))]), createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-mobile-only sb-next", _ctx.currentMobilePage + 1 < _ctx.mobilePageCount ? '' : 'hidden']),
    onClick: _cache[6] || (_cache[6] = function () {
      return _ctx.mobileNext && _ctx.mobileNext.apply(_ctx, arguments);
    })
  }, [createTextVNode(toDisplayString$1(_ctx.nextLabel ? _ctx.nextLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.NEXT")) + " ", 1), createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-right"
  })], 2), createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-text--caption-link sb-tablet-and-up next", _ctx.currentDesktopPage + 1 < _ctx.desktopPageCount ? '' : 'hidden']),
    onClick: _cache[7] || (_cache[7] = function () {
      return _ctx.desktopNext && _ctx.desktopNext.apply(_ctx, arguments);
    })
  }, [createTextVNode(toDisplayString$1(_ctx.nextLabel ? _ctx.nextLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.NEXT")) + " ", 1), createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-right"
  })], 2)])) : createCommentVNode("", true)], 2))]);
}

script$8.render = render$9;
script$8.__scopeId = "data-v-0666f6be";

/**
 * Identical to PaginatedTable, but instead of call back, this table requires all data and state to be passed in as props.
 *
 * This is to make usage of vue-apollo smart queries to fetch the underlying data easier.
 *
 * Emits the following, which must be used to update loading/data props
 *
 * "setPage(number)"
 * "setPageSize(number)"
 * "setSort({ sortAsc, sortBy })
 *
 * Please see PaginatedTable for example usage + additional documentation
 */
var script$7 = defineComponent({
  components: {
    ObjectTable: script$k,
    ContentLoader: __default__$1
  },
  emits: {
    sort: function sort(_) {
      return true;
    },
    "update:selectedRows": function updateSelectedRows(_) {
      return true;
    },
    rowClick: function rowClick(_) {
      return true;
    },
    setPage: function setPage(page) {
      return page >= 0;
    },
    setPageSize: function setPageSize(page) {
      return page >= 0;
    },
    setSort: function setSort(_) {
      return true;
    }
  },
  props: {
    columnOptions: {
      type: Array,
      required: true
    },

    /**
     * NOTE, this option is deprecated, use the slots instead
     *
     * @deprecated
     */
    customCellComponentFactory: {
      type: Function,
      required: false
    },

    /**
     * Message to display, if the table is empty.
     *
     * By default rendered inside an h4 tag
     */
    emptyTableMessage: {
      type: String,
      required: false
    },

    /**
     * Custom label for Next -button
     */
    nextLabel: {
      type: String,
      required: false
    },

    /**
     * Custom label for Previous -button
     */
    previousLabel: {
      type: String,
      required: false
    },

    /**
     * Page size for desktops
     */
    desktopPageSize: {
      type: Number,
      required: false,
      default: function _default() {
        return 10;
      }
    },

    /**
     * Page size for mobile
     */
    mobilePageSize: {
      type: Number,
      required: false,
      default: function _default() {
        return 6;
      }
    },

    /**
     * If cells of the table can be selected
     *
     * Selected tables are mapped to the model prop "selectedRows", and each cell will have the css class "sb-selected"
     */
    allowSelection: {
      type: Boolean,
      required: false
    },

    /**
     * If desktop controls (ctrl must be pressed, to expand selection) should be used
     */
    preferDesktopSelectionControls: {
      type: Boolean,
      required: false
    },

    /**
     * If the first column should be checkbox, displaying if the row is selected or not. (only if allowSelection is enabled)
     */
    includeSelectionCheckbox: {
      type: Boolean,
      required: false
    },

    /**
     * If the first column in the heading should be a checkbox to select all values
     */
    includeHeadingSelectAll: {
      type: Boolean,
      required: false
    },

    /**
     * Currently selected rows.
     *
     * Map with v-model:selectedRows.
     *
     * Only enabled, if the prop allowSelection is given
     */
    selectedRows: {
      type: Array,
      required: false
    },

    /**
     * If selection should be reset when clicking outside the component
     */
    removeSelectionOnDocumentClick: {
      type: Boolean,
      required: false
    },

    /**
     * If page links should be hidden (only show previous/next)
     */
    hidePageLinks: {
      type: Boolean,
      required: false
    },
    // EVENT PAGINATED PROPS

    /**
     * If the table is currently loading data
     */
    loading: {
      type: Boolean,
      required: true
    },

    /**
     * Currently displayed data
     */
    data: {
      type: Array,
      required: true
    },

    /**
     * Total number of rows
     */
    totalCount: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    var _this$selectedRows;

    return {
      currentBigPage: 0,
      currentMobilePage: 0,
      currentDesktopPage: 0,
      sortBy: null,
      sortAsc: null,
      selectedRowsInternal: (_this$selectedRows = this.selectedRows) !== null && _this$selectedRows !== void 0 ? _this$selectedRows : [],
      hasMore: undefined
    };
  },
  computed: {
    bigPageSize: function bigPageSize() {
      // Optimization if mobile and desktop are equal
      if (this.mobilePageSize === this.desktopPageSize) {

        return this.desktopPageSize;
      }


      return this.mobilePageSize * this.desktopPageSize;
    },
    desktopPageLinks: function desktopPageLinks() {
      return this.createLinks(this.currentDesktopPage, this.desktopPageCount, 7);
    },
    bigPageCount: function bigPageCount() {
      var _this$totalCount;

      // totalCount not NaN here
      return Math.ceil(((_this$totalCount = this.totalCount) !== null && _this$totalCount !== void 0 ? _this$totalCount : 0) / this.bigPageSize);
    },
    mobilePageCount: function mobilePageCount() {
      var _this$totalCount2;

      // totalCount not NaN here
      return Math.ceil(((_this$totalCount2 = this.totalCount) !== null && _this$totalCount2 !== void 0 ? _this$totalCount2 : 0) / this.mobilePageSize);
    },
    desktopPageCount: function desktopPageCount() {
      var _this$totalCount3;

      // totalCount not NaN here
      return Math.ceil(((_this$totalCount3 = this.totalCount) !== null && _this$totalCount3 !== void 0 ? _this$totalCount3 : 0) / this.desktopPageSize);
    },
    internalData: function internalData() {
      var _this$data;

      return _toConsumableArray$2((_this$data = this.data) !== null && _this$data !== void 0 ? _this$data : []);
    },
    mobileData: function mobileData() {
      var offSet = this.currentMobilePage - this.bigPageSize / this.mobilePageSize * this.currentBigPage;
      return this.internalData.slice(offSet * this.mobilePageSize, offSet * this.mobilePageSize + this.mobilePageSize);
    },
    desktopData: function desktopData() {
      var offSet = this.currentDesktopPage - this.bigPageSize / this.desktopPageSize * this.currentBigPage;
      return this.internalData.slice(offSet * this.desktopPageSize, offSet * this.desktopPageSize + this.desktopPageSize);
    },
    propsWatcher: function propsWatcher() {
      // Trick to use the same handler for watching multiple props
      // Note that we are watching the loadData cb
      return {
        page: this.currentBigPage,
        pageSize: this.bigPageSize,
        sortAsc: this.sortAsc,
        sortBy: this.sortBy
      };
    }
  },
  methods: {
    uuid: uuid,
    createLinks: function createLinks(page, pageCount, linkCount) {
      if (this.hidePageLinks) {
        return [];
      }

      if (this.hasMore !== undefined) {
        return [];
      }

      if (pageCount <= 1) {
        return [];
      }

      var res = [];

      var pushIfValid = function pushIfValid(val) {
        // Note, we allow null, to indicate "..."
        if (val === undefined) return false;
        if (val < 0) return false;
        if (val >= pageCount) return false;
        if (res.includes(val)) return false;
        res.push(val);
        return true;
      }; // If length is less than linkCount, just add all numbers, without "..."s


      if (pageCount <= linkCount) {
        for (var _i = 0; _i < pageCount; _i++) {
          res.push(_i);
        }

        return res;
      }

      pushIfValid(page - 1);
      pushIfValid(page);
      pushIfValid(page + 1); // Add values from start/end, until we have enough elements

      var pushFromEnd = true; // If we pass the current, we only need 1 "...", so need to push until length is 6, otherwise leave space for 2 "..."
      // The algorithm below works for all other page/pageCounts, expect if we passed the current value in either page - 1 or page + 1

      var currentIsPassed = page === 2 || page === pageCount - 3;
      var i = 0;

      while (currentIsPassed ? res.length < linkCount - 1 : res.length < linkCount - 2) {
        if (pushFromEnd) {
          if (!pushIfValid(pageCount - 1 - i)) {
            currentIsPassed = true;
          }
        } else {
          if (!pushIfValid(i)) {
            currentIsPassed = true;
          }

          i++;
        }

        pushFromEnd = !pushFromEnd;
      } // Note, at this point res doesn't contain nulls (since the assertions)


      res.sort(function (a, b) {
        return a - b;
      }); // Add ... to the left

      for (var _i2 = 1; _i2 < res.length; _i2++) {
        if (res[_i2] - res[_i2 - 1] != 1) {
          res.splice(_i2, 0, null);
          break;
        }
      } // Add ... to the right.


      for (var _i3 = res.length - 2; _i3 > 0; _i3--) {
        // Note if we encounter the null we inserted before, we can break here
        if (res[_i3] == null) break;

        if (res[_i3 + 1] - res[_i3] != 1) {
          res.splice(_i3 + 1, 0, null);
          break;
        }
      }

      return res;
    },
    changeBigPageIfNeeded: function changeBigPageIfNeeded(currentPage, pageSize) {
      if (this.bigPageSize < pageSize || this.bigPageSize % pageSize !== 0) ; // Ensure first item in the currentPage is in the bigPage
      // This check is enough, because this.bigPageSize > currentPage and this.bigPageSize % currentPage === 0


      var index = currentPage * pageSize;

      if (index < this.currentBigPage * this.bigPageSize || index >= (this.currentBigPage + 1) * this.bigPageSize) {
        this.currentBigPage = Math.floor(index / this.bigPageSize);
      }
    },
    setDesktopPage: function setDesktopPage(page) {
      this.currentDesktopPage = Math.max(0, Math.min(page, this.desktopPageCount - 1));
      this.changeBigPageIfNeeded(this.currentDesktopPage, this.desktopPageSize);
      this.clampMobileToDesktop();
    },
    setMobilePage: function setMobilePage(page) {
      this.currentMobilePage = Math.max(0, Math.min(page, this.mobilePageCount - 1));
      this.changeBigPageIfNeeded(this.currentMobilePage, this.mobilePageSize);
      this.clampDesktopToMobile();
    },
    desktopPrevious: function desktopPrevious() {
      this.setDesktopPage(this.currentDesktopPage - 1);
    },
    desktopNext: function desktopNext() {
      this.setDesktopPage(this.currentDesktopPage + 1);
    },
    mobilePrevious: function mobilePrevious() {
      this.setMobilePage(this.currentMobilePage - 1);
    },
    mobileNext: function mobileNext() {
      this.setMobilePage(this.currentMobilePage + 1);
    },
    clampMobileToDesktop: function clampMobileToDesktop() {
      // Ensure the first desktop item is somewhere in the mobile page
      var index = this.currentDesktopPage * this.desktopPageSize;

      if (index < this.currentMobilePage * this.mobilePageSize || index >= (this.currentMobilePage + 1) * this.mobilePageSize) {
        this.currentMobilePage = Math.floor(index / this.mobilePageSize);
      }
    },
    clampDesktopToMobile: function clampDesktopToMobile() {
      // Ensure the first mobile item is somewhere in the desktop page
      var index = this.currentMobilePage * this.mobilePageSize;

      if (index < this.currentDesktopPage * this.desktopPageSize || index >= (this.currentDesktopPage + 1) * this.desktopPageSize) {
        this.currentDesktopPage = Math.floor(index / this.desktopPageSize);
      }
    },
    setSort: function setSort(val) {
      var _val$sortBy, _val$sortAsc;

      this.sortBy = (_val$sortBy = val === null || val === void 0 ? void 0 : val.sortBy) !== null && _val$sortBy !== void 0 ? _val$sortBy : null;
      this.sortAsc = (_val$sortAsc = val === null || val === void 0 ? void 0 : val.sortAsc) !== null && _val$sortAsc !== void 0 ? _val$sortAsc : null;
      this.$emit("setSort", val);
    }
  },
  watch: {
    selectedRowsInternal: function selectedRowsInternal(val) {
      if (val !== this.selectedRows) this.$emit("update:selectedRows", val);
    },
    selectedRows: function selectedRows(val) {
      if (val !== this.selectedRowsInternal) this.selectedRowsInternal = val;
    },
    currentBigPage: {
      handler: function handler(val) {
        this.$emit("setPage", val);
      },
      immediate: true
    },
    bigPageSize: {
      handler: function handler(val) {
        this.$emit("setPageSize", val);
      },
      immediate: true
    }
  }
});

var _hoisted_1$6 = {
  class: "sb-paginated-table"
};
var _hoisted_2$6 = {
  key: 0,
  class: "sb-empty"
};
var _hoisted_3$5 = {
  class: "sb-table-wrapper"
};
var _hoisted_4$4 = {
  key: 0,
  class: "sb-page-selection"
};
var _hoisted_5$3 = {
  class: "sb-pages"
};
var _hoisted_6$3 = ["onClick"];
var _hoisted_7$3 = {
  key: 1,
  class: "sb-more-indicator sb-tablet-and-up"
};
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$allowSelection, _ctx$allowSelection2;

  var _component_content_loader = resolveComponent("content-loader");

  var _component_ObjectTable = resolveComponent("ObjectTable");

  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock("div", _hoisted_1$6, [_ctx.totalCount === 0 ? (openBlock(), createElementBlock("div", _hoisted_2$6, [createElementVNode("h4", null, toDisplayString$1(_ctx.emptyTableMessage), 1)])) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(["sb-table-page-wrapper", {
      loading: _ctx.loading
    }])
  }, [createElementVNode("div", _hoisted_3$5, [createVNode(_component_content_loader, {
    class: "sb-content-loader",
    height: "100%",
    width: "100%"
  }), createVNode(_component_ObjectTable, {
    class: "sb-table--plain sb-table sb-mobile-only",
    data: _ctx.mobileData,
    "selected-rows": _ctx.selectedRowsInternal,
    "onUpdate:selected-rows": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.selectedRowsInternal = $event;
    }),
    "column-options": _ctx.columnOptions,
    customCellComponentFactory: _ctx.customCellComponentFactory,
    onSort: _ctx.setSort,
    onRowClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$emit('rowClick', $event);
    }),
    "allow-selection": (_ctx$allowSelection = _ctx.allowSelection) !== null && _ctx$allowSelection !== void 0 ? _ctx$allowSelection : false,
    includeSelectionCheckbox: _ctx.includeSelectionCheckbox,
    preferDesktopSelectionControls: _ctx.preferDesktopSelectionControls,
    includeHeadingSelectAll: _ctx.includeHeadingSelectAll,
    removeSelectionOnDocumentClick: _ctx.removeSelectionOnDocumentClick,
    doNotSort: ""
  }, {
    "heading-cell": withCtx(function (_ref) {
      var path = _ref.path,
          value = _ref.value;
      return [renderSlot(_ctx.$slots, "heading-cell", {
        path: path,
        value: value
      }, function () {
        return [createTextVNode(toDisplayString$1(value), 1)];
      })];
    }),
    "body-cell": withCtx(function (_ref2) {
      var path = _ref2.path,
          value = _ref2.value,
          row = _ref2.row;
      return [renderSlot(_ctx.$slots, "body-cell", {
        path: path,
        value: value,
        row: row
      }, function () {
        return [createTextVNode(toDisplayString$1(value), 1)];
      })];
    }),
    _: 3
  }, 8, ["data", "selected-rows", "column-options", "customCellComponentFactory", "onSort", "allow-selection", "includeSelectionCheckbox", "preferDesktopSelectionControls", "includeHeadingSelectAll", "removeSelectionOnDocumentClick"]), createVNode(_component_ObjectTable, {
    class: "sb-table--plain sb-table sb-tablet-and-up",
    "selected-rows": _ctx.selectedRowsInternal,
    "onUpdate:selected-rows": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.selectedRowsInternal = $event;
    }),
    data: _ctx.desktopData,
    "column-options": _ctx.columnOptions,
    customCellComponentFactory: _ctx.customCellComponentFactory,
    "allow-selection": (_ctx$allowSelection2 = _ctx.allowSelection) !== null && _ctx$allowSelection2 !== void 0 ? _ctx$allowSelection2 : false,
    includeSelectionCheckbox: _ctx.includeSelectionCheckbox,
    preferDesktopSelectionControls: _ctx.preferDesktopSelectionControls,
    includeHeadingSelectAll: _ctx.includeHeadingSelectAll,
    removeSelectionOnDocumentClick: _ctx.removeSelectionOnDocumentClick,
    onSort: _ctx.setSort,
    onRowClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.$emit('rowClick', $event);
    }),
    doNotSort: ""
  }, {
    "heading-cell": withCtx(function (_ref3) {
      var path = _ref3.path,
          value = _ref3.value;
      return [renderSlot(_ctx.$slots, "heading-cell", {
        path: path,
        value: value
      }, function () {
        return [createTextVNode(toDisplayString$1(value), 1)];
      })];
    }),
    "body-cell": withCtx(function (_ref4) {
      var path = _ref4.path,
          value = _ref4.value,
          row = _ref4.row;
      return [renderSlot(_ctx.$slots, "body-cell", {
        path: path,
        value: value,
        row: row
      }, function () {
        return [createTextVNode(toDisplayString$1(value), 1)];
      })];
    }),
    _: 3
  }, 8, ["selected-rows", "data", "column-options", "customCellComponentFactory", "allow-selection", "includeSelectionCheckbox", "preferDesktopSelectionControls", "includeHeadingSelectAll", "removeSelectionOnDocumentClick", "onSort"])]), _ctx.totalCount ? (openBlock(), createElementBlock("div", _hoisted_4$4, [createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-mobile-only sb-previous", _ctx.currentMobilePage > 0 ? '' : 'hidden']),
    onClick: _cache[4] || (_cache[4] = function () {
      return _ctx.mobilePrevious && _ctx.mobilePrevious.apply(_ctx, arguments);
    })
  }, [createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-left"
  }), createTextVNode(" " + toDisplayString$1(_ctx.previousLabel ? _ctx.previousLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.PREVIOUS")), 1)], 2), createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-tablet-and-up sb-previous", _ctx.currentDesktopPage > 0 ? '' : 'hidden']),
    onClick: _cache[5] || (_cache[5] = function () {
      return _ctx.desktopPrevious && _ctx.desktopPrevious.apply(_ctx, arguments);
    })
  }, [createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-left"
  }), createTextVNode(" " + toDisplayString$1(_ctx.previousLabel ? _ctx.previousLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.PREVIOUS")), 1)], 2), createElementVNode("div", _hoisted_5$3, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.desktopPageLinks, function (page) {
    return openBlock(), createElementBlock(Fragment, {
      key: _ctx.uuid(page)
    }, [page !== null ? (openBlock(), createElementBlock("button", {
      key: 0,
      class: normalizeClass(["sb-button--link sb-text--caption-link sb-page-link sb-tablet-and-up", page === _ctx.currentDesktopPage ? 'current' : '']),
      onClick: function onClick($event) {
        return _ctx.setDesktopPage(page);
      }
    }, toDisplayString$1(page + 1), 11, _hoisted_6$3)) : (openBlock(), createElementBlock("div", _hoisted_7$3, "..."))], 64);
  }), 128))]), createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-mobile-only sb-next", _ctx.currentMobilePage + 1 < _ctx.mobilePageCount ? '' : 'hidden']),
    onClick: _cache[6] || (_cache[6] = function () {
      return _ctx.mobileNext && _ctx.mobileNext.apply(_ctx, arguments);
    })
  }, [createTextVNode(toDisplayString$1(_ctx.nextLabel ? _ctx.nextLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.NEXT")) + " ", 1), createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-right"
  })], 2), createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-text--caption-link sb-tablet-and-up next", _ctx.currentDesktopPage + 1 < _ctx.desktopPageCount ? '' : 'hidden']),
    onClick: _cache[7] || (_cache[7] = function () {
      return _ctx.desktopNext && _ctx.desktopNext.apply(_ctx, arguments);
    })
  }, [createTextVNode(toDisplayString$1(_ctx.nextLabel ? _ctx.nextLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.NEXT")) + " ", 1), createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-right"
  })], 2)])) : createCommentVNode("", true)], 2))]);
}

script$7.render = render$8;
script$7.__scopeId = "data-v-ef70f69e";

/**
 * A PageSelection with data fetching

 * This component makes no assumptions on how the data is fetched, but for example an easy implementation for loadData is a simple wrapper around $apollo.query
 *
 * DEV note, loadData is function, but we will treat is as reactive. if THE loadData REFERENCE CHANGES, WE WILL FORCE A REFETCH.
 *
 * loadData must return a promise with the key "data", which contains a list of rows to display.
 *
 * In addition, on of the following 2 keys must be set "totalCount" or "hasMore", which are used to display page navigation links (hasMore shows only previous/next, totalCount displays fine tuned page links)
 *
 * This is key, if you are using reactive props inside your loadData, since we won't automatically refetch data in this case.
 *
 * A simple workaround this is making loadData a computed property, and make sure it is recreated, when ever your component changes (note that simply using the properties inside the function body won't be enough, you need to make sure to touch any properties before you return the function to us).
 *
 * Default styling is based on Hub, and has striping based on two css properties, var(--sb-gray-2) and var(--sb-gray-1)
 *
 *
 * If you wish to render custom complex content inside the table cell, the named slots "body-cell" and "heading-cell" can be used to style the body or heading content.
 *
 * See vue documentation on the usage of scoped slots: https://vuejs.org/guide/components/slots.html#scoped-slots
 *
 * The slots recieve 3 arguments, which can be used inside the slot: path, value and row.
 *
 * Path is the current path being rendered (matched one of the options in column-options), value is the formatted value of the cell and row is the full object for this row (identically one of those in data).
 *
 * Example syntax for using an object table this way would be:
 *  <PageSelection loadData="fetchData">
 *  <PageSelection>
 */
var script$6 = defineComponent({
  name: "PageSelection",
  emits: {
    updateCurrentPage: function updateCurrentPage(_) {
      return true;
    },
    newMobileData: function newMobileData(_) {
      return true;
    },
    newDesktopData: function newDesktopData(_) {
      return true;
    }
  },
  props: {
    loadData: {
      type: Function,
      required: true
    },

    /**
     * Custom label for Next -button
     */
    nextLabel: {
      type: String,
      required: false
    },

    /**
     * Custom label for Previous -button
     */
    previousLabel: {
      type: String,
      required: false
    },
    desktopPageSize: {
      type: Number,
      default: 20
    },
    mobilePageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Object,
      default: function _default() {
        return {
          currentDesktopPage: 0,
          currentMobilePage: 0
        };
      }
    }
  },
  data: function data() {
    return {
      data: [],
      currentBigPage: 0,
      currentMobilePage: 0,
      currentDesktopPage: 0,
      counter: 0,
      pendingQueries: 0,
      sortBy: null,
      sortAsc: null,
      totalCount: null,
      hasMore: undefined
    };
  },
  computed: {
    bigPageSize: function bigPageSize() {
      // Optimization if mobile and desktop are equal
      if (this.mobilePageSize === this.desktopPageSize) {

        return this.desktopPageSize;
      }


      return this.mobilePageSize * this.desktopPageSize;
    },
    loading: function loading() {
      return this.pendingQueries > 0;
    },
    desktopPageLinks: function desktopPageLinks() {
      return this.createLinks(this.currentDesktopPage, this.desktopPageCount, 7);
    },
    mobilePageCount: function mobilePageCount() {
      var _this$totalCount;

      return Math.ceil(((_this$totalCount = this.totalCount) !== null && _this$totalCount !== void 0 ? _this$totalCount : 0) / this.mobilePageSize);
    },
    desktopPageCount: function desktopPageCount() {
      var _this$totalCount2;

      return Math.ceil(((_this$totalCount2 = this.totalCount) !== null && _this$totalCount2 !== void 0 ? _this$totalCount2 : 0) / this.desktopPageSize);
    },
    internalData: function internalData() {
      var _this$data;

      return _toConsumableArray$2((_this$data = this.data) !== null && _this$data !== void 0 ? _this$data : []);
    },
    mobileData: function mobileData() {
      var offSet = this.currentMobilePage - this.bigPageSize / this.mobilePageSize * this.currentBigPage;
      return this.internalData.slice(offSet * this.mobilePageSize, offSet * this.mobilePageSize + this.mobilePageSize);
    },
    desktopData: function desktopData() {
      var offSet = this.currentDesktopPage - this.bigPageSize / this.desktopPageSize * this.currentBigPage;
      return this.internalData.slice(offSet * this.desktopPageSize, offSet * this.desktopPageSize + this.desktopPageSize);
    },
    propsWatcher: function propsWatcher() {
      // Trick to use the same handler for watching multiple props
      // Note that we are watching the loadData cb
      return {
        page: this.currentBigPage,
        pageSize: this.bigPageSize,
        loadData: this.loadData,
        sortAsc: this.sortAsc,
        sortBy: this.sortBy
      };
    }
  },
  watch: {
    propsWatcher: {
      immediate: true,
      handler: function handler(_ref) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var page, pageSize, loadData, sortBy, sortAsc, count, res, _res$data, _res$data3, _ref2, _res$data2;

          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  page = _ref.page, pageSize = _ref.pageSize, loadData = _ref.loadData, sortBy = _ref.sortBy, sortAsc = _ref.sortAsc;
                  // use this.counter to keep track of the latest loadData api call requested
                  count = ++_this.counter;

                  _this.pendingQueries++;
                  _context.prev = 4;
                  _context.next = 7;
                  return loadData({
                    page: page,
                    pageSize: pageSize,
                    sortBy: sortBy,
                    sortAsc: sortAsc !== null && sortAsc !== void 0 ? sortAsc : true
                  });

                case 7:
                  res = _context.sent;
                  console.log(res, "res");


                  if (count === _this.counter) {


                    _this.pendingQueries = 1;
                    _this.data = res === null || res === void 0 ? void 0 : res.data;

                    if (!_this.data) {
                      console.error("@sarake/sarake-storybook", "PageSelection", "Invalid return value, data key is missing", res);
                    }

                    _this.totalCount = res === null || res === void 0 ? void 0 : res.totalCount;

                    if (_this.totalCount != null) {
                      _this.hasMore = undefined;

                      if (_this.totalCount > 0 && !(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.length) && page > 0) {
                        // page selection is out of bounds, reset to largest valid
                        _this.setMobilePage(Number.POSITIVE_INFINITY);

                        console.warn("@sarake/sarake-storybook", "PageSelection", "Current page selection is out of bounds for total count, resetting to largest available page");
                      }
                    } else if ((res === null || res === void 0 ? void 0 : res.hasMore) != null) {

                      if (res.hasMore) {
                        // at least one item beyond the current page;
                        _this.totalCount = (page + 1) * pageSize + 1;
                      } else {
                        _this.totalCount = (_ref2 = page * pageSize + (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.length)) !== null && _ref2 !== void 0 ? _ref2 : 1;
                      }

                      _this.hasMore = res === null || res === void 0 ? void 0 : res.hasMore;

                      if (_this.hasMore === false && !(res !== null && res !== void 0 && (_res$data3 = res.data) !== null && _res$data3 !== void 0 && _res$data3.length) && page > 0) {
                        console.warn("@sarake/sarake-storybook", "PageSelection", "Current page selection is out of bounds, and no total count found, resetting to 0");

                        _this.setMobilePage(0);
                      }
                    } else {
                      console.error("@sarake/sarake-storybook", "PageSelection", "Invalid return value, totalCount or hasMore key not found", res);
                    }
                  }

                  _context.next = 16;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context["catch"](4);
                  console.error("@sarake/sarake-storybook", "PageSelection", "error fetching data", _context.t0);

                case 16:
                  _context.prev = 16;
                  _this.pendingQueries = Math.max(_this.pendingQueries - 1, 0);
                  return _context.finish(16);

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[4, 13, 16, 19]]);
        }))();
      }
    },
    currentPage: {
      handler: function handler(newValue) {
        if (newValue) {
          this.currentMobilePage = newValue.currentMobilePage;
          this.currentDesktopPage = newValue.currentDesktopPage;
        }
      },
      immediate: true
    },
    mobileData: function mobileData() {
      this.$emit("newMobileData", this.mobileData);
    },
    desktopData: function desktopData() {
      this.$emit("newDesktopData", this.desktopData);
    }
  },
  methods: {
    uuid: uuid,
    createLinks: function createLinks(page, pageCount, linkCount) {
      if (pageCount <= 1) {
        return [];
      }

      var res = [];

      var pushIfValid = function pushIfValid(val) {
        // Note, we allow null, to indicate "..."
        if (val === undefined) return false;
        if (val < 0) return false;
        if (val >= pageCount) return false;
        if (res.includes(val)) return false;
        res.push(val);
        return true;
      }; // If length is less than linkCount, just add all numbers, without "..."s


      if (pageCount <= linkCount) {
        for (var _i = 0; _i < pageCount; _i++) {
          res.push(_i);
        }

        return res;
      }

      pushIfValid(page - 1);
      pushIfValid(page);
      pushIfValid(page + 1); // Add values from start/end, until we have enough elements

      var pushFromEnd = true; // If we pass the current, we only need 1 "...", so need to push until length is 6, otherwise leave space for 2 "..."
      // The algorithm below works for all other page/pageCounts, expect if we passed the current value in either page - 1 or page + 1

      var currentIsPassed = page === 2 || page === pageCount - 3;
      var i = 0;

      while (currentIsPassed ? res.length < linkCount - 1 : res.length < linkCount - 2) {
        if (pushFromEnd) {
          if (!pushIfValid(pageCount - 1 - i)) {
            currentIsPassed = true;
          }
        } else {
          if (!pushIfValid(i)) {
            currentIsPassed = true;
          }

          i++;
        }

        pushFromEnd = !pushFromEnd;
      }

      res.sort(function (a, b) {
        if (a === null) {
          return 1;
        }

        if (b === null) {
          return -1;
        } else return a - b;
      }); // Add ... to the left

      for (var _i2 = 1; _i2 < res.length; _i2++) {
        if (res[_i2] - res[_i2 - 1] !== 1) {
          res.splice(_i2, 0, null);
          break;
        }
      } // Add ... to the right.


      for (var _i3 = res.length - 2; _i3 > 0; _i3--) {
        // Note if we encounter the null we inserted before, we can break here
        if (res[_i3] == null) break;

        if (res[_i3 + 1] - res[_i3] !== 1) {
          res.splice(_i3 + 1, 0, null);
          break;
        }
      }

      return res;
    },
    changeBigPageIfNeeded: function changeBigPageIfNeeded(currentPage, pageSize) {
      if (this.bigPageSize < pageSize || this.bigPageSize % pageSize !== 0) {
        console.error("Invalid pageSize ", pageSize, "in Pagination", "this.bigPageSize must be a multiple of pageSize ");
      } // Ensure first item in the currentPage is in the bigPage
      // This check is enough, because this.bigPageSize > currentPage and this.bigPageSize % currentPage === 0


      var index = currentPage * pageSize;

      if (index < this.currentBigPage * this.bigPageSize || index >= (this.currentBigPage + 1) * this.bigPageSize) {
        this.currentBigPage = Math.floor(index / this.bigPageSize);
      }
    },
    setDesktopPage: function setDesktopPage(page) {
      this.currentDesktopPage = Math.max(0, Math.min(page, this.desktopPageCount - 1));
      this.changeBigPageIfNeeded(this.currentDesktopPage, this.desktopPageSize);
      this.clampMobileToDesktop();
      this.$emit("updateCurrentPage", {
        currentDesktopPage: this.currentDesktopPage,
        currentMobilePage: this.currentDesktopPage
      });
    },
    setMobilePage: function setMobilePage(page) {
      this.currentMobilePage = Math.max(0, Math.min(page, this.mobilePageCount - 1));
      this.changeBigPageIfNeeded(this.currentMobilePage, this.mobilePageSize);
      this.clampDesktopToMobile();
      this.$emit("updateCurrentPage", {
        currentDesktopPage: this.currentMobilePage,
        currentMobilePage: this.currentMobilePage
      });
    },
    desktopPrevious: function desktopPrevious() {
      this.setDesktopPage(this.currentDesktopPage - 1);
    },
    desktopNext: function desktopNext() {
      this.setDesktopPage(this.currentDesktopPage + 1);
    },
    mobilePrevious: function mobilePrevious() {
      this.setMobilePage(this.currentMobilePage - 1);
    },
    mobileNext: function mobileNext() {
      this.setMobilePage(this.currentMobilePage + 1);
    },
    clampMobileToDesktop: function clampMobileToDesktop() {
      // Ensure the first desktop item is somewhere in the mobile page
      var index = this.currentDesktopPage * this.desktopPageSize;

      if (index < this.currentMobilePage * this.mobilePageSize || index >= (this.currentMobilePage + 1) * this.mobilePageSize) {
        this.currentMobilePage = Math.floor(index / this.mobilePageSize);
      }
    },
    clampDesktopToMobile: function clampDesktopToMobile() {
      // Ensure the first mobile item is somewhere in the desktop page
      var index = this.currentMobilePage * this.mobilePageSize;

      if (index < this.currentDesktopPage * this.desktopPageSize || index >= (this.currentDesktopPage + 1) * this.desktopPageSize) {
        this.currentDesktopPage = Math.floor(index / this.desktopPageSize);
      }
    },
    setSort: function setSort(_ref3) {
      var sortAsc = _ref3.sortAsc,
          sortBy = _ref3.sortBy;
      this.sortBy = sortBy !== null && sortBy !== void 0 ? sortBy : null;
      this.sortAsc = sortAsc !== null && sortAsc !== void 0 ? sortAsc : null;
    }
  }
});

var _hoisted_1$5 = {
  key: 0,
  class: "sb-page-selection"
};
var _hoisted_2$5 = {
  class: "sb-pages"
};
var _hoisted_3$4 = ["onClick"];
var _hoisted_4$3 = {
  key: 1,
  class: "sb-more-indicator sb-tablet-and-up"
};
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return _ctx.totalCount ? (openBlock(), createElementBlock("div", _hoisted_1$5, [createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-mobile-only sb-previous", _ctx.currentMobilePage > 0 ? '' : 'hidden']),
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.mobilePrevious && _ctx.mobilePrevious.apply(_ctx, arguments);
    })
  }, [createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-left"
  }), createTextVNode(" " + toDisplayString$1(_ctx.previousLabel ? _ctx.previousLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.PREVIOUS")), 1)], 2), createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-tablet-and-up sb-previous", _ctx.currentDesktopPage > 0 ? '' : 'hidden']),
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.desktopPrevious && _ctx.desktopPrevious.apply(_ctx, arguments);
    })
  }, [createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-left"
  }), createTextVNode(" " + toDisplayString$1(_ctx.previousLabel ? _ctx.previousLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.PREVIOUS")), 1)], 2), createElementVNode("div", _hoisted_2$5, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.desktopPageLinks, function (page) {
    return openBlock(), createElementBlock(Fragment, {
      key: _ctx.uuid(page === null || page === void 0 ? void 0 : page.toString())
    }, [page !== null ? (openBlock(), createElementBlock("button", {
      key: 0,
      class: normalizeClass(["sb-button--link sb-text--caption-link sb-page-link sb-tablet-and-up", page === _ctx.currentDesktopPage ? 'current' : '']),
      onClick: function onClick($event) {
        return _ctx.setDesktopPage(page);
      }
    }, toDisplayString$1(page + 1), 11, _hoisted_3$4)) : (openBlock(), createElementBlock("div", _hoisted_4$3, "..."))], 64);
  }), 128))]), createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-mobile-only sb-next", _ctx.currentMobilePage + 1 < _ctx.mobilePageCount ? '' : 'hidden']),
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.mobileNext && _ctx.mobileNext.apply(_ctx, arguments);
    })
  }, [createTextVNode(toDisplayString$1(_ctx.nextLabel ? _ctx.nextLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.NEXT")) + " ", 1), createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-right"
  })], 2), createElementVNode("button", {
    class: normalizeClass(["sb-button--link sb-text--caption-link sb-tablet-and-up next", _ctx.currentDesktopPage + 1 < _ctx.desktopPageCount ? '' : 'hidden']),
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.desktopNext && _ctx.desktopNext.apply(_ctx, arguments);
    })
  }, [createTextVNode(toDisplayString$1(_ctx.nextLabel ? _ctx.nextLabel : _ctx.$t("SARAKE_STORYBOOK_ARIA.PaginatedTable.NEXT")) + " ", 1), createVNode(_component_font_awesome_icon, {
    class: "sb-icon",
    icon: "fa-regular fa-chevron-right"
  })], 2)])) : createCommentVNode("", true);
}

script$6.render = render$7;
script$6.__scopeId = "data-v-be94e556";

/**
 * A variant of TextField.
 *
 * Instead of updating the modelValue immediately as the user types, will wait updateDelay, before updating the parent value.
 *
 * Useful for implementing text search fields etc.
 *
 * Custom properties:
 * <ul>
 *  <li>--sb-label-input-gap: control how much margin is between the input field and label</li>
 *  <li>--sb-error-color: color used to indicate an invalid input value</li>
 * </ul>
 */
var script$5 = defineComponent({
  name: "DelayedTextField",
  components: {
    InputLabelWrapper: script$q,
    FontAwesomeIcon: FontAwesomeIcon
  },
  data: function data() {
    return {
      errorSpanId: uuid(),
      passwordVisible: false,
      timeoutId: null
    };
  },
  methods: {
    immediateEmit: function immediateEmit(e) {
      var _e$target$value, _e$target;

      //@ts-ignore
      var newVal = (_e$target$value = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) !== null && _e$target$value !== void 0 ? _e$target$value : "";

      if (this.timeoutId != null) {

        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      this.$emit("update:modelValue", newVal);
    },
    handleInput: function handleInput(e) {
      var _e$target$value2,
          _e$target2,
          _this = this;

      //@ts-ignore
      var newVal = (_e$target$value2 = (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value) !== null && _e$target$value2 !== void 0 ? _e$target$value2 : "";

      if (this.timeoutId != null) {

        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      } // window access is safe


      this.timeoutId = window.setTimeout(function () {

        _this.$emit("update:modelValue", newVal);
      }, this.updateDelay || 800);
    },
    focus: function focus() {
      var _input$focus;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$focus = input.focus) === null || _input$focus === void 0 ? void 0 : _input$focus.call(input);
    },
    blur: function blur() {
      var _input$blur;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$blur = input.blur) === null || _input$blur === void 0 ? void 0 : _input$blur.call(input);
    },
    select: function select() {
      var _input$select;

      var input = this.$refs.input;
      input === null || input === void 0 ? void 0 : (_input$select = input.select) === null || _input$select === void 0 ? void 0 : _input$select.call(input);
    }
  },
  computed: {
    inputType: function inputType() {
      if (this.type === "password" && this.passwordVisible) {
        return "text";
      }

      return this.type || "text";
    },
    hasError: function hasError() {
      //FIXME; we could help validate a required attribute on blur/focus
      return !!this.errorMessage;
    }
  },
  props: {
    /**
     * Number of milliseconds to wait, before updating the value
     */
    updateDelay: {
      type: Number,
      required: false,
      default: 800
    },

    /**
     * A custom id for the input field.
     *
     * Should only be used, if you intend to render a custom label for the input
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return uuid();
      }
    },

    /**
     * Label position, defaults to left
     */
    labelPosition: {
      type: String,
      required: false
    },

    /**
     * Current field value
     */
    modelValue: {
      type: String,
      required: true
    },

    /**
     *
     */
    passwordEye: {
      type: Boolean,
      required: false,
      default: function _default() {
        return true;
      }
    },

    /**
     * Input label.
     *
     * Note, if you want to render a custom label, don't pass a title, but pass an explicit id, with the htmlFor attribute set accordingly
     */
    label: {
      type: String,
      required: false
    },

    /**
     * the aria-label html property.
     *
     * Note, do not pass this prop, if the label attribute is already good enough for screen readers, if for some reason you want screenreaders to see a different label than regular users, use this property
     */
    ariaLabel: {
      type: String,
      required: false
    },

    /**
     * Input field type.
     * Passed directly to the underlying input field (so pass for example password, if you want to render a password field etc.)
     */
    type: {
      type: String,
      required: false
    },

    /**
     * Indicate this field as mandatory.
     *
     * Note this simply renders a '*' next to the label (and adds appropriate aria-attributes), we do not validate the user input in anyway
     */
    indicateMandatory: {
      type: Boolean,
      required: false
    },

    /**
     * Error message to render below the input field.
     *
     * Note, any non empty string value indicates that this input field is somehow invalid, and this will be indicated both visually and accessability wise.
     *
     * Note, that this error message will be used by screenreaders as well.
     *
     * Note, if you do not wish to show an error message for visual users, please include the error message anyway, but hide it with css (do not use display none, so screenreaders can understand what is wrong)
     */
    errorMessage: {
      type: String,
      required: false
    },

    /**
     * If the error message should shown, even if the user is currently modifying the text field.
     *
     * By default errors are only shown, when the text field is inactive
     */
    showErrorWhenFocused: {
      type: Boolean,
      required: false
    }
  }
});

var _hoisted_1$4 = ["htmlFor"];
var _hoisted_2$4 = ["id", "value", "type", "aria-label", "aria-required", "aria-invalid", "aria-errormessage"];
var _hoisted_3$3 = ["id"];
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _component_InputLabelWrapper = resolveComponent("InputLabelWrapper");

  return openBlock(), createBlock(_component_InputLabelWrapper, {
    labelPosition: _ctx.labelPosition,
    class: normalizeClass(["sb-text-input-wrapper", [_ctx.hasError ? 'sb-invalid' : '', !_ctx.modelValue ? 'sb-is-empty' : '', _ctx.passwordEye && _ctx.type === 'password' ? 'sb-relative' : '']]),
    "indicate-mandatory": _ctx.indicateMandatory,
    showErrorWhenFocused: _ctx.showErrorWhenFocused,
    invalid: !!_ctx.errorMessage,
    "no-label": !_ctx.label
  }, {
    label: withCtx(function () {
      return [createElementVNode("label", {
        htmlFor: _ctx.id
      }, toDisplayString$1(_ctx.label), 9, _hoisted_1$4)];
    }),
    input: withCtx(function () {
      return [createElementVNode("input", mergeProps({
        id: _ctx.id,
        value: _ctx.modelValue,
        onInput: _cache[0] || (_cache[0] = function () {
          return _ctx.handleInput && _ctx.handleInput.apply(_ctx, arguments);
        }),
        onKeyup: _cache[1] || (_cache[1] = withKeys(function () {
          return _ctx.immediateEmit && _ctx.immediateEmit.apply(_ctx, arguments);
        }, ["enter"])),
        onBlur: _cache[2] || (_cache[2] = function () {
          return _ctx.immediateEmit && _ctx.immediateEmit.apply(_ctx, arguments);
        }),
        type: _ctx.inputType,
        "aria-label": _ctx.ariaLabel || undefined,
        "aria-required": _ctx.indicateMandatory,
        "aria-invalid": _ctx.hasError,
        "aria-errormessage": _ctx.errorSpanId
      }, _ctx.$attrs, {
        class: {
          password: _ctx.type === 'password' && _ctx.passwordEye
        },
        ref: "input"
      }), null, 16, _hoisted_2$4), _ctx.type === 'password' && _ctx.passwordEye && !_ctx.passwordVisible ? (openBlock(), createBlock(_component_font_awesome_icon, {
        key: 0,
        class: "eye-icon",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.passwordVisible = !_ctx.passwordVisible;
        }),
        icon: ['fas', 'eye']
      })) : _ctx.type === 'password' && _ctx.passwordEye ? (openBlock(), createBlock(_component_font_awesome_icon, {
        key: 1,
        class: "eye-icon",
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return _ctx.passwordVisible = !_ctx.passwordVisible;
        }),
        icon: ['fas', 'eye-slash']
      })) : createCommentVNode("", true)];
    }),
    error: withCtx(function () {
      return [_ctx.hasError ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "sb-error-message",
        id: _ctx.errorSpanId
      }, toDisplayString$1(_ctx.errorMessage), 9, _hoisted_3$3)) : createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["labelPosition", "class", "indicate-mandatory", "showErrorWhenFocused", "invalid", "no-label"]);
}

script$5.render = render$6;
script$5.__scopeId = "data-v-bc45a03c";

/**
 * Wrapper component for storybook inputs.
 *
 * Provides logic for forcing error messages to show, when a form is submitted.
 */

var script$4 = defineComponent({
  props: {
    /**
     * Disable first invalid field focus on error
     */
    disableFirstFieldFocusOnSubmit: {
      required: false
    }
  },
  emits: {
    submit: function submit(_) {
      // FIXME; come up with the proper submit event type
      return true;
    }
  },
  provide: function provide() {
    var _ref;

    return _ref = {}, _defineProperty$8(_ref, registerInputFieldSymbol, this.registerInputField), _defineProperty$8(_ref, unregisterInputFieldSymbol, this.unregisterInputField), _ref;
  },
  data: function data() {
    return {
      childInputHandlers: new Set()
    };
  },
  methods: {
    registerInputField: function registerInputField(field) {

      this.childInputHandlers.add(field);
    },
    unregisterInputField: function unregisterInputField(field) {

      this.childInputHandlers.delete(field);
    },
    handleSubmit: function handleSubmit(event) {

      var foundError = false; // Note, this is not really correct, cause the order of stuff in childInputHandlers is based on mount order
      // But it's probably correct, and it's not the end of the world if we focus the wrong field

      var _iterator = _createForOfIteratorHelper(this.childInputHandlers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _input$didSubmit;

          var input = _step.value;
          if (!input) continue;

          if (IS_DEV) ;

          input === null || input === void 0 ? void 0 : (_input$didSubmit = input.didSubmit) === null || _input$didSubmit === void 0 ? void 0 : _input$didSubmit.call(input);

          if (!this.disableFirstFieldFocusOnSubmit) {
            if (!foundError) {
              var _input$isInvalid;

              if (input !== null && input !== void 0 && (_input$isInvalid = input.isInvalid) !== null && _input$isInvalid !== void 0 && _input$isInvalid.call(input) && input !== null && input !== void 0 && input.focusWithError) {
                var _input$focusWithError;

                if (IS_DEV) ;

                input === null || input === void 0 ? void 0 : (_input$focusWithError = input.focusWithError) === null || _input$focusWithError === void 0 ? void 0 : _input$focusWithError.call(input);
                foundError = true;
              }
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.$emit("submit", event);
    }
  }
});

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("form", {
    onSubmit: _cache[0] || (_cache[0] = withModifiers(function () {
      return _ctx.handleSubmit && _ctx.handleSubmit.apply(_ctx, arguments);
    }, ["prevent"]))
  }, [renderSlot(_ctx.$slots, "default")], 32);
}

script$4.render = render$5;

/**
 * A simple wrapper around BasicModal, to allow using promises to track modal open/close
 *
 * Exposes a single method, confirm, which returns a promise, which results to either true/false, depending on user input. (promise will never reject)
 *
 * Note the parent view does not need to do anything other to manage the modal state, simply await the promise returned by calling the confirm method (via the modal ref).
 *
 * As an escape hatch, a forceClose method is also exposed
 *
 * User input is controlled by the two callback functions passed to the modalContent slot
 *
 * Usage
 *
 *  &lt;ConfirmationModal ref="modal">
 *
 *  &lt;template #modalContent={cancel, confirm}>
 *
 *  &lt;button @click="cancel">Cancel</button>
 *
 *  &lt;button @click="confirm">Confirm</button>
 *
 *  &lt;/template>
 *
 *  &lt;/ConfirmationModal>
 *
 * ... in your method...
 * const ok = await this.$refs.modal?.confirm?.()
 *
 * ok will be true/false depending on user input
 * (Null checks are for best practice, not really relevant)
 */

var script$3 = defineComponent({
  name: "PromiseModal",
  components: {
    BasicModal: script$g
  },
  emits: ["close"],
  data: function data() {
    return {
      cancelCb: null,
      confirmCb: null
    };
  },
  props: {
    /**
     * Prevent click on document (user can't click outside the modal to close it)
     */
    disableClickOutside: Boolean
  },
  methods: {
    confirm: function confirm() {
      var _this = this,
          _this$$refs2,
          _this$$refs2$modal,
          _this$$refs2$modal$op;

      var promise = new Promise(function (resolve) {
        _this.cancelCb = function () {

          return resolve(false);
        };

        _this.confirmCb = function () {

          return resolve(true);
        };
      }).finally(function () {
        var _this$$refs, _this$$refs$modal;


        (_this$$refs = _this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$modal = _this$$refs.modal) === null || _this$$refs$modal === void 0 ? void 0 : _this$$refs$modal.close();
        _this.cancelCb = null;
        _this.confirmCb = null;
      }); //@ts-ignore

      (_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 ? void 0 : (_this$$refs2$modal = _this$$refs2.modal) === null || _this$$refs2$modal === void 0 ? void 0 : (_this$$refs2$modal$op = _this$$refs2$modal.open) === null || _this$$refs2$modal$op === void 0 ? void 0 : _this$$refs2$modal$op.call(_this$$refs2$modal);
      return promise;
    },
    forceClose: function forceClose() {
      var _this$$refs3, _this$$refs3$modal, _this$$refs3$modal$cl;


      (_this$$refs3 = this.$refs) === null || _this$$refs3 === void 0 ? void 0 : (_this$$refs3$modal = _this$$refs3.modal) === null || _this$$refs3$modal === void 0 ? void 0 : (_this$$refs3$modal$cl = _this$$refs3$modal.close) === null || _this$$refs3$modal$cl === void 0 ? void 0 : _this$$refs3$modal$cl.call(_this$$refs3$modal);

      if (this.cancelCb) {
        var _this$cancelCb;

        (_this$cancelCb = this.cancelCb) === null || _this$cancelCb === void 0 ? void 0 : _this$cancelCb.call(this);
      }
    }
  }
});

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_BasicModal = resolveComponent("BasicModal");

  return openBlock(), createBlock(_component_BasicModal, {
    ref: "modal",
    onClose: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.cancelCb ? _ctx.cancelCb() : undefined;
    }),
    teleportToBody: "",
    disableClickOutside: _ctx.disableClickOutside
  }, {
    modalHeader: withCtx(function () {
      return [renderSlot(_ctx.$slots, "modalHeader", {
        cancel: _ctx.cancelCb,
        confirm: _ctx.confirmCb
      })];
    }),
    modalBody: withCtx(function () {
      return [renderSlot(_ctx.$slots, "modalBody", {
        cancel: _ctx.cancelCb,
        confirm: _ctx.confirmCb
      })];
    }),
    _: 3
  }, 8, ["disableClickOutside"]);
}

script$3.render = render$4;

/**
 * A simple HTML text editor.
 */

var script$2 = defineComponent({
  name: "TextEditor",
  props: {
    /** editable div id */
    id: String,

    /** if edit mode provide value (richtext) */
    modelValue: String,

    /** if the field is  invalid */
    invalid: Boolean,

    /** is field focused on mount */
    focused: Boolean
  },
  data: function data() {
    return {
      text: "",
      cleanText: ""
    };
  },
  mounted: function mounted() {
    document.addEventListener("click", this.blurInput);

    if (this.focused) {
      this.$refs.editor.focus();
    }
  },
  methods: {
    focusEditor: function focusEditor() {
      /** focus editor */
      this.$refs.editor.focus();
      this.$emit("focus");
    },
    bold: function bold() {
      document.execCommand("bold");
      this.$refs.editor.focus();
    },
    underline: function underline() {
      document.execCommand("underline");
      this.$refs.editor.focus();
    },
    italic: function italic() {
      document.execCommand("italic");
      this.$refs.editor.focus();
    },
    list: function list() {
      document.execCommand("insertUnorderedList");
      this.$refs.editor.focus();
    },
    orderedList: function orderedList() {
      document.execCommand("insertOrderedList");
      this.$refs.editor.focus();
    },
    biggerFontSize: function biggerFontSize() {
      document.execCommand("fontsize", false, "4");
      this.$refs.editor.focus();
    },
    normalFontSize: function normalFontSize() {
      document.execCommand("fontsize", false, "3");
      this.$refs.editor.focus();
    },
    smallerFontSize: function smallerFontSize() {
      document.execCommand("fontsize", false, "2");
      this.$refs.editor.focus();
    },
    removeFormat: function removeFormat() {
      document.execCommand("removeFormat");
    },
    strikeThrough: function strikeThrough() {
      document.execCommand("strikeThrough");
      this.$refs.editor.focus();
    },
    fontColor: function fontColor() {
      document.execCommand("foreColor", false, "#9a42ff");
      this.$refs.editor.focus();
    },
    fontBlack: function fontBlack() {
      document.execCommand("foreColor", false, "#000000");
      this.$refs.editor.focus();
    },
    subscript: function subscript() {
      document.execCommand("subscript");
      this.$refs.editor.focus();
    },
    superscript: function superscript() {
      document.execCommand("superscript");
      this.$refs.editor.focus();
    },
    save: function save() {
      var text = this.$refs.editor.innerHTML;
      /** PREVENT TEXT TO OVERFLOW CONTAINER IN <pre> TAG */

      text = text.replace(/<pre/g, "<div");
      var cleanText = this.$refs.editor.innerText;
      this.text = text;
      this.cleanText = cleanText;
      /** emit keyup to save text as user inputs it */

      this.$emit("update:modelValue", this.text);
    },
    blurInput: function blurInput() {
      /** blur input */
      this.$emit("blur");
    },
    getEditorCleanTextValue: function getEditorCleanTextValue() {
      return this.$refs.editor.innerText;
    }
  },
  watch: {
    modelValue: function modelValue(val) {
      if (val != this.text) {
        this.text = val;
        this.$refs.editor.innerHTML = val;
        this.cleanText = this.$refs.editor.innerText;
      }
    },
    focused: function focused() {
      /* TRACK CHANGE TO FOCUS INPUT WHEN DEEPLY NESTED */
      if (this.focused) {
        this.$refs.editor.focus();
      }
    }
  }
});

var _hoisted_1$3 = {
  class: "sb-text-editor__buttons"
};
var _hoisted_2$3 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_3$2 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_4$2 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_5$2 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_6$2 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_7$2 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_8$1 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_9$1 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_10$1 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_11$1 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_12 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_13 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_14 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_15 = {
  class: "sb-text-editor__button__tooltip"
};
var _hoisted_16 = ["id"];
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock("div", {
    onClick: _cache[15] || (_cache[15] = withModifiers(function () {
      return _ctx.focusEditor && _ctx.focusEditor.apply(_ctx, arguments);
    }, ["stop"])),
    class: "sb-text-editor",
    id: "text-editor"
  }, [createElementVNode("div", _hoisted_1$3, [createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = function ($event) {
      _ctx.bold();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--bold",
    type: "button",
    id: "bold"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'bold'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_2$3, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.BOLD")), 1)]), createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      _ctx.underline();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--underline",
    type: "button",
    id: "underline"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'underline'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_3$2, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.UNDERLINE")), 1)]), createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = function ($event) {
      _ctx.italic();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--italic",
    type: "button",
    id: "italic"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'italic'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_4$2, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.ITALIC")), 1)]), createElementVNode("button", {
    onClick: _cache[3] || (_cache[3] = function ($event) {
      _ctx.list();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--list-ul",
    type: "button",
    id: "unordered"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'list-ul'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_5$2, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.UNORDERED_LIST")), 1)]), createElementVNode("button", {
    onClick: _cache[4] || (_cache[4] = function ($event) {
      _ctx.orderedList();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--list-ol",
    type: "button",
    id: "ordered"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'list-ol'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_6$2, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.ORDERED_LIST")), 1)]), createElementVNode("button", {
    onClick: _cache[5] || (_cache[5] = function ($event) {
      _ctx.biggerFontSize();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--font-bigger",
    type: "button",
    id: "large"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'text-size'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_7$2, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.BIGGER_TEXT_SIZE")), 1)]), createElementVNode("button", {
    onClick: _cache[6] || (_cache[6] = function ($event) {
      _ctx.normalFontSize();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--font-normal",
    type: "button",
    id: "regular"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'text-size'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_8$1, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.NORMAL_TEXT_SIZE")), 1)]), createElementVNode("button", {
    onClick: _cache[7] || (_cache[7] = function ($event) {
      _ctx.smallerFontSize();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--font-smaller",
    type: "button",
    id: "small"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'text-size'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_9$1, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.SMALLER_TEXT_SIZE")), 1)]), createElementVNode("button", {
    onClick: _cache[8] || (_cache[8] = function ($event) {
      _ctx.removeFormat();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--remove-format",
    type: "button",
    id: "remove"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'remove-format'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_10$1, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.REMOVE_TEXT_FORMATTING")), 1)]), createElementVNode("button", {
    onClick: _cache[9] || (_cache[9] = function ($event) {
      _ctx.strikeThrough();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--striketrough",
    type: "button",
    id: "strike"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'strikethrough'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_11$1, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.STRIKE_TROUGH")), 1)]), createElementVNode("button", {
    onClick: _cache[10] || (_cache[10] = function ($event) {
      _ctx.fontColor();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--text-color",
    type: "button",
    id: "color"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'eye-dropper'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_12, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.CHANGE_TEXT_COLOR")), 1)]), createElementVNode("button", {
    onClick: _cache[11] || (_cache[11] = function ($event) {
      _ctx.fontBlack();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--text-default",
    type: "button",
    id: "black"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'eye-dropper'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_13, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.DEFAULT_TEXT_COLOR")), 1)]), createElementVNode("button", {
    onClick: _cache[12] || (_cache[12] = function ($event) {
      _ctx.superscript();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--superscript",
    type: "button",
    id: "superscript"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'superscript'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_14, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.SUPERSCRIPT")), 1)]), createElementVNode("button", {
    onClick: _cache[13] || (_cache[13] = function ($event) {
      _ctx.subscript();

      _ctx.save();
    }),
    class: "sb-text-editor__button sb-text-editor__button--subscript",
    type: "button",
    id: "subscript"
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fal', 'subscript'],
    class: "sb-text-editor__button__icon"
  }), createElementVNode("span", _hoisted_15, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_ARIA.HTMLEditor.TEXT_EDITOR.SUBSCRIPT")), 1)])]), createElementVNode("div", {
    contenteditable: "true",
    class: normalizeClass(["sb-text-editor__editable", {
      warning: _ctx.invalid
    }]),
    ref: "editor",
    id: _ctx.id,
    tabindex: "0",
    onKeyup: _cache[14] || (_cache[14] = function () {
      return _ctx.save && _ctx.save.apply(_ctx, arguments);
    })
  }, null, 42, _hoisted_16)]);
}

script$2.render = render$3;
script$2.__scopeId = "data-v-6de8d700";

var script$1 = defineComponent({
  name: "MobileMenu",
  components: {
    DropdownMenu: script$d,
    DropdownMenuItem: script$c
  },
  props: {
    currentUser: {
      type: Object,
      default: null
    }
  }
});

var _hoisted_1$2 = {
  class: "mobile-nav"
};
var _hoisted_2$2 = {
  class: "user-icon-wrapper"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _component_DropdownMenuItem = resolveComponent("DropdownMenuItem");

  var _component_DropdownMenu = resolveComponent("DropdownMenu");

  return openBlock(), createElementBlock("div", _hoisted_1$2, [createVNode(_component_DropdownMenu, {
    "close-icon": "fa-light fa-bars",
    "open-icon": "fa-regular fa-xmark",
    "align-right": true
  }, {
    default: withCtx(function () {
      return [_ctx.currentUser != null ? (openBlock(), createBlock(_component_DropdownMenuItem, {
        key: 0,
        class: "user-name not-clickable",
        "not-clickable": true
      }, {
        default: withCtx(function () {
          return [createElementVNode("h3", null, [createElementVNode("span", _hoisted_2$2, [createVNode(_component_font_awesome_icon, {
            class: "icon",
            icon: "fa-user"
          })]), createTextVNode(" " + toDisplayString$1(_ctx.currentUser.displayName), 1)])];
        }),
        _: 1
      })) : createCommentVNode("", true), renderSlot(_ctx.$slots, "mobileMenu")];
    }),
    _: 3
  })]);
}

script$1.render = render$2;
script$1.__scopeId = "data-v-376387ec";

/**
 Navigation
 This component displays a navigation bar at the top of the screen.
 Included mobile menu.

 Component properties

 product - an object of product information (name, path)
 menuList - a list of menu for desktop navigation bar
 loginUser - an object of login user used for mobile menu (displayName)

 DEVELOPER NOTE:
  There are 4 slots that need to be added
  - productLogo: Display logo for product
  - langList: Display a list of language options
    Language button should have class locale-button, if it has been selected, add current class
  - userMenu: Display a list of user options
  - mobileMenu: Render a menu for mobile
    If mobileMenu contains submenu, sub menu item should have sub-menu class

 */
var __default__ = defineComponent({
  name: "NavigationBar",
  components: {
    MobileMenu: script$1,
    DropdownMenuItem: script$c,
    DropdownMenu: script$d
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    menuList: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    loginUser: {
      type: Object,
      required: true
    },
    userMenuWidth: [Number, String],
    userMenuDropdownWidth: [Number, String],
    navHeight: [Number, String]
  },
  computed: {
    customUserMenuWidth: function customUserMenuWidth() {
      return this.resolveWithUnit(this.userMenuWidth, "128px");
    },
    customUserMenuDropdownWidth: function customUserMenuDropdownWidth() {
      return this.resolveWithUnit(this.userMenuDropdownWidth, "191px");
    },
    customNavHeight: function customNavHeight() {
      return this.resolveWithUnit(this.navHeight, "55px");
    }
  },
  methods: {
    type: function type(item) {
      if (item.to) {
        return "router-link";
      } else {
        return "a";
      }
    },
    resolveWithUnit: function resolveWithUnit(val) {
      var falsy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "auto";

      if (!val) {
        return falsy;
      }

      if (isNumber(val)) {
        return val + "px";
      } // Assume our user passed a unit, for example '100%'


      return val;
    }
  }
});

var __injectCSSVars__ = function __injectCSSVars__() {
  useCssVars(function (_ctx) {
    return {
      "203d6255": _ctx.customNavHeight,
      "657dc8c7": _ctx.customUserMenuWidth,
      "f03c3394": _ctx.customUserMenuDropdownWidth
    };
  });
};

var __setup__ = __default__.setup;
__default__.setup = __setup__ ? function (props, ctx) {
  __injectCSSVars__();

  return __setup__(props, ctx);
} : __injectCSSVars__;

var _withScopeId$1 = function _withScopeId(n) {
  return pushScopeId("data-v-7b7c8d6a"), n = n(), popScopeId(), n;
};

var _hoisted_1$1 = {
  class: "sb-main-menu"
};
var _hoisted_2$1 = {
  class: "nav"
};
var _hoisted_3$1 = {
  class: "nav-link-text header-logo"
};
var _hoisted_4$1 = {
  class: "name"
};

var _hoisted_5$1 = /*#__PURE__*/_withScopeId$1(function () {
  return /*#__PURE__*/createElementVNode("span", {
    class: "dot"
  }, ".", -1);
});

var _hoisted_6$1 = {
  class: "nav-container"
};
var _hoisted_7$1 = {
  class: "sb-navigation-text"
};
var _hoisted_8 = {
  class: "nav-container nav-group-right"
};
var _hoisted_9 = {
  class: "nav-item lang-section"
};
var _hoisted_10 = {
  id: "language-dropdown",
  "aria-hidden": "true",
  class: "s-sr-only"
};
var _hoisted_11 = {
  class: "nav-item user-menu"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_DropdownMenu = resolveComponent("DropdownMenu");

  var _component_MobileMenu = resolveComponent("MobileMenu");

  return openBlock(), createElementBlock("div", null, [createElementVNode("div", _hoisted_1$1, [createElementVNode("nav", _hoisted_2$1, [(openBlock(), createBlock(resolveDynamicComponent(_ctx.type({
    title: _ctx.product.name,
    to: _ctx.product.path
  })), {
    to: _ctx.product.path,
    class: "nav-link logo"
  }, {
    default: withCtx(function () {
      return [createElementVNode("div", _hoisted_3$1, [renderSlot(_ctx.$slots, "productLogo"), createElementVNode("div", _hoisted_4$1, [createTextVNode(toDisplayString$1(_ctx.product.name), 1), _hoisted_5$1])])];
    }),
    _: 3
  }, 8, ["to"])), createElementVNode("div", _hoisted_6$1, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.menuList, function (item, index) {
    return openBlock(), createBlock(resolveDynamicComponent(_ctx.type(item)), {
      key: index,
      to: item.to,
      href: item.href,
      class: "nav-link"
    }, {
      default: withCtx(function () {
        return [createElementVNode("div", _hoisted_7$1, [createElementVNode("span", null, toDisplayString$1(item.title), 1)])];
      }),
      _: 2
    }, 1032, ["to", "href"]);
  }), 128))]), createElementVNode("div", _hoisted_8, [createElementVNode("div", _hoisted_9, [createElementVNode("span", _hoisted_10, toDisplayString$1(_ctx.$t("SR_LABEL.MSG_LANGUAGE_DROPDOWN")), 1), createVNode(_component_DropdownMenu, {
    class: "locale-selection"
  }, {
    label: withCtx(function () {
      return [createTextVNode(toDisplayString$1(_ctx.$i18n.locale), 1)];
    }),
    default: withCtx(function () {
      return [renderSlot(_ctx.$slots, "langList")];
    }),
    _: 3
  })]), createElementVNode("div", _hoisted_11, [renderSlot(_ctx.$slots, "userMenu")])]), createVNode(_component_MobileMenu, {
    "current-user": _ctx.loginUser
  }, {
    mobileMenu: withCtx(function () {
      return [renderSlot(_ctx.$slots, "mobileMenu")];
    }),
    _: 3
  }, 8, ["current-user"])])])]);
}

__default__.render = render$1;
__default__.__scopeId = "data-v-7b7c8d6a";

var ONLY_MANDATORY = "0";
var ALL = "1";
var id = uuid();
var sarakefiPrivacyPolicy = "https://www.sarake.fi/tietosuojaseloste/"; // Symbol use to guarantee multiple versions of this modal do no exist

var singletonSymbol = cookieModalSingletonSymbol;
/**
 * Generic cookie modal.
 *
 * Note that one of the callback will always be called, even if the modal is not visible (according to the saved value)
 * 
 * onSeeMoreInformation is optional, by default it redirects to https://www.sarake.fi/tietosuojaseloste/.
 * 
 * The cookie modal must be a singleton instance, meaning it must mounted exactly once on the document. (Add it to your App.vue)
 *
 * DEV note, if you want to override or provide more localizations, override fields from SARAKE_STORYBOOK_COOKIE_MODAL in your vue i18n messages
 * 
 * If for some reason you want to access the raw cookie value (for example to clear the user selection), use the exported enum COOKIE_POLICY_COOKIE.
 * 
 * To remove the selection, make sure to remove the appropriate cookie and localStorage value.
 * 
 * @example
 * import { COOKIE_POLICY_COOKIE } from "@sarake/sarake-storybook/enums";
 
 */

var script = defineComponent({
  components: {
    PromiseModal: script$3
  },
  props: {
    disableGA: {
      required: false,
      type: Boolean
    },
    onAllAccepted: {
      required: false,
      type: Function
    },
    onMandatoryAccepted: {
      required: false,
      type: Function
    },
    onSeeMoreInformation: {
      required: false,
      type: Function,
      default: function _default() {
        console.log("@sarake/sarake-storybook", "CookieModal", "Redirect to ", sarakefiPrivacyPolicy);
        window.open(sarakefiPrivacyPolicy, "_blank");
      }
    }
  },
  methods: {
    isValidSingleton: function isValidSingleton() {
      // FIXME do typescript stuff
      // @ts-ignore
      return !document[singletonSymbol] || document[singletonSymbol] == id;
    },
    saveAcceptance: function saveAcceptance(val) {
      if (val == null) return; // Save into sarake.fi cookie.
      // Note that this will fail for domain not in sarake.fi (for example localhost)

      var tenYears = 1000 * 60 * 60 * 24 * 365 * 10;
      setCookie(COOKIE_POLICY_COOKIE, val, {
        domain: "sarake.fi",
        maxAge: tenYears
      }); // And into localStorage

      localStorage.setItem(COOKIE_POLICY_COOKIE, val); // Gtag integration

      if (this.disableGA) {
        return;
      } // Note, GA is only done when value changes, it is assumed that ga is initialized correctly, so we don't need to do this every time


      var consent = {
        functionality_storage: val == ALL ? "granted" : "denied",
        security_storage: val == ALL ? "granted" : "denied",
        ad_storage: val == ALL ? "granted" : "denied",
        analytics_storage: val == ALL ? "granted" : "denied",
        personalization: val == ALL ? "granted" : "denied"
      }; // @ts-ignore

      if (typeof window.gtag === "function") {
        // @ts-ignore
        window.gtag("consent", "update", consent);
      }
    },
    cookieAcceptanceLevel: function cookieAcceptanceLevel() {
      var _localStorage$getItem;

      var checkCookie = function checkCookie(cookie) {
        var _cookie$trim, _cookie$trim2;

        if (!cookie) {
          return false;
        }

        if ((cookie === null || cookie === void 0 ? void 0 : (_cookie$trim = cookie.trim) === null || _cookie$trim === void 0 ? void 0 : _cookie$trim.call(cookie)) == ONLY_MANDATORY) {
          return true;
        }

        if ((cookie === null || cookie === void 0 ? void 0 : (_cookie$trim2 = cookie.trim) === null || _cookie$trim2 === void 0 ? void 0 : _cookie$trim2.call(cookie)) == ALL) {
          return true;
        }

        console.warn("@sarake/sarake-storybook", "CookieModal", "Unknown tos acceptance level", cookie);
        return false;
      }; // First check for cross domain cookie


      var cookie = getCookie(COOKIE_POLICY_COOKIE);

      if (cookie != null) {

        if (checkCookie(cookie)) {
          // Override localStorage with cookie value
          localStorage.setItem(COOKIE_POLICY_COOKIE, cookie);
          return cookie;
        }
      } // Fallback to localStorage


      cookie = (_localStorage$getItem = localStorage.getItem(COOKIE_POLICY_COOKIE)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : undefined;

      if (checkCookie(cookie)) {
        return cookie;
      }

      return null;
    },
    reset: function reset() {
      // Remove stored values
      localStorage.removeItem(COOKIE_POLICY_COOKIE);
      removeCookie(COOKIE_POLICY_COOKIE, {
        domain: "sarake.fi"
      }); // Show modal

      this.collectAcceptance();
    },
    collectAcceptance: function collectAcceptance() {
      var _this = this;

      // @ts-ignore
      this.$refs.modal.confirm().then(function (ok) {
        var level = ok ? ALL : ONLY_MANDATORY;

        _this.saveAcceptance(level);

        if (level == ALL) {
          if (typeof _this.onAllAccepted === "function") _this.onAllAccepted();
        } else if (typeof _this.onMandatoryAccepted === "function") {
          _this.onMandatoryAccepted();
        }
      });
    }
  },
  mounted: function mounted() {

    if (!this.isValidSingleton()) {
      console.warn("@sarake/sarake-storybook", "CookieModal", "Multiple instances of CookieModal are mounted, ensure only one instance of this component is mounted");
      return;
    } // We are the valid singleton, check if cookie acceptance is present


    var acceptance = this.cookieAcceptanceLevel();

    if (acceptance == ALL) {
      if (typeof this.onAllAccepted === "function") {
        this.onAllAccepted();
      }
    } else if (acceptance == ONLY_MANDATORY) {
      if (typeof this.onMandatoryAccepted === "function") {
        this.onMandatoryAccepted();
      }
    } else {
      this.collectAcceptance();
    }
  },
  unmounted: function unmounted() {
    if (this.isValidSingleton()) {
      // @ts-ignore
      delete document[singletonSymbol];
    } else {
      console.warn("@sarake/sarake-storybook", "CookieModal", "Multiple instances of CookieModal are mounted, ensure only one instance of this component is mounted");
    }
  }
});

var _withScopeId = function _withScopeId(n) {
  return pushScopeId("data-v-408e989a"), n = n(), popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/createElementVNode("svg", {
    alt: "",
    class: "sb-sarake",
    viewBox: "0 0 74 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [/*#__PURE__*/createElementVNode("g", {
    "clip-path": "url(#clip0_2549_12634)"
  }, [/*#__PURE__*/createElementVNode("path", {
    d: "M55.935 15.8365C54.7299 15.8365 53.6246 15.8463 52.5216 15.8243C52.3743 15.8219 52.1817 15.6755 52.0914 15.5388C51.2713 14.3065 50.4703 13.0621 49.6621 11.8225C49.5837 11.7005 49.4957 11.5858 49.4102 11.4638C49.0608 11.8127 48.7209 12.1202 48.4214 12.4642C48.3334 12.5667 48.3358 12.7741 48.3334 12.9327C48.3263 13.8795 48.3287 14.8263 48.3287 15.8048H45.2814V0H48.3144V8.14275C48.5141 7.9573 48.6282 7.86213 48.728 7.75477C49.6859 6.71283 50.6343 5.65869 51.6089 4.63383C51.7681 4.46546 52.0534 4.34345 52.2863 4.33613C53.4011 4.30685 54.5159 4.32149 55.7519 4.32149C55.5832 4.5167 55.4881 4.63383 55.3835 4.74851C54.1927 6.04423 53.0137 7.34726 51.8038 8.6259C51.5423 8.90407 51.5495 9.07732 51.7515 9.38234C53.0517 11.354 54.3305 13.3427 55.6141 15.3241C55.7092 15.4705 55.7995 15.6193 55.935 15.839V15.8365Z",
    fill: "#133D74"
  }), /*#__PURE__*/createElementVNode("path", {
    d: "M60.1827 11.2125C60.3942 13.4745 63.2609 14.026 65.702 12.291C66.2606 12.9108 66.824 13.5355 67.4016 14.1773C66.0657 15.4705 64.4921 16.0733 62.6904 15.9952C60.601 15.9049 58.8635 15.0752 57.82 13.1573C56.2393 10.2511 56.893 5.22927 61.7658 4.25078C64.05 3.79203 66.4793 4.81445 67.6107 6.65187C68.1812 7.57913 68.3286 8.61131 68.3452 9.67765C68.3524 10.0388 68.3262 10.4024 68.3524 10.7611C68.3761 11.1149 68.2549 11.2223 67.9031 11.2198C65.5024 11.2052 63.104 11.2125 60.7032 11.2125C60.5321 11.2125 60.3586 11.2125 60.1827 11.2125ZM60.2825 8.93341H65.1387C65.1482 7.68649 64.1689 6.7812 62.8449 6.7812C61.4734 6.7812 60.2754 7.77434 60.2849 8.93341H60.2825Z",
    fill: "#133D74"
  }), /*#__PURE__*/createElementVNode("path", {
    d: "M18.1388 8.63587C18.2576 7.52317 17.6443 6.78624 16.6009 6.70816C15.4884 6.62276 14.483 6.95705 13.525 7.49633C13.3587 7.58905 13.1994 7.69642 12.9974 7.82086L11.633 5.80043C12.6384 5.03666 13.72 4.55352 14.9037 4.33634C16.2491 4.08745 17.5897 4.05817 18.8994 4.57548C20.4373 5.18063 21.2193 6.37386 21.2573 8.00143C21.3168 10.588 21.274 13.177 21.274 15.8001H18.4097V14.4434C18.1554 14.6874 17.9938 14.8436 17.8321 14.9973C15.8901 16.8421 12.2367 15.988 11.3739 13.4844C11.1077 12.7133 11.0696 11.9227 11.2812 11.1321C11.671 9.68757 12.7739 9.05802 14.0717 8.84572C15.2246 8.65783 16.4131 8.69443 17.5873 8.63587C17.7727 8.62611 17.9605 8.63587 18.1411 8.63587H18.1388ZM18.0936 10.893C17.3258 10.893 16.5509 10.8808 15.776 10.9003C15.5312 10.9076 15.2816 10.976 15.0487 11.0565C14.4782 11.2541 14.2405 11.6543 14.2952 12.2668C14.3499 12.8842 14.7634 13.2404 15.5883 13.3844C17.188 13.6626 18.4715 12.401 18.096 10.893H18.0936Z",
    fill: "#133D74"
  }), /*#__PURE__*/createElementVNode("path", {
    d: "M39.1703 8.63542C39.2701 7.52027 38.683 6.79799 37.6656 6.71015C36.5389 6.61254 35.5168 6.94928 34.547 7.49831C34.383 7.59104 34.2238 7.6984 34.0241 7.82041C33.5677 7.14449 33.1209 6.48322 32.6597 5.79998C33.91 4.85808 35.272 4.34565 36.7648 4.21388C37.8225 4.11872 38.8731 4.1602 39.8905 4.55794C41.4284 5.16066 42.2366 6.33193 42.2793 7.96194C42.3459 10.5631 42.296 13.1668 42.296 15.8021H39.4293V14.4454C39.1655 14.6992 38.992 14.8627 38.8208 15.0335C36.886 16.9441 32.9045 15.8485 32.3079 13.179C32.0607 12.0785 32.1106 11.0146 32.8214 10.0897C33.4061 9.33086 34.2428 8.94044 35.1437 8.83307C36.2917 8.69642 37.4588 8.69398 38.6164 8.63786C38.8042 8.6281 38.9896 8.63786 39.1703 8.63786V8.63542ZM39.1227 10.8901C38.355 10.8901 37.5801 10.8779 36.8052 10.8974C36.5603 10.9047 36.3108 10.9706 36.0778 11.0536C35.5073 11.2512 35.2696 11.649 35.3219 12.2639C35.3742 12.8813 35.7878 13.24 36.6126 13.3839C38.2123 13.6621 39.4935 12.4079 39.1227 10.8925V10.8901Z",
    fill: "#133D74"
  }), /*#__PURE__*/createElementVNode("path", {
    d: "M-6.44305e-05 14.1701L1.31678 12.2521C1.69472 12.4839 2.04889 12.7182 2.4197 12.9232C3.22311 13.3648 4.08596 13.6064 4.99872 13.5966C5.31248 13.5942 5.64763 13.5259 5.93762 13.399C6.49146 13.1574 6.59604 12.5108 6.13016 12.1155C5.80926 11.8422 5.41469 11.6445 5.02962 11.4737C4.08833 11.0565 3.1114 10.7173 2.18913 10.2658C0.0855067 9.24099 0.313696 6.21521 2.06315 5.07567C3.86965 3.89952 5.75222 3.93124 7.67044 4.72185C8.15772 4.92194 8.60934 5.21232 9.12277 5.48561L7.97707 7.58901C7.5706 7.3816 7.19029 7.17175 6.79571 6.98874C6.09688 6.6642 5.35764 6.56904 4.59938 6.63004C4.46865 6.6398 4.33792 6.67396 4.21194 6.71056C3.89818 6.80085 3.64146 6.95702 3.59155 7.32792C3.53925 7.7281 3.72703 8.00628 4.05981 8.16489C4.44488 8.35034 4.84659 8.49919 5.24354 8.65048C6.03983 8.95549 6.87415 9.18487 7.6324 9.56797C9.42227 10.4757 9.89291 12.7304 8.67352 14.3726C7.99846 15.2852 7.05005 15.7708 5.96852 15.9148C3.8126 16.2027 1.86348 15.6171 0.118784 14.3018C0.0855067 14.275 0.05936 14.2384 -0.00244141 14.1701H-6.44305e-05Z",
    fill: "#133D74"
  }), /*#__PURE__*/createElementVNode("path", {
    d: "M27.302 15.8196H24.25V4.40467H27.2925V5.87364C28.3051 4.9293 29.3011 4.22166 30.7082 4.18994C30.7082 5.12452 30.7178 6.00785 30.694 6.89118C30.694 6.97902 30.4991 7.11323 30.3802 7.13275C30.0641 7.18643 29.7289 7.15227 29.4175 7.22304C28.2623 7.48657 27.7251 8.35526 27.4803 9.44112C27.3567 9.99259 27.3187 10.5733 27.3092 11.1419C27.2854 12.5255 27.302 13.9115 27.302 15.2975C27.302 15.4609 27.302 15.622 27.302 15.8196Z",
    fill: "#133D74"
  }), /*#__PURE__*/createElementVNode("path", {
    d: "M70.4298 14.1455C70.4298 13.0816 71.1595 12.3301 72.1959 12.3325C73.2085 12.3325 73.9977 13.1256 73.9977 14.1407C73.9977 15.1558 73.2037 15.9537 72.1959 15.9561C71.1524 15.9561 70.4298 15.2192 70.4298 14.1455Z",
    fill: "#F04F46"
  })]), /*#__PURE__*/createElementVNode("defs", null, [/*#__PURE__*/createElementVNode("clipPath", {
    id: "clip0_2549_12634"
  }, [/*#__PURE__*/createElementVNode("rect", {
    width: "74",
    height: "16",
    fill: "white"
  })])])], -1);
});

var _hoisted_2 = {
  class: "sb-cookie-container"
};
var _hoisted_3 = {
  class: "sb-cookie-header"
};
var _hoisted_4 = {
  class: "sb-cookie-body"
};
var _hoisted_5 = {
  class: "sb-cookie-actions"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = ["onClick"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_PromiseModal = resolveComponent("PromiseModal");

  return openBlock(), createBlock(_component_PromiseModal, {
    ref: "modal",
    class: "sb-cookie-modal",
    disableClickOutside: ""
  }, {
    modalHeader: withCtx(function () {
      return [_hoisted_1];
    }),
    modalBody: withCtx(function (_ref) {
      var confirm = _ref.confirm,
          cancel = _ref.cancel;
      return [createElementVNode("div", _hoisted_2, [createElementVNode("h3", _hoisted_3, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_COOKIE_MODAL.HEADING")), 1), createElementVNode("p", _hoisted_4, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_COOKIE_MODAL.BODY")), 1), createElementVNode("div", _hoisted_5, [createElementVNode("button", {
        class: "accept-all button--primary",
        onClick: confirm
      }, [createElementVNode("span", null, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_COOKIE_MODAL.ACCEPT_ALL")), 1)], 8, _hoisted_6), createElementVNode("button", {
        class: "accept-mandatory button--secondary",
        onClick: cancel
      }, [createElementVNode("span", null, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_COOKIE_MODAL.ACCEPT_MANDATORY")), 1)], 8, _hoisted_7), createElementVNode("button", {
        class: "read-more button--link",
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.onSeeMoreInformation();
        })
      }, [createElementVNode("span", null, toDisplayString$1(_ctx.$t("SARAKE_STORYBOOK_COOKIE_MODAL.READ_MORE")), 1)])])])];
    }),
    _: 1
  }, 512);
}

script.render = render;
script.__scopeId = "data-v-408e989a";

// Export every component to be included in the final build

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SearchableDropdown: script$p,
  TextField: script$o,
  IntegerField: script$n,
  SelectField: script$m,
  ObjectTable: script$k,
  ExpandedPanel: script$j,
  Toast: script$i,
  SingleToast: __default__$3,
  ModalOverlay: script$h,
  BasicModal: script$g,
  CustomSelectField: script$f,
  TypeToSearch: script$e,
  CheckboxField: script$l,
  DropdownMenu: script$d,
  DropdownMenuItem: script$c,
  InfoBox: script$b,
  PhoneNumberField: script$a,
  IntegerSelectField: script$9,
  TooltipComponent: __default__$2,
  ContentLoader: __default__$1,
  PaginatedTable: script$8,
  PaginatedTableEvent: script$7,
  PageSelection: script$6,
  DelayedTextField: script$5,
  SBForm: script$4,
  PromiseModal: script$3,
  HTMLEditor: script$2,
  NavigationBar: __default__,
  CookieModal: script,
  TableVariant: TableVariant,
  ModalSize: ModalSize,
  ToastType: ToastType,
  COOKIE_POLICY_COOKIE: COOKIE_POLICY_COOKIE
});

/**
 * Validate messages passed to i18n, mainly check that all objects in the languages are of the same shape
 */
function validateMessages(messages) {
  if (!messages || _typeof$5(messages) !== "object") {
    return;
  }

  var keys = Object.keys(messages);
  if (keys.length === 1) return;
  /**
   * Flatten object keys to dot notation
   */

  function flattenKeys(obj) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var recursionGuard = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (!obj) return [];
    var res = [];

    for (var key in obj) {
      var path = !base ? key : base + "." + key;

      if (key == null || _typeof$5(obj[key]) !== "object") {
        res.push(path);
      } else {
        recursionGuard.push(obj);

        if (!recursionGuard.includes(obj[key])) {
          res.push.apply(res, _toConsumableArray$2(flattenKeys(obj[key], path, recursionGuard)));
        }
      }
    }

    return res;
  }

  var flatKeys = keys.map(function (key) {
    return {
      key: key,
      messages: flattenKeys(messages[key])
    };
  }); // Each element in flat key should be identical

  Object.values(flatKeys).forEach(function (obj, _, arr) {
    var key = obj.key,
        messages = obj.messages;

    var _iterator = _createForOfIteratorHelper(messages),
        _step;

    try {
      var _loop = function _loop() {
        var message = _step.value;
        Object.values(arr).forEach(function (obj2) {
          if (!obj2.messages.includes(message)) {
            console.warn("@sarake/sarake-storybook ", "i18n messages validator: ", "Messages object \"".concat(key, "\" contained translation key \"").concat(message, "\" not found in \"").concat(obj2.key, "\""));
          }
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
}

var plugin = {
  /**
   * Vue plugin to set up the sarake-storybook package for usage in a project
   *
   * Usage:
   *
   * Vue.use(plugin, options)
   *
   * @param Vue vue instance
   * @param options options
   */
  install: function install(Vue, options) {
    var _options$vueI18nOptio, _options$disableMessa;


    Vue.component("FontAwesomeIcon", FontAwesomeIcon);
    library$1.add( // fas
    faChevronDown$1, faChevronUp$1, faGear$1, faCheckCircle, faTimesCircle, faInfoCircle$1, faUser, // fal
    faCaretDown, faCaretUp, faCircleInfo, faTriangleExclamation, faBold, faUnderline, faListUl, faListOl, faTextSize, faRemoveFormat, faStrikethrough, faEyeDropper, faSuperscript, faSubscript, faItalic, faCog, faInfoCircle, faSignOut, faBars, // far, FIXME; far doesn't have built-in ts decl
    faTimes, faChevronRight, faChevronLeft, faEyeSlash, faEye, faChevronDown, faChevronUp); // i8n config

    if ((options === null || options === void 0 ? void 0 : options.vueI18nOptions) == null) {
      console.warn("@sarake/sarake-storybook", "Missing vueI18nOptions, do not configure vue-18n separately, but pass any configurations as plugin options");
    } //Note, typing of the global vue instance is done by the ExternalTypes.d.ts


    var i8nOptions = merge_1({
      legacy: true,
      locale: "fi",
      globalInjection: true,
      messages: messages
    }, (_options$vueI18nOptio = options === null || options === void 0 ? void 0 : options.vueI18nOptions) !== null && _options$vueI18nOptio !== void 0 ? _options$vueI18nOptio : {});


    if (!((_options$disableMessa = options === null || options === void 0 ? void 0 : options.disableMessageValidator) !== null && _options$disableMessa !== void 0 ? _options$disableMessa : true)) {
      var _i8nOptions$messages;

      validateMessages((_i8nOptions$messages = i8nOptions === null || i8nOptions === void 0 ? void 0 : i8nOptions.messages) !== null && _i8nOptions$messages !== void 0 ? _i8nOptions$messages : {});
    }

    var i8n = createI18n(i8nOptions);
    Vue.use(i8n);

    if ((options === null || options === void 0 ? void 0 : options.addComponentsGlobally) !== false) {
      Object.entries(components).forEach(function (_ref) {
        var _ref2 = _slicedToArray$3(_ref, 2),
            name = _ref2[0],
            c = _ref2[1];

        // Skip default exports
        if (name === "default") {
          return;
        }

        Vue.component(name, c);
      });
    } // Embed version info
    // FIXME remove @ts-ignore
    // @ts-ignore


    if (!IS_SSR && typeof {
      "module": "esm",
      "version": "1.0.3",
      "dependencies": {
        "i18n": "9.2.0",
        "fontawesome": "3.0.1",
        "lodash": "4.17.21"
      },
      "buildFlags": {
        "env": "production",
        "VUE_I18N_LEGACY_API": true,
        "VUE_I18N_FULL_INSTALL": false,
        "INTLIFY_PROD_DEVTOOLS": false,
        "VUE_PROD_DEVTOOLS": false
      }
    } !== "undefined") {
      // @ts-ignore
      window["__SARAKE_STORYBOOK_BUILD_INFO__"] = {
        "module": "esm",
        "version": "1.0.3",
        "dependencies": {
          "i18n": "9.2.0",
          "fontawesome": "3.0.1",
          "lodash": "4.17.21"
        },
        "buildFlags": {
          "env": "production",
          "VUE_I18N_LEGACY_API": true,
          "VUE_I18N_FULL_INSTALL": false,
          "INTLIFY_PROD_DEVTOOLS": false,
          "VUE_PROD_DEVTOOLS": false
        }
      };
    }
  }
};

export { script$g as BasicModal, COOKIE_POLICY_COOKIE, script$l as CheckboxField, __default__$1 as ContentLoader, script as CookieModal, script$f as CustomSelectField, script$5 as DelayedTextField, script$d as DropdownMenu, script$c as DropdownMenuItem, script$j as ExpandedPanel, script$2 as HTMLEditor, script$b as InfoBox, script$n as IntegerField, script$9 as IntegerSelectField, script$h as ModalOverlay, ModalSize, __default__ as NavigationBar, script$k as ObjectTable, script$6 as PageSelection, script$8 as PaginatedTable, script$7 as PaginatedTableEvent, script$a as PhoneNumberField, script$3 as PromiseModal, script$4 as SBForm, script$p as SearchableDropdown, script$m as SelectField, __default__$3 as SingleToast, TableVariant, script$o as TextField, script$i as Toast, ToastType, __default__$2 as TooltipComponent, script$e as TypeToSearch, plugin as default };
